/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * Goodies API
 * OpenAPI spec version: 1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { customInstance } from './axios-instance';
export interface TestResponseDto {
  /** ID of the test item */
  id: number;
  /** Name of the test item */
  name: string;
  /** Creation timestamp */
  createdAt: string;
}

export type CollectionResponseDtoRarity =
  (typeof CollectionResponseDtoRarity)[keyof typeof CollectionResponseDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionResponseDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Image object-fit style
 */
export type CollectionResponseDtoImagePosition =
  (typeof CollectionResponseDtoImagePosition)[keyof typeof CollectionResponseDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionResponseDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface CollectionResponseDto {
  id: string;
  name: string;
  /** @nullable */
  description: string | null;
  brandId: string;
  brandName: string;
  rarity: CollectionResponseDtoRarity;
  totalSupply: number;
  /** @nullable */
  image?: string | null;
  /** Image object-fit style */
  imagePosition: CollectionResponseDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured: number;
  /** @nullable */
  lottie?: string | null;
  /** @nullable */
  nftGetGemsCollectionId?: string | null;
  /** If true, items from this collection cannot be traded on marketplaces */
  isNonTradeable: boolean;
}

export interface PaginationMetaDto {
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
  /** Total number of items */
  total: number;
  /** Total number of pages */
  totalPages: number;
  /** Has next page */
  hasNextPage: boolean;
  /** Has previous page */
  hasPreviousPage: boolean;
  /** The sort property by which the data is sorted */
  sortBy: string;
}

export interface CollectionListResponseDto {
  /** Array of collection items */
  data: CollectionResponseDto[];
  /** Pagination metadata */
  meta: PaginationMetaDto;
}

export type CollectionWithDropsResponseDtoRarity =
  (typeof CollectionWithDropsResponseDtoRarity)[keyof typeof CollectionWithDropsResponseDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionWithDropsResponseDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Image object-fit style
 */
export type CollectionWithDropsResponseDtoImagePosition =
  (typeof CollectionWithDropsResponseDtoImagePosition)[keyof typeof CollectionWithDropsResponseDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionWithDropsResponseDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface CollectionWithDropsResponseDto {
  id: string;
  name: string;
  /** @nullable */
  description: string | null;
  brandId: string;
  brandName: string;
  rarity: CollectionWithDropsResponseDtoRarity;
  totalSupply: number;
  /** @nullable */
  image?: string | null;
  /** Image object-fit style */
  imagePosition: CollectionWithDropsResponseDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured: number;
  /** @nullable */
  lottie?: string | null;
  /** @nullable */
  nftGetGemsCollectionId?: string | null;
  /** If true, items from this collection cannot be traded on marketplaces */
  isNonTradeable: boolean;
  inDropSupply: number;
  freeSupply: number;
}

export interface StickerResponseDto {
  /** Unique identifier for the sticker */
  id: string;
  /** Display name of the sticker */
  name: string;
  /** File name of the sticker image */
  fileName: string;
  /** Array of emojis associated with the sticker */
  emojis: string[];
  /** Creation timestamp */
  createdAt: string;
}

export interface CollectionAvailabilityResponseDto {
  /** Collection ID */
  collectionId: string;
  /** Collection name */
  collectionName: string;
  /** Total number of packs in the collection */
  totalPacks: number;
  /** Number of packs available for new drops */
  availablePacks: number;
  /** Total number of unavailable packs */
  unavailablePacks: number;
  /** Number of packs owned by users */
  packsOwnedByUsers: number;
  /** Number of packs with existing claims */
  packsWithClaims: number;
  /** Number of burned packs (never available for re-assignment) */
  packsBurned: number;
  /** Number of packs reserved by active or ended drops */
  packsReservedByDrops: number;
  /** Number of packs reserved by active direct sale offers */
  packsInDirectSales: number;
  /** Number of available packs, including reserved packs by drops or sales */
  availablePacksForDisplay: number;
}

export type CreateCollectionDtoRarity = (typeof CreateCollectionDtoRarity)[keyof typeof CreateCollectionDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCollectionDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Image object-fit style
 */
export type CreateCollectionDtoImagePosition =
  (typeof CreateCollectionDtoImagePosition)[keyof typeof CreateCollectionDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCollectionDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface CreateCollectionDto {
  name: string;
  /** NFT lottie URL */
  lottie?: string;
  brandId: string;
  /** @nullable */
  description: string | null;
  rarity: CreateCollectionDtoRarity;
  totalSupply: number;
  /** Image object-fit style */
  imagePosition?: CreateCollectionDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured?: number;
  /** If true, items from this collection cannot be traded on marketplaces */
  isNonTradeable?: boolean;
  /** GetGems collection ID for NFT minting */
  nftGetGemsCollectionId?: string;
}

export interface CreateCollectionWithImageDto {
  /** Collection image file */
  image: Blob;
  request: CreateCollectionDto;
}

export interface CreateCollectionResponseDto {
  id: string;
}

export type UpdateCollectionDtoRarity = (typeof UpdateCollectionDtoRarity)[keyof typeof UpdateCollectionDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCollectionDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Image object-fit style
 */
export type UpdateCollectionDtoImagePosition =
  (typeof UpdateCollectionDtoImagePosition)[keyof typeof UpdateCollectionDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCollectionDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface UpdateCollectionDto {
  name?: string;
  /** @nullable */
  description?: string | null;
  rarity?: UpdateCollectionDtoRarity;
  totalSupply?: number;
  visible?: boolean;
  publicSale?: boolean;
  /** Image object-fit style */
  imagePosition?: UpdateCollectionDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured?: number;
  /** NFT lottie URL */
  lottie?: string;
  /** If true, items from this collection cannot be traded on marketplaces */
  isNonTradeable?: boolean;
}

export interface AddStickersMultipartDto {
  /** One or more sticker image files */
  stickers: Blob[];
  /** JSON with stickers array. Example: {"stickers": [{"name": "Sticker 1", "emojis": ["😺", "🎉"]}]} */
  meta: string;
}

export interface RemoveStickersDto {
  stickers: string[];
}

export interface UpdateCollectionImageDto {
  /** New collection image file */
  image: Blob;
}

export interface UpdateCollectionLottieDto {
  /** Lottie animation JSON file */
  lottie: Blob;
}

export interface StickerDto {
  fileName: string;
  name: string;
}

/**
 * Image object-fit style
 */
export type UnwrappedPackDtoImagePosition =
  (typeof UnwrappedPackDtoImagePosition)[keyof typeof UnwrappedPackDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnwrappedPackDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export type UnwrappedPackDtoRarity = (typeof UnwrappedPackDtoRarity)[keyof typeof UnwrappedPackDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnwrappedPackDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Status of sticker pack creation
 */
export type UnwrappedPackDtoStickerPackStatus =
  (typeof UnwrappedPackDtoStickerPackStatus)[keyof typeof UnwrappedPackDtoStickerPackStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnwrappedPackDtoStickerPackStatus = {
  NOT_CREATED: 'NOT_CREATED',
  PENDING: 'PENDING',
  CREATED: 'CREATED',
  FAILED: 'FAILED',
} as const;

export interface UnwrappedPackDto {
  /** @nullable */
  description: string | null;
  imageUrl: string;
  /** Image object-fit style */
  imagePosition: UnwrappedPackDtoImagePosition;
  numberInCollection: string;
  collectionId: string;
  collectionName: string;
  brandId: string;
  brandName: string;
  rarity: UnwrappedPackDtoRarity;
  stickers: StickerDto[];
  /**
   * Telegram sticker set URL - only provided for unwrapped packs
   * @nullable
   */
  telegramStickerSetUrl: string | null;
  /**
   * Telegram sticker set name - only provided for unwrapped packs
   * @nullable
   */
  telegramStickerSetName: string | null;
  /** Whether this pack can be minted as an NFT (collection has nftGetGemsCollectionId) */
  isMintable: boolean;
  /** Status of sticker pack creation */
  stickerPackStatus: UnwrappedPackDtoStickerPackStatus;
}

/**
 * Type of NFT minted for this pack
 */
export type PackNftDtoNftType = (typeof PackNftDtoNftType)[keyof typeof PackNftDtoNftType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PackNftDtoNftType = {
  BLINDBOX: 'BLINDBOX',
  COLLECTION: 'COLLECTION',
} as const;

/**
 * Current status of NFT minting
 */
export type PackNftDtoNftMintStatus = (typeof PackNftDtoNftMintStatus)[keyof typeof PackNftDtoNftMintStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PackNftDtoNftMintStatus = {
  NOT_MINTED: 'NOT_MINTED',
  PENDING: 'PENDING',
  DONE: 'DONE',
  FAILED: 'FAILED',
} as const;

export interface PackNftDto {
  /** Type of NFT minted for this pack */
  nftType: PackNftDtoNftType;
  /**
   * NFT address on blockchain
   * @nullable
   */
  nftAddress: string | null;
  /** Current status of NFT minting */
  nftMintStatus: PackNftDtoNftMintStatus;
  /**
   * Timestamp when NFT was minted
   * @nullable
   */
  nftMintedAt: string | null;
  /**
   * URL for NFT metadata
   * @nullable
   */
  nftMetadataUrl: string | null;
}

/**
 * @nullable
 */
export type PackResponseDtoUnwrapped = UnwrappedPackDto | null;

/**
 * NFT information for this pack if minted
 * @nullable
 */
export type PackResponseDtoNft = PackNftDto | null;

export interface PackResponseDto {
  id: string;
  /** @nullable */
  name: string | null;
  isNonTradeable: boolean;
  /**
   * Datetime until pack is staked
   * @nullable
   */
  stakedTill: string | null;
  /**
   * Activity ID where pack is staked
   * @nullable
   */
  stakedInActivityId: string | null;
  /** @nullable */
  unwrapped: PackResponseDtoUnwrapped;
  /**
   * NFT information for this pack if minted
   * @nullable
   */
  nft: PackResponseDtoNft;
}

export interface UserOpenedPacksResponseDto {
  /** */
  openedPacks: PackResponseDto[];
}

export type BlindboxPackResponseDtoPossibleRaritiesItem =
  (typeof BlindboxPackResponseDtoPossibleRaritiesItem)[keyof typeof BlindboxPackResponseDtoPossibleRaritiesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BlindboxPackResponseDtoPossibleRaritiesItem = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * NFT information for this pack if minted
 * @nullable
 */
export type BlindboxPackResponseDtoNft = PackNftDto | null;

export interface BlindboxPackResponseDto {
  id: string;
  /** @nullable */
  name: string | null;
  /** @nullable */
  dropId: string | null;
  /** @nullable */
  possibleRarities: BlindboxPackResponseDtoPossibleRaritiesItem[] | null;
  /**
   * NFT information for this pack if minted
   * @nullable
   */
  nft: BlindboxPackResponseDtoNft;
}

export interface UserBlindboxPacksResponseDto {
  /** */
  blindboxPacks: BlindboxPackResponseDto[];
}

export interface UnwrapResponseDto {
  packId: string;
  telegramStickerSetUrl: string;
  telegramStickerSetName: string;
  createdAt: string;
  stickers: StickerDto[];
}

/**
 * URL of the collection image
 * @nullable
 */
export type PossibleDropItemDtoCollectionImageUrl = { [key: string]: unknown } | null;

/**
 * Image object-fit style
 */
export type PossibleDropItemDtoCollectionImagePosition =
  (typeof PossibleDropItemDtoCollectionImagePosition)[keyof typeof PossibleDropItemDtoCollectionImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PossibleDropItemDtoCollectionImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

/**
 * Rarity of the collection
 */
export type PossibleDropItemDtoRarity = (typeof PossibleDropItemDtoRarity)[keyof typeof PossibleDropItemDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PossibleDropItemDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

export interface PossibleDropItemDto {
  /** Unique identifier of the collection */
  collectionId: string;
  /** Name of the collection */
  collectionName: string;
  /**
   * URL of the collection image
   * @nullable
   */
  collectionImageUrl: PossibleDropItemDtoCollectionImageUrl;
  /** Image object-fit style */
  collectionImagePosition: PossibleDropItemDtoCollectionImagePosition;
  /**
   * Name of the brand that owns the collection
   * @nullable
   */
  brandName: string | null;
  /** Total supply of packs for this collection in the drop */
  totalSupply: string;
  /**
   * Probability of getting this collection when opening a pack (0-1 where 1 = 100%)
   * @minimum 0
   * @maximum 1
   */
  dropChance: number;
  /** Rarity of the collection */
  rarity: PossibleDropItemDtoRarity;
}

export interface PossibleDropsResponseDto {
  /** List of possible collections and their drop probabilities */
  collections: PossibleDropItemDto[];
  /** ID of the drop these collections belong to */
  dropId: string;
  /** Total number of collections in this drop */
  totalCollections: number;
}

export interface FindPackByPartnerIdsRequestDto {
  /** Collection ID in partner naming (BigInt string) */
  collectionId: string;
  /** Pack ID in partner naming (BigInt string) */
  packId: string;
  /** Instance in partner naming (BigInt string) */
  instance: string;
  /** Telegram user ID to verify ownership */
  telegramUserId: string;
  /** Marketplace identifier (mid parameter from start param) */
  mid?: string;
}

export interface FindPackByPartnerIdsResponseDto {
  /**
   * Internal pack ID (UUID)
   * @nullable
   */
  packId: string | null;
  /** Whether the pack was found */
  found: boolean;
  /**
   * Marketplace UUID (resolved from mid parameter)
   * @nullable
   */
  marketplaceId: string | null;
}

export interface TransferToMarketRequestDto {
  /** Internal pack ID to transfer */
  packId: string;
  /** Marketplace UUID identifier */
  marketplaceId: string;
}

export type DirectSaleOfferResponseDtoCollectionRarity =
  (typeof DirectSaleOfferResponseDtoCollectionRarity)[keyof typeof DirectSaleOfferResponseDtoCollectionRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSaleOfferResponseDtoCollectionRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Computed status based on time and database status
 */
export type DirectSaleOfferResponseDtoComputedStatus =
  (typeof DirectSaleOfferResponseDtoComputedStatus)[keyof typeof DirectSaleOfferResponseDtoComputedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSaleOfferResponseDtoComputedStatus = {
  scheduled: 'scheduled',
  active: 'active',
  ended: 'ended',
  archived: 'archived',
} as const;

/**
 * Infinite supply configuration - generate_on_sale means packs are generated on-demand, disabled means fixed supply
 */
export type DirectSaleOfferResponseDtoInfiniteSupply =
  (typeof DirectSaleOfferResponseDtoInfiniteSupply)[keyof typeof DirectSaleOfferResponseDtoInfiniteSupply];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSaleOfferResponseDtoInfiniteSupply = {
  generate_on_sale: 'generate_on_sale',
  disabled: 'disabled',
} as const;

/**
 * Sale description
 * @nullable
 */
export type DirectSaleOfferResponseDtoDescription = { [key: string]: unknown } | null;

export interface DirectSaleOfferResponseDto {
  id: string;
  /** Collection ID */
  collectionId: string;
  /** Collection name */
  collectionName: string;
  /**
   * Collection image
   * @nullable
   */
  collectionImage: string | null;
  collectionRarity: DirectSaleOfferResponseDtoCollectionRarity;
  /** Collection image position */
  collectionImagePosition: string;
  /** Brand ID */
  brandId: string;
  /** Brand name */
  brandName: string;
  /**
   * Price per pack in Telegram Stars
   * @nullable
   */
  starPricePerPack: string | null;
  /**
   * Price per pack in TON
   * @nullable
   */
  tonPricePerPack: string | null;
  /** Sale start time */
  startTime: string;
  /** Sale end time */
  endTime: string;
  /** Computed status based on time and database status */
  computedStatus: DirectSaleOfferResponseDtoComputedStatus;
  /** Sale title */
  title: string;
  /** Infinite supply configuration - generate_on_sale means packs are generated on-demand, disabled means fixed supply */
  infiniteSupply: DirectSaleOfferResponseDtoInfiniteSupply;
  /**
   * Sale description
   * @nullable
   */
  description: DirectSaleOfferResponseDtoDescription;
  /** Total number of packs available in this sale */
  totalSupplyInSale: number;
  /** Number of packs currently in stock */
  inStock: number;
  /** Display order (supports negative numbers) */
  order: number;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
}

export interface DirectSaleOfferListResponseDto {
  offers: DirectSaleOfferResponseDto[];
  /** Total count of offers matching filters */
  total: number;
}

/**
 * Payment method for the purchase
 */
export type CreateDirectSalePurchaseDtoPaymentMethod =
  (typeof CreateDirectSalePurchaseDtoPaymentMethod)[keyof typeof CreateDirectSalePurchaseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDirectSalePurchaseDtoPaymentMethod = {
  telegram_stars: 'telegram_stars',
  ton_wallet: 'ton_wallet',
} as const;

export interface CreateDirectSalePurchaseDto {
  /**
   * Number of packs to purchase
   * @minimum 1
   * @maximum 100
   */
  packsCount: number;
  /** Payment method for the purchase */
  paymentMethod: CreateDirectSalePurchaseDtoPaymentMethod;
}

export interface CreatePurchaseResponseDto {
  /** Purchase ID */
  purchaseId: string;
  /** Telegram invoice URL for payment (not provided for TON wallet purchases) */
  invoiceUrl?: string;
  /** Number of packs in this purchase */
  packsCount: number;
  /** Total price in Telegram Stars or TON */
  totalStarPrice: string;
}

/**
 * Enable/disable infinite supply. When enabled, packs are generated on-demand during sales
 */
export type CreateDirectSaleOfferDtoInfiniteSupply =
  (typeof CreateDirectSaleOfferDtoInfiniteSupply)[keyof typeof CreateDirectSaleOfferDtoInfiniteSupply];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateDirectSaleOfferDtoInfiniteSupply = {
  generate_on_sale: 'generate_on_sale',
  disabled: 'disabled',
} as const;

export interface CreateDirectSaleOfferDto {
  /** Collection ID */
  collectionId: string;
  /**
   * Price per pack in Telegram Stars
   * @minimum 1
   */
  starPricePerPack: number;
  /**
   * Price per pack in TON
   * @minimum 0.01
   */
  tonPricePerPack?: number;
  /** Sale start time (ISO 8601) */
  startTime: string;
  /** Sale end time (ISO 8601) */
  endTime: string;
  /**
   * Sale title
   * @maxLength 200
   */
  title: string;
  /**
   * Sale description
   * @maxLength 1000
   */
  description?: string;
  /**
   * Total number of packs available in this sale
   * @minimum 1
   */
  totalSupplyInSale: number;
  /** Display order (supports negative numbers) */
  order?: number;
  /** Enable/disable infinite supply. When enabled, packs are generated on-demand during sales */
  infiniteSupply?: CreateDirectSaleOfferDtoInfiniteSupply;
}

export interface CreatedEntityResponseDto {
  /** Whether the operation was successful */
  success: boolean;
  /** The ID of the created entity */
  entityId: string;
  /** Success message describing the operation */
  message: string;
}

/**
 * Sale offer status
 */
export type UpdateDirectSaleOfferDtoStatus =
  (typeof UpdateDirectSaleOfferDtoStatus)[keyof typeof UpdateDirectSaleOfferDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDirectSaleOfferDtoStatus = {
  active: 'active',
  archived: 'archived',
} as const;

/**
 * Enable/disable infinite supply. When enabled, packs are generated on-demand during sales
 */
export type UpdateDirectSaleOfferDtoInfiniteSupply =
  (typeof UpdateDirectSaleOfferDtoInfiniteSupply)[keyof typeof UpdateDirectSaleOfferDtoInfiniteSupply];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDirectSaleOfferDtoInfiniteSupply = {
  generate_on_sale: 'generate_on_sale',
  disabled: 'disabled',
} as const;

export interface UpdateDirectSaleOfferDto {
  /**
   * Price per pack in Telegram Stars
   * @minimum 1
   */
  starPricePerPack?: number;
  /**
   * Price per pack in TON
   * @minimum 0.01
   */
  tonPricePerPack?: number;
  /** Sale start time (ISO 8601) */
  startTime?: string;
  /** Sale end time (ISO 8601) */
  endTime?: string;
  /**
   * Sale title
   * @maxLength 200
   */
  title?: string;
  /**
   * Sale description
   * @maxLength 1000
   */
  description?: string;
  /** Sale offer status */
  status?: UpdateDirectSaleOfferDtoStatus;
  /**
   * Total number of packs available in this sale
   * @minimum 1
   */
  totalSupplyInSale?: number;
  /** Display order (supports negative numbers) */
  order?: number;
  /** Enable/disable infinite supply. When enabled, packs are generated on-demand during sales */
  infiniteSupply?: UpdateDirectSaleOfferDtoInfiniteSupply;
}

export interface DirectSaleOfferSummaryResponseDto {
  /** Number of unique users who purchased from this offer */
  uniqueUsersCount: number;
  /** Total number of packs sold through this offer */
  totalPacksSold: number;
  /** Total number of purchase transactions */
  totalPurchasesCount: number;
}

/**
 * Filter by purchase status
 */
export type DirectSalePurchaseFiltersDtoStatus =
  (typeof DirectSalePurchaseFiltersDtoStatus)[keyof typeof DirectSalePurchaseFiltersDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSalePurchaseFiltersDtoStatus = {
  pending: 'pending',
  completed: 'completed',
  failed: 'failed',
} as const;

/**
 * Filter by payment method
 */
export type DirectSalePurchaseFiltersDtoPaymentMethod =
  (typeof DirectSalePurchaseFiltersDtoPaymentMethod)[keyof typeof DirectSalePurchaseFiltersDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSalePurchaseFiltersDtoPaymentMethod = {
  telegram_stars: 'telegram_stars',
  ton_wallet: 'ton_wallet',
} as const;

export interface DirectSalePurchaseFiltersDto {
  /** Filter by user ID */
  userId?: string;
  /** Filter by direct sale offer ID */
  directSaleOfferId?: string;
  /** Filter by purchase status */
  status?: DirectSalePurchaseFiltersDtoStatus;
  /** Filter by payment method */
  paymentMethod?: DirectSalePurchaseFiltersDtoPaymentMethod;
  /** Filter purchases created after this date (ISO 8601 format) */
  startDate?: string;
  /** Filter purchases created before this date (ISO 8601 format) */
  endDate?: string;
}

export interface ParticipateDto {
  /** Number of packs to participate for */
  numberOfPacks: number;
  /** Amount of TON to lock (must be at least packPrice * numberOfPacks) */
  amountToLock: string;
}

export interface ParticipationResponseDto {
  lockId: string;
  message: string;
}

export interface ParticipationStatusDto {
  dropId: string;
  dropName: string;
  packPrice: string;
  numberOfPacks: number;
  amountLocked: string;
  status: string;
  /**
   * Date and time when the lock was confirmed
   * @nullable
   */
  confirmedAt: string | null;
  /**
   * Date and time when the lock was created
   * @nullable
   */
  createdAt: string | null;
  /** Whether the user has acknowledged the participation */
  acknowledged: boolean;
}

export interface MyWhitelistedDropsResponseDto {
  /** Array of drop IDs for which the user is whitelisted */
  dropIds: string[];
}

export interface IncreaseLockDto {
  /** Additional amount of TON to lock */
  additionalAmount: string;
  /** Additional number of packs to lock for (optional) */
  additionalPacks?: number;
}

export interface IncreaseLockResponseDto {
  lockId: string;
  newTotalAmount: string;
  previousAmount: string;
  additionalAmount: string;
  newTotalPacks: number;
  previousPacks: number;
  additionalPacks: number;
  message: string;
}

export interface DropStatsResponseDto {
  /** Id of the drop */
  dropId: string;
  /** Total amount of TON locked in this drop */
  totalLockedAmount: string;
  /** Total number of packs locked by users in this drop */
  totalLockedPacks: number;
  /** Total supply of packs available in this drop */
  totalPackSupply: number;
  /**
   * Maximum number of packs a user can lock in this drop
   * @nullable
   */
  maxPacksPerUser: number | null;
  /**
   * Price per pack in TON. Returns null if drop has not started yet.
   * @nullable
   */
  packPrice: string | null;
}

export interface AckAndClaimResponseDto {
  /** Success message */
  message: string;
  /** List of claimed pack IDs */
  claimedPackIds: string[];
  /** Amount of refunded TON */
  refundAmount: number;
  /** Number of packs claimed */
  packsClaimedCount: number;
}

export interface CollectionInDropDto {
  id: string;
  name: string;
  description?: string;
  brandId: string;
  brandName: string;
  rarity: string;
  totalSupply: string;
  /** Collection image URL */
  image?: string;
  visible: boolean;
  publicSale: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface DropCollectionResponseDto {
  id: string;
  dropId: string;
  totalSupply: string;
  /** Collection details including image URL */
  collection: CollectionInDropDto;
  createdAt: string;
}

export interface DropResponseDto {
  id: string;
  name: string;
  /** @nullable */
  slug: string | null;
  /** @nullable */
  description: string | null;
  startTime: string;
  endTime: string;
  /** @nullable */
  image: string | null;
  status: string;
  /** @nullable */
  walletId: string | null;
  createdAt: string;
  updatedAt: string;
  claimAllowed: boolean;
  /**
   * Maximum number of packs a single user can lock in this drop
   * @nullable
   */
  maxPacksPerUser: number | null;
  dropCollections: DropCollectionResponseDto[];
}

export interface DropListResponseDto {
  /** Array of drop items */
  data: DropResponseDto[];
  /** Pagination metadata */
  meta: PaginationMetaDto;
}

/**
 * String code identifying the sorting priority
 */
export type SortedDropItemResponseDtoSortingPriorityCode =
  (typeof SortedDropItemResponseDtoSortingPriorityCode)[keyof typeof SortedDropItemResponseDtoSortingPriorityCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortedDropItemResponseDtoSortingPriorityCode = {
  COMPLETED_CLAIMABLE: 'COMPLETED_CLAIMABLE',
  ACTIVE: 'ACTIVE',
  UPCOMING: 'UPCOMING',
} as const;

export interface SortedDropItemResponseDto {
  id: string;
  name: string;
  /** @nullable */
  slug: string | null;
  /** @nullable */
  description: string | null;
  startTime: string;
  endTime: string;
  /** @nullable */
  image: string | null;
  status: string;
  /** @nullable */
  walletId: string | null;
  createdAt: string;
  updatedAt: string;
  claimAllowed: boolean;
  /**
   * Maximum number of packs a single user can lock in this drop
   * @nullable
   */
  maxPacksPerUser: number | null;
  dropCollections: DropCollectionResponseDto[];
  /**
   * Sorting priority (2 = completed claimable, 3 = active, 4 = upcoming)
   * @minimum 2
   * @maximum 4
   */
  sortingPriority: number;
  /** String code identifying the sorting priority */
  sortingPriorityCode: SortedDropItemResponseDtoSortingPriorityCode;
}

export interface ActiveLockDto {
  dropId: string;
  dropName: string;
  amountLocked: string;
  numberOfPacks: number;
  status: string;
}

export interface WalletResponseDto {
  address: string;
  activeLocks: ActiveLockDto[];
  totalLocked: string;
  rawAddress: string;
}

export interface WithdrawDto {
  /** Destination TON address */
  toAddress: string;
  /** Amount to withdraw in TON */
  amount: string;
}

export interface TransactionDto {
  /** */
  id: string;
  /** */
  amount: string;
  /** */
  status: string;
  /** */
  createdAt: string;
}

export interface AddCustomWalletRequestDto {
  /**
   * TON wallet address in HEX format
   * @maxLength 100
   */
  address: string;
}

/**
 */
export type TaskDtoType = (typeof TaskDtoType)[keyof typeof TaskDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskDtoType = {
  FOLLOW_TELEGRAM: 'FOLLOW_TELEGRAM',
  FOLLOW_X: 'FOLLOW_X',
  CONNECT_WALLET: 'CONNECT_WALLET',
} as const;

/**
 * @nullable
 */
export type TaskDtoStatus = (typeof TaskDtoStatus)[keyof typeof TaskDtoStatus] | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TaskDtoStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export interface TaskDto {
  /** */
  id: string;
  /** */
  name: string;
  /** */
  description: string;
  /** */
  reward: number;
  /** */
  createdAt: string;
  /** */
  updatedAt: string;
  /** @nullable */
  completedAt: string | null;
  /** @nullable */
  icon: string | null;
  /** @nullable */
  order: number | null;
  /** @nullable */
  constantName: string | null;
  /** */
  type: TaskDtoType;
  /** @nullable */
  status: TaskDtoStatus;
  /** @nullable */
  url: string | null;
  /**
   * Date when task should be rechecked for completion
   * @nullable
   */
  refreshAt: string | null;
}

export interface CreateTaskDto {
  name: string;
  constantName: string;
  description: string;
  reward: string;
  order: number;
  reusableInterval: number;
  icon: string;
  type: string;
  url?: string;
}

export type UpdateTaskDtoType = (typeof UpdateTaskDtoType)[keyof typeof UpdateTaskDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTaskDtoType = {
  FOLLOW_TELEGRAM: 'FOLLOW_TELEGRAM',
  FOLLOW_X: 'FOLLOW_X',
  CONNECT_WALLET: 'CONNECT_WALLET',
} as const;

export interface UpdateTaskDto {
  name?: string;
  constantName?: string;
  description?: string;
  reward?: string;
  order?: number;
  reusableInterval?: number;
  icon?: string;
  type?: UpdateTaskDtoType;
  url?: string;
  visible?: boolean;
}

export interface LevelRequirementsResponseDto {
  /** Level number */
  level: number;
  /** XP needed to reach this level from previous level */
  xpNeeded: number;
  /** Total XP required to reach this level from level 0 */
  totalXpRequired: number;
  /** Luck multiplier for this level */
  luck: number;
}

export interface WithdrawNftDto {
  /** Pack ID to withdraw NFT from */
  packId: string;
  /** TON address to withdraw NFT to */
  toAddress: string;
}

export interface WithdrawExternalNftDto {
  /** TON address to withdraw external NFT to */
  toAddress: string;
}

export interface SyncUserNftsResponseDto {
  /** Whether the sync was successful */
  success: boolean;
  /** Response message */
  message: string;
  /** Number of NFTs found on blockchain */
  nftsFound: number;
  /** Number of NFTs updated in database */
  nftsUpdated: number;
  /** Number of NFTs found on blockchain but not in database */
  nftsNotFound: number;
  /** Number of external NFTs created during sync */
  externalNftsCreated?: number;
  /** Number of external NFTs skipped (already exist) */
  externalNftsSkipped?: number;
}

export interface RateLimitResponseDto {
  /** Error message */
  message: string;
  /** Seconds remaining until next sync is allowed */
  secondsRemaining: number;
}

/**
 * Partner ID
 * @nullable
 */
export type CollectionDataDtoPartnerId = { [key: string]: unknown } | null;

/**
 * Collection description
 * @nullable
 */
export type CollectionDataDtoDescription = { [key: string]: unknown } | null;

/**
 * Brand description
 * @nullable
 */
export type CollectionDataDtoBrandDescription = { [key: string]: unknown } | null;

/**
 * Collection image URL
 * @nullable
 */
export type CollectionDataDtoImage = { [key: string]: unknown } | null;

/**
 * Brand image URL
 * @nullable
 */
export type CollectionDataDtoBrandImage = { [key: string]: unknown } | null;

/**
 * Brand cover image URL
 * @nullable
 */
export type CollectionDataDtoBrandCoverImage = { [key: string]: unknown } | null;

/**
 * Collection rarity
 */
export type CollectionDataDtoRarity = (typeof CollectionDataDtoRarity)[keyof typeof CollectionDataDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionDataDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  secret_rare: 'secret_rare',
} as const;

/**
 * Collection Lottie animation URL
 * @nullable
 */
export type CollectionDataDtoLottie = { [key: string]: unknown } | null;

/**
 * NFT GetGems collection ID
 * @nullable
 */
export type CollectionDataDtoNftGetGemsCollectionId = { [key: string]: unknown } | null;

export interface CollectionDataDto {
  /** Collection ID (UUID) */
  collectionId: string;
  /**
   * Partner ID
   * @nullable
   */
  partnerId: CollectionDataDtoPartnerId;
  /** Collection name */
  collectionName: string;
  /**
   * Collection description
   * @nullable
   */
  description: CollectionDataDtoDescription;
  /** Brand name */
  brandName: string;
  /**
   * Brand description
   * @nullable
   */
  brandDescription: CollectionDataDtoBrandDescription;
  /**
   * Collection image URL
   * @nullable
   */
  image: CollectionDataDtoImage;
  /**
   * Brand image URL
   * @nullable
   */
  brandImage: CollectionDataDtoBrandImage;
  /**
   * Brand cover image URL
   * @nullable
   */
  brandCoverImage: CollectionDataDtoBrandCoverImage;
  /** Collection rarity */
  rarity: CollectionDataDtoRarity;
  /**
   * Collection Lottie animation URL
   * @nullable
   */
  lottie: CollectionDataDtoLottie;
  /** Initial supply (total supply) */
  totalSupply: string;
  /** Current supply (packs owned by users) */
  currentSupply: number;
  /**
   * Release date from the earliest drop containing this collection
   * @nullable
   */
  releaseDate: string | null;
  /**
   * Drop price from the earliest drop containing this collection
   * @nullable
   */
  dropPrice: string | null;
  /**
   * NFT GetGems collection ID
   * @nullable
   */
  nftGetGemsCollectionId: CollectionDataDtoNftGetGemsCollectionId;
  /** Collection creation date */
  createdAt: string;
}

/**
 * Type of pack
 */
export type ExternalMarketplaceOwnedPackDtoType =
  (typeof ExternalMarketplaceOwnedPackDtoType)[keyof typeof ExternalMarketplaceOwnedPackDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalMarketplaceOwnedPackDtoType = {
  COLLECTION: 'COLLECTION',
  BLINDBOX: 'BLINDBOX',
} as const;

/**
 * First sticker file URL - only for COLLECTION type, null for BLINDBOX
 * @nullable
 */
export type ExternalMarketplaceOwnedPackDtoFirstStickerUrl = { [key: string]: unknown } | null;

export interface ExternalMarketplaceOwnedPackDto {
  /** Type of pack */
  type: ExternalMarketplaceOwnedPackDtoType;
  /** Collection name - Brand name for collections, "Goodies Blindbox" for blindboxes */
  collectionName: string;
  /**
   * Collection image link - Brand image for collections
   * @nullable
   */
  collectionImageLink: string | null;
  /** Pack name - Collection name for collections, drop name for blindboxes */
  packName: string;
  /** Collection ID in partner naming */
  collectionId: string;
  /** Pack ID in partner naming */
  packId: string;
  /** Instance ID in partner naming */
  instance: string;
  /**
   * Image URL - collection image for unwrapped packs, drop ball image for wrapped packs
   * @nullable
   */
  imageLink: string | null;
  /**
   * First sticker file URL - only for COLLECTION type, null for BLINDBOX
   * @nullable
   */
  firstStickerUrl: ExternalMarketplaceOwnedPackDtoFirstStickerUrl;
}

export interface ExternalMarketplaceUserOwnershipResponseDto {
  /** Array of packs owned by the user */
  ownedPacks: ExternalMarketplaceOwnedPackDto[];
}

export interface VerifyOwnershipRequestDto {
  /** The ID of the drop to check ownership for */
  dropId: string;
  /** The Telegram user ID to check ownership for */
  telegramUserId: string;
}

export interface VerifyOwnershipResponseDto {
  /** The number of packs owned by the user from the specified drop */
  packAmount: number;
  /** Whether the user owns at least one pack from the drop */
  isOwner: boolean;
  /** ISO 8601 timestamp of when the database was queried */
  timestamp: string;
}

export interface TransferFromMarketRequestDto {
  /**
   * Unique request ID from partner marketplace (max 64 characters)
   * @maxLength 64
   */
  requestId: string;
  /** Collection ID in partner naming (BigInt string) */
  collectionId: string;
  /** Pack ID in partner naming (BigInt string) */
  packId: string;
  /** Instance in partner naming (BigInt string) */
  instance: string;
  /** Telegram user ID to transfer pack to */
  telegramUserId: string;
}

export interface CollectionsListResponseDto {
  /** Array of collection items */
  data: CollectionDataDto[];
  /** Pagination metadata */
  meta: PaginationMetaDto;
}

export interface HoldersResponseDto {
  /** List of Telegram user IDs of pack holders */
  telegramUserIds: string[];
  /** Total number of holders */
  count: number;
}

export interface SyncPalaceNftRequestDto {
  /** Optional salt to vary the request ID hash. Use different values to force re-sync with new request IDs. */
  salt?: string;
}

/**
 * Pack claim state
 */
export type PackClaimResponseDtoState = (typeof PackClaimResponseDtoState)[keyof typeof PackClaimResponseDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PackClaimResponseDtoState = {
  WAITING_FOR_CLAIM: 'WAITING_FOR_CLAIM',
  CLAIMED: 'CLAIMED',
} as const;

export interface PackClaimResponseDto {
  /** Pack claim ID */
  id: string;
  /** Pack claim state */
  state: PackClaimResponseDtoState;
  /** Drop ID */
  dropId: string;
  /** Pack ID */
  packId: string;
  /** User ID */
  userId: string;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
}

export interface LoginDto {
  /** Telegram WebApp initData string */
  initData: string;
  /**
   * Referral code
   * @nullable
   */
  referral?: string | null;
}

export interface AuthUserResponseDto {
  /** */
  id: string;
  /** @nullable */
  telegramId: string | null;
  /** @nullable */
  username: string | null;
  /** */
  firstName: string;
  /** @nullable */
  lastName?: string | null;
  /** */
  xp: number;
  /** */
  isPremium: boolean;
  /** */
  referralCode: string;
  /** @nullable */
  referralUserId?: string | null;
  /** */
  onboardingDaysOnTelegram: number;
  /** */
  onboarded: boolean;
  /** @nullable */
  photoUrl?: string | null;
}

export interface AuthResponseDto {
  /** JWT access token */
  access_token: string;
  /** Token expiration timestamp in milliseconds since Unix epoch */
  expires_at: number;
  /** User information */
  user: AuthUserResponseDto;
}

export interface XpProgressDto {
  /**
   * Total XP points the user has
   */
  totalXp: number;
  /**
   * Current user level
   */
  currentLevel: number;
  /**
   * Next level the user can reach
   */
  nextLevel: number;
  /**
   * XP points needed to reach the next level
   */
  xpToNextLevel: number;
  /**
   * Total XP points required for the next level
   */
  nextLevelXp: number;
  /**
   * Percentage progress towards next level (0-100)
   */
  currentLevelPercentage: number;
  /**
   * Luck multiplier for current level
   */
  currentLevelLuck: number;
}

export interface UserResponseDto {
  /** */
  id: string;
  /** @nullable */
  telegramId: string | null;
  /** @nullable */
  username: string | null;
  /** */
  firstName: string;
  /** @nullable */
  lastName: string | null;
  /** */
  xp: XpProgressDto;
  /** */
  isPremium: boolean;
  /** */
  wallet: WalletResponseDto;
  /** */
  referralCode: string;
  /** @nullable */
  customReferralCode?: string | null;
  /** @nullable */
  referralUserId?: string | null;
  /** */
  onboardingDaysOnTelegram: number;
  /** */
  onboarded: boolean;
  /** @nullable */
  photoUrl?: string | null;
}

export interface UpdateUserDto {
  firstName?: string;
  lastName?: string;
}

/**
 * Status of the referral reward: pending (user below level 3), claimable (user reached level 3, reward not claimed), claimed (reward already claimed)
 */
export type RefferedUserResponseDtoRewardStatus =
  (typeof RefferedUserResponseDtoRewardStatus)[keyof typeof RefferedUserResponseDtoRewardStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefferedUserResponseDtoRewardStatus = {
  pending: 'pending',
  claimable: 'claimable',
  claimed: 'claimed',
} as const;

export interface RefferedUserResponseDto {
  /** */
  id: string;
  /** @nullable */
  username: string | null;
  /** */
  firstName: string;
  /** @nullable */
  lastName: string | null;
  /** */
  reward: number;
  /**
   * Current level of the referred user
   */
  currentLevel: number;
  /**
   * Status of the referral reward: pending (user below level 3), claimable (user reached level 3, reward not claimed), claimed (reward already claimed)
   */
  rewardStatus: RefferedUserResponseDtoRewardStatus;
}

export interface OnboardDto {
  /** True if onboarded */
  hasOnboarded: boolean;
  /** Total sum of XP that the user gets for onboarding */
  totalXpReward: number;
  /** Onboarding XP reward for being premium */
  premiumReward: number;
  /** Onboarding XP reward for each started year the user has telegram */
  telegramAgeReward: number;
  /** Onboarding XP reward for joining via an invite from a friend */
  referralReward: number;
  /** Days on Telegram */
  daysOnTelegram: number;
}

export interface RewardConfigResponseDto {
  /** XP reward amount for successful invitation (what the inviter receives) */
  invitationReward: number;
  /** XP reward amount for successfuly joining via an invite link */
  xpForOnboardingWithReferral: number;
}

export interface PlatformStatsDto {
  /** Total number of users */
  totalUsers: number;
  /** Total number of collections */
  totalCollections: number;
  /** Total number of packs */
  totalPacks: number;
  /** Number of currently active collections */
  activeCollections: number;
}

export interface FinanceStatsDto {
  /** Total transaction volume in TON */
  totalVolume: string;
  /** Total number of locks */
  totalLocks: number;
  /** Total amount locked in TON */
  lockedAmount: string;
}

export interface PlatformAnalyticsDto {
  /** Platform statistics */
  platform: PlatformStatsDto;
  /** Financial statistics */
  finance: FinanceStatsDto;
  /** Timestamp of analytics generation */
  timestamp: string;
}

/**
 * Telegram ID
 * @nullable
 */
export type UserByWalletResponseDtoTelegramId = { [key: string]: unknown } | null;

/**
 * Last name
 * @nullable
 */
export type UserByWalletResponseDtoLastName = { [key: string]: unknown } | null;

/**
 * Username
 * @nullable
 */
export type UserByWalletResponseDtoUsername = { [key: string]: unknown } | null;

/**
 * Custom referral code
 * @nullable
 */
export type UserByWalletResponseDtoCustomReferralCode = { [key: string]: unknown } | null;

/**
 * Photo URL
 * @nullable
 */
export type UserByWalletResponseDtoPhotoUrl = { [key: string]: unknown } | null;

export interface UserByWalletResponseDto {
  /** User ID */
  id: string;
  /**
   * Telegram ID
   * @nullable
   */
  telegramId: UserByWalletResponseDtoTelegramId;
  /** First name */
  firstName: string;
  /**
   * Last name
   * @nullable
   */
  lastName: UserByWalletResponseDtoLastName;
  /**
   * Username
   * @nullable
   */
  username: UserByWalletResponseDtoUsername;
  /** User role */
  role: string;
  /** User XP */
  xp: number;
  /** Is premium user */
  isPremium: boolean;
  /** Referral code */
  referralCode: string;
  /**
   * Custom referral code
   * @nullable
   */
  customReferralCode: UserByWalletResponseDtoCustomReferralCode;
  /** User onboarded status */
  onboarded: boolean;
  /**
   * Photo URL
   * @nullable
   */
  photoUrl: UserByWalletResponseDtoPhotoUrl;
  /** Can send Telegram message */
  canSendTelegramMessage: boolean;
  /** Created at timestamp */
  createdAt: string;
  /** Updated at timestamp */
  updatedAt: string;
}

export interface FindUsersByTelegramIdsDto {
  /** Array of Telegram IDs */
  telegramIds: string[];
}

export interface FindUsersByTelegramIdsResponseDto {
  /** Array of user IDs */
  userIds: string[];
}

export interface FindUsersByUsernamesDto {
  /** Array of Telegram usernames */
  usernames: string[];
}

export interface FindUsersByUsernamesResponseDto {
  /** Array of user IDs */
  userIds: string[];
}

/**
 * Brand description
 * @nullable
 */
export type BrandInfoDtoDescription = { [key: string]: unknown } | null;

/**
 * Brand image
 * @nullable
 */
export type BrandInfoDtoImage = { [key: string]: unknown } | null;

/**
 * Brand cover image
 * @nullable
 */
export type BrandInfoDtoCoverImage = { [key: string]: unknown } | null;

/**
 * Brand URL
 * @nullable
 */
export type BrandInfoDtoUrl = { [key: string]: unknown } | null;

export interface BrandInfoDto {
  /** Brand ID */
  id: string;
  /** Brand name */
  name: string;
  /**
   * Brand description
   * @nullable
   */
  description: BrandInfoDtoDescription;
  /**
   * Brand image
   * @nullable
   */
  image: BrandInfoDtoImage;
  /**
   * Brand cover image
   * @nullable
   */
  coverImage: BrandInfoDtoCoverImage;
  /**
   * Brand URL
   * @nullable
   */
  url: BrandInfoDtoUrl;
}

/**
 * Collection description
 * @nullable
 */
export type CollectionInfoDtoDescription = { [key: string]: unknown } | null;

/**
 * Collection image
 * @nullable
 */
export type CollectionInfoDtoImage = { [key: string]: unknown } | null;

/**
 * Collection lottie
 * @nullable
 */
export type CollectionInfoDtoLottie = { [key: string]: unknown } | null;

/**
 * GetGems collection ID
 * @nullable
 */
export type CollectionInfoDtoNftGetGemsCollectionId = { [key: string]: unknown } | null;

/**
 * GetGems metadata URL
 * @nullable
 */
export type CollectionInfoDtoNftGetGemsMetadataUrl = { [key: string]: unknown } | null;

export interface CollectionInfoDto {
  /** Collection ID */
  id: string;
  /** Collection name */
  name: string;
  /**
   * Collection description
   * @nullable
   */
  description: CollectionInfoDtoDescription;
  /** Collection rarity */
  rarity: string;
  /** Collection total supply */
  totalSupply: string;
  /**
   * Collection image
   * @nullable
   */
  image: CollectionInfoDtoImage;
  /** Collection image position */
  imagePosition: string;
  /** Collection is featured */
  featured: number;
  /** Collection is visible */
  visible: boolean;
  /** Collection public sale status */
  publicSale: boolean;
  /**
   * Collection lottie
   * @nullable
   */
  lottie: CollectionInfoDtoLottie;
  /**
   * Collection partner ID
   * @nullable
   */
  partnerId: string | null;
  /**
   * GetGems collection ID
   * @nullable
   */
  nftGetGemsCollectionId: CollectionInfoDtoNftGetGemsCollectionId;
  /**
   * GetGems metadata URL
   * @nullable
   */
  nftGetGemsMetadataUrl: CollectionInfoDtoNftGetGemsMetadataUrl;
  /** Brand information */
  brand: BrandInfoDto;
  /** Collection created at timestamp */
  createdAt: string;
  /** Collection updated at timestamp */
  updatedAt: string;
}

/**
 * Telegram ID
 * @nullable
 */
export type UserInfoDtoTelegramId = { [key: string]: unknown } | null;

/**
 * Last name
 * @nullable
 */
export type UserInfoDtoLastName = { [key: string]: unknown } | null;

/**
 * Username
 * @nullable
 */
export type UserInfoDtoUsername = { [key: string]: unknown } | null;

export interface UserInfoDto {
  /** User ID */
  id: string;
  /**
   * Telegram ID
   * @nullable
   */
  telegramId: UserInfoDtoTelegramId;
  /** First name */
  firstName: string;
  /**
   * Last name
   * @nullable
   */
  lastName: UserInfoDtoLastName;
  /**
   * Username
   * @nullable
   */
  username: UserInfoDtoUsername;
}

/**
 * NFT mint request ID
 * @nullable
 */
export type NftInfoDtoNftMintRequestId = { [key: string]: unknown } | null;

/**
 * NFT minted at timestamp
 * @nullable
 */
export type NftInfoDtoNftMintedAt = { [key: string]: unknown } | null;

/**
 * NFT metadata URL
 * @nullable
 */
export type NftInfoDtoNftMetadataUrl = { [key: string]: unknown } | null;

export interface NftInfoDto {
  /** NFT ID */
  id: string;
  /** NFT type */
  nftType: string;
  /**
   * NFT address on blockchain
   * @nullable
   */
  nftAddress: string | null;
  /** NFT mint status */
  nftMintStatus: string;
  /**
   * NFT mint request ID
   * @nullable
   */
  nftMintRequestId: NftInfoDtoNftMintRequestId;
  /**
   * NFT minted at timestamp
   * @nullable
   */
  nftMintedAt: NftInfoDtoNftMintedAt;
  /**
   * NFT metadata URL
   * @nullable
   */
  nftMetadataUrl: NftInfoDtoNftMetadataUrl;
  /** Is NFT burned */
  burned: boolean;
  /** Should NFT be burned */
  shouldBeBurned: boolean;
  /** NFT created at timestamp */
  createdAt: string;
  /** NFT updated at timestamp */
  updatedAt: string;
}

/**
 * Pack name
 * @nullable
 */
export type PackByNftResponseDtoName = { [key: string]: unknown } | null;

/**
 * Telegram sticker set name
 * @nullable
 */
export type PackByNftResponseDtoTelegramStickerSetName = { [key: string]: unknown } | null;

/**
 * Telegram sticker URL
 * @nullable
 */
export type PackByNftResponseDtoTelegramStickerUrl = { [key: string]: unknown } | null;

/**
 * Owner information
 * @nullable
 */
export type PackByNftResponseDtoUser = UserInfoDto | null;

export interface PackByNftResponseDto {
  /** Pack ID */
  id: string;
  /**
   * Pack name
   * @nullable
   */
  name: PackByNftResponseDtoName;
  /** Number in collection */
  numberInCollection: string;
  /**
   * Telegram sticker set name
   * @nullable
   */
  telegramStickerSetName: PackByNftResponseDtoTelegramStickerSetName;
  /**
   * Telegram sticker URL
   * @nullable
   */
  telegramStickerUrl: PackByNftResponseDtoTelegramStickerUrl;
  /** Sticker pack status */
  stickerPackStatus: string;
  /** Is pack unwrapped */
  unwrapped: boolean;
  /** Pack created at timestamp */
  createdAt: string;
  /** Pack updated at timestamp */
  updatedAt: string;
  /** Collection information */
  collection: CollectionInfoDto;
  /**
   * Owner information
   * @nullable
   */
  user: PackByNftResponseDtoUser;
  /** NFT information */
  nft: NftInfoDto;
}

export interface ResetOnboardedResponseDto {
  /** Indicates if the operation was successful */
  success: boolean;
  /** Status message */
  message: string;
}

export interface SetCustomReferralCodeDto {
  /** Custom referral code (4-20 chars, lowercase alphanumeric + underscore) */
  customReferralCode: string;
}

export interface SetCustomReferralCodeResponseDto {
  /** Indicates if the operation was successful */
  success: boolean;
  /** Status message */
  message: string;
}

/**
 * Individual service statuses
 */
export type SystemHealthDtoServices = { [key: string]: { [key: string]: unknown } };

export interface SystemHealthDto {
  /** Overall system status */
  status: string;
  /** Health check timestamp */
  timestamp: string;
  /** Individual service statuses */
  services: SystemHealthDtoServices;
  /** Error message if unhealthy */
  error?: string;
}

export interface AddXpDto {
  /** User ID to add XP to */
  userId: string;
  /** Amount of XP to add (must be positive) */
  xp: number;
}

export interface AddXpResponseDto {
  /** Whether XP addition was successful */
  success: boolean;
  /** Amount of XP added */
  xpAdded: number;
  /** User total XP after addition */
  totalXp: number;
  /** User level after XP addition */
  newLevel: number;
  /** User ID that received the XP */
  userId: string;
}

export interface SentryTestResponseDto {
  /** Whether the Sentry test was successful */
  success: boolean;
  /** The Sentry event ID that was generated */
  sentryEventId?: string;
  /** Message about the test result */
  message: string;
  /** The configured Sentry DSN */
  sentryDsn?: string;
  /** Direct URL to view the error in Sentry (development only) */
  sentryUrl?: string;
}

export interface ResetTasksDto {
  /** Array of task IDs to reset for the user */
  taskIds?: string[];
  /** If true, reset all tasks for the user. Takes precedence over taskIds. */
  resetAll?: boolean;
}

export interface ResetTasksResponseDto {
  /** Indicates if the operation was successful */
  success: boolean;
  /** Status message */
  message: string;
  /** Number of task records reset */
  resetCount: number;
}

export interface CreateApiKeyDto {
  /** Username for the API key */
  username: string;
  /**
   * Password for the API key (will be hashed with bcrypt)
   * @minLength 8
   */
  password: string;
  /** Optional description of the API key */
  description?: string;
}

/**
 * Description of the API key
 */
export type CreateApiKeyResponseDtoDescription = { [key: string]: unknown };

export interface CreateApiKeyResponseDto {
  /** ID of the created API key */
  id: string;
  /** Username of the API key */
  username: string;
  /** Description of the API key */
  description?: CreateApiKeyResponseDtoDescription;
  /** Creation timestamp */
  createdAt: string;
  /** Success message */
  message: string;
}

export interface MarketplaceInfoDto {
  /** Marketplace ID */
  id: string;
  /** Marketplace name */
  name: string;
  /** Owner user ID */
  ownerUserId: string;
  /** Owner user first name */
  ownerFirstName: string;
  /** Owner user last name */
  ownerLastName?: string;
  /** Owner username */
  ownerUsername?: string;
  /** Whether the marketplace is active (derived from deactivatedAt being null) */
  isActive: boolean;
  /** Marketplace creation timestamp */
  createdAt: string;
  /** Marketplace last update timestamp */
  updatedAt: string;
}

/**
 * Description of the API key
 */
export type ApiKeyListItemDtoDescription = { [key: string]: unknown };

export interface ApiKeyListItemDto {
  /** ID of the API key */
  id: string;
  /** Username of the API key */
  username: string;
  /** Description of the API key */
  description?: ApiKeyListItemDtoDescription;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
  /** Associated marketplace information */
  marketplace?: MarketplaceInfoDto;
}

export interface DeleteApiKeyResponseDto {
  /** Success message */
  message: string;
  /** ID of the deleted API key */
  id: string;
}

export interface CreateMarketplaceDto {
  /** Name of the marketplace */
  name: string;
  /** UUID of the user who will own the packs */
  ownerUserId: string;
  /** Marketplace identifier (mid) */
  mid: string;
}

export interface MarketplaceResponseDto {
  /** Success status */
  success: boolean;
  /** Marketplace ID */
  marketplaceId: string;
  /** Success message */
  message: string;
}

export interface CreateNonTelegramUserDto {
  /** First name of the user */
  firstName: string;
  /** Last name of the user */
  lastName?: string;
  /** Username for the user */
  username?: string;
}

export interface NonTelegramUserResponseDto {
  /** Success status */
  success: boolean;
  /** Created user ID */
  userId: string;
  /** Success message */
  message: string;
}

export interface TeddieCollectionDto {
  /** Collection ID */
  id: string;
  /** Collection name */
  name: string;
}

export type UpdateDropStatusDtoStatus = (typeof UpdateDropStatusDtoStatus)[keyof typeof UpdateDropStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateDropStatusDtoStatus = {
  active: 'active',
  ended: 'ended',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export interface UpdateDropStatusDto {
  status: UpdateDropStatusDtoStatus;
}

export interface UpdateDropClaimAllowedDto {
  claimAllowed: boolean;
}

export interface LockDto {
  /** Lock ID */
  id: string;
  /** Drop ID */
  dropId: string;
  /** User ID */
  userId: string;
  /** Amount */
  amountLocked: string;
  /** Amount to refund */
  amountToRefund: string;
  /** Refund executed */
  refundExecuted: boolean;
}

export interface CreateDropCollectionDto {
  collectionId: string;
  totalSupply: number;
}

export interface CreateDropDto {
  name: string;
  slug: string;
  description: string;
  price: number;
  startTime: string;
  endTime: string;
  collections: CreateDropCollectionDto[];
  /**
   * Maximum number of packs a single user can lock in this drop
   * @nullable
   */
  maxPacksPerUser?: number | null;
}

export interface CreateDropWithImageDto {
  /** Drop image file */
  image?: Blob;
  request: CreateDropDto;
}

export interface UpdateDropDto {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  price?: number | null;
  /** @nullable */
  startTime?: string | null;
  /** @nullable */
  endTime?: string | null;
  /** @nullable */
  collections?: CreateDropCollectionDto[] | null;
}

export interface UpdateDropWithImageDto {
  /** Drop image file */
  image?: Blob;
  request: UpdateDropDto;
}

export interface BulkWhitelistDto {
  /** Array of user IDs to add or remove from whitelist */
  userIds: string[];
}

export interface BulkWhitelistResponseDto {
  /** Number of users successfully processed */
  successCount: number;
  /** Array of user IDs that were successfully processed */
  processedUserIds: string[];
  /** Success message */
  message: string;
}

export interface WhitelistUserResponseDto {
  /** Whitelist entry ID */
  id: string;
  /** Drop ID */
  dropId: string;
  /** User ID */
  userId: string;
  /** User first name */
  firstName: string;
  /**
   * User last name
   * @nullable
   */
  lastName: string | null;
  /**
   * User username
   * @nullable
   */
  username: string | null;
  /** Date when user was added to whitelist */
  createdAt: string;
}

/**
 * Minimum level required for automatic whitelist. Users with this level or higher will be automatically whitelisted. Set to null to remove the condition.
 * @minimum 0
 * @maximum 10
 * @nullable
 */
export type SetDropConditionDtoMinLevel = { [key: string]: unknown } | null;

export interface SetDropConditionDto {
  /**
   * Minimum level required for automatic whitelist. Users with this level or higher will be automatically whitelisted. Set to null to remove the condition.
   * @minimum 0
   * @maximum 10
   * @nullable
   */
  minLevel: SetDropConditionDtoMinLevel;
}

export interface SuccessResultDto {
  /** Success message describing the operation */
  message: string;
  /**
   * The ID of the created or updated entity
   * @nullable
   */
  entityId: string | null;
}

export interface DropConditionResponseDto {
  /** Unique identifier for the drop condition */
  id: string;
  /** Drop ID this condition applies to */
  dropId: string;
  /**
   * Minimum level required for automatic whitelist
   * @minimum 0
   * @maximum 10
   */
  minLevel: number;
  /** Date when condition was created */
  createdAt: string;
  /** Date when condition was last updated */
  updatedAt: string;
}

export interface WhitelistCollectionItemDto {
  /** Collection ID to add to whitelist */
  collectionId: string;
  /** Whether to require pack to be unwrapped for whitelist eligibility */
  requireUnwrapped: boolean;
}

export interface SetCollectionWhitelistDto {
  /** Array of collections and their unwrap requirements. Users who own packs from ANY of these collections will be whitelisted. */
  collections: WhitelistCollectionItemDto[];
}

export interface CollectionWhitelistItemResponseDto {
  /** Unique identifier for the whitelist collection entry */
  id: string;
  /** Drop ID this collection whitelist applies to */
  dropId: string;
  /** Collection ID that grants whitelist access */
  collectionId: string;
  /** Whether pack must be unwrapped for whitelist eligibility */
  requireUnwrapped: boolean;
  /** Date when whitelist entry was created */
  createdAt: string;
  /** Date when whitelist entry was last updated */
  updatedAt: string;
}

export interface CollectionWhitelistResponseDto {
  /** List of collections that grant whitelist access for this drop */
  collections: CollectionWhitelistItemResponseDto[];
  /** Total number of whitelisted collections */
  count: number;
}

/**
 * Maximum number of packs a single user can lock in this drop. Set to null to remove the limit.
 * @minimum 1
 * @nullable
 */
export type SetMaxPacksPerUserDtoMaxPacksPerUser = { [key: string]: unknown } | null;

export interface SetMaxPacksPerUserDto {
  /**
   * Maximum number of packs a single user can lock in this drop. Set to null to remove the limit.
   * @minimum 1
   * @nullable
   */
  maxPacksPerUser: SetMaxPacksPerUserDtoMaxPacksPerUser;
}

export interface LockDetailDto {
  /** Drop ID */
  dropId: string;
  /** Number of packs locked in this drop */
  numberOfPacks: number;
  /** Amount locked in this drop (TON) */
  amountLocked: string;
}

export interface LockExploitUserPartialDto {
  /** User ID */
  userId: string;
  /**
   * Telegram ID
   * @nullable
   */
  telegramId: string | null;
  /**
   * Username
   * @nullable
   */
  username: string | null;
  /** Wallet address */
  walletAddress: string;
  /** User experience points */
  xp: number;
  /** User luck level (0-10) */
  level: number;
  /** Luck multiplier for this level */
  luckMultiplier: number;
  /** Array of locks per drop */
  locks: LockDetailDto[];
  /** Total number of packs locked across all drops */
  totalPacks: number;
  /** Total amount locked in TON across all drops */
  totalAmountLocked: string;
}

export interface LockExploitPartialStatsDto {
  /** Total number of users analyzed */
  totalUsers: number;
}

export interface LockExploitAnalysisPartialResponseDto {
  /** List of users with locks (without balance data) */
  users: LockExploitUserPartialDto[];
  /** Statistics about the analysis */
  stats: LockExploitPartialStatsDto;
}

export interface PackParticipantUserDto {
  /** User ID */
  id: string;
  /**
   * Telegram ID
   * @nullable
   */
  telegramId: string | null;
}

export interface DropWinnerDto {
  /** User information */
  user: PackParticipantUserDto;
  /** Amount to refund to the user */
  amountToRefund: string;
  /** Array of pack IDs won by the user */
  packIds: string[];
}

export interface DropLoserDto {
  /** User information */
  user: PackParticipantUserDto;
  /** Amount to refund to the user */
  amountToRefund: string;
}

/**
 * Distribution of luck scores by range
 */
export type AllocationStatsDtoLuckScoreDistribution = { [key: string]: unknown };

export interface AllocationStatsDto {
  /** Total luck score across all participants */
  totalLuckScore: number;
  /** Average luck score */
  averageLuckScore: number;
  /** Distribution of luck scores by range */
  luckScoreDistribution: AllocationStatsDtoLuckScoreDistribution;
  /** Fairness score (percentage of participants who won) */
  fairnessScore: number;
}

export interface WhitelistBreakdownDto {
  /** User IDs manually added to the whitelist */
  manualWhitelist: string[];
  /** User IDs whitelisted by meeting level conditions */
  conditionWhitelist: string[];
  /** User IDs whitelisted by having treasury transactions */
  treasuryWhitelist: string[];
  /** User IDs whitelisted by owning packs from whitelisted collections */
  collectionWhitelist: string[];
}

export interface AllocationResultDto {
  /** Drop ID */
  dropId: string;
  /** Total number of participants */
  totalParticipants: number;
  /** List of winners */
  winners: DropWinnerDto[];
  /** List of losers */
  losers: DropLoserDto[];
  /** Total packs distributed */
  totalPacksDistributed: number;
  /** Allocation statistics */
  allocationStats: AllocationStatsDto;
  /** Breakdown of whitelisted users by whitelist type */
  whitelistBreakdown?: WhitelistBreakdownDto;
}

/**
 * Additional metadata
 */
export type NftAuditResponseDtoMetadata = { [key: string]: unknown };

export interface NftAuditResponseDto {
  /** Audit record ID */
  id: string;
  /** User ID */
  userId: string;
  /** Pack ID */
  packId: string;
  /** Action performed */
  action: string;
  /** Request ID */
  requestId?: string;
  /** Queue Job ID */
  queueJobId?: string;
  /** NFT Address */
  nftAddress?: string;
  /** NFT Type */
  nftType?: string;
  /** Collection ID */
  collectionId?: string;
  /** Transaction Hash */
  transactionHash?: string;
  /** Transaction Sequence Number */
  transactionSeqno?: string;
  /** Transaction Amount */
  transactionAmount?: string;
  /** Status */
  status?: string;
  /** Error Message */
  errorMessage?: string;
  /** Processing Time in Milliseconds */
  processingTimeMs?: string;
  /** Additional metadata */
  metadata?: NftAuditResponseDtoMetadata;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
}

/**
 * Transaction type
 */
export type NftTransactionDtoType = (typeof NftTransactionDtoType)[keyof typeof NftTransactionDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NftTransactionDtoType = {
  burn: 'burn',
  mint: 'mint',
  withdraw_nft: 'withdraw_nft',
} as const;

/**
 * Transaction status
 */
export type NftTransactionDtoStatus = (typeof NftTransactionDtoStatus)[keyof typeof NftTransactionDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NftTransactionDtoStatus = {
  confirmed: 'confirmed',
  failed: 'failed',
  not_landed: 'not_landed',
  pending: 'pending',
  ready_for_send: 'ready_for_send',
  requested: 'requested',
  sent_to_queue: 'sent_to_queue',
} as const;

/**
 * GetGems request ID
 */
export type NftTransactionDtoGetgemsRequestId = { [key: string]: unknown };

/**
 * GetGems collection ID
 */
export type NftTransactionDtoGetgemsCollectionId = { [key: string]: unknown };

/**
 * GetGems request address
 */
export type NftTransactionDtoGetgemsRequestAddress = { [key: string]: unknown };

/**
 * GetGems request payload
 */
export type NftTransactionDtoGetgemsRequestPayload = { [key: string]: unknown };

/**
 * GetGems request amount
 */
export type NftTransactionDtoGetgemsRequestAmount = { [key: string]: unknown };

/**
 * Collection ID
 */
export type NftTransactionDtoCollectionId = { [key: string]: unknown };

/**
 * Transaction hash
 */
export type NftTransactionDtoTxHash = { [key: string]: unknown };

/**
 * Sequence number
 */
export type NftTransactionDtoSeqno = { [key: string]: unknown };

/**
 * Transaction amount
 */
export type NftTransactionDtoAmount = { [key: string]: unknown };

/**
 * Transaction address
 */
export type NftTransactionDtoTxAddress = { [key: string]: unknown };

/**
 * Transaction payload
 */
export type NftTransactionDtoTxPayload = { [key: string]: unknown };

/**
 * NFT address
 */
export type NftTransactionDtoNftAddress = { [key: string]: unknown };

/**
 * NFT type
 */
export type NftTransactionDtoNftType = (typeof NftTransactionDtoNftType)[keyof typeof NftTransactionDtoNftType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NftTransactionDtoNftType = {
  BLINDBOX: 'BLINDBOX',
  COLLECTION: 'COLLECTION',
} as const;

/**
 * Recipient address for withdraw operations
 */
export type NftTransactionDtoToAddress = { [key: string]: unknown };

export interface NftTransactionDto {
  /** Transaction ID */
  id: string;
  /** User ID */
  userId: string;
  /** Pack ID */
  packId?: string;
  /** External NFT ID */
  externalNftId?: string;
  /** Transaction type */
  type: NftTransactionDtoType;
  /** Transaction status */
  status: NftTransactionDtoStatus;
  /** GetGems request ID */
  getgemsRequestId?: NftTransactionDtoGetgemsRequestId;
  /** GetGems collection ID */
  getgemsCollectionId?: NftTransactionDtoGetgemsCollectionId;
  /** GetGems request address */
  getgemsRequestAddress?: NftTransactionDtoGetgemsRequestAddress;
  /** GetGems request payload */
  getgemsRequestPayload?: NftTransactionDtoGetgemsRequestPayload;
  /** GetGems request amount */
  getgemsRequestAmount?: NftTransactionDtoGetgemsRequestAmount;
  /** Collection ID */
  collectionId?: NftTransactionDtoCollectionId;
  /** Transaction hash */
  txHash?: NftTransactionDtoTxHash;
  /** Sequence number */
  seqno?: NftTransactionDtoSeqno;
  /** Transaction amount */
  amount?: NftTransactionDtoAmount;
  /** Transaction address */
  txAddress?: NftTransactionDtoTxAddress;
  /** Transaction payload */
  txPayload?: NftTransactionDtoTxPayload;
  /** NFT address */
  nftAddress?: NftTransactionDtoNftAddress;
  /** NFT type */
  nftType?: NftTransactionDtoNftType;
  /** Recipient address for withdraw operations */
  toAddress?: NftTransactionDtoToAddress;
  /** Creation timestamp */
  createdAt?: string;
  /** Last update timestamp */
  updatedAt?: string;
  /**
   * Confirmation timestamp
   * @nullable
   */
  confirmedAt?: string | null;
}

/**
 * Filter by action type
 */
export type SaleAuditFiltersDtoAction = (typeof SaleAuditFiltersDtoAction)[keyof typeof SaleAuditFiltersDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SaleAuditFiltersDtoAction = {
  PURCHASE_CREATED: 'PURCHASE_CREATED',
  INVOICE_CREATED: 'INVOICE_CREATED',
  INVOICE_CANCELLED: 'INVOICE_CANCELLED',
  PAYMENT_PRE_CHECKOUT_VALIDATED: 'PAYMENT_PRE_CHECKOUT_VALIDATED',
  PAYMENT_PRE_CHECKOUT_FAILED: 'PAYMENT_PRE_CHECKOUT_FAILED',
  PAYMENT_COMPLETED: 'PAYMENT_COMPLETED',
  PACKS_ASSIGNMENT_STARTED: 'PACKS_ASSIGNMENT_STARTED',
  PACKS_ASSIGNMENT_COMPLETED: 'PACKS_ASSIGNMENT_COMPLETED',
  PACKS_ASSIGNMENT_FAILED: 'PACKS_ASSIGNMENT_FAILED',
  PURCHASE_COMPLETED: 'PURCHASE_COMPLETED',
  PURCHASE_FAILED: 'PURCHASE_FAILED',
  STOCK_DECREMENTED: 'STOCK_DECREMENTED',
} as const;

export interface SaleAuditFiltersDto {
  /** Filter by user ID */
  userId?: string;
  /** Filter by purchase ID */
  purchaseId?: string;
  /** Filter by offer ID */
  directSaleOfferId?: string;
  /** Filter by purchase ID */
  directSalePurchaseId?: string;
  /** Filter by invoice ID */
  invoiceId?: string;
  /** Filter by action type */
  action?: SaleAuditFiltersDtoAction;
  /**
   * Limit number of results
   * @minimum 1
   * @maximum 200
   */
  limit?: number;
}

/**
 * Additional metadata
 */
export type SaleAuditResponseDtoMetadata = { [key: string]: unknown };

export interface SaleAuditResponseDto {
  /** Audit record ID */
  id: string;
  /** User ID */
  userId: string;
  /** Direct sale purchase ID */
  directSalePurchaseId?: string;
  /** Direct sale offer ID */
  directSaleOfferId?: string;
  /** Payment ID */
  paymentId?: string;
  /** Action performed */
  action: string;
  /** Number of packs */
  packsCount?: number;
  /** Total price in stars */
  totalStarPrice?: string;
  /** Total price in TON */
  totalTonPrice?: string;
  /** Purchase status */
  purchaseStatus?: string;
  /** Invoice ID */
  invoiceId?: string;
  /** Invoice URL */
  invoiceUrl?: string;
  /** Payment status */
  paymentStatus?: string;
  /** Telegram charge ID */
  telegramChargeId?: string;
  /** Error message */
  errorMessage?: string;
  /** Error code */
  errorCode?: string;
  /** Additional metadata */
  metadata?: SaleAuditResponseDtoMetadata;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
}

/**
 * User Telegram ID
 * @nullable
 */
export type PaymentSearchResultDtoUserTelegramId = { [key: string]: unknown } | null;

/**
 * User first name
 * @nullable
 */
export type PaymentSearchResultDtoUserFirstName = { [key: string]: unknown } | null;

/**
 * User last name
 * @nullable
 */
export type PaymentSearchResultDtoUserLastName = { [key: string]: unknown } | null;

/**
 * Purchase ID
 * @nullable
 */
export type PaymentSearchResultDtoPurchaseId = { [key: string]: unknown } | null;

/**
 * Offer ID
 * @nullable
 */
export type PaymentSearchResultDtoOfferId = { [key: string]: unknown } | null;

/**
 * Offer title
 * @nullable
 */
export type PaymentSearchResultDtoOfferTitle = { [key: string]: unknown } | null;

/**
 * Telegram charge ID
 * @nullable
 */
export type PaymentSearchResultDtoTelegramChargeId = { [key: string]: unknown } | null;

/**
 * Number of packs in purchase
 * @nullable
 */
export type PaymentSearchResultDtoPacksCount = { [key: string]: unknown } | null;

/**
 * Purchase status
 * @nullable
 */
export type PaymentSearchResultDtoPurchaseStatus = { [key: string]: unknown } | null;

/**
 * Payment completed at timestamp
 * @nullable
 */
export type PaymentSearchResultDtoCompletedAt = { [key: string]: unknown } | null;

/**
 * Payment refunded at timestamp
 * @nullable
 */
export type PaymentSearchResultDtoRefundedAt = { [key: string]: unknown } | null;

/**
 * Refund reason
 * @nullable
 */
export type PaymentSearchResultDtoRefundReason = { [key: string]: unknown } | null;

/**
 * Who initiated the refund
 * @nullable
 */
export type PaymentSearchResultDtoRefundedBy = { [key: string]: unknown } | null;

export interface PaymentSearchResultDto {
  /** Payment ID */
  paymentId: string;
  /** User ID */
  userId: string;
  /**
   * User Telegram ID
   * @nullable
   */
  userTelegramId: PaymentSearchResultDtoUserTelegramId;
  /**
   * User first name
   * @nullable
   */
  userFirstName: PaymentSearchResultDtoUserFirstName;
  /**
   * User last name
   * @nullable
   */
  userLastName: PaymentSearchResultDtoUserLastName;
  /**
   * Purchase ID
   * @nullable
   */
  purchaseId: PaymentSearchResultDtoPurchaseId;
  /**
   * Offer ID
   * @nullable
   */
  offerId: PaymentSearchResultDtoOfferId;
  /**
   * Offer title
   * @nullable
   */
  offerTitle: PaymentSearchResultDtoOfferTitle;
  /** Invoice ID */
  invoiceId: string;
  /** Payment amount */
  amount: string;
  /** Currency code */
  currency: string;
  /** Payment title */
  title: string;
  /** Payment description */
  description: string;
  /** Payment status */
  status: string;
  /**
   * Telegram charge ID
   * @nullable
   */
  telegramChargeId: PaymentSearchResultDtoTelegramChargeId;
  /**
   * Number of packs in purchase
   * @nullable
   */
  packsCount: PaymentSearchResultDtoPacksCount;
  /**
   * Purchase status
   * @nullable
   */
  purchaseStatus: PaymentSearchResultDtoPurchaseStatus;
  /** Payment created at timestamp */
  createdAt: string;
  /**
   * Payment completed at timestamp
   * @nullable
   */
  completedAt: PaymentSearchResultDtoCompletedAt;
  /**
   * Payment refunded at timestamp
   * @nullable
   */
  refundedAt: PaymentSearchResultDtoRefundedAt;
  /**
   * Refund reason
   * @nullable
   */
  refundReason: PaymentSearchResultDtoRefundReason;
  /**
   * Who initiated the refund
   * @nullable
   */
  refundedBy: PaymentSearchResultDtoRefundedBy;
}

export interface SearchPaymentsResponseDto {
  /** List of payments */
  items: PaymentSearchResultDto[];
  /** Total number of payments matching filters */
  total: number;
  /** Current page number */
  page: number;
  /** Number of items per page */
  limit: number;
  /** Total number of pages */
  totalPages: number;
}

/**
 * Completed at timestamp
 * @nullable
 */
export type PurchaseInfoDtoCompletedAt = { [key: string]: unknown } | null;

export interface PurchaseInfoDto {
  /** Purchase ID */
  id: string;
  /** Number of packs */
  packsCount: number;
  /**
   * Total price in Stars
   * @nullable
   */
  totalStarPrice: string | null;
  /**
   * Total price in TON
   * @nullable
   */
  totalTonPrice: string | null;
  /** Purchase status */
  status: string;
  /** Created at timestamp */
  createdAt: string;
  /**
   * Completed at timestamp
   * @nullable
   */
  completedAt: PurchaseInfoDtoCompletedAt;
}

export interface OfferInfoDto {
  /** Offer ID */
  id: string;
  /** Collection ID */
  collectionId: string;
  /** Offer title */
  title: string;
  /**
   * Offer description
   * @nullable
   */
  description: string | null;
  /**
   * Star price per pack
   * @nullable
   */
  starPricePerPack: string | null;
  /**
   * TON price per pack
   * @nullable
   */
  tonPricePerPack: string | null;
  /** Offer status */
  status: string;
}

/**
 * Telegram sticker set name
 * @nullable
 */
export type PackInfoDtoTelegramStickerSetName = { [key: string]: unknown } | null;

export interface PackInfoDto {
  /** Pack ID */
  id: string;
  /** Pack number in collection */
  numberInCollection: string;
  /**
   * Telegram sticker set name
   * @nullable
   */
  telegramStickerSetName: PackInfoDtoTelegramStickerSetName;
  /** Pack status */
  stickerPackStatus: string;
}

/**
 * Telegram charge ID
 * @nullable
 */
export type PaymentDetailResponseDtoTelegramChargeId = { [key: string]: unknown } | null;

/**
 * Provider payment charge ID
 * @nullable
 */
export type PaymentDetailResponseDtoProviderPaymentChargeId = { [key: string]: unknown } | null;

/**
 * Completed at timestamp
 * @nullable
 */
export type PaymentDetailResponseDtoCompletedAt = { [key: string]: unknown } | null;

/**
 * Refunded at timestamp
 * @nullable
 */
export type PaymentDetailResponseDtoRefundedAt = { [key: string]: unknown } | null;

/**
 * Refund reason
 * @nullable
 */
export type PaymentDetailResponseDtoRefundReason = { [key: string]: unknown } | null;

/**
 * Who initiated the refund
 * @nullable
 */
export type PaymentDetailResponseDtoRefundedBy = { [key: string]: unknown } | null;

/**
 * Purchase information
 * @nullable
 */
export type PaymentDetailResponseDtoPurchase = PurchaseInfoDto | null;

/**
 * Offer information
 * @nullable
 */
export type PaymentDetailResponseDtoOffer = OfferInfoDto | null;

export interface PaymentDetailResponseDto {
  /** Payment ID */
  id: string;
  /** User ID */
  userId: string;
  /** Invoice ID */
  invoiceId: string;
  /** Payment amount */
  amount: string;
  /** Currency code */
  currency: string;
  /** Payment title */
  title: string;
  /** Payment description */
  description: string;
  /** Payment status */
  status: string;
  /**
   * Telegram charge ID
   * @nullable
   */
  telegramChargeId: PaymentDetailResponseDtoTelegramChargeId;
  /**
   * Provider payment charge ID
   * @nullable
   */
  providerPaymentChargeId: PaymentDetailResponseDtoProviderPaymentChargeId;
  /** Created at timestamp */
  createdAt: string;
  /**
   * Completed at timestamp
   * @nullable
   */
  completedAt: PaymentDetailResponseDtoCompletedAt;
  /**
   * Refunded at timestamp
   * @nullable
   */
  refundedAt: PaymentDetailResponseDtoRefundedAt;
  /**
   * Refund reason
   * @nullable
   */
  refundReason: PaymentDetailResponseDtoRefundReason;
  /**
   * Who initiated the refund
   * @nullable
   */
  refundedBy: PaymentDetailResponseDtoRefundedBy;
  /** User information */
  user: UserInfoDto;
  /**
   * Purchase information
   * @nullable
   */
  purchase: PaymentDetailResponseDtoPurchase;
  /**
   * Offer information
   * @nullable
   */
  offer: PaymentDetailResponseDtoOffer;
  /** Associated packs */
  packs: PackInfoDto[];
  /** Audit trail */
  auditTrail: SaleAuditResponseDto[];
}

export interface ManualRefundRequestDto {
  /**
   * Reason for the refund
   * @minLength 10
   * @maxLength 500
   */
  reason: string;
}

export interface RefundResponseDto {
  /** Payment ID that was refunded */
  paymentId: string;
  /** Refund reason */
  reason: string;
  /** Who initiated the refund */
  refundedBy: string;
  /** Timestamp when refund was processed */
  refundedAt: string;
  /** Success message */
  message: string;
}

export interface CreateGetGemsCollectionDto {
  /** Our collection UUID */
  ourCollectionId: string;
  /** GetGems collection ID (must start with a letter) */
  getgemsCollectionId: string;
  /** Royalty percent for secondary sales (0-50) */
  royaltyPercent: number;
  /** Royalty treasury TON address */
  royaltyAddress?: string;
  /** Collection image URL */
  collectionImage?: string;
  /** Collection cover image URL */
  collectionCoverImage?: string;
  /** Collection description */
  collectionDescription?: string;
  /** Collection social links */
  socialLinks?: string[];
  /** NFT description */
  nftDescription?: string;
  /** Total free supply */
  totalSupply?: number;
}

/**
 * Minting status mirror from GetGems
 */
export type CreateGetGemsCollectionResponseDtoMintingStatus = { [key: string]: unknown };

export interface CreateGetGemsCollectionResponseDto {
  getgemsCollectionId: string;
  ourCollectionId: string;
  /** Minting status mirror from GetGems */
  mintingStatus: CreateGetGemsCollectionResponseDtoMintingStatus;
}

export interface UpdateGetGemsCollectionDto {
  /** New total amount (optional) */
  totalAmount?: number;
  /** Royalty percent (0-50) */
  royaltyPercent?: number;
  /** Royalty treasury TON address */
  royaltyAddress?: string;
  collectionName?: string;
  collectionDescription?: string;
  collectionImage?: string;
  collectionCoverImage?: string;
  socialLinks?: string[];
}

export interface SearchTopHoldersCollectionRequest {
  collectionId: string;
  holderCount: number;
}

export interface SearchTopHoldersRequest {
  collections: SearchTopHoldersCollectionRequest[];
}

export interface SearchTopHoldersResponseItem {
  telegramId: string;
  packCount: number;
  userId: string;
}

export interface SearchTopHoldersResponse {
  items: SearchTopHoldersResponseItem[];
}

export interface GetReconciliationOverviewRequestDto {
  /** Collection ID to get reconciliation overview for */
  collectionId: string;
}

export interface TelegramTransactionDto {
  /** Telegram transaction ID */
  telegramTransactionId: string;
  /** Star amount for this transaction */
  amount: number;
  /** Transaction date (unix timestamp) */
  date: number;
  /** Invoice payload (purchaseId) from the transaction */
  invoicePayload: string;
}

/**
 * Username
 * @nullable
 */
export type UserDiscrepancyDtoUsername = { [key: string]: unknown } | null;

export interface UserDiscrepancyDto {
  /** Internal user ID */
  userId: string;
  /** Telegram user ID */
  telegramId: string;
  /**
   * Username
   * @nullable
   */
  username: UserDiscrepancyDtoUsername;
  /** First name */
  firstName: string;
  /** Total stars paid according to Telegram API */
  telegramStarsPaid: number;
  /** Expected packs based on stars paid and price per pack */
  expectedPacks: number;
  /** Packs currently owned by user */
  packsOwned: number;
  /** Number of packs missing (expectedPacks - packsOwned) */
  discrepancy: number;
  /** Matched Telegram transactions for this user */
  telegramTransactions: TelegramTransactionDto[];
}

export interface GetReconciliationOverviewResponseDto {
  /** Collection ID */
  collectionId: string;
  /** Collection name */
  collectionName: string;
  /** Star price per pack used for calculation */
  starPricePerPack: string;
  /** Total users with discrepancy (paid but missing packs) */
  totalUsersWithDiscrepancy: number;
  /** Users with discrepancy details */
  users: UserDiscrepancyDto[];
}

export interface ManualDeliverPacksRequestDto {
  /** Collection ID to deliver packs from */
  collectionId: string;
  /** User ID to deliver packs to */
  userId: string;
  /**
   * Number of packs to deliver to this user
   * @minimum 1
   */
  packCount: number;
  /** Reason for manual delivery (for audit purposes) */
  reason?: string;
}

/**
 * Error message if delivery failed
 * @nullable
 */
export type UserDeliveryResultDtoError = { [key: string]: unknown } | null;

export interface UserDeliveryResultDto {
  /** User ID */
  userId: string;
  /** Number of packs requested for delivery */
  packsRequested: number;
  /** Number of packs successfully delivered */
  packsDelivered: number;
  /** IDs of delivered packs */
  deliveredPackIds: string[];
  /** Number of packs that were auto-generated */
  packsGenerated: number;
  /** Success status */
  success: boolean;
  /**
   * Error message if delivery failed
   * @nullable
   */
  error: UserDeliveryResultDtoError;
}

export interface GetTelegramStarTransactionsRequestDto {
  /** Offset for pagination (number of transactions to skip) */
  offset?: number;
  /**
   * Maximum number of transactions to return per page
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
}

export interface TelegramUserDto {
  /** Telegram user ID */
  id: number;
  /** Whether the user is a bot */
  is_bot: boolean;
  /** User first name */
  first_name: string;
  /** Username */
  username?: string;
}

export interface TransactionSourceDto {
  /** Source type (e.g., "user", "fragment", etc.) */
  type: string;
  /** User information if source type is "user" */
  user?: TelegramUserDto;
  /** Invoice payload (purchase ID) if available */
  invoice_payload?: string;
}

export interface StarTransactionDto {
  /** Unique transaction identifier */
  id: string;
  /** Amount of Telegram Stars */
  amount: number;
  /** Transaction date (Unix timestamp) */
  date: number;
  /** Transaction source information */
  source?: TransactionSourceDto;
}

export interface GetTelegramStarTransactionsResponseDto {
  /** Array of star transactions */
  transactions: StarTransactionDto[];
  /** Offset used for this request */
  offset: number;
  /** Limit used for this request */
  limit: number;
  /** Total number of transactions returned */
  count: number;
  /** Whether there are more transactions available */
  hasMore: boolean;
}

export interface BroadcastButtonDto {
  /** Button label text */
  text: string;
  /** Mini App path to open when clicked */
  miniAppPath: string;
}

export interface BroadcastMessageDto {
  /** HTML-formatted message body. Supported tags: <b>, <i>, <u>, <s>, <a href="url">, <code>, <pre>, <tg-spoiler>. Use \n for newlines. */
  message: string;
  /** Optional HTML-formatted description shown above the message (same formatting rules). When an image is attached, description + message are combined into the photo caption. */
  description?: string;
  /** Inline buttons to attach to the message */
  buttons?: BroadcastButtonDto[];
}

export interface BroadcastMessageWithImageDto {
  /** Optional media file. Photos: JPG, PNG, WebP. Animations: GIF, MP4 (sent as animation). Max 20MB. */
  image?: Blob;
  request: BroadcastMessageDto;
}

export interface BroadcastMessageResponseDto {
  /** Number of messages queued for delivery */
  queuedCount: number;
}

export interface CreateStickersPackDto {
  /** Pack ID to create stickers pack for */
  packId: string;
}

export interface RecreateStickersPackResponseDto {
  /** Whether the re-creation job was successfully added to queue */
  success: boolean;
  /** Response message */
  message: string;
}

export interface RateLimitStickersResponseDto {
  /** Error message */
  message: string;
  /** Seconds remaining until next re-create is allowed */
  secondsRemaining: number;
}

export interface UploadStickerMultipartDto {
  name: string;
  emojis?: string[];
  collectionId: string;
  /** Sticker image file (.tgs or .webp) */
  file: Blob;
}

export interface UploadStickerResponseDto {
  success: boolean;
  url: string;
  fileName: string;
  size: number;
  mimeType: string;
}

/**
 * Image object-fit style
 */
export type BrandDtoImagePosition = (typeof BrandDtoImagePosition)[keyof typeof BrandDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface BrandDto {
  id: string;
  name: string;
  /** @nullable */
  description: string | null;
  /** @nullable */
  image: string | null;
  /** Image object-fit style */
  imagePosition: BrandDtoImagePosition;
  /** @nullable */
  coverImage: string | null;
  /** @nullable */
  url: string | null;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured: number;
}

export interface BrandListResponseDto {
  /** Array of brand items */
  data: BrandDto[];
  /** Pagination metadata */
  meta: PaginationMetaDto;
}

/**
 * Image object-fit style
 */
export type CreateBrandDtoImagePosition =
  (typeof CreateBrandDtoImagePosition)[keyof typeof CreateBrandDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateBrandDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface CreateBrandDto {
  name: string;
  description: string;
  url?: string;
  /** Image object-fit style */
  imagePosition?: CreateBrandDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured?: number;
}

export interface CreateBrandWithImageDto {
  /** Brand image file */
  image: Blob;
  /** Brand cover image file */
  coverImage?: Blob;
  request: CreateBrandDto;
}

/**
 * Image object-fit style
 */
export type UpdateBrandDtoImagePosition =
  (typeof UpdateBrandDtoImagePosition)[keyof typeof UpdateBrandDtoImagePosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateBrandDtoImagePosition = {
  cover: 'cover',
  contain: 'contain',
} as const;

export interface UpdateBrandDto {
  name?: string;
  description?: string;
  url?: string;
  /** Image object-fit style */
  imagePosition?: UpdateBrandDtoImagePosition;
  /** Featured priority (0 = not featured, higher = more prominent) */
  featured?: number;
}

export interface UpdateBrandWithImageDto {
  /** Brand image file */
  image?: Blob;
  /** Brand cover image file */
  coverImage?: Blob;
  request: UpdateBrandDto;
}

/**
 * Service status
 */
export type ServiceStatusDtoStatus = (typeof ServiceStatusDtoStatus)[keyof typeof ServiceStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceStatusDtoStatus = {
  ok: 'ok',
  timeout: 'timeout',
  error: 'error',
} as const;

export interface ServiceStatusDto {
  /** Service status */
  status: ServiceStatusDtoStatus;
  /** Response time in milliseconds */
  responseTime?: number;
  /** Error message if status is error */
  error?: string;
}

/**
 * Overall health status
 */
export type MetricsHealthDtoStatus = (typeof MetricsHealthDtoStatus)[keyof typeof MetricsHealthDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MetricsHealthDtoStatus = {
  healthy: 'healthy',
  unhealthy: 'unhealthy',
} as const;

export interface MetricsHealthDto {
  /** Overall health status */
  status: MetricsHealthDtoStatus;
  /** Health check timestamp */
  timestamp: string;
  /** Database health status */
  database: ServiceStatusDto;
  /** Redis health status */
  redis: ServiceStatusDto;
}

/**
 * Description of the OAuth client application
 * @nullable
 */
export type AuthorizeClientInfoResponseDtoDescription = { [key: string]: unknown } | null;

/**
 * Icon URL of the OAuth client application
 * @nullable
 */
export type AuthorizeClientInfoResponseDtoIconUrl = { [key: string]: unknown } | null;

export interface AuthorizeClientInfoResponseDto {
  /** Name of the OAuth client application */
  name: string;
  /**
   * Description of the OAuth client application
   * @nullable
   */
  description?: AuthorizeClientInfoResponseDtoDescription;
  /**
   * Icon URL of the OAuth client application
   * @nullable
   */
  iconUrl?: AuthorizeClientInfoResponseDtoIconUrl;
}

export interface AuthorizeRequestDto {
  /** Public client ID of the OAuth application */
  clientId: string;
  /** Redirect URI to send the authorization code to */
  redirectUri: string;
  /** Opaque state value from the third party */
  state?: string;
}

/**
 * State value passed by the third party
 * @nullable
 */
export type AuthorizeCodeResponseDtoState = { [key: string]: unknown } | null;

export interface AuthorizeCodeResponseDto {
  /** Authorization code to be exchanged for tokens */
  code: string;
  /**
   * State value passed by the third party
   * @nullable
   */
  state?: AuthorizeCodeResponseDtoState;
}

/**
 * Grant type: "authorization_code" or "refresh_token"
 */
export type TokenRequestDtoGrantType = (typeof TokenRequestDtoGrantType)[keyof typeof TokenRequestDtoGrantType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TokenRequestDtoGrantType = {
  authorization_code: 'authorization_code',
  refresh_token: 'refresh_token',
} as const;

export interface TokenRequestDto {
  /** Grant type: "authorization_code" or "refresh_token" */
  grantType: TokenRequestDtoGrantType;
  /** Authorization code (required for authorization_code grant) */
  code?: string;
  /** Public client ID */
  clientId: string;
  /** Client secret */
  clientSecret: string;
  /** Redirect URI (required for authorization_code grant, must match the one used during authorization) */
  redirectUri?: string;
  /** Refresh token (required for refresh_token grant) */
  refreshToken?: string;
}

export interface TokenResponseDto {
  /** JWT access token */
  accessToken: string;
  /** Token type */
  tokenType: string;
  /** Access token expiration time in seconds */
  expiresIn: number;
  /** Refresh token for obtaining new access tokens */
  refreshToken: string;
}

export interface CreateOauthClientDto {
  /** Name of the OAuth client application */
  name: string;
  /** Description of the OAuth client application */
  description?: string;
  /** Allowed redirect URIs for the OAuth client */
  redirectUris: string[];
  /** Icon URL for the OAuth client application */
  iconUrl?: string;
}

export interface CreateOauthClientResponseDto {
  /** Internal ID of the OAuth client */
  id: string;
  /** Public client ID used in OAuth flows */
  clientId: string;
  /** Client secret (only shown once, store it securely) */
  clientSecret: string;
  /** Name of the OAuth client */
  name: string;
  /** Allowed redirect URIs */
  redirectUris: string[];
  /** Creation timestamp */
  createdAt: string;
}

/**
 * Description of the OAuth client
 * @nullable
 */
export type OauthClientListItemDtoDescription = { [key: string]: unknown } | null;

/**
 * Icon URL
 * @nullable
 */
export type OauthClientListItemDtoIconUrl = { [key: string]: unknown } | null;

export interface OauthClientListItemDto {
  /** Internal ID of the OAuth client */
  id: string;
  /** Public client ID */
  clientId: string;
  /** Name of the OAuth client */
  name: string;
  /**
   * Description of the OAuth client
   * @nullable
   */
  description?: OauthClientListItemDtoDescription;
  /** Allowed redirect URIs */
  redirectUris: string[];
  /**
   * Icon URL
   * @nullable
   */
  iconUrl?: OauthClientListItemDtoIconUrl;
  /** Creation timestamp */
  createdAt: string;
}

/**
 * @nullable
 */
export type PromoCampaignListItemDtoDescription = { [key: string]: unknown } | null;

export type PromoCampaignListItemDtoType =
  (typeof PromoCampaignListItemDtoType)[keyof typeof PromoCampaignListItemDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignListItemDtoType = {
  unique: 'unique',
  universal: 'universal',
} as const;

/**
 * @nullable
 */
export type PromoCampaignListItemDtoUniversalCode = { [key: string]: unknown } | null;

export type PromoCampaignListItemDtoStatus =
  (typeof PromoCampaignListItemDtoStatus)[keyof typeof PromoCampaignListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignListItemDtoStatus = {
  active: 'active',
  paused: 'paused',
  exhausted: 'exhausted',
  ended: 'ended',
} as const;

export type PromoCampaignListItemDtoEffectiveStatus =
  (typeof PromoCampaignListItemDtoEffectiveStatus)[keyof typeof PromoCampaignListItemDtoEffectiveStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignListItemDtoEffectiveStatus = {
  active: 'active',
  ended: 'ended',
  exhausted: 'exhausted',
  expired: 'expired',
  paused: 'paused',
  scheduled: 'scheduled',
} as const;

/**
 * @nullable
 */
export type PromoCampaignListItemDtoEndDate = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignListItemDtoTotalSupply = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignListItemDtoRemainingSupply = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignListItemDtoMaxClaimsPerUser = { [key: string]: unknown } | null;

export type PromoCampaignListItemDtoSupplyMode =
  (typeof PromoCampaignListItemDtoSupplyMode)[keyof typeof PromoCampaignListItemDtoSupplyMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignListItemDtoSupplyMode = {
  fixed: 'fixed',
  generate_on_claim: 'generate_on_claim',
} as const;

export interface PromoCampaignListItemDto {
  id: string;
  name: string;
  /** @nullable */
  description: PromoCampaignListItemDtoDescription;
  type: PromoCampaignListItemDtoType;
  /** @nullable */
  universalCode: PromoCampaignListItemDtoUniversalCode;
  collectionId: string;
  collectionName: string;
  status: PromoCampaignListItemDtoStatus;
  effectiveStatus: PromoCampaignListItemDtoEffectiveStatus;
  startDate: string;
  /** @nullable */
  endDate: PromoCampaignListItemDtoEndDate;
  /** @nullable */
  totalSupply: PromoCampaignListItemDtoTotalSupply;
  claimedSupply: number;
  /** @nullable */
  remainingSupply: PromoCampaignListItemDtoRemainingSupply;
  /** @nullable */
  maxClaimsPerUser: PromoCampaignListItemDtoMaxClaimsPerUser;
  supplyMode: PromoCampaignListItemDtoSupplyMode;
  createdAt: string;
  updatedAt: string;
}

export type CreatePromoCampaignDtoType = (typeof CreatePromoCampaignDtoType)[keyof typeof CreatePromoCampaignDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePromoCampaignDtoType = {
  unique: 'unique',
  universal: 'universal',
} as const;

/**
 * @nullable
 */
export type CreatePromoCampaignDtoMaxClaimsPerUser = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type CreatePromoCampaignDtoTotalSupply = { [key: string]: unknown } | null;

/**
 * 'fixed' reserves N packs from collection (requires totalSupply). 'generate_on_claim' creates new packs on demand (totalSupply optional — null means unlimited).
 */
export type CreatePromoCampaignDtoSupplyMode =
  (typeof CreatePromoCampaignDtoSupplyMode)[keyof typeof CreatePromoCampaignDtoSupplyMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePromoCampaignDtoSupplyMode = {
  fixed: 'fixed',
  generate_on_claim: 'generate_on_claim',
} as const;

export interface CreatePromoCampaignDto {
  name: string;
  description?: string;
  type: CreatePromoCampaignDtoType;
  universalCode?: string;
  codePrefix?: string;
  codeLength?: number;
  collectionId: string;
  packsPerClaim?: number;
  /** @nullable */
  maxClaimsPerUser?: CreatePromoCampaignDtoMaxClaimsPerUser;
  /** @nullable */
  totalSupply?: CreatePromoCampaignDtoTotalSupply;
  /** 'fixed' reserves N packs from collection (requires totalSupply). 'generate_on_claim' creates new packs on demand (totalSupply optional — null means unlimited). */
  supplyMode: CreatePromoCampaignDtoSupplyMode;
  startDate: string;
  endDate?: string;
}

/**
 * @nullable
 */
export type PromoCampaignResponseDtoDescription = { [key: string]: unknown } | null;

export type PromoCampaignResponseDtoType =
  (typeof PromoCampaignResponseDtoType)[keyof typeof PromoCampaignResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignResponseDtoType = {
  unique: 'unique',
  universal: 'universal',
} as const;

/**
 * @nullable
 */
export type PromoCampaignResponseDtoUniversalCode = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignResponseDtoCodePrefix = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignResponseDtoMaxClaimsPerUser = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignResponseDtoTotalSupply = { [key: string]: unknown } | null;

export type PromoCampaignResponseDtoSupplyMode =
  (typeof PromoCampaignResponseDtoSupplyMode)[keyof typeof PromoCampaignResponseDtoSupplyMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignResponseDtoSupplyMode = {
  fixed: 'fixed',
  generate_on_claim: 'generate_on_claim',
} as const;

export type PromoCampaignResponseDtoStatus =
  (typeof PromoCampaignResponseDtoStatus)[keyof typeof PromoCampaignResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignResponseDtoStatus = {
  active: 'active',
  paused: 'paused',
  exhausted: 'exhausted',
  ended: 'ended',
} as const;

export type PromoCampaignResponseDtoEffectiveStatus =
  (typeof PromoCampaignResponseDtoEffectiveStatus)[keyof typeof PromoCampaignResponseDtoEffectiveStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignResponseDtoEffectiveStatus = {
  active: 'active',
  ended: 'ended',
  exhausted: 'exhausted',
  expired: 'expired',
  paused: 'paused',
  scheduled: 'scheduled',
} as const;

/**
 * @nullable
 */
export type PromoCampaignResponseDtoEndDate = { [key: string]: unknown } | null;

export interface PromoCampaignResponseDto {
  id: string;
  name: string;
  /** @nullable */
  description: PromoCampaignResponseDtoDescription;
  type: PromoCampaignResponseDtoType;
  /** @nullable */
  universalCode: PromoCampaignResponseDtoUniversalCode;
  /** @nullable */
  codePrefix: PromoCampaignResponseDtoCodePrefix;
  codeLength: number;
  collectionId: string;
  packsPerClaim: number;
  /** @nullable */
  maxClaimsPerUser: PromoCampaignResponseDtoMaxClaimsPerUser;
  /** @nullable */
  totalSupply: PromoCampaignResponseDtoTotalSupply;
  claimedSupply: number;
  supplyMode: PromoCampaignResponseDtoSupplyMode;
  status: PromoCampaignResponseDtoStatus;
  effectiveStatus: PromoCampaignResponseDtoEffectiveStatus;
  startDate: string;
  /** @nullable */
  endDate: PromoCampaignResponseDtoEndDate;
  createdAt: string;
  updatedAt: string;
}

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoDescription = { [key: string]: unknown } | null;

export type PromoCampaignDetailResponseDtoType =
  (typeof PromoCampaignDetailResponseDtoType)[keyof typeof PromoCampaignDetailResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignDetailResponseDtoType = {
  unique: 'unique',
  universal: 'universal',
} as const;

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoUniversalCode = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoCodePrefix = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoMaxClaimsPerUser = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoTotalSupply = { [key: string]: unknown } | null;

export type PromoCampaignDetailResponseDtoSupplyMode =
  (typeof PromoCampaignDetailResponseDtoSupplyMode)[keyof typeof PromoCampaignDetailResponseDtoSupplyMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignDetailResponseDtoSupplyMode = {
  fixed: 'fixed',
  generate_on_claim: 'generate_on_claim',
} as const;

export type PromoCampaignDetailResponseDtoStatus =
  (typeof PromoCampaignDetailResponseDtoStatus)[keyof typeof PromoCampaignDetailResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignDetailResponseDtoStatus = {
  active: 'active',
  paused: 'paused',
  exhausted: 'exhausted',
  ended: 'ended',
} as const;

export type PromoCampaignDetailResponseDtoEffectiveStatus =
  (typeof PromoCampaignDetailResponseDtoEffectiveStatus)[keyof typeof PromoCampaignDetailResponseDtoEffectiveStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCampaignDetailResponseDtoEffectiveStatus = {
  active: 'active',
  ended: 'ended',
  exhausted: 'exhausted',
  expired: 'expired',
  paused: 'paused',
  scheduled: 'scheduled',
} as const;

/**
 * @nullable
 */
export type PromoCampaignDetailResponseDtoEndDate = { [key: string]: unknown } | null;

/**
 * Remaining supply (totalSupply - claimedSupply) or null
 * @nullable
 */
export type PromoCampaignDetailResponseDtoRemainingSupply = { [key: string]: unknown } | null;

export interface PromoCampaignDetailResponseDto {
  id: string;
  name: string;
  /** @nullable */
  description: PromoCampaignDetailResponseDtoDescription;
  type: PromoCampaignDetailResponseDtoType;
  /** @nullable */
  universalCode: PromoCampaignDetailResponseDtoUniversalCode;
  /** @nullable */
  codePrefix: PromoCampaignDetailResponseDtoCodePrefix;
  codeLength: number;
  collectionId: string;
  packsPerClaim: number;
  /** @nullable */
  maxClaimsPerUser: PromoCampaignDetailResponseDtoMaxClaimsPerUser;
  /** @nullable */
  totalSupply: PromoCampaignDetailResponseDtoTotalSupply;
  claimedSupply: number;
  supplyMode: PromoCampaignDetailResponseDtoSupplyMode;
  status: PromoCampaignDetailResponseDtoStatus;
  effectiveStatus: PromoCampaignDetailResponseDtoEffectiveStatus;
  startDate: string;
  /** @nullable */
  endDate: PromoCampaignDetailResponseDtoEndDate;
  createdAt: string;
  updatedAt: string;
  /** Total promo codes generated for this campaign */
  totalCodesGenerated: number;
  /** Number of valid (unused) codes */
  validCodesCount: number;
  /** Number of used codes */
  usedCodesCount: number;
  /** Number of invalidated codes */
  invalidatedCodesCount: number;
  /** Distinct user count who have claimed */
  totalClaimants: number;
  /**
   * Remaining supply (totalSupply - claimedSupply) or null
   * @nullable
   */
  remainingSupply: PromoCampaignDetailResponseDtoRemainingSupply;
}

export type UpdatePromoCampaignDtoStatus =
  (typeof UpdatePromoCampaignDtoStatus)[keyof typeof UpdatePromoCampaignDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdatePromoCampaignDtoStatus = {
  active: 'active',
  paused: 'paused',
  exhausted: 'exhausted',
  ended: 'ended',
} as const;

/**
 * @nullable
 */
export type UpdatePromoCampaignDtoMaxClaimsPerUser = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type UpdatePromoCampaignDtoTotalSupply = { [key: string]: unknown } | null;

export interface UpdatePromoCampaignDto {
  name?: string;
  description?: string;
  status?: UpdatePromoCampaignDtoStatus;
  startDate?: string;
  endDate?: string;
  /** @nullable */
  maxClaimsPerUser?: UpdatePromoCampaignDtoMaxClaimsPerUser;
  /** @nullable */
  totalSupply?: UpdatePromoCampaignDtoTotalSupply;
}

/**
 * Code status
 */
export type PromoCodeResponseDtoStatus = (typeof PromoCodeResponseDtoStatus)[keyof typeof PromoCodeResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCodeResponseDtoStatus = {
  valid: 'valid',
  used: 'used',
  invalidated: 'invalidated',
} as const;

/**
 * User ID who used the code
 * @nullable
 */
export type PromoCodeResponseDtoUsedByUserId = { [key: string]: unknown } | null;

/**
 * When the code was used
 * @nullable
 */
export type PromoCodeResponseDtoUsedAt = { [key: string]: unknown } | null;

export interface PromoCodeResponseDto {
  /** Promo code ID */
  id: string;
  /** The promo code string */
  code: string;
  /** Code status */
  status: PromoCodeResponseDtoStatus;
  /**
   * User ID who used the code
   * @nullable
   */
  usedByUserId?: PromoCodeResponseDtoUsedByUserId;
  /**
   * When the code was used
   * @nullable
   */
  usedAt?: PromoCodeResponseDtoUsedAt;
  /** When the code was created */
  createdAt: string;
}

/**
 * Code status
 */
export type PromoCodeUsedResponseDtoStatus =
  (typeof PromoCodeUsedResponseDtoStatus)[keyof typeof PromoCodeUsedResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoCodeUsedResponseDtoStatus = {
  valid: 'valid',
  used: 'used',
  invalidated: 'invalidated',
} as const;

/**
 * User ID who used the code
 * @nullable
 */
export type PromoCodeUsedResponseDtoUsedByUserId = { [key: string]: unknown } | null;

/**
 * When the code was used
 * @nullable
 */
export type PromoCodeUsedResponseDtoUsedAt = { [key: string]: unknown } | null;

/**
 * Telegram ID of the user
 * @nullable
 */
export type PromoCodeUsedResponseDtoTelegramId = { [key: string]: unknown } | null;

/**
 * Telegram username
 * @nullable
 */
export type PromoCodeUsedResponseDtoUsername = { [key: string]: unknown } | null;

/**
 * User first name
 * @nullable
 */
export type PromoCodeUsedResponseDtoFirstName = { [key: string]: unknown } | null;

/**
 * User last name
 * @nullable
 */
export type PromoCodeUsedResponseDtoLastName = { [key: string]: unknown } | null;

export interface PromoCodeUsedResponseDto {
  /** Promo code ID */
  id: string;
  /** The promo code string */
  code: string;
  /** Code status */
  status: PromoCodeUsedResponseDtoStatus;
  /**
   * User ID who used the code
   * @nullable
   */
  usedByUserId?: PromoCodeUsedResponseDtoUsedByUserId;
  /**
   * When the code was used
   * @nullable
   */
  usedAt?: PromoCodeUsedResponseDtoUsedAt;
  /** When the code was created */
  createdAt: string;
  /**
   * Telegram ID of the user
   * @nullable
   */
  telegramId?: PromoCodeUsedResponseDtoTelegramId;
  /**
   * Telegram username
   * @nullable
   */
  username?: PromoCodeUsedResponseDtoUsername;
  /**
   * User first name
   * @nullable
   */
  firstName?: PromoCodeUsedResponseDtoFirstName;
  /**
   * User last name
   * @nullable
   */
  lastName?: PromoCodeUsedResponseDtoLastName;
}

export interface PromoCodeExportItemDto {
  /** The promo code string */
  code: string;
  /** When the code was created */
  createdAt: string;
}

/**
 * Code status
 */
export type InvalidateCodeResponseDtoStatus =
  (typeof InvalidateCodeResponseDtoStatus)[keyof typeof InvalidateCodeResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InvalidateCodeResponseDtoStatus = {
  invalidated: 'invalidated',
} as const;

export interface InvalidateCodeResponseDto {
  /** Promo code ID */
  id: string;
  /** The promo code string */
  code: string;
  /** Code status */
  status: InvalidateCodeResponseDtoStatus;
  /** When the code was created */
  createdAt?: string;
}

export interface BulkInvalidateBodyDto {
  /** Must be true to confirm bulk invalidation */
  confirm: boolean;
}

export interface BulkInvalidateResponseDto {
  /** Number of codes invalidated */
  invalidatedCount: number;
}

export interface GeneratePromoCodesDto {
  /**
   * Number of unique codes to generate
   * @minimum 1
   * @maximum 10000
   */
  count: number;
}

/**
 * Campaign total supply limit or null if unlimited
 * @nullable
 */
export type GeneratePromoCodesResponseDtoTotalSupply = { [key: string]: unknown } | null;

/**
 * How many more codes can be generated (totalSupply - totalValidCodes) or null if unlimited
 * @nullable
 */
export type GeneratePromoCodesResponseDtoRemainingGeneratable = { [key: string]: unknown } | null;

export interface GeneratePromoCodesResponseDto {
  /** Number of codes generated in this batch */
  generatedCount: number;
  /** Total valid (unused) codes after generation */
  totalValidCodes: number;
  /**
   * Campaign total supply limit or null if unlimited
   * @nullable
   */
  totalSupply: GeneratePromoCodesResponseDtoTotalSupply;
  /**
   * How many more codes can be generated (totalSupply - totalValidCodes) or null if unlimited
   * @nullable
   */
  remainingGeneratable: GeneratePromoCodesResponseDtoRemainingGeneratable;
}

/**
 * Telegram ID of the user
 * @nullable
 */
export type PromoParticipantResponseDtoTelegramId = { [key: string]: unknown } | null;

/**
 * Telegram username
 * @nullable
 */
export type PromoParticipantResponseDtoUsername = { [key: string]: unknown } | null;

/**
 * User last name
 * @nullable
 */
export type PromoParticipantResponseDtoLastName = { [key: string]: unknown } | null;

/**
 * Promo code ID (nullable for legacy rows)
 * @nullable
 */
export type PromoParticipantResponseDtoCodeId = { [key: string]: unknown } | null;

export interface PromoParticipantResponseDto {
  /** Claim record ID */
  claimId: string;
  /** User ID */
  userId: string;
  /**
   * Telegram ID of the user
   * @nullable
   */
  telegramId?: PromoParticipantResponseDtoTelegramId;
  /**
   * Telegram username
   * @nullable
   */
  username?: PromoParticipantResponseDtoUsername;
  /** User first name */
  firstName: string;
  /**
   * User last name
   * @nullable
   */
  lastName?: PromoParticipantResponseDtoLastName;
  /** The actual code string used (snapshot from claim) */
  codeSnapshot: string;
  /**
   * Promo code ID (nullable for legacy rows)
   * @nullable
   */
  codeId?: PromoParticipantResponseDtoCodeId;
  /** Pack IDs received */
  packIds: string[];
  /** Number of packs received */
  packsReceived: number;
  /** When the claim was made */
  claimedAt: string;
}

export interface ClaimPromoCodeDto {
  /** The promo code to claim */
  code: string;
}

export interface ClaimPromoCodeSuccessResponseDto {
  /** Campaign ID */
  campaignId: string;
  /** Campaign name */
  campaignName: string;
  /** Collection ID */
  collectionId: string;
  /**
   * Collection image URL
   * @nullable
   */
  collectionImageUrl?: string | null;
  /** Collection name */
  collectionName: string;
  /** Collection rarity */
  collectionRarity: string;
  /** IDs of packs received */
  packIds: string[];
  /** Number of packs received */
  packsReceived: number;
}

export interface ClaimPromoCodeErrorResponseDto {
  /** Machine-readable error code for client-side branching. Absent for framework-level errors (e.g. throttling). */
  errorCode?: string;
  /** Error message */
  message: string;
  /** HTTP status code */
  statusCode: number;
}

export interface CreateExternalCollectionDto {
  /** Collection address on blockchain */
  collectionAddress: string;
  /** Collection name */
  collectionName: string;
  /** Collection description */
  description?: string;
  /** Collection image URL */
  image?: string;
}

export interface UpdateExternalCollectionDto {
  /** Collection name */
  collectionName?: string;
  /** Collection description */
  description?: string;
  /** Collection image URL */
  image?: string;
  /** Is collection active */
  isActive?: boolean;
}

/**
 * Event type
 */
export type CreateWorkshopEventDtoEventType =
  (typeof CreateWorkshopEventDtoEventType)[keyof typeof CreateWorkshopEventDtoEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWorkshopEventDtoEventType = {
  AIRDROP: 'AIRDROP',
} as const;

export interface CreateWorkshopEventDto {
  /** Event name */
  name: string;
  /** Event description */
  description?: string;
  /** Event type */
  eventType: CreateWorkshopEventDtoEventType;
  /** Event start time */
  startTime: string;
  /** Event end time */
  endTime: string;
  /** Tier 1 threshold (top XY for guaranteed prize) */
  tier1Threshold?: number;
}

export interface CreateWorkshopEventWithImageDto {
  /** Event image file */
  image?: Blob;
  request: CreateWorkshopEventDto;
}

/**
 * Event status
 */
export type UpdateWorkshopEventDtoStatus =
  (typeof UpdateWorkshopEventDtoStatus)[keyof typeof UpdateWorkshopEventDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateWorkshopEventDtoStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  ENDED: 'ENDED',
} as const;

export interface UpdateWorkshopEventDto {
  /** Event name */
  name?: string;
  /** Event description */
  description?: string;
  /** Event start time */
  startTime?: string;
  /** Event end time */
  endTime?: string;
  /** Event status */
  status?: UpdateWorkshopEventDtoStatus;
  /** Tier 1 threshold */
  tier1Threshold?: number;
}

export interface UpdateWorkshopEventWithImageDto {
  /** Event image file */
  image?: Blob;
  request: UpdateWorkshopEventDto;
}

/**
 * Activity type
 */
export type CreateWorkshopEventActivityDtoActivityType =
  (typeof CreateWorkshopEventActivityDtoActivityType)[keyof typeof CreateWorkshopEventActivityDtoActivityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWorkshopEventActivityDtoActivityType = {
  BURNING: 'BURNING',
  STAKING: 'STAKING',
} as const;

export interface CreateWorkshopEventActivityDto {
  /** Event ID */
  eventId: string;
  /** Activity type */
  activityType: CreateWorkshopEventActivityDtoActivityType;
  /** Activity name (if not provided, will use event name) */
  name?: string;
  /** Lock period in days (for staking) */
  lockPeriodDays?: number;
  /** Activity start time (if not provided, will use event start time) */
  startTime?: string;
  /** Activity end time (if not provided, will use event end time) */
  endTime?: string;
}

/**
 * Activity status
 */
export type UpdateWorkshopEventActivityDtoStatus =
  (typeof UpdateWorkshopEventActivityDtoStatus)[keyof typeof UpdateWorkshopEventActivityDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateWorkshopEventActivityDtoStatus = {
  ACTIVE: 'ACTIVE',
  CANCELLED: 'CANCELLED',
  ENDED: 'ENDED',
} as const;

export interface UpdateWorkshopEventActivityDto {
  /** Activity name */
  name?: string;
  /** Lock period in days */
  lockPeriodDays?: number;
  /** Activity start time */
  startTime?: string;
  /** Activity end time */
  endTime?: string;
  /** Activity status */
  status?: UpdateWorkshopEventActivityDtoStatus;
}

/**
 * Asset type
 */
export type AddActivityAssetDtoAssetType =
  (typeof AddActivityAssetDtoAssetType)[keyof typeof AddActivityAssetDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AddActivityAssetDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

export interface AddActivityAssetDto {
  /** Asset type */
  assetType: AddActivityAssetDtoAssetType;
  /** Asset identifier (UUID - collection.id or external_collection.id) */
  assetIdentifier: string;
  /** Minimum points */
  pointsMin: number;
  /** Maximum points */
  pointsMax: number;
}

export interface AddActivityBonusCollectionDto {
  /** Bonus collection ID */
  bonusCollectionId: string;
}

/**
 * Asset type
 */
export type CreateAssetPointsConfigDtoAssetType =
  (typeof CreateAssetPointsConfigDtoAssetType)[keyof typeof CreateAssetPointsConfigDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAssetPointsConfigDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

/**
 * Function type
 */
export type CreateAssetPointsConfigDtoFunctionType =
  (typeof CreateAssetPointsConfigDtoFunctionType)[keyof typeof CreateAssetPointsConfigDtoFunctionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateAssetPointsConfigDtoFunctionType = {
  BURNING: 'BURNING',
  FORGING: 'FORGING',
  STAKING: 'STAKING',
} as const;

export interface CreateAssetPointsConfigDto {
  /** Asset type */
  assetType: CreateAssetPointsConfigDtoAssetType;
  /** Asset identifier (UUID - collection.id or external_collection.id) */
  assetIdentifier: string;
  /** Function type */
  functionType: CreateAssetPointsConfigDtoFunctionType;
  /** Minimum points */
  pointsMin: number;
  /** Maximum points */
  pointsMax: number;
}

export interface UpdateAssetPointsConfigDto {
  /** Minimum points */
  pointsMin?: number;
  /** Maximum points */
  pointsMax?: number;
  /** Is config active */
  isActive?: boolean;
}

export interface ForgeCheatSheetItemDto {
  /** Collection ID needed for forge */
  collectionId: string;
  /**
   * Required number of packs from the collection
   * @minimum 1
   */
  requiredCount: number;
}

export interface CreateForgeEventWithImageDto {
  /** Forge event name */
  name: string;
  /** Forge event description */
  description?: string;
  /**
   * Success probability percentage (0-100)
   * @minimum 0
   * @maximum 100
   */
  successProbability: number;
  /** Collection ID that will be produced on successful forge */
  outputCollectionId: string;
  /**
   * Points range minimum for a forge attempt
   * @minimum 0
   */
  pointsMin: number;
  /**
   * Points range maximum for a forge attempt
   * @minimum 0
   */
  pointsMax: number;
  /** Cheatsheet items defining required collections */
  cheatSheet: ForgeCheatSheetItemDto[];
  image?: Blob;
}

export interface UpdateForgeEventWithImageDto {
  /** Forge event name */
  name?: string;
  /** Forge event description */
  description?: string;
  /**
   * Success probability percentage (0-100)
   * @minimum 0
   * @maximum 100
   */
  successProbability?: number;
  /** Is forge event active */
  isActive?: boolean;
  /** Collection ID that will be produced on successful forge */
  outputCollectionId?: string;
  /**
   * Points range minimum for a forge attempt
   * @minimum 0
   */
  pointsMin?: number;
  /**
   * Points range maximum for a forge attempt
   * @minimum 0
   */
  pointsMax?: number;
  /** Cheatsheet items defining required collections */
  cheatSheet?: ForgeCheatSheetItemDto[];
  image?: Blob;
}

export interface ForgeOrphanedSuccessAttemptDto {
  /** workshop_points_audit row id */
  id: string;
  /** User who initiated the forge attempt */
  userId: string;
  /** Forge event id this attempt belonged to */
  forgeEventId: string;
  /** Pack ids that were burned by this attempt (input assets sent to burn wallet) */
  burnedPackIds: string[];
  /** Final points awarded for the (otherwise unrewarded) successful attempt */
  finalPoints: number;
  /** When the attempt was recorded (UTC ISO timestamp) */
  createdAt: string;
}

export interface ForgeOrphanedSuccessAttemptListDto {
  /** Total number of orphaned successful attempts for this forge event */
  total: number;
  /** Orphaned successful attempts ordered by creation time (oldest first) */
  items: ForgeOrphanedSuccessAttemptDto[];
}

/**
 * Collection type
 */
export type CreateWorkshopBonusCollectionDtoCollectionType =
  (typeof CreateWorkshopBonusCollectionDtoCollectionType)[keyof typeof CreateWorkshopBonusCollectionDtoCollectionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateWorkshopBonusCollectionDtoCollectionType = {
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
} as const;

export interface CreateWorkshopBonusCollectionDto {
  /** Collection type */
  collectionType: CreateWorkshopBonusCollectionDtoCollectionType;
  /** Collection ID (UUID - collection.id or external_collection.id) */
  collectionId: string;
  /**
   * Bonus percentage (e.g., 2.5 for 2.5%)
   * @minimum 0
   * @maximum 100
   */
  bonusPercentage: number;
}

export interface UpdateWorkshopBonusCollectionDto {
  /**
   * Bonus percentage (e.g., 2.5 for 2.5%)
   * @minimum 0
   * @maximum 100
   */
  bonusPercentage?: number;
  /** Is active */
  isActive?: boolean;
}

/**
 * Collection description
 * @nullable
 */
export type ExternalCollectionDtoDescription = { [key: string]: unknown } | null;

/**
 * User ID who created the collection
 * @nullable
 */
export type ExternalCollectionDtoCreatedBy = { [key: string]: unknown } | null;

export interface ExternalCollectionDto {
  /** External collection ID */
  id: string;
  /** Collection address on blockchain */
  collectionAddress: string;
  /** Collection name */
  collectionName: string;
  /**
   * Collection description
   * @nullable
   */
  description?: ExternalCollectionDtoDescription;
  /** Whether the collection is active */
  isActive: boolean;
  /**
   * User ID who created the collection
   * @nullable
   */
  createdBy?: ExternalCollectionDtoCreatedBy;
  /** Created at timestamp */
  createdAt: string;
  /** Updated at timestamp */
  updatedAt: string;
  /**
   * External collection image URL
   * @nullable
   */
  image?: string | null;
}

/**
 * NFT metadata
 * @nullable
 */
export type ExternalPackNftDtoMetadata = { [key: string]: unknown } | null;

/**
 * Activity ID where NFT is staked
 * @nullable
 */
export type ExternalPackNftDtoStakedInActivityId = { [key: string]: unknown } | null;

/**
 * Timestamp when NFT was synced
 * @nullable
 */
export type ExternalPackNftDtoSyncedAt = { [key: string]: unknown } | null;

export interface ExternalPackNftDto {
  /** External pack NFT ID */
  id: string;
  /** User ID who owns this NFT */
  userId: string;
  /** External collection ID */
  externalCollectionId: string;
  /** NFT address on blockchain */
  nftAddress: string;
  /**
   * NFT metadata
   * @nullable
   */
  metadata?: ExternalPackNftDtoMetadata;
  /** Whether the NFT was burned */
  burned: boolean;
  /** Whether the NFT should be burned */
  shouldBeBurned: boolean;
  /**
   * Datetime until NFT is staked
   * @nullable
   */
  stakedTill?: string | null;
  /**
   * Activity ID where NFT is staked
   * @nullable
   */
  stakedInActivityId?: ExternalPackNftDtoStakedInActivityId;
  /**
   * Timestamp when NFT was synced
   * @nullable
   */
  syncedAt?: ExternalPackNftDtoSyncedAt;
  /** Created at timestamp */
  createdAt: string;
  /** Updated at timestamp */
  updatedAt: string;
  /** External collection details */
  externalCollection: ExternalCollectionDto;
}

/**
 * Asset type
 */
export type WorkshopEventActivityAssetResponseDtoAssetType =
  (typeof WorkshopEventActivityAssetResponseDtoAssetType)[keyof typeof WorkshopEventActivityAssetResponseDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopEventActivityAssetResponseDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

export interface WorkshopEventActivityAssetResponseDto {
  /** Asset ID */
  id: string;
  /** Activity ID */
  activityId: string;
  /** Asset type */
  assetType: WorkshopEventActivityAssetResponseDtoAssetType;
  /** Asset identifier (UUID) */
  assetIdentifier: string;
  /** Minimum points */
  pointsMin: number;
  /** Maximum points */
  pointsMax: number;
  /** Created at */
  createdAt: string;
}

/**
 * Activity type
 */
export type WorkshopEventActivityResponseDtoActivityType =
  (typeof WorkshopEventActivityResponseDtoActivityType)[keyof typeof WorkshopEventActivityResponseDtoActivityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopEventActivityResponseDtoActivityType = {
  BURNING: 'BURNING',
  STAKING: 'STAKING',
} as const;

/**
 * Activity status
 */
export type WorkshopEventActivityResponseDtoStatus =
  (typeof WorkshopEventActivityResponseDtoStatus)[keyof typeof WorkshopEventActivityResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopEventActivityResponseDtoStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED',
} as const;

export interface WorkshopEventActivityResponseDto {
  /** Activity ID */
  id: string;
  /** Event ID */
  eventId: string;
  /** Activity type */
  activityType: WorkshopEventActivityResponseDtoActivityType;
  /** Activity name */
  name: string;
  /**
   * Lock period in days (for staking)
   * @nullable
   */
  lockPeriodDays?: number | null;
  /** Activity start time */
  startTime: string;
  /** Activity end time */
  endTime: string;
  /** Activity status */
  status: WorkshopEventActivityResponseDtoStatus;
  /** Created at */
  createdAt: string;
  /** Updated at */
  updatedAt: string;
  /** Activity assets */
  assets?: WorkshopEventActivityAssetResponseDto[];
}

/**
 * Event type
 */
export type WorkshopEventResponseDtoEventType =
  (typeof WorkshopEventResponseDtoEventType)[keyof typeof WorkshopEventResponseDtoEventType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopEventResponseDtoEventType = {
  AIRDROP: 'AIRDROP',
} as const;

/**
 * Event status
 */
export type WorkshopEventResponseDtoStatus =
  (typeof WorkshopEventResponseDtoStatus)[keyof typeof WorkshopEventResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopEventResponseDtoStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED',
} as const;

/**
 * Tier 1 threshold
 * @nullable
 */
export type WorkshopEventResponseDtoTier1Threshold = { [key: string]: unknown } | null;

export interface WorkshopEventResponseDto {
  /** Event ID */
  id: string;
  /** Event name */
  name: string;
  /** Activity ID */
  activityId: string;
  /**
   * Event description
   * @nullable
   */
  description?: string | null;
  /** Event type */
  eventType: WorkshopEventResponseDtoEventType;
  /** Event start time */
  startTime: string;
  /** Event end time */
  endTime: string;
  /** Event status */
  status: WorkshopEventResponseDtoStatus;
  /**
   * Tier 1 threshold
   * @nullable
   */
  tier1Threshold?: WorkshopEventResponseDtoTier1Threshold;
  /**
   * Event image URL
   * @nullable
   */
  image?: string | null;
  /** Created at */
  createdAt: string;
  /** Updated at */
  updatedAt: string;
  /** Total participants */
  totalParticipants: number;
  /** Current user position */
  yourPosition: number;
  /** Earned points */
  earnedPoints: number;
  /** Total burned NFTs for this event */
  burned: number;
  /** Total staked NFTs for this event */
  staked: number;
  /** Number of NFTs burned by current user in this activity (only for BURNING) */
  burnedCount?: number;
  /** Number of NFTs staked by current user in this activity (only for STAKING) */
  stakedCount?: number;
  /** Event activities */
  activities?: WorkshopEventActivityResponseDto[];
}

export interface WorkshopEventsByActivityTypeResponseDto {
  /** Ongoing events (endTime in the future) */
  ongoing: WorkshopEventResponseDto[];
  /** Passed events (endTime in the past) */
  passed: WorkshopEventResponseDto[];
}

/**
 * Collection type
 */
export type WorkshopBonusCollectionResponseDtoCollectionType =
  (typeof WorkshopBonusCollectionResponseDtoCollectionType)[keyof typeof WorkshopBonusCollectionResponseDtoCollectionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopBonusCollectionResponseDtoCollectionType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

export interface WorkshopBonusCollectionResponseDto {
  /** Bonus collection ID */
  id: string;
  /** Collection type */
  collectionType: WorkshopBonusCollectionResponseDtoCollectionType;
  /** Collection ID */
  collectionId: string;
  /** Bonus percentage */
  bonusPercentage: string;
  /** Is active */
  isActive: boolean;
  /** Created at */
  createdAt: string;
  /** Updated at */
  updatedAt: string;
}

/**
 * Activity type
 */
export type WorkshopActivityDetailResponseDtoActivityType =
  (typeof WorkshopActivityDetailResponseDtoActivityType)[keyof typeof WorkshopActivityDetailResponseDtoActivityType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopActivityDetailResponseDtoActivityType = {
  BURNING: 'BURNING',
  STAKING: 'STAKING',
} as const;

/**
 * Activity status
 */
export type WorkshopActivityDetailResponseDtoStatus =
  (typeof WorkshopActivityDetailResponseDtoStatus)[keyof typeof WorkshopActivityDetailResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopActivityDetailResponseDtoStatus = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  CANCELLED: 'CANCELLED',
} as const;

export interface WorkshopActivityDetailResponseDto {
  /** Activity ID */
  id: string;
  /** Event ID */
  eventId: string;
  /** Activity type */
  activityType: WorkshopActivityDetailResponseDtoActivityType;
  /** Activity name */
  name: string;
  /**
   * Lock period in days (for staking)
   * @nullable
   */
  lockPeriodDays?: number | null;
  /** Activity start time */
  startTime: string;
  /** Activity end time */
  endTime: string;
  /** Activity status */
  status: WorkshopActivityDetailResponseDtoStatus;
  /** Created at */
  createdAt: string;
  /** Updated at */
  updatedAt: string;
  /** Event details */
  event: WorkshopEventResponseDto;
  /** Activity assets */
  assets: WorkshopEventActivityAssetResponseDto[];
  /** Bonus collections */
  bonusCollections: WorkshopBonusCollectionResponseDto[];
  /** Current user position (rank) in event leaderboard */
  yourPosition?: number;
  /** Total number of participants in event */
  totalParticipants: number;
  /** Earned points by current user in this event */
  earnedPoints?: number;
  /** Number of NFTs burned by current user in this activity (only for BURNING) */
  burnedCount?: number;
  /** Number of NFTs staked by current user in this activity (only for STAKING) */
  stakedCount?: number;
}

/**
 * Asset type
 */
export type ActivityAssetResponseDtoAssetType =
  (typeof ActivityAssetResponseDtoAssetType)[keyof typeof ActivityAssetResponseDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityAssetResponseDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

/**
 * Collection rarity (for INTERNAL_COLLECTION)
 */
export type ActivityAssetResponseDtoRarity =
  (typeof ActivityAssetResponseDtoRarity)[keyof typeof ActivityAssetResponseDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityAssetResponseDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

export interface ActivityAssetResponseDto {
  /** Asset ID */
  id: string;
  /** Asset type */
  assetType: ActivityAssetResponseDtoAssetType;
  /** Asset identifier (Collection ID or External Collection ID) */
  assetIdentifier: string;
  /** Minimum points */
  pointsMin: number;
  /** Maximum points */
  pointsMax: number;
  /** Collection name (for both INTERNAL_COLLECTION and EXTERNAL_COLLECTION) */
  collectionName?: string;
  /**
   * Collection image (for both INTERNAL_COLLECTION and EXTERNAL_COLLECTION)
   * @nullable
   */
  collectionImage?: string | null;
  /** Collection rarity (for INTERNAL_COLLECTION) */
  rarity?: ActivityAssetResponseDtoRarity;
  /** Created at */
  createdAt: string;
}

/**
 * Asset type
 */
export type ActivityAssetAvailableResponseDtoAssetType =
  (typeof ActivityAssetAvailableResponseDtoAssetType)[keyof typeof ActivityAssetAvailableResponseDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityAssetAvailableResponseDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

/**
 * Collection rarity (for INTERNAL_COLLECTION)
 */
export type ActivityAssetAvailableResponseDtoRarity =
  (typeof ActivityAssetAvailableResponseDtoRarity)[keyof typeof ActivityAssetAvailableResponseDtoRarity];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityAssetAvailableResponseDtoRarity = {
  common: 'common',
  uncommon: 'uncommon',
  rare: 'rare',
  ultra_rare: 'ultra_rare',
  legendary: 'legendary',
  ultimate: 'ultimate',
  heirloom: 'heirloom',
} as const;

/**
 * Activity in which the asset is staked
 * @nullable
 */
export type ActivityAssetAvailableResponseDtoStakedInActivityId = { [key: string]: unknown } | null;

export interface ActivityAssetAvailableResponseDto {
  /** Asset ID */
  id: string;
  /** Asset type */
  assetType: ActivityAssetAvailableResponseDtoAssetType;
  /** Asset identifier (Collection ID or External Collection ID) */
  assetIdentifier: string;
  /** Minimum points */
  pointsMin: number;
  /** Maximum points */
  pointsMax: number;
  /** Collection name (for both INTERNAL_COLLECTION and EXTERNAL_COLLECTION) */
  collectionName?: string;
  /**
   * Collection image (for both INTERNAL_COLLECTION and EXTERNAL_COLLECTION)
   * @nullable
   */
  collectionImage?: string | null;
  /** Collection rarity (for INTERNAL_COLLECTION) */
  rarity?: ActivityAssetAvailableResponseDtoRarity;
  /** numberInCollection from user pack */
  numberInCollection: number;
  /**
   * Datetime until asset is staked (null if free)
   * @nullable
   */
  stakedTill?: string | null;
  /**
   * Activity in which the asset is staked
   * @nullable
   */
  stakedInActivityId?: ActivityAssetAvailableResponseDtoStakedInActivityId;
  /** Created at */
  createdAt: string;
}

export interface ForgeCheatSheetPackResponseDto {
  /**
   * Pack ID (null if user does not have this pack)
   * @nullable
   */
  packId: string | null;
  /** Collection ID */
  collectionId: string;
  /**
   * Collection name
   * @nullable
   */
  collectionName: string | null;
  /**
   * Collection image
   * @nullable
   */
  collectionImage: string | null;
  /**
   * Collection rarity
   * @nullable
   */
  rarity: string | null;
  /**
   * Pack number in collection
   * @nullable
   */
  numberInCollection: number | null;
  /** Whether the pack is available for forging (not burned, not staked) */
  available: boolean;
}

export interface ForgeCheatSheetResponseDto {
  items: ForgeCheatSheetPackResponseDto[];
  requirements: ForgeCheatSheetItemDto[];
}

export interface ForgeActiveEventResponseDto {
  id: string;
  name: string;
  /** @nullable */
  image: string | null;
  /** How many times the user can currently forge using this event. */
  craftableCount: number;
  /** How many stickers are required for a single forge attempt. */
  packCountPerAttempt: number;
}

export interface ForgePreviewRequestDto {
  /** Array of pack IDs to use for forge */
  packIds: string[];
}

export interface ForgePreviewInputOutputCollectionDto {
  id: string;
  name: string;
  /** @nullable */
  image: string | null;
  /** @nullable */
  rarity: string | null;
}

export interface ForgePreviewUserPositionDto {
  rank: number;
  totalPoints: number;
}

export interface ForgePreviewPointsRangeDto {
  min: number;
  max: number;
  /** Bonus percentage applied to points */
  bonusAppliedPercent: number;
}

export interface ForgeInputCollectionResponseDto {
  collection: ForgePreviewInputOutputCollectionDto;
  /** @nullable */
  requiredCount: string | null;
  chosenCount: number;
  packIds: string[];
}

/**
 * @nullable
 */
export type ForgePreviewResponseDtoUserPosition = ForgePreviewUserPositionDto | null;

export interface ForgePreviewResponseDto {
  outputCollection: ForgePreviewInputOutputCollectionDto;
  /** Success chance including level bonus */
  successChance: number;
  userLevel: number;
  /** Extra success chance coming from level luck multiplier in % */
  extraChancePercent: number;
  /** @nullable */
  userPosition: ForgePreviewResponseDtoUserPosition;
  pointsRange: ForgePreviewPointsRangeDto;
  inputCollections: ForgeInputCollectionResponseDto[];
}

export interface ForgeStartRequestDto {
  /** Array of pack IDs to use for forge */
  packIds: string[];
}

/**
 * Output pack if successful
 * @nullable
 */
export type ForgeStartResponseDtoOutputPack = ForgePreviewInputOutputCollectionDto | null;

export interface ForgeStartResponseDto {
  /** Whether the forge was successful */
  success: boolean;
  /**
   * Output pack if successful
   * @nullable
   */
  outputPack: ForgeStartResponseDtoOutputPack;
  /** Array of pack IDs that were burned */
  burnedPackIds: string[];
  /** Array of pack IDs that were returned (only on failure) */
  returnedPackIds: string[];
  /** Points gained from forging */
  pointsGained: number;
  /** XP gained from forging */
  xpGained: number;
  /** Change in user position in leaderboard after forging */
  positionChange: number;
}

export interface LeaderboardEntryDto {
  /** User ID */
  userId: string;
  /**
   * Username
   * @nullable
   */
  username?: string | null;
  /** First name */
  firstName: string;
  /**
   * Photo URL
   * @nullable
   */
  photoUrl?: string | null;
  /** Total points */
  totalPoints: number;
  /** Rank (position in leaderboard) */
  rank: number;
  /** User level */
  level: number;
}

export interface UserPositionDto {
  /** User rank */
  rank: number;
  /** Total points */
  totalPoints: number;
  /** Position in current list (index in users array), -1 if not in current list */
  positionInList?: number;
}

export interface LeaderboardResponseDto {
  /** Leaderboard entries */
  users: LeaderboardEntryDto[];
  /** Total number of users in leaderboard */
  total: number;
  /** Current user position (if authenticated) */
  yourPosition?: UserPositionDto;
  /** Earned points for this event (only for event leaderboard) */
  earnedPoints?: number;
}

export interface EventInfoDto {
  /** Event ID */
  id: string;
  /** Event name */
  name: string;
  /**
   * Event image URL
   * @nullable
   */
  image?: string | null;
  /** Total burned NFTs for this event */
  burned: number;
  /** Total staked NFTs for this event */
  staked: number;
}

export interface EventLeaderboardResponseDto {
  /** Leaderboard entries */
  users: LeaderboardEntryDto[];
  /** Total number of users in leaderboard */
  total: number;
  /** Current user position (if authenticated) */
  yourPosition?: UserPositionDto;
  /** Earned points for this event (only for event leaderboard) */
  earnedPoints?: number;
  /** Event information */
  event?: EventInfoDto;
}

export interface UserRankResponseDto {
  /** User rank */
  rank: number;
  /** Total points */
  totalPoints: number;
  /** Total number of users in leaderboard */
  totalUsers: number;
  /** Earned points for this event (only if eventId provided) */
  earnedPoints?: number;
}

export interface CalculateBurningPointsRangeDto {
  /** Activity ID */
  activityId: string;
  /** Internal asset IDs (pack IDs) */
  internal_assets: string[];
  /** External asset IDs (external NFT IDs) */
  external_assets: string[];
}

export interface CalculateBurningPointsRangeResponseDto {
  /** Minimum points user can earn */
  pointsMin: number;
  /** Maximum points user can earn */
  pointsMax: number;
}

/**
 * Asset type
 */
export type BurnAssetItemDtoAssetType = (typeof BurnAssetItemDtoAssetType)[keyof typeof BurnAssetItemDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BurnAssetItemDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

export interface BurnAssetItemDto {
  /** Asset type */
  assetType: BurnAssetItemDtoAssetType;
  /** Pack ID (for INTERNAL_COLLECTION) */
  packId?: string;
  /** External NFT ID (for EXTERNAL_COLLECTION) */
  externalNftId?: string;
}

export interface BurnAssetsInActivityDto {
  /** Activity ID */
  activityId: string;
  /** Assets to burn */
  assets: BurnAssetItemDto[];
}

export interface BurnAssetsInActivityResponseDto {
  /** Total points earned */
  totalPoints: number;
  /** Current user position in leaderboard */
  currentPosition: number;
  /** Position change (negative means moved up, positive means moved down) */
  positionChange: number;
  /** Total participants in leaderboard */
  totalParticipants: number;
  /** XP gained from this burning */
  xpGained: number;
}

export interface CalculateStakingPointsRangeDto {
  /** Activity ID */
  activityId: string;
  /** Internal asset IDs (pack IDs) */
  internal_assets: string[];
  /** External asset IDs (external NFT IDs) */
  external_assets: string[];
}

export interface CalculateStakingPointsRangeResponseDto {
  /** Minimum points user can earn */
  pointsMin: number;
  /** Maximum points user can earn */
  pointsMax: number;
}

/**
 * Asset type
 */
export type StakeAssetItemDtoAssetType = (typeof StakeAssetItemDtoAssetType)[keyof typeof StakeAssetItemDtoAssetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StakeAssetItemDtoAssetType = {
  EXTERNAL_COLLECTION: 'EXTERNAL_COLLECTION',
  INTERNAL_COLLECTION: 'INTERNAL_COLLECTION',
} as const;

export interface StakeAssetItemDto {
  /** Asset type */
  assetType: StakeAssetItemDtoAssetType;
  /** Pack ID (for INTERNAL_COLLECTION) */
  packId?: string;
  /** External NFT ID (for EXTERNAL_COLLECTION) */
  externalNftId?: string;
}

export interface StakeAssetsInActivityDto {
  /** Activity ID */
  activityId: string;
  /** Assets to stake */
  assets: StakeAssetItemDto[];
}

export interface StakeAssetsInActivityResponseDto {
  /** Total points earned */
  totalPoints: number;
  /** Current position in leaderboard */
  currentPosition: number;
  /** Position change compared to before action */
  positionChange: number;
  /** Total participants in event */
  totalParticipants: number;
  /** XP gained from staking */
  xpGained: number;
}

export interface TeddieBadgeDto {
  /** Badge name (intern, nakamoto, midas) */
  name: string;
  /** Whether the badge is active (user owns the collection) */
  isActive: boolean;
  /** Bonus percentage for this badge */
  bonusPercentage: number;
}

export interface TeddieBadgesResponseDto {
  /** List of Teddie badges */
  badges: TeddieBadgeDto[];
}

export type AppControllerGetHello200 = {
  message?: string;
  version?: string;
  timestamp?: string;
};

export type AppControllerGetHealth200 = {
  status?: string;
  timestamp?: string;
  uptime?: number;
};

export type AppControllerGetSentryError500 = {
  statusCode?: number;
  timestamp?: string;
  message?: string;
  sentryId?: string;
  sentryUrl?: string;
};

export type CollectionsControllerGetAllCollectionsParams = {
  /**
   * Minimum featured value - filter items with featured >= this value
   */
  minimumFeatured?: number;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: CollectionsControllerGetAllCollectionsSortOrder;
};

export type CollectionsControllerGetAllCollectionsSortOrder =
  (typeof CollectionsControllerGetAllCollectionsSortOrder)[keyof typeof CollectionsControllerGetAllCollectionsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CollectionsControllerGetAllCollectionsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type DirectSaleOffersControllerGetAllDirectSaleOffersParams = {
  /**
   * Filter by computed status
   */
  computedStatus?: DirectSaleOffersControllerGetAllDirectSaleOffersComputedStatus;
  excludeArchived?: boolean;
  /**
   * How the offers are ordered
   */
  order?: DirectSaleOffersControllerGetAllDirectSaleOffersOrder;
  /**
   * How many items should be returned at most.
   */
  limit?: number;
};

export type DirectSaleOffersControllerGetAllDirectSaleOffersComputedStatus =
  (typeof DirectSaleOffersControllerGetAllDirectSaleOffersComputedStatus)[keyof typeof DirectSaleOffersControllerGetAllDirectSaleOffersComputedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSaleOffersControllerGetAllDirectSaleOffersComputedStatus = {
  scheduled: 'scheduled',
  active: 'active',
  ended: 'ended',
  archived: 'archived',
} as const;

export type DirectSaleOffersControllerGetAllDirectSaleOffersOrder =
  (typeof DirectSaleOffersControllerGetAllDirectSaleOffersOrder)[keyof typeof DirectSaleOffersControllerGetAllDirectSaleOffersOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectSaleOffersControllerGetAllDirectSaleOffersOrder = {
  ORDER: 'ORDER',
  ENDED_AT: 'ENDED_AT',
} as const;

export type AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams = {
  /**
   * Filter by computed status
   */
  computedStatus?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersComputedStatus;
  excludeArchived?: boolean;
  /**
   * How the offers are ordered
   */
  order?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersOrder;
  /**
   * How many items should be returned at most.
   */
  limit?: number;
};

export type AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersComputedStatus =
  (typeof AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersComputedStatus)[keyof typeof AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersComputedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersComputedStatus = {
  scheduled: 'scheduled',
  active: 'active',
  ended: 'ended',
  archived: 'archived',
} as const;

export type AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersOrder =
  (typeof AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersOrder)[keyof typeof AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersOrder = {
  ORDER: 'ORDER',
  ENDED_AT: 'ENDED_AT',
} as const;

export type DropsControllerGetAllDropsPaginatedParams = {
  /**
   * Filter by drop status
   */
  status?: DropsControllerGetAllDropsPaginatedStatus;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: DropsControllerGetAllDropsPaginatedSortOrder;
};

export type DropsControllerGetAllDropsPaginatedStatus =
  (typeof DropsControllerGetAllDropsPaginatedStatus)[keyof typeof DropsControllerGetAllDropsPaginatedStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DropsControllerGetAllDropsPaginatedStatus = {
  active: 'active',
  ended: 'ended',
  completed: 'completed',
  cancelled: 'cancelled',
} as const;

export type DropsControllerGetAllDropsPaginatedSortOrder =
  (typeof DropsControllerGetAllDropsPaginatedSortOrder)[keyof typeof DropsControllerGetAllDropsPaginatedSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DropsControllerGetAllDropsPaginatedSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type WalletsControllerGetBalanceParams = {
  /**
   * Set to "true" to bypass cache and fetch fresh balance from blockchain
   */
  refresh?: string;
};

export type WalletsControllerGetBalance200 = {
  balance?: string;
  rawBalance?: string;
  minWithdrawAmount?: string;
  maxWithdrawAmount?: string;
};

export type WalletsControllerWithdraw201 = {
  transactionId?: string;
  comment?: string;
  status?: string;
  message?: string;
};

export type NftControllerWithdrawExternalNft201 = {
  /** Transaction ID */
  id?: string;
};

export type PartnerControllerGetCollectionsParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PartnerControllerGetCollectionsSortOrder;
};

export type PartnerControllerGetCollectionsSortOrder =
  (typeof PartnerControllerGetCollectionsSortOrder)[keyof typeof PartnerControllerGetCollectionsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PartnerControllerGetCollectionsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PartnerControllerGetHoldersParams = {
  /**
   * Collection ID (UUID)
   */
  collectionId: string;
};

export type PartnerControllerGetDropPacksHoldersParams = {
  /**
   * Drop ID (UUID)
   */
  dropId: string;
};

export type AdminPartnerControllerSyncPalaceNft200Synced = {
  brands?: number;
  collections?: number;
  drops?: number;
};

export type AdminPartnerControllerSyncPalaceNft200 = {
  synced?: AdminPartnerControllerSyncPalaceNft200Synced;
};

export type AdminControllerGetRecentTransactionsParams = {
  /**
   * Number of transactions to return
   */
  limit?: number;
};

export type AdminControllerTestRpcLimiterParams = {
  /**
   * Number of parallel requests per second
   */
  requestsPerSecond: number;
  /**
   * TON address for testing (if not provided, a standard test address will be used)
   */
  address?: string;
  /**
   * Test duration in seconds (default: 10)
   */
  durationSeconds?: number;
  /**
   * If true, bypasses queue and calls limiter directly (better for testing limiter itself)
   */
  direct?: boolean;
};

export type AdminNftAuditControllerGetRecentAuditEventsParams = {
  /**
   * Number of recent events to return (default: 50)
   */
  limit?: number;
  /**
   * Filter by specific action type
   */
  action?: string;
};

export type AdminPaymentsControllerSearchPaymentsParams = {
  /**
   * Filter by user ID
   */
  userId?: string;
  /**
   * Filter payments from this date (ISO 8601)
   */
  startDate?: string;
  /**
   * Filter payments until this date (ISO 8601)
   */
  endDate?: string;
  /**
   * Filter by payment status
   */
  status?: AdminPaymentsControllerSearchPaymentsStatus;
  /**
   * Filter by direct sale offer ID
   */
  directSaleOfferId?: string;
  /**
   * Page number for pagination
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
};

export type AdminPaymentsControllerSearchPaymentsStatus =
  (typeof AdminPaymentsControllerSearchPaymentsStatus)[keyof typeof AdminPaymentsControllerSearchPaymentsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPaymentsControllerSearchPaymentsStatus = {
  pending: 'pending',
  completed: 'completed',
  refunded: 'refunded',
  cancelled: 'cancelled',
} as const;

export type AdminAnalyticsControllerGetSummaryParams = {
  /**
   * Time window in seconds (default: 900 = 15 minutes)
   */
  window?: string;
};

export type AdminAnalyticsControllerGetSummary200 = {
  totalCalls?: number;
  totalDropped?: number;
  avgWaitTime?: number;
  p50WaitTime?: number;
  p95WaitTime?: number;
  p99WaitTime?: number;
  waitingTotal?: number;
};

export type AdminAnalyticsControllerGetMethodsParams = {
  /**
   * Time window in seconds (default: 900 = 15 minutes)
   */
  window?: string;
};

export type AdminAnalyticsControllerGetMethods200ItemWaitTimeBucketsItem = {
  bucket?: string;
  count?: number;
};

export type AdminAnalyticsControllerGetMethods200Item = {
  operation?: string;
  totalCalls?: number;
  totalDropped?: number;
  avgWaitTime?: number;
  waitTimeBuckets?: AdminAnalyticsControllerGetMethods200ItemWaitTimeBucketsItem[];
};

export type AdminAnalyticsControllerGetTimeSeriesParams = {
  /**
   * Time window in seconds (default: 900 = 15 minutes)
   */
  window?: string;
  /**
   * Step size in seconds (default: 60 = 1 minute)
   */
  step?: string;
};

export type AdminAnalyticsControllerGetTimeSeries200Item = {
  timestamp?: number;
  calls?: number;
  dropped?: number;
};

export type AdminAnalyticsControllerGetCongestion200 = {
  waitingTotal?: number;
  p95WaitTime?: number;
  dropRate?: number;
  isCongested?: boolean;
  warnings?: string[];
};

export type BrandControllerGetAllBrandsParams = {
  /**
   * Minimum featured value - filter items with featured >= this value
   */
  minimumFeatured?: number;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: BrandControllerGetAllBrandsSortOrder;
};

export type BrandControllerGetAllBrandsSortOrder =
  (typeof BrandControllerGetAllBrandsSortOrder)[keyof typeof BrandControllerGetAllBrandsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrandControllerGetAllBrandsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type MetricsControllerIndexParams = {
  /**
   * Metrics authentication key (alternative to X-Metrics-Key header)
   */
  key?: string;
};

export type MetricsControllerGetHealthParams = {
  /**
   * Metrics authentication key (alternative to X-Metrics-Key header)
   */
  key?: string;
};

export type OauthControllerGetAuthorizeInfoParams = {
  /**
   * Public client ID
   */
  client_id: string;
  /**
   * Redirect URI
   */
  redirect_uri: string;
  /**
   * Opaque state value
   */
  state?: string;
};

export type PromoAdminCampaignControllerListCampaignsParams = {
  /**
   * Filter by status (comma-separated for multiple): active, paused, exhausted, ended
   */
  status?: string;
  /**
   * Case-insensitive search on campaign name
   */
  search?: string;
  /**
   * Filter by campaign type
   */
  type?: PromoAdminCampaignControllerListCampaignsType;
  /**
   * Filter campaigns with startDate >= this ISO date
   */
  startDateFrom?: string;
  /**
   * Filter campaigns with startDate <= this ISO date
   */
  startDateTo?: string;
  /**
   * Filter by computed effective status (comma-separated): active, paused, expired, scheduled, exhausted, ended
   */
  effectiveStatus?: string;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PromoAdminCampaignControllerListCampaignsSortOrder;
};

export type PromoAdminCampaignControllerListCampaignsType =
  (typeof PromoAdminCampaignControllerListCampaignsType)[keyof typeof PromoAdminCampaignControllerListCampaignsType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminCampaignControllerListCampaignsType = {
  unique: 'unique',
  universal: 'universal',
} as const;

export type PromoAdminCampaignControllerListCampaignsSortOrder =
  (typeof PromoAdminCampaignControllerListCampaignsSortOrder)[keyof typeof PromoAdminCampaignControllerListCampaignsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminCampaignControllerListCampaignsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PromoAdminCodeControllerListCodesParams = {
  /**
   * Filter by status (comma-separated): valid, used, invalidated
   */
  status?: string;
  /**
   * Search by code substring (case-insensitive)
   */
  search?: string;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PromoAdminCodeControllerListCodesSortOrder;
};

export type PromoAdminCodeControllerListCodesSortOrder =
  (typeof PromoAdminCodeControllerListCodesSortOrder)[keyof typeof PromoAdminCodeControllerListCodesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminCodeControllerListCodesSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PromoAdminCodeControllerListValidCodesParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PromoAdminCodeControllerListValidCodesSortOrder;
};

export type PromoAdminCodeControllerListValidCodesSortOrder =
  (typeof PromoAdminCodeControllerListValidCodesSortOrder)[keyof typeof PromoAdminCodeControllerListValidCodesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminCodeControllerListValidCodesSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PromoAdminCodeControllerListUsedCodesParams = {
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PromoAdminCodeControllerListUsedCodesSortOrder;
};

export type PromoAdminCodeControllerListUsedCodesSortOrder =
  (typeof PromoAdminCodeControllerListUsedCodesSortOrder)[keyof typeof PromoAdminCodeControllerListUsedCodesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminCodeControllerListUsedCodesSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type PromoAdminParticipantControllerListParticipantsParams = {
  /**
   * Search by telegramId, username, firstName, or lastName (case-insensitive)
   */
  search?: string;
  /**
   * Filter claims after this ISO date
   */
  claimedAfter?: string;
  /**
   * Filter claims before this ISO date
   */
  claimedBefore?: string;
  /**
   * Page number (1-based)
   */
  page?: number;
  /**
   * Number of items per page
   */
  limit?: number;
  /**
   * Sort field
   */
  sortBy?: string;
  /**
   * Sort order (asc or desc)
   */
  sortOrder?: PromoAdminParticipantControllerListParticipantsSortOrder;
};

export type PromoAdminParticipantControllerListParticipantsSortOrder =
  (typeof PromoAdminParticipantControllerListParticipantsSortOrder)[keyof typeof PromoAdminParticipantControllerListParticipantsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromoAdminParticipantControllerListParticipantsSortOrder = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type WorkshopControllerGetEventsByActivityTypeParams = {
  /**
   * Activity type
   */
  type: WorkshopControllerGetEventsByActivityTypeType;
};

export type WorkshopControllerGetEventsByActivityTypeType =
  (typeof WorkshopControllerGetEventsByActivityTypeType)[keyof typeof WorkshopControllerGetEventsByActivityTypeType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkshopControllerGetEventsByActivityTypeType = {
  BURNING: 'BURNING',
  STAKING: 'STAKING',
} as const;

export type WorkshopControllerGetGlobalLeaderboardParams = {
  /**
   * Limit number of results (default: 100)
   */
  limit?: number;
  /**
   * Offset for pagination (default: 0)
   */
  offset?: number;
};

export type WorkshopControllerGetEventLeaderboardParams = {
  /**
   * Limit number of results (default: 100)
   */
  limit?: number;
  /**
   * Offset for pagination (default: 0)
   */
  offset?: number;
};

export type WorkshopControllerGetUserRankParams = {
  /**
   * Event ID (optional, for event-specific rank)
   */
  eventId?: string;
};

/**
 * @summary Get application info
 */
export const appControllerGetHello = (signal?: AbortSignal) => {
  return customInstance<AppControllerGetHello200>({ url: `/`, method: 'GET', signal });
};

export const getAppControllerGetHelloQueryKey = () => {
  return [`/`] as const;
};

export const getAppControllerGetHelloQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHelloQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHello>>> = ({ signal }) =>
    appControllerGetHello(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetHello>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AppControllerGetHelloQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetHello>>>;
export type AppControllerGetHelloQueryError = unknown;

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetHello>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetHello>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetHello>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get application info
 */

export function useAppControllerGetHello<
  TData = Awaited<ReturnType<typeof appControllerGetHello>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHello>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAppControllerGetHelloQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Health check endpoint
 */
export const appControllerGetHealth = (signal?: AbortSignal) => {
  return customInstance<AppControllerGetHealth200>({ url: `/health`, method: 'GET', signal });
};

export const getAppControllerGetHealthQueryKey = () => {
  return [`/health`] as const;
};

export const getAppControllerGetHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetHealth>>> = ({ signal }) =>
    appControllerGetHealth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AppControllerGetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof appControllerGetHealth>>>;
export type AppControllerGetHealthQueryError = unknown;

export function useAppControllerGetHealth<
  TData = Awaited<ReturnType<typeof appControllerGetHealth>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetHealth>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetHealth>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetHealth<
  TData = Awaited<ReturnType<typeof appControllerGetHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetHealth>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetHealth>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetHealth<
  TData = Awaited<ReturnType<typeof appControllerGetHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Health check endpoint
 */

export function useAppControllerGetHealth<
  TData = Awaited<ReturnType<typeof appControllerGetHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAppControllerGetHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Test Sentry error reporting
 */
export const appControllerGetSentryError = (signal?: AbortSignal) => {
  return customInstance<unknown>({ url: `/debug-sentry`, method: 'GET', signal });
};

export const getAppControllerGetSentryErrorQueryKey = () => {
  return [`/debug-sentry`] as const;
};

export const getAppControllerGetSentryErrorQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetSentryError>>,
  TError = AppControllerGetSentryError500,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetSentryError>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetSentryErrorQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetSentryError>>> = ({ signal }) =>
    appControllerGetSentryError(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetSentryError>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AppControllerGetSentryErrorQueryResult = NonNullable<
  Awaited<ReturnType<typeof appControllerGetSentryError>>
>;
export type AppControllerGetSentryErrorQueryError = AppControllerGetSentryError500;

export function useAppControllerGetSentryError<
  TData = Awaited<ReturnType<typeof appControllerGetSentryError>>,
  TError = AppControllerGetSentryError500,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetSentryError>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetSentryError>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetSentryError>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetSentryError<
  TData = Awaited<ReturnType<typeof appControllerGetSentryError>>,
  TError = AppControllerGetSentryError500,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetSentryError>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetSentryError>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetSentryError>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetSentryError<
  TData = Awaited<ReturnType<typeof appControllerGetSentryError>>,
  TError = AppControllerGetSentryError500,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetSentryError>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Test Sentry error reporting
 */

export function useAppControllerGetSentryError<
  TData = Awaited<ReturnType<typeof appControllerGetSentryError>>,
  TError = AppControllerGetSentryError500,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetSentryError>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAppControllerGetSentryErrorQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Test ApiProperty filter interceptor
 */
export const appControllerGetTestInterceptor = (signal?: AbortSignal) => {
  return customInstance<TestResponseDto>({ url: `/test-interceptor`, method: 'GET', signal });
};

export const getAppControllerGetTestInterceptorQueryKey = () => {
  return [`/test-interceptor`] as const;
};

export const getAppControllerGetTestInterceptorQueryOptions = <
  TData = Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAppControllerGetTestInterceptorQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>> = ({ signal }) =>
    appControllerGetTestInterceptor(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AppControllerGetTestInterceptorQueryResult = NonNullable<
  Awaited<ReturnType<typeof appControllerGetTestInterceptor>>
>;
export type AppControllerGetTestInterceptorQueryError = unknown;

export function useAppControllerGetTestInterceptor<
  TData = Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetTestInterceptor>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetTestInterceptor<
  TData = Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
        TError,
        Awaited<ReturnType<typeof appControllerGetTestInterceptor>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAppControllerGetTestInterceptor<
  TData = Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Test ApiProperty filter interceptor
 */

export function useAppControllerGetTestInterceptor<
  TData = Awaited<ReturnType<typeof appControllerGetTestInterceptor>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof appControllerGetTestInterceptor>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAppControllerGetTestInterceptorQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all collections - filtered, sorted, paginated
 */
export const collectionsControllerGetAllCollections = (params?: CollectionsControllerGetAllCollectionsParams) => {
  return customInstance<CollectionListResponseDto>({ url: `/collections`, method: 'GET', params });
};

export const getCollectionsControllerGetAllCollectionsQueryKey = (
  params?: CollectionsControllerGetAllCollectionsParams,
) => {
  return [`/collections`, ...(params ? [params] : [])] as const;
};

export const getCollectionsControllerGetAllCollectionsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    CollectionsControllerGetAllCollectionsParams['page']
  >,
  TError = unknown,
>(
  params?: CollectionsControllerGetAllCollectionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        TError,
        TData,
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        QueryKey,
        CollectionsControllerGetAllCollectionsParams['page']
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCollectionsControllerGetAllCollectionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    QueryKey,
    CollectionsControllerGetAllCollectionsParams['page']
  > = ({ pageParam }) => collectionsControllerGetAllCollections({ ...params, page: pageParam || params?.['page'] });

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    TError,
    TData,
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    QueryKey,
    CollectionsControllerGetAllCollectionsParams['page']
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CollectionsControllerGetAllCollectionsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>
>;
export type CollectionsControllerGetAllCollectionsInfiniteQueryError = unknown;

export function useCollectionsControllerGetAllCollectionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    CollectionsControllerGetAllCollectionsParams['page']
  >,
  TError = unknown,
>(
  params: undefined | CollectionsControllerGetAllCollectionsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        TError,
        TData,
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        QueryKey,
        CollectionsControllerGetAllCollectionsParams['page']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
          QueryKey
        >,
        'initialData'
      >;
  },
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetAllCollectionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    CollectionsControllerGetAllCollectionsParams['page']
  >,
  TError = unknown,
>(
  params?: CollectionsControllerGetAllCollectionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        TError,
        TData,
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        QueryKey,
        CollectionsControllerGetAllCollectionsParams['page']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
          QueryKey
        >,
        'initialData'
      >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetAllCollectionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    CollectionsControllerGetAllCollectionsParams['page']
  >,
  TError = unknown,
>(
  params?: CollectionsControllerGetAllCollectionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        TError,
        TData,
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        QueryKey,
        CollectionsControllerGetAllCollectionsParams['page']
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all collections - filtered, sorted, paginated
 */

export function useCollectionsControllerGetAllCollectionsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
    CollectionsControllerGetAllCollectionsParams['page']
  >,
  TError = unknown,
>(
  params?: CollectionsControllerGetAllCollectionsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        TError,
        TData,
        Awaited<ReturnType<typeof collectionsControllerGetAllCollections>>,
        QueryKey,
        CollectionsControllerGetAllCollectionsParams['page']
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCollectionsControllerGetAllCollectionsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a collection
 */
export const collectionsControllerGetCollection = (id: string, signal?: AbortSignal) => {
  return customInstance<CollectionResponseDto>({ url: `/collections/${id}`, method: 'GET', signal });
};

export const getCollectionsControllerGetCollectionQueryKey = (id: string) => {
  return [`/collections/${id}`] as const;
};

export const getCollectionsControllerGetCollectionQueryOptions = <
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollection>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCollectionsControllerGetCollectionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof collectionsControllerGetCollection>>> = ({ signal }) =>
    collectionsControllerGetCollection(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CollectionsControllerGetCollectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerGetCollection>>
>;
export type CollectionsControllerGetCollectionQueryError = unknown;

export function useCollectionsControllerGetCollection<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollection>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollection>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollection<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollection>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollection>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollection<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollection>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a collection
 */

export function useCollectionsControllerGetCollection<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollection>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollection>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCollectionsControllerGetCollectionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update collection properties (excluding image)
 */
export const collectionsControllerUpdateCollection = (id: string, updateCollectionDto: UpdateCollectionDto) => {
  return customInstance<CollectionResponseDto>({
    url: `/collections/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateCollectionDto,
  });
};

export const getCollectionsControllerUpdateCollectionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>,
    TError,
    { id: string; data: UpdateCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>,
  TError,
  { id: string; data: UpdateCollectionDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerUpdateCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>,
    { id: string; data: UpdateCollectionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return collectionsControllerUpdateCollection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerUpdateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>
>;
export type CollectionsControllerUpdateCollectionMutationBody = UpdateCollectionDto;
export type CollectionsControllerUpdateCollectionMutationError = void;

/**
 * @summary Update collection properties (excluding image)
 */
export const useCollectionsControllerUpdateCollection = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>,
    TError,
    { id: string; data: UpdateCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollection>>,
  TError,
  { id: string; data: UpdateCollectionDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerUpdateCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete a collection
 */
export const collectionsControllerDeleteCollection = (id: string) => {
  return customInstance<void>({ url: `/collections/${id}`, method: 'DELETE' });
};

export const getCollectionsControllerDeleteCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['collectionsControllerDeleteCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return collectionsControllerDeleteCollection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerDeleteCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>
>;

export type CollectionsControllerDeleteCollectionMutationError = unknown;

/**
 * @summary Delete a collection
 */
export const useCollectionsControllerDeleteCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerDeleteCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getCollectionsControllerDeleteCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get a collection by brand id
 */
export const collectionsControllerGetCollectionByBrandId = (brandId: string, signal?: AbortSignal) => {
  return customInstance<CollectionWithDropsResponseDto[]>({
    url: `/collections/brand/${brandId}`,
    method: 'GET',
    signal,
  });
};

export const getCollectionsControllerGetCollectionByBrandIdQueryKey = (brandId: string) => {
  return [`/collections/brand/${brandId}`] as const;
};

export const getCollectionsControllerGetCollectionByBrandIdQueryOptions = <
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
  TError = unknown,
>(
  brandId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCollectionsControllerGetCollectionByBrandIdQueryKey(brandId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>> = ({
    signal,
  }) => collectionsControllerGetCollectionByBrandId(brandId, signal);

  return { queryKey, queryFn, enabled: !!brandId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CollectionsControllerGetCollectionByBrandIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>
>;
export type CollectionsControllerGetCollectionByBrandIdQueryError = unknown;

export function useCollectionsControllerGetCollectionByBrandId<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
  TError = unknown,
>(
  brandId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionByBrandId<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
  TError = unknown,
>(
  brandId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionByBrandId<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
  TError = unknown,
>(
  brandId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get a collection by brand id
 */

export function useCollectionsControllerGetCollectionByBrandId<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>,
  TError = unknown,
>(
  brandId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionByBrandId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCollectionsControllerGetCollectionByBrandIdQueryOptions(brandId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all stickers belonging to a collection
 */
export const collectionsControllerGetCollectionStickers = (id: string, signal?: AbortSignal) => {
  return customInstance<StickerResponseDto[]>({ url: `/collections/${id}/stickers`, method: 'GET', signal });
};

export const getCollectionsControllerGetCollectionStickersQueryKey = (id: string) => {
  return [`/collections/${id}/stickers`] as const;
};

export const getCollectionsControllerGetCollectionStickersQueryOptions = <
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCollectionsControllerGetCollectionStickersQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>> = ({ signal }) =>
    collectionsControllerGetCollectionStickers(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CollectionsControllerGetCollectionStickersQueryResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>
>;
export type CollectionsControllerGetCollectionStickersQueryError = void;

export function useCollectionsControllerGetCollectionStickers<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionStickers<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionStickers<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all stickers belonging to a collection
 */

export function useCollectionsControllerGetCollectionStickers<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionStickers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCollectionsControllerGetCollectionStickersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get collection pack availability (remaining supply)
 */
export const collectionsControllerGetCollectionAvailability = (id: string, signal?: AbortSignal) => {
  return customInstance<CollectionAvailabilityResponseDto>({
    url: `/collections/${id}/availability`,
    method: 'GET',
    signal,
  });
};

export const getCollectionsControllerGetCollectionAvailabilityQueryKey = (id: string) => {
  return [`/collections/${id}/availability`] as const;
};

export const getCollectionsControllerGetCollectionAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCollectionsControllerGetCollectionAvailabilityQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>> = ({
    signal,
  }) => collectionsControllerGetCollectionAvailability(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CollectionsControllerGetCollectionAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>
>;
export type CollectionsControllerGetCollectionAvailabilityQueryError = void;

export function useCollectionsControllerGetCollectionAvailability<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionAvailability<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
          TError,
          Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCollectionsControllerGetCollectionAvailability<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get collection pack availability (remaining supply)
 */

export function useCollectionsControllerGetCollectionAvailability<
  TData = Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof collectionsControllerGetCollectionAvailability>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCollectionsControllerGetCollectionAvailabilityQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new collection
 */
export const collectionsControllerCreateCollection = (
  createCollectionWithImageDto: CreateCollectionWithImageDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append('image', createCollectionWithImageDto.image);
  formData.append('request', JSON.stringify(createCollectionWithImageDto.request));

  return customInstance<CreateCollectionResponseDto>({
    url: `/collections/create`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCollectionsControllerCreateCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerCreateCollection>>,
    TError,
    { data: CreateCollectionWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerCreateCollection>>,
  TError,
  { data: CreateCollectionWithImageDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerCreateCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerCreateCollection>>,
    { data: CreateCollectionWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return collectionsControllerCreateCollection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerCreateCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerCreateCollection>>
>;
export type CollectionsControllerCreateCollectionMutationBody = CreateCollectionWithImageDto;
export type CollectionsControllerCreateCollectionMutationError = unknown;

/**
 * @summary Create a new collection
 */
export const useCollectionsControllerCreateCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerCreateCollection>>,
    TError,
    { data: CreateCollectionWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerCreateCollection>>,
  TError,
  { data: CreateCollectionWithImageDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerCreateCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add stickers to a collection (Swagger-friendly)
 */
export const collectionsControllerAddStickersToCollection = (
  collectionId: string,
  addStickersMultipartDto: AddStickersMultipartDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  addStickersMultipartDto.stickers.forEach((value) => formData.append('stickers', value));
  formData.append('meta', addStickersMultipartDto.meta);

  return customInstance<CollectionResponseDto>({
    url: `/collections/${collectionId}/add-stickers`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getCollectionsControllerAddStickersToCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>,
    TError,
    { collectionId: string; data: AddStickersMultipartDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>,
  TError,
  { collectionId: string; data: AddStickersMultipartDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerAddStickersToCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>,
    { collectionId: string; data: AddStickersMultipartDto }
  > = (props) => {
    const { collectionId, data } = props ?? {};

    return collectionsControllerAddStickersToCollection(collectionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerAddStickersToCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>
>;
export type CollectionsControllerAddStickersToCollectionMutationBody = AddStickersMultipartDto;
export type CollectionsControllerAddStickersToCollectionMutationError = unknown;

/**
 * @summary Add stickers to a collection (Swagger-friendly)
 */
export const useCollectionsControllerAddStickersToCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>,
    TError,
    { collectionId: string; data: AddStickersMultipartDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerAddStickersToCollection>>,
  TError,
  { collectionId: string; data: AddStickersMultipartDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerAddStickersToCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Remove stickers from a collection
 */
export const collectionsControllerRemoveStickersFromCollection = (
  collectionId: string,
  removeStickersDto: RemoveStickersDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/collections/${collectionId}/remove-stickers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: removeStickersDto,
    signal,
  });
};

export const getCollectionsControllerRemoveStickersFromCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>,
    TError,
    { collectionId: string; data: RemoveStickersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>,
  TError,
  { collectionId: string; data: RemoveStickersDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerRemoveStickersFromCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>,
    { collectionId: string; data: RemoveStickersDto }
  > = (props) => {
    const { collectionId, data } = props ?? {};

    return collectionsControllerRemoveStickersFromCollection(collectionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerRemoveStickersFromCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>
>;
export type CollectionsControllerRemoveStickersFromCollectionMutationBody = RemoveStickersDto;
export type CollectionsControllerRemoveStickersFromCollectionMutationError = unknown;

/**
 * @summary Remove stickers from a collection
 */
export const useCollectionsControllerRemoveStickersFromCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>,
    TError,
    { collectionId: string; data: RemoveStickersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerRemoveStickersFromCollection>>,
  TError,
  { collectionId: string; data: RemoveStickersDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerRemoveStickersFromCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update collection image
 */
export const collectionsControllerUpdateCollectionImage = (
  id: string,
  updateCollectionImageDto: UpdateCollectionImageDto,
) => {
  const formData = new FormData();
  formData.append('image', updateCollectionImageDto.image);

  return customInstance<void>({
    url: `/collections/${id}/image`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getCollectionsControllerUpdateCollectionImageMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>,
    TError,
    { id: string; data: UpdateCollectionImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>,
  TError,
  { id: string; data: UpdateCollectionImageDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerUpdateCollectionImage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>,
    { id: string; data: UpdateCollectionImageDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return collectionsControllerUpdateCollectionImage(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerUpdateCollectionImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>
>;
export type CollectionsControllerUpdateCollectionImageMutationBody = UpdateCollectionImageDto;
export type CollectionsControllerUpdateCollectionImageMutationError = unknown;

/**
 * @summary Update collection image
 */
export const useCollectionsControllerUpdateCollectionImage = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>,
    TError,
    { id: string; data: UpdateCollectionImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionImage>>,
  TError,
  { id: string; data: UpdateCollectionImageDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerUpdateCollectionImageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update collection Lottie animation file
 */
export const collectionsControllerUpdateCollectionLottie = (
  id: string,
  updateCollectionLottieDto: UpdateCollectionLottieDto,
) => {
  const formData = new FormData();
  formData.append('lottie', updateCollectionLottieDto.lottie);

  return customInstance<void>({
    url: `/collections/${id}/lottie`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getCollectionsControllerUpdateCollectionLottieMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>,
    TError,
    { id: string; data: UpdateCollectionLottieDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>,
  TError,
  { id: string; data: UpdateCollectionLottieDto },
  TContext
> => {
  const mutationKey = ['collectionsControllerUpdateCollectionLottie'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>,
    { id: string; data: UpdateCollectionLottieDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return collectionsControllerUpdateCollectionLottie(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CollectionsControllerUpdateCollectionLottieMutationResult = NonNullable<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>
>;
export type CollectionsControllerUpdateCollectionLottieMutationBody = UpdateCollectionLottieDto;
export type CollectionsControllerUpdateCollectionLottieMutationError = void;

/**
 * @summary Update collection Lottie animation file
 */
export const useCollectionsControllerUpdateCollectionLottie = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>,
    TError,
    { id: string; data: UpdateCollectionLottieDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof collectionsControllerUpdateCollectionLottie>>,
  TError,
  { id: string; data: UpdateCollectionLottieDto },
  TContext
> => {
  const mutationOptions = getCollectionsControllerUpdateCollectionLottieMutationOptions(options);

  return useMutation(mutationOptions);
};

export const cdnControllerHealth = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/cdn/health`, method: 'GET', signal });
};

export const getCdnControllerHealthQueryKey = () => {
  return [`/cdn/health`] as const;
};

export const getCdnControllerHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof cdnControllerHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cdnControllerHealth>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCdnControllerHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cdnControllerHealth>>> = ({ signal }) =>
    cdnControllerHealth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof cdnControllerHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CdnControllerHealthQueryResult = NonNullable<Awaited<ReturnType<typeof cdnControllerHealth>>>;
export type CdnControllerHealthQueryError = unknown;

export function useCdnControllerHealth<
  TData = Awaited<ReturnType<typeof cdnControllerHealth>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof cdnControllerHealth>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof cdnControllerHealth>>,
        TError,
        Awaited<ReturnType<typeof cdnControllerHealth>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCdnControllerHealth<
  TData = Awaited<ReturnType<typeof cdnControllerHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cdnControllerHealth>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof cdnControllerHealth>>,
        TError,
        Awaited<ReturnType<typeof cdnControllerHealth>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCdnControllerHealth<
  TData = Awaited<ReturnType<typeof cdnControllerHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cdnControllerHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useCdnControllerHealth<
  TData = Awaited<ReturnType<typeof cdnControllerHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof cdnControllerHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCdnControllerHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get unwrapped packs
 */
export const packsControllerGetUserPacks = (signal?: AbortSignal) => {
  return customInstance<UserOpenedPacksResponseDto>({ url: `/packs/unwrapped`, method: 'GET', signal });
};

export const getPacksControllerGetUserPacksQueryKey = () => {
  return [`/packs/unwrapped`] as const;
};

export const getPacksControllerGetUserPacksQueryOptions = <
  TData = Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetUserPacks>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPacksControllerGetUserPacksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof packsControllerGetUserPacks>>> = ({ signal }) =>
    packsControllerGetUserPacks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PacksControllerGetUserPacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerGetUserPacks>>
>;
export type PacksControllerGetUserPacksQueryError = unknown;

export function usePacksControllerGetUserPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetUserPacks>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
        TError,
        Awaited<ReturnType<typeof packsControllerGetUserPacks>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetUserPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetUserPacks>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
        TError,
        Awaited<ReturnType<typeof packsControllerGetUserPacks>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetUserPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetUserPacks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get unwrapped packs
 */

export function usePacksControllerGetUserPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetUserPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetUserPacks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPacksControllerGetUserPacksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get blindbox packs
 */
export const packsControllerGetBlindboxPacks = (signal?: AbortSignal) => {
  return customInstance<UserBlindboxPacksResponseDto>({ url: `/packs/blindboxes`, method: 'GET', signal });
};

export const getPacksControllerGetBlindboxPacksQueryKey = () => {
  return [`/packs/blindboxes`] as const;
};

export const getPacksControllerGetBlindboxPacksQueryOptions = <
  TData = Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPacksControllerGetBlindboxPacksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>> = ({ signal }) =>
    packsControllerGetBlindboxPacks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PacksControllerGetBlindboxPacksQueryResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>
>;
export type PacksControllerGetBlindboxPacksQueryError = unknown;

export function usePacksControllerGetBlindboxPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
        TError,
        Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetBlindboxPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
        TError,
        Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetBlindboxPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get blindbox packs
 */

export function usePacksControllerGetBlindboxPacks<
  TData = Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetBlindboxPacks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPacksControllerGetBlindboxPacksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get pack details
 */
export const packsControllerGetPackById = (id: string, signal?: AbortSignal) => {
  return customInstance<PackResponseDto>({ url: `/packs/${id}`, method: 'GET', signal });
};

export const getPacksControllerGetPackByIdQueryKey = (id: string) => {
  return [`/packs/${id}`] as const;
};

export const getPacksControllerGetPackByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof packsControllerGetPackById>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackById>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPacksControllerGetPackByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof packsControllerGetPackById>>> = ({ signal }) =>
    packsControllerGetPackById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof packsControllerGetPackById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PacksControllerGetPackByIdQueryResult = NonNullable<Awaited<ReturnType<typeof packsControllerGetPackById>>>;
export type PacksControllerGetPackByIdQueryError = void;

export function usePacksControllerGetPackById<
  TData = Awaited<ReturnType<typeof packsControllerGetPackById>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof packsControllerGetPackById>>,
          TError,
          Awaited<ReturnType<typeof packsControllerGetPackById>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetPackById<
  TData = Awaited<ReturnType<typeof packsControllerGetPackById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof packsControllerGetPackById>>,
          TError,
          Awaited<ReturnType<typeof packsControllerGetPackById>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetPackById<
  TData = Awaited<ReturnType<typeof packsControllerGetPackById>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackById>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pack details
 */

export function usePacksControllerGetPackById<
  TData = Awaited<ReturnType<typeof packsControllerGetPackById>>,
  TError = void,
>(
  id: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackById>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPacksControllerGetPackByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Unwrap a pack to reveal rarity and create Telegram sticker set
 */
export const packsControllerUnwrapPack = (id: string, signal?: AbortSignal) => {
  return customInstance<UnwrapResponseDto>({ url: `/packs/${id}/unwrap`, method: 'POST', signal });
};

export const getPacksControllerUnwrapPackMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerUnwrapPack>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof packsControllerUnwrapPack>>, TError, { id: string }, TContext> => {
  const mutationKey = ['packsControllerUnwrapPack'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof packsControllerUnwrapPack>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return packsControllerUnwrapPack(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PacksControllerUnwrapPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerUnwrapPack>>
>;

export type PacksControllerUnwrapPackMutationError = void;

/**
 * @summary Unwrap a pack to reveal rarity and create Telegram sticker set
 */
export const usePacksControllerUnwrapPack = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerUnwrapPack>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof packsControllerUnwrapPack>>, TError, { id: string }, TContext> => {
  const mutationOptions = getPacksControllerUnwrapPackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get possible collections and drop probabilities for an unopened pack
 */
export const packsControllerGetPackPossibleDrops = (id: string, signal?: AbortSignal) => {
  return customInstance<PossibleDropsResponseDto>({ url: `/packs/${id}/possible-drops`, method: 'GET', signal });
};

export const getPacksControllerGetPackPossibleDropsQueryKey = (id: string) => {
  return [`/packs/${id}/possible-drops`] as const;
};

export const getPacksControllerGetPackPossibleDropsQueryOptions = <
  TData = Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPacksControllerGetPackPossibleDropsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>> = ({ signal }) =>
    packsControllerGetPackPossibleDrops(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PacksControllerGetPackPossibleDropsQueryResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>
>;
export type PacksControllerGetPackPossibleDropsQueryError = void;

export function usePacksControllerGetPackPossibleDrops<
  TData = Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
          TError,
          Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetPackPossibleDrops<
  TData = Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
          TError,
          Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePacksControllerGetPackPossibleDrops<
  TData = Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get possible collections and drop probabilities for an unopened pack
 */

export function usePacksControllerGetPackPossibleDrops<
  TData = Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof packsControllerGetPackPossibleDrops>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPacksControllerGetPackPossibleDropsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find internal pack ID by partner marketplace IDs
 */
export const packsControllerFindPackByPartnerIds = (
  findPackByPartnerIdsRequestDto: FindPackByPartnerIdsRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<FindPackByPartnerIdsResponseDto>({
    url: `/packs/find-by-partner-ids`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: findPackByPartnerIdsRequestDto,
    signal,
  });
};

export const getPacksControllerFindPackByPartnerIdsMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>,
    TError,
    { data: FindPackByPartnerIdsRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>,
  TError,
  { data: FindPackByPartnerIdsRequestDto },
  TContext
> => {
  const mutationKey = ['packsControllerFindPackByPartnerIds'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>,
    { data: FindPackByPartnerIdsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return packsControllerFindPackByPartnerIds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PacksControllerFindPackByPartnerIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>
>;
export type PacksControllerFindPackByPartnerIdsMutationBody = FindPackByPartnerIdsRequestDto;
export type PacksControllerFindPackByPartnerIdsMutationError = void;

/**
 * @summary Find internal pack ID by partner marketplace IDs
 */
export const usePacksControllerFindPackByPartnerIds = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>,
    TError,
    { data: FindPackByPartnerIdsRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof packsControllerFindPackByPartnerIds>>,
  TError,
  { data: FindPackByPartnerIdsRequestDto },
  TContext
> => {
  const mutationOptions = getPacksControllerFindPackByPartnerIdsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Transfer pack to partner marketplace
 */
export const packsControllerTransferToMarket = (
  transferToMarketRequestDto: TransferToMarketRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/packs/transfer-to-market`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transferToMarketRequestDto,
    signal,
  });
};

export const getPacksControllerTransferToMarketMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerTransferToMarket>>,
    TError,
    { data: TransferToMarketRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof packsControllerTransferToMarket>>,
  TError,
  { data: TransferToMarketRequestDto },
  TContext
> => {
  const mutationKey = ['packsControllerTransferToMarket'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof packsControllerTransferToMarket>>,
    { data: TransferToMarketRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return packsControllerTransferToMarket(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PacksControllerTransferToMarketMutationResult = NonNullable<
  Awaited<ReturnType<typeof packsControllerTransferToMarket>>
>;
export type PacksControllerTransferToMarketMutationBody = TransferToMarketRequestDto;
export type PacksControllerTransferToMarketMutationError = void;

/**
 * @summary Transfer pack to partner marketplace
 */
export const usePacksControllerTransferToMarket = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof packsControllerTransferToMarket>>,
    TError,
    { data: TransferToMarketRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof packsControllerTransferToMarket>>,
  TError,
  { data: TransferToMarketRequestDto },
  TContext
> => {
  const mutationOptions = getPacksControllerTransferToMarketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all direct sale offers with filters
 */
export const directSaleOffersControllerGetAllDirectSaleOffers = (
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  signal?: AbortSignal,
) => {
  return customInstance<DirectSaleOfferListResponseDto>({ url: `/direct-sale-offers`, method: 'GET', params, signal });
};

export const getDirectSaleOffersControllerGetAllDirectSaleOffersQueryKey = (
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
) => {
  return [`/direct-sale-offers`, ...(params ? [params] : [])] as const;
};

export const getDirectSaleOffersControllerGetAllDirectSaleOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
  TError = unknown,
>(
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDirectSaleOffersControllerGetAllDirectSaleOffersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>> = ({
    signal,
  }) => directSaleOffersControllerGetAllDirectSaleOffers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DirectSaleOffersControllerGetAllDirectSaleOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>
>;
export type DirectSaleOffersControllerGetAllDirectSaleOffersQueryError = unknown;

export function useDirectSaleOffersControllerGetAllDirectSaleOffers<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
  TError = unknown,
>(
  params: undefined | DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
          TError,
          Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDirectSaleOffersControllerGetAllDirectSaleOffers<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
  TError = unknown,
>(
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
          TError,
          Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDirectSaleOffersControllerGetAllDirectSaleOffers<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
  TError = unknown,
>(
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all direct sale offers with filters
 */

export function useDirectSaleOffersControllerGetAllDirectSaleOffers<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>,
  TError = unknown,
>(
  params?: DirectSaleOffersControllerGetAllDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetAllDirectSaleOffers>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDirectSaleOffersControllerGetAllDirectSaleOffersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get direct sale offer details by ID
 */
export const directSaleOffersControllerGetDirectSaleOfferDetails = (id: string, signal?: AbortSignal) => {
  return customInstance<DirectSaleOfferResponseDto>({ url: `/direct-sale-offers/${id}`, method: 'GET', signal });
};

export const getDirectSaleOffersControllerGetDirectSaleOfferDetailsQueryKey = (id: string) => {
  return [`/direct-sale-offers/${id}`] as const;
};

export const getDirectSaleOffersControllerGetDirectSaleOfferDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDirectSaleOffersControllerGetDirectSaleOfferDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>> = ({
    signal,
  }) => directSaleOffersControllerGetDirectSaleOfferDetails(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DirectSaleOffersControllerGetDirectSaleOfferDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>
>;
export type DirectSaleOffersControllerGetDirectSaleOfferDetailsQueryError = void;

export function useDirectSaleOffersControllerGetDirectSaleOfferDetails<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
          TError,
          Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDirectSaleOffersControllerGetDirectSaleOfferDetails<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
          TError,
          Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDirectSaleOffersControllerGetDirectSaleOfferDetails<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get direct sale offer details by ID
 */

export function useDirectSaleOffersControllerGetDirectSaleOfferDetails<
  TData = Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof directSaleOffersControllerGetDirectSaleOfferDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDirectSaleOffersControllerGetDirectSaleOfferDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a purchase for a direct sale offer
 */
export const directSaleOffersControllerCreateDirectSalePurchase = (
  id: string,
  createDirectSalePurchaseDto: CreateDirectSalePurchaseDto,
  signal?: AbortSignal,
) => {
  return customInstance<CreatePurchaseResponseDto>({
    url: `/direct-sale-offers/${id}/purchase`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDirectSalePurchaseDto,
    signal,
  });
};

export const getDirectSaleOffersControllerCreateDirectSalePurchaseMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>,
    TError,
    { id: string; data: CreateDirectSalePurchaseDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>,
  TError,
  { id: string; data: CreateDirectSalePurchaseDto },
  TContext
> => {
  const mutationKey = ['directSaleOffersControllerCreateDirectSalePurchase'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>,
    { id: string; data: CreateDirectSalePurchaseDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return directSaleOffersControllerCreateDirectSalePurchase(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DirectSaleOffersControllerCreateDirectSalePurchaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>
>;
export type DirectSaleOffersControllerCreateDirectSalePurchaseMutationBody = CreateDirectSalePurchaseDto;
export type DirectSaleOffersControllerCreateDirectSalePurchaseMutationError = void;

/**
 * @summary Create a purchase for a direct sale offer
 */
export const useDirectSaleOffersControllerCreateDirectSalePurchase = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>,
    TError,
    { id: string; data: CreateDirectSalePurchaseDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof directSaleOffersControllerCreateDirectSalePurchase>>,
  TError,
  { id: string; data: CreateDirectSalePurchaseDto },
  TContext
> => {
  const mutationOptions = getDirectSaleOffersControllerCreateDirectSalePurchaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create a direct sale offer with optional infinite supply. When infiniteSupply is set to "generate_on_sale", packs are generated on-demand during sales. When set to "disabled" (default), the specified totalSupplyInSale must be available.
 * @summary Create a new direct sale offer
 */
export const adminDirectSaleOffersControllerCreateDirectSaleOffer = (
  createDirectSaleOfferDto: CreateDirectSaleOfferDto,
  signal?: AbortSignal,
) => {
  return customInstance<CreatedEntityResponseDto>({
    url: `/admin/direct-sale-offers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createDirectSaleOfferDto,
    signal,
  });
};

export const getAdminDirectSaleOffersControllerCreateDirectSaleOfferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>,
    TError,
    { data: CreateDirectSaleOfferDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>,
  TError,
  { data: CreateDirectSaleOfferDto },
  TContext
> => {
  const mutationKey = ['adminDirectSaleOffersControllerCreateDirectSaleOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>,
    { data: CreateDirectSaleOfferDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminDirectSaleOffersControllerCreateDirectSaleOffer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDirectSaleOffersControllerCreateDirectSaleOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>
>;
export type AdminDirectSaleOffersControllerCreateDirectSaleOfferMutationBody = CreateDirectSaleOfferDto;
export type AdminDirectSaleOffersControllerCreateDirectSaleOfferMutationError = void;

/**
 * @summary Create a new direct sale offer
 */
export const useAdminDirectSaleOffersControllerCreateDirectSaleOffer = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>,
    TError,
    { data: CreateDirectSaleOfferDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerCreateDirectSaleOffer>>,
  TError,
  { data: CreateDirectSaleOfferDto },
  TContext
> => {
  const mutationOptions = getAdminDirectSaleOffersControllerCreateDirectSaleOfferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all direct sale offers with filters
 */
export const adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers = (
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  signal?: AbortSignal,
) => {
  return customInstance<DirectSaleOfferListResponseDto>({
    url: `/admin/direct-sale-offers`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryKey = (
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
) => {
  return [`/admin/direct-sale-offers`, ...(params ? [params] : [])] as const;
};

export const getAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
  TError = unknown,
>(
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>
  > = ({ signal }) => adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>
>;
export type AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryError = unknown;

export function useAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffers<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
  TError = unknown,
>(
  params: undefined | AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
          TError,
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffers<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
  TError = unknown,
>(
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
          TError,
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffers<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
  TError = unknown,
>(
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all direct sale offers with filters
 */

export function useAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffers<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
  TError = unknown,
>(
  params?: AdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetAllAdminDirectSaleOffers>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDirectSaleOffersControllerGetAllAdminDirectSaleOffersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update direct sale offer fields including infinite supply configuration. When disabling infinite supply (changing from "generate_on_sale" to "disabled"), sufficient packs must be available. When enabling infinite supply, pack availability is not validated.
 * @summary Update a direct sale offer
 */
export const adminDirectSaleOffersControllerUpdateDirectSaleOffer = (
  id: string,
  updateDirectSaleOfferDto: UpdateDirectSaleOfferDto,
) => {
  return customInstance<CreatedEntityResponseDto>({
    url: `/admin/direct-sale-offers/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateDirectSaleOfferDto,
  });
};

export const getAdminDirectSaleOffersControllerUpdateDirectSaleOfferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>,
    TError,
    { id: string; data: UpdateDirectSaleOfferDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>,
  TError,
  { id: string; data: UpdateDirectSaleOfferDto },
  TContext
> => {
  const mutationKey = ['adminDirectSaleOffersControllerUpdateDirectSaleOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>,
    { id: string; data: UpdateDirectSaleOfferDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDirectSaleOffersControllerUpdateDirectSaleOffer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDirectSaleOffersControllerUpdateDirectSaleOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>
>;
export type AdminDirectSaleOffersControllerUpdateDirectSaleOfferMutationBody = UpdateDirectSaleOfferDto;
export type AdminDirectSaleOffersControllerUpdateDirectSaleOfferMutationError = void;

/**
 * @summary Update a direct sale offer
 */
export const useAdminDirectSaleOffersControllerUpdateDirectSaleOffer = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>,
    TError,
    { id: string; data: UpdateDirectSaleOfferDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUpdateDirectSaleOffer>>,
  TError,
  { id: string; data: UpdateDirectSaleOfferDto },
  TContext
> => {
  const mutationOptions = getAdminDirectSaleOffersControllerUpdateDirectSaleOfferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Archive a direct sale offer
 */
export const adminDirectSaleOffersControllerArchiveDirectSaleOffer = (id: string) => {
  return customInstance<void>({ url: `/admin/direct-sale-offers/${id}/archive`, method: 'PATCH' });
};

export const getAdminDirectSaleOffersControllerArchiveDirectSaleOfferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminDirectSaleOffersControllerArchiveDirectSaleOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminDirectSaleOffersControllerArchiveDirectSaleOffer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDirectSaleOffersControllerArchiveDirectSaleOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>
>;

export type AdminDirectSaleOffersControllerArchiveDirectSaleOfferMutationError = void;

/**
 * @summary Archive a direct sale offer
 */
export const useAdminDirectSaleOffersControllerArchiveDirectSaleOffer = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerArchiveDirectSaleOffer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminDirectSaleOffersControllerArchiveDirectSaleOfferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Unarchive a direct sale offer with supply validation
 */
export const adminDirectSaleOffersControllerUnarchiveDirectSaleOffer = (id: string) => {
  return customInstance<CreatedEntityResponseDto>({
    url: `/admin/direct-sale-offers/${id}/unarchive`,
    method: 'PATCH',
  });
};

export const getAdminDirectSaleOffersControllerUnarchiveDirectSaleOfferMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminDirectSaleOffersControllerUnarchiveDirectSaleOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminDirectSaleOffersControllerUnarchiveDirectSaleOffer(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDirectSaleOffersControllerUnarchiveDirectSaleOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>
>;

export type AdminDirectSaleOffersControllerUnarchiveDirectSaleOfferMutationError = void;

/**
 * @summary Unarchive a direct sale offer with supply validation
 */
export const useAdminDirectSaleOffersControllerUnarchiveDirectSaleOffer = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerUnarchiveDirectSaleOffer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminDirectSaleOffersControllerUnarchiveDirectSaleOfferMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get summary statistics for a direct sale offer
 */
export const adminDirectSaleOffersControllerGetDirectSaleOfferSummary = (id: string, signal?: AbortSignal) => {
  return customInstance<DirectSaleOfferSummaryResponseDto>({
    url: `/admin/direct-sale-offers/${id}/summary`,
    method: 'GET',
    signal,
  });
};

export const getAdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryKey = (id: string) => {
  return [`/admin/direct-sale-offers/${id}/summary`] as const;
};

export const getAdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>
  > = ({ signal }) => adminDirectSaleOffersControllerGetDirectSaleOfferSummary(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>
>;
export type AdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryError = void;

export function useAdminDirectSaleOffersControllerGetDirectSaleOfferSummary<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
          TError,
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDirectSaleOffersControllerGetDirectSaleOfferSummary<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
          TError,
          Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDirectSaleOffersControllerGetDirectSaleOfferSummary<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get summary statistics for a direct sale offer
 */

export function useAdminDirectSaleOffersControllerGetDirectSaleOfferSummary<
  TData = Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSaleOfferSummary>>,
        TError,
        TData
      >
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDirectSaleOffersControllerGetDirectSaleOfferSummaryQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get paginated list of direct sale purchases with optional filters
 */
export const adminDirectSaleOffersControllerGetDirectSalePurchasesList = (
  directSalePurchaseFiltersDto: DirectSalePurchaseFiltersDto,
  signal?: AbortSignal,
) => {
  return customInstance<DirectSaleOfferListResponseDto>({
    url: `/admin/direct-sale-offers/purchases/list`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: directSalePurchaseFiltersDto,
    signal,
  });
};

export const getAdminDirectSaleOffersControllerGetDirectSalePurchasesListMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>,
    TError,
    { data: DirectSalePurchaseFiltersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>,
  TError,
  { data: DirectSalePurchaseFiltersDto },
  TContext
> => {
  const mutationKey = ['adminDirectSaleOffersControllerGetDirectSalePurchasesList'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>,
    { data: DirectSalePurchaseFiltersDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminDirectSaleOffersControllerGetDirectSalePurchasesList(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDirectSaleOffersControllerGetDirectSalePurchasesListMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>
>;
export type AdminDirectSaleOffersControllerGetDirectSalePurchasesListMutationBody = DirectSalePurchaseFiltersDto;
export type AdminDirectSaleOffersControllerGetDirectSalePurchasesListMutationError = void;

/**
 * @summary Get paginated list of direct sale purchases with optional filters
 */
export const useAdminDirectSaleOffersControllerGetDirectSalePurchasesList = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>,
    TError,
    { data: DirectSalePurchaseFiltersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDirectSaleOffersControllerGetDirectSalePurchasesList>>,
  TError,
  { data: DirectSalePurchaseFiltersDto },
  TContext
> => {
  const mutationOptions = getAdminDirectSaleOffersControllerGetDirectSalePurchasesListMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Lock TON for drop participation
 */
export const dropsControllerParticipate = (dropId: string, participateDto: ParticipateDto, signal?: AbortSignal) => {
  return customInstance<ParticipationResponseDto>({
    url: `/drops/${dropId}/participate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: participateDto,
    signal,
  });
};

export const getDropsControllerParticipateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerParticipate>>,
    TError,
    { dropId: string; data: ParticipateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dropsControllerParticipate>>,
  TError,
  { dropId: string; data: ParticipateDto },
  TContext
> => {
  const mutationKey = ['dropsControllerParticipate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dropsControllerParticipate>>,
    { dropId: string; data: ParticipateDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return dropsControllerParticipate(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DropsControllerParticipateMutationResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerParticipate>>
>;
export type DropsControllerParticipateMutationBody = ParticipateDto;
export type DropsControllerParticipateMutationError = void;

/**
 * @summary Lock TON for drop participation
 */
export const useDropsControllerParticipate = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerParticipate>>,
    TError,
    { dropId: string; data: ParticipateDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dropsControllerParticipate>>,
  TError,
  { dropId: string; data: ParticipateDto },
  TContext
> => {
  const mutationOptions = getDropsControllerParticipateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user's participation details for a drop
 */
export const dropsControllerGetParticipation = (dropId: string, signal?: AbortSignal) => {
  return customInstance<ParticipationStatusDto>({ url: `/drops/${dropId}/participation`, method: 'GET', signal });
};

export const getDropsControllerGetParticipationQueryKey = (dropId: string) => {
  return [`/drops/${dropId}/participation`] as const;
};

export const getDropsControllerGetParticipationQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetParticipation>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetParticipationQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetParticipation>>> = ({ signal }) =>
    dropsControllerGetParticipation(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetParticipationQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetParticipation>>
>;
export type DropsControllerGetParticipationQueryError = void;

export function useDropsControllerGetParticipation<
  TData = Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetParticipation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetParticipation>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetParticipation<
  TData = Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetParticipation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetParticipation>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetParticipation<
  TData = Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetParticipation>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user's participation details for a drop
 */

export function useDropsControllerGetParticipation<
  TData = Awaited<ReturnType<typeof dropsControllerGetParticipation>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetParticipation>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetParticipationQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get drop IDs for which the current user is whitelisted
 */
export const dropsControllerGetMyWhitelistedDrops = (signal?: AbortSignal) => {
  return customInstance<MyWhitelistedDropsResponseDto>({ url: `/drops/my-whitelisted-drops`, method: 'GET', signal });
};

export const getDropsControllerGetMyWhitelistedDropsQueryKey = () => {
  return [`/drops/my-whitelisted-drops`] as const;
};

export const getDropsControllerGetMyWhitelistedDropsQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetMyWhitelistedDropsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>> = ({ signal }) =>
    dropsControllerGetMyWhitelistedDrops(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetMyWhitelistedDropsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>
>;
export type DropsControllerGetMyWhitelistedDropsQueryError = unknown;

export function useDropsControllerGetMyWhitelistedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetMyWhitelistedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetMyWhitelistedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get drop IDs for which the current user is whitelisted
 */

export function useDropsControllerGetMyWhitelistedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetMyWhitelistedDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetMyWhitelistedDropsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Increase locked amount for existing drop participation
 */
export const dropsControllerIncreaseLock = (dropId: string, increaseLockDto: IncreaseLockDto, signal?: AbortSignal) => {
  return customInstance<IncreaseLockResponseDto>({
    url: `/drops/${dropId}/increase-lock`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: increaseLockDto,
    signal,
  });
};

export const getDropsControllerIncreaseLockMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerIncreaseLock>>,
    TError,
    { dropId: string; data: IncreaseLockDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dropsControllerIncreaseLock>>,
  TError,
  { dropId: string; data: IncreaseLockDto },
  TContext
> => {
  const mutationKey = ['dropsControllerIncreaseLock'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dropsControllerIncreaseLock>>,
    { dropId: string; data: IncreaseLockDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return dropsControllerIncreaseLock(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DropsControllerIncreaseLockMutationResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerIncreaseLock>>
>;
export type DropsControllerIncreaseLockMutationBody = IncreaseLockDto;
export type DropsControllerIncreaseLockMutationError = void;

/**
 * @summary Increase locked amount for existing drop participation
 */
export const useDropsControllerIncreaseLock = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerIncreaseLock>>,
    TError,
    { dropId: string; data: IncreaseLockDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dropsControllerIncreaseLock>>,
  TError,
  { dropId: string; data: IncreaseLockDto },
  TContext
> => {
  const mutationOptions = getDropsControllerIncreaseLockMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get drop statistics including total locked amount, packs, and pack price (after drop starts)
 */
export const dropsControllerGetDropStats = (dropId: string, signal?: AbortSignal) => {
  return customInstance<DropStatsResponseDto>({ url: `/drops/${dropId}/stats`, method: 'GET', signal });
};

export const getDropsControllerGetDropStatsQueryKey = (dropId: string) => {
  return [`/drops/${dropId}/stats`] as const;
};

export const getDropsControllerGetDropStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetDropStats>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetDropStatsQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetDropStats>>> = ({ signal }) =>
    dropsControllerGetDropStats(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetDropStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetDropStats>>
>;
export type DropsControllerGetDropStatsQueryError = void;

export function useDropsControllerGetDropStats<
  TData = Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetDropStats>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetDropStats>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetDropStats<
  TData = Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetDropStats>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetDropStats>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetDropStats<
  TData = Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetDropStats>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get drop statistics including total locked amount, packs, and pack price (after drop starts)
 */

export function useDropsControllerGetDropStats<
  TData = Awaited<ReturnType<typeof dropsControllerGetDropStats>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetDropStats>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetDropStatsQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all user participations across drops
 */
export const dropsControllerGetAllParticipations = (signal?: AbortSignal) => {
  return customInstance<ParticipationStatusDto[]>({ url: `/drops/participations`, method: 'GET', signal });
};

export const getDropsControllerGetAllParticipationsQueryKey = () => {
  return [`/drops/participations`] as const;
};

export const getDropsControllerGetAllParticipationsQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetAllParticipationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>> = ({ signal }) =>
    dropsControllerGetAllParticipations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetAllParticipationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>
>;
export type DropsControllerGetAllParticipationsQueryError = unknown;

export function useDropsControllerGetAllParticipations<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetAllParticipations<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetAllParticipations<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all user participations across drops
 */

export function useDropsControllerGetAllParticipations<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllParticipations>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetAllParticipationsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Acknowledge participation and claim all packs for a drop
 */
export const dropsControllerAckAndClaimPacks = (dropId: string, signal?: AbortSignal) => {
  return customInstance<AckAndClaimResponseDto>({ url: `/drops/${dropId}/ack-and-claim`, method: 'POST', signal });
};

export const getDropsControllerAckAndClaimPacksMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>,
    TError,
    { dropId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>,
  TError,
  { dropId: string },
  TContext
> => {
  const mutationKey = ['dropsControllerAckAndClaimPacks'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>,
    { dropId: string }
  > = (props) => {
    const { dropId } = props ?? {};

    return dropsControllerAckAndClaimPacks(dropId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DropsControllerAckAndClaimPacksMutationResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>
>;

export type DropsControllerAckAndClaimPacksMutationError = void;

/**
 * @summary Acknowledge participation and claim all packs for a drop
 */
export const useDropsControllerAckAndClaimPacks = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>,
    TError,
    { dropId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof dropsControllerAckAndClaimPacks>>,
  TError,
  { dropId: string },
  TContext
> => {
  const mutationOptions = getDropsControllerAckAndClaimPacksMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all drops with pagination
 */
export const dropsControllerGetAllDropsPaginated = (
  params?: DropsControllerGetAllDropsPaginatedParams,
  signal?: AbortSignal,
) => {
  return customInstance<DropListResponseDto>({ url: `/drops`, method: 'GET', params, signal });
};

export const getDropsControllerGetAllDropsPaginatedQueryKey = (params?: DropsControllerGetAllDropsPaginatedParams) => {
  return [`/drops`, ...(params ? [params] : [])] as const;
};

export const getDropsControllerGetAllDropsPaginatedQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
  TError = unknown,
>(
  params?: DropsControllerGetAllDropsPaginatedParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetAllDropsPaginatedQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>> = ({ signal }) =>
    dropsControllerGetAllDropsPaginated(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetAllDropsPaginatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>
>;
export type DropsControllerGetAllDropsPaginatedQueryError = unknown;

export function useDropsControllerGetAllDropsPaginated<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
  TError = unknown,
>(
  params: undefined | DropsControllerGetAllDropsPaginatedParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetAllDropsPaginated<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
  TError = unknown,
>(
  params?: DropsControllerGetAllDropsPaginatedParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetAllDropsPaginated<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
  TError = unknown,
>(
  params?: DropsControllerGetAllDropsPaginatedParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all drops with pagination
 */

export function useDropsControllerGetAllDropsPaginated<
  TData = Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>,
  TError = unknown,
>(
  params?: DropsControllerGetAllDropsPaginatedParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetAllDropsPaginated>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetAllDropsPaginatedQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get active and upcoming drops sorted by start time
 */
export const dropsControllerGetSortedDrops = (signal?: AbortSignal) => {
  return customInstance<SortedDropItemResponseDto[]>({ url: `/drops/sorted`, method: 'GET', signal });
};

export const getDropsControllerGetSortedDropsQueryKey = () => {
  return [`/drops/sorted`] as const;
};

export const getDropsControllerGetSortedDropsQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetSortedDropsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>> = ({ signal }) =>
    dropsControllerGetSortedDrops(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetSortedDropsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>
>;
export type DropsControllerGetSortedDropsQueryError = unknown;

export function useDropsControllerGetSortedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetSortedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
        TError,
        Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetSortedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active and upcoming drops sorted by start time
 */

export function useDropsControllerGetSortedDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetSortedDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetSortedDropsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get possible collections and drop probabilities for a specific drop
 */
export const dropsControllerGetPossibleDrops = (dropId: string, signal?: AbortSignal) => {
  return customInstance<PossibleDropsResponseDto>({ url: `/drops/${dropId}/possible-drops`, method: 'GET', signal });
};

export const getDropsControllerGetPossibleDropsQueryKey = (dropId: string) => {
  return [`/drops/${dropId}/possible-drops`] as const;
};

export const getDropsControllerGetPossibleDropsQueryOptions = <
  TData = Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDropsControllerGetPossibleDropsQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>> = ({ signal }) =>
    dropsControllerGetPossibleDrops(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DropsControllerGetPossibleDropsQueryResult = NonNullable<
  Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>
>;
export type DropsControllerGetPossibleDropsQueryError = void;

export function useDropsControllerGetPossibleDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetPossibleDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
          TError,
          Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDropsControllerGetPossibleDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get possible collections and drop probabilities for a specific drop
 */

export function useDropsControllerGetPossibleDrops<
  TData = Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof dropsControllerGetPossibleDrops>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDropsControllerGetPossibleDropsQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get current on-chain wallet balance
 */
export const walletsControllerGetBalance = (params?: WalletsControllerGetBalanceParams, signal?: AbortSignal) => {
  return customInstance<WalletsControllerGetBalance200>({ url: `/wallets/balance`, method: 'GET', params, signal });
};

export const getWalletsControllerGetBalanceQueryKey = (params?: WalletsControllerGetBalanceParams) => {
  return [`/wallets/balance`, ...(params ? [params] : [])] as const;
};

export const getWalletsControllerGetBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsControllerGetBalance>>,
  TError = unknown,
>(
  params?: WalletsControllerGetBalanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetBalance>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsControllerGetBalanceQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsControllerGetBalance>>> = ({ signal }) =>
    walletsControllerGetBalance(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsControllerGetBalance>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WalletsControllerGetBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerGetBalance>>
>;
export type WalletsControllerGetBalanceQueryError = unknown;

export function useWalletsControllerGetBalance<
  TData = Awaited<ReturnType<typeof walletsControllerGetBalance>>,
  TError = unknown,
>(
  params: undefined | WalletsControllerGetBalanceParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetBalance>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletsControllerGetBalance>>,
          TError,
          Awaited<ReturnType<typeof walletsControllerGetBalance>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetBalance<
  TData = Awaited<ReturnType<typeof walletsControllerGetBalance>>,
  TError = unknown,
>(
  params?: WalletsControllerGetBalanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetBalance>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletsControllerGetBalance>>,
          TError,
          Awaited<ReturnType<typeof walletsControllerGetBalance>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetBalance<
  TData = Awaited<ReturnType<typeof walletsControllerGetBalance>>,
  TError = unknown,
>(
  params?: WalletsControllerGetBalanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetBalance>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current on-chain wallet balance
 */

export function useWalletsControllerGetBalance<
  TData = Awaited<ReturnType<typeof walletsControllerGetBalance>>,
  TError = unknown,
>(
  params?: WalletsControllerGetBalanceParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetBalance>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWalletsControllerGetBalanceQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get complete wallet information
 */
export const walletsControllerGetWalletInfo = (signal?: AbortSignal) => {
  return customInstance<WalletResponseDto>({ url: `/wallets/info`, method: 'GET', signal });
};

export const getWalletsControllerGetWalletInfoQueryKey = () => {
  return [`/wallets/info`] as const;
};

export const getWalletsControllerGetWalletInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsControllerGetWalletInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>> = ({ signal }) =>
    walletsControllerGetWalletInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WalletsControllerGetWalletInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>
>;
export type WalletsControllerGetWalletInfoQueryError = unknown;

export function useWalletsControllerGetWalletInfo<
  TData = Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetWalletInfo<
  TData = Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetWalletInfo<
  TData = Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get complete wallet information
 */

export function useWalletsControllerGetWalletInfo<
  TData = Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetWalletInfo>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWalletsControllerGetWalletInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Initiate withdrawal to external address
 */
export const walletsControllerWithdraw = (withdrawDto: WithdrawDto, signal?: AbortSignal) => {
  return customInstance<WalletsControllerWithdraw201>({
    url: `/wallets/withdraw`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: withdrawDto,
    signal,
  });
};

export const getWalletsControllerWithdrawMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof walletsControllerWithdraw>>,
    TError,
    { data: WithdrawDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof walletsControllerWithdraw>>,
  TError,
  { data: WithdrawDto },
  TContext
> => {
  const mutationKey = ['walletsControllerWithdraw'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof walletsControllerWithdraw>>, { data: WithdrawDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return walletsControllerWithdraw(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WalletsControllerWithdrawMutationResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerWithdraw>>
>;
export type WalletsControllerWithdrawMutationBody = WithdrawDto;
export type WalletsControllerWithdrawMutationError = void;

/**
 * @summary Initiate withdrawal to external address
 */
export const useWalletsControllerWithdraw = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof walletsControllerWithdraw>>,
    TError,
    { data: WithdrawDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof walletsControllerWithdraw>>,
  TError,
  { data: WithdrawDto },
  TContext
> => {
  const mutationOptions = getWalletsControllerWithdrawMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get transaction history
 */
export const walletsControllerGetTransactions = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/wallets/transactions`, method: 'GET', signal });
};

export const getWalletsControllerGetTransactionsQueryKey = () => {
  return [`/wallets/transactions`] as const;
};

export const getWalletsControllerGetTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransactions>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsControllerGetTransactionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsControllerGetTransactions>>> = ({ signal }) =>
    walletsControllerGetTransactions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WalletsControllerGetTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerGetTransactions>>
>;
export type WalletsControllerGetTransactionsQueryError = unknown;

export function useWalletsControllerGetTransactions<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransactions>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetTransactions>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetTransactions<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransactions>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetTransactions>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetTransactions<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransactions>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get transaction history
 */

export function useWalletsControllerGetTransactions<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransactions>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransactions>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWalletsControllerGetTransactionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get transaction details
 */
export const walletsControllerGetTransaction = (id: string, signal?: AbortSignal) => {
  return customInstance<TransactionDto>({ url: `/wallets/transaction/${id}`, method: 'GET', signal });
};

export const getWalletsControllerGetTransactionQueryKey = (id: string) => {
  return [`/wallets/transaction/${id}`] as const;
};

export const getWalletsControllerGetTransactionQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransaction>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsControllerGetTransactionQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsControllerGetTransaction>>> = ({ signal }) =>
    walletsControllerGetTransaction(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WalletsControllerGetTransactionQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerGetTransaction>>
>;
export type WalletsControllerGetTransactionQueryError = unknown;

export function useWalletsControllerGetTransaction<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransaction>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
          TError,
          Awaited<ReturnType<typeof walletsControllerGetTransaction>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetTransaction<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransaction>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
          TError,
          Awaited<ReturnType<typeof walletsControllerGetTransaction>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetTransaction<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransaction>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get transaction details
 */

export function useWalletsControllerGetTransaction<
  TData = Awaited<ReturnType<typeof walletsControllerGetTransaction>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetTransaction>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWalletsControllerGetTransactionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get deposit history
 */
export const walletsControllerGetDeposits = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/wallets/deposits`, method: 'GET', signal });
};

export const getWalletsControllerGetDepositsQueryKey = () => {
  return [`/wallets/deposits`] as const;
};

export const getWalletsControllerGetDepositsQueryOptions = <
  TData = Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetDeposits>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletsControllerGetDepositsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof walletsControllerGetDeposits>>> = ({ signal }) =>
    walletsControllerGetDeposits(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WalletsControllerGetDepositsQueryResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerGetDeposits>>
>;
export type WalletsControllerGetDepositsQueryError = unknown;

export function useWalletsControllerGetDeposits<
  TData = Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetDeposits>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetDeposits>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetDeposits<
  TData = Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetDeposits>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
        TError,
        Awaited<ReturnType<typeof walletsControllerGetDeposits>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWalletsControllerGetDeposits<
  TData = Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetDeposits>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get deposit history
 */

export function useWalletsControllerGetDeposits<
  TData = Awaited<ReturnType<typeof walletsControllerGetDeposits>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof walletsControllerGetDeposits>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWalletsControllerGetDepositsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a custom wallet
 */
export const walletsControllerAddCustomWallet = (
  addCustomWalletRequestDto: AddCustomWalletRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/wallets/add-custom-wallet`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addCustomWalletRequestDto,
    signal,
  });
};

export const getWalletsControllerAddCustomWalletMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>,
    TError,
    { data: AddCustomWalletRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>,
  TError,
  { data: AddCustomWalletRequestDto },
  TContext
> => {
  const mutationKey = ['walletsControllerAddCustomWallet'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>,
    { data: AddCustomWalletRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return walletsControllerAddCustomWallet(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WalletsControllerAddCustomWalletMutationResult = NonNullable<
  Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>
>;
export type WalletsControllerAddCustomWalletMutationBody = AddCustomWalletRequestDto;
export type WalletsControllerAddCustomWalletMutationError = void;

/**
 * @summary Add a custom wallet
 */
export const useWalletsControllerAddCustomWallet = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>,
    TError,
    { data: AddCustomWalletRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof walletsControllerAddCustomWallet>>,
  TError,
  { data: AddCustomWalletRequestDto },
  TContext
> => {
  const mutationOptions = getWalletsControllerAddCustomWalletMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user tasks
 */
export const tasksControllerGetTasks = (signal?: AbortSignal) => {
  return customInstance<TaskDto[]>({ url: `/tasks`, method: 'GET', signal });
};

export const getTasksControllerGetTasksQueryKey = () => {
  return [`/tasks`] as const;
};

export const getTasksControllerGetTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof tasksControllerGetTasks>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTasks>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTasksControllerGetTasksQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof tasksControllerGetTasks>>> = ({ signal }) =>
    tasksControllerGetTasks(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof tasksControllerGetTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type TasksControllerGetTasksQueryResult = NonNullable<Awaited<ReturnType<typeof tasksControllerGetTasks>>>;
export type TasksControllerGetTasksQueryError = void;

export function useTasksControllerGetTasks<
  TData = Awaited<ReturnType<typeof tasksControllerGetTasks>>,
  TError = void,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTasks>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof tasksControllerGetTasks>>,
        TError,
        Awaited<ReturnType<typeof tasksControllerGetTasks>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTasksControllerGetTasks<
  TData = Awaited<ReturnType<typeof tasksControllerGetTasks>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTasks>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof tasksControllerGetTasks>>,
        TError,
        Awaited<ReturnType<typeof tasksControllerGetTasks>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useTasksControllerGetTasks<
  TData = Awaited<ReturnType<typeof tasksControllerGetTasks>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTasks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user tasks
 */

export function useTasksControllerGetTasks<
  TData = Awaited<ReturnType<typeof tasksControllerGetTasks>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof tasksControllerGetTasks>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getTasksControllerGetTasksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a task
 */
export const tasksControllerCreateTask = (createTaskDto: CreateTaskDto, signal?: AbortSignal) => {
  return customInstance<TaskDto>({
    url: `/tasks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createTaskDto,
    signal,
  });
};

export const getTasksControllerCreateTaskMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksControllerCreateTask>>,
    TError,
    { data: CreateTaskDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksControllerCreateTask>>,
  TError,
  { data: CreateTaskDto },
  TContext
> => {
  const mutationKey = ['tasksControllerCreateTask'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tasksControllerCreateTask>>, { data: CreateTaskDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return tasksControllerCreateTask(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksControllerCreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerCreateTask>>
>;
export type TasksControllerCreateTaskMutationBody = CreateTaskDto;
export type TasksControllerCreateTaskMutationError = void;

/**
 * @summary Create a task
 */
export const useTasksControllerCreateTask = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksControllerCreateTask>>,
    TError,
    { data: CreateTaskDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksControllerCreateTask>>,
  TError,
  { data: CreateTaskDto },
  TContext
> => {
  const mutationOptions = getTasksControllerCreateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Start a task
 */
export const tasksControllerStartTask = (id: string, signal?: AbortSignal) => {
  return customInstance<TaskDto>({ url: `/tasks/${id}/start`, method: 'POST', signal });
};

export const getTasksControllerStartTaskMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof tasksControllerStartTask>>, TError, { id: string }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof tasksControllerStartTask>>, TError, { id: string }, TContext> => {
  const mutationKey = ['tasksControllerStartTask'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tasksControllerStartTask>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return tasksControllerStartTask(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksControllerStartTaskMutationResult = NonNullable<Awaited<ReturnType<typeof tasksControllerStartTask>>>;

export type TasksControllerStartTaskMutationError = void;

/**
 * @summary Start a task
 */
export const useTasksControllerStartTask = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof tasksControllerStartTask>>, TError, { id: string }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof tasksControllerStartTask>>, TError, { id: string }, TContext> => {
  const mutationOptions = getTasksControllerStartTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Manually check and complete all user tasks
 */
export const tasksControllerCheckTask = (signal?: AbortSignal) => {
  return customInstance<TaskDto[]>({ url: `/tasks/check`, method: 'POST', signal });
};

export const getTasksControllerCheckTaskMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof tasksControllerCheckTask>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof tasksControllerCheckTask>>, TError, void, TContext> => {
  const mutationKey = ['tasksControllerCheckTask'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof tasksControllerCheckTask>>, void> = () => {
    return tasksControllerCheckTask();
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksControllerCheckTaskMutationResult = NonNullable<Awaited<ReturnType<typeof tasksControllerCheckTask>>>;

export type TasksControllerCheckTaskMutationError = void;

/**
 * @summary Manually check and complete all user tasks
 */
export const useTasksControllerCheckTask = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof tasksControllerCheckTask>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof tasksControllerCheckTask>>, TError, void, TContext> => {
  const mutationOptions = getTasksControllerCheckTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update a task
 */
export const tasksControllerUpdateTask = (id: string, updateTaskDto: UpdateTaskDto) => {
  return customInstance<TaskDto>({
    url: `/tasks/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateTaskDto,
  });
};

export const getTasksControllerUpdateTaskMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksControllerUpdateTask>>,
    TError,
    { id: string; data: UpdateTaskDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof tasksControllerUpdateTask>>,
  TError,
  { id: string; data: UpdateTaskDto },
  TContext
> => {
  const mutationKey = ['tasksControllerUpdateTask'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof tasksControllerUpdateTask>>,
    { id: string; data: UpdateTaskDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return tasksControllerUpdateTask(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TasksControllerUpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof tasksControllerUpdateTask>>
>;
export type TasksControllerUpdateTaskMutationBody = UpdateTaskDto;
export type TasksControllerUpdateTaskMutationError = void;

/**
 * @summary Update a task
 */
export const useTasksControllerUpdateTask = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof tasksControllerUpdateTask>>,
    TError,
    { id: string; data: UpdateTaskDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof tasksControllerUpdateTask>>,
  TError,
  { id: string; data: UpdateTaskDto },
  TContext
> => {
  const mutationOptions = getTasksControllerUpdateTaskMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all level requirements with XP thresholds and luck multipliers
 */
export const experienceControllerGetLevelRequirements = (signal?: AbortSignal) => {
  return customInstance<LevelRequirementsResponseDto[]>({
    url: `/experience/level-requirements`,
    method: 'GET',
    signal,
  });
};

export const getExperienceControllerGetLevelRequirementsQueryKey = () => {
  return [`/experience/level-requirements`] as const;
};

export const getExperienceControllerGetLevelRequirementsQueryOptions = <
  TData = Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getExperienceControllerGetLevelRequirementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>> = ({ signal }) =>
    experienceControllerGetLevelRequirements(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ExperienceControllerGetLevelRequirementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>
>;
export type ExperienceControllerGetLevelRequirementsQueryError = void;

export function useExperienceControllerGetLevelRequirements<
  TData = Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
  TError = void,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
        TError,
        Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExperienceControllerGetLevelRequirements<
  TData = Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
        TError,
        Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExperienceControllerGetLevelRequirements<
  TData = Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all level requirements with XP thresholds and luck multipliers
 */

export function useExperienceControllerGetLevelRequirements<
  TData = Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof experienceControllerGetLevelRequirements>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getExperienceControllerGetLevelRequirementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mint collection or blindbix NFT
 */
export const nftControllerMintCollectionNft = (packId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/nft/mint/${packId}`, method: 'POST', signal });
};

export const getNftControllerMintCollectionNftMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerMintCollectionNft>>,
    TError,
    { packId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof nftControllerMintCollectionNft>>,
  TError,
  { packId: string },
  TContext
> => {
  const mutationKey = ['nftControllerMintCollectionNft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof nftControllerMintCollectionNft>>, { packId: string }> = (
    props,
  ) => {
    const { packId } = props ?? {};

    return nftControllerMintCollectionNft(packId);
  };

  return { mutationFn, ...mutationOptions };
};

export type NftControllerMintCollectionNftMutationResult = NonNullable<
  Awaited<ReturnType<typeof nftControllerMintCollectionNft>>
>;

export type NftControllerMintCollectionNftMutationError = void;

/**
 * @summary Mint collection or blindbix NFT
 */
export const useNftControllerMintCollectionNft = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerMintCollectionNft>>,
    TError,
    { packId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof nftControllerMintCollectionNft>>,
  TError,
  { packId: string },
  TContext
> => {
  const mutationOptions = getNftControllerMintCollectionNftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Withdraw NFT from pack
 */
export const nftControllerWithdrawNft = (packId: string, withdrawNftDto: WithdrawNftDto, signal?: AbortSignal) => {
  return customInstance<void>({
    url: `/nft/withdraw/${packId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: withdrawNftDto,
    signal,
  });
};

export const getNftControllerWithdrawNftMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerWithdrawNft>>,
    TError,
    { packId: string; data: WithdrawNftDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof nftControllerWithdrawNft>>,
  TError,
  { packId: string; data: WithdrawNftDto },
  TContext
> => {
  const mutationKey = ['nftControllerWithdrawNft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof nftControllerWithdrawNft>>,
    { packId: string; data: WithdrawNftDto }
  > = (props) => {
    const { packId, data } = props ?? {};

    return nftControllerWithdrawNft(packId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NftControllerWithdrawNftMutationResult = NonNullable<Awaited<ReturnType<typeof nftControllerWithdrawNft>>>;
export type NftControllerWithdrawNftMutationBody = WithdrawNftDto;
export type NftControllerWithdrawNftMutationError = void;

/**
 * @summary Withdraw NFT from pack
 */
export const useNftControllerWithdrawNft = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerWithdrawNft>>,
    TError,
    { packId: string; data: WithdrawNftDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof nftControllerWithdrawNft>>,
  TError,
  { packId: string; data: WithdrawNftDto },
  TContext
> => {
  const mutationOptions = getNftControllerWithdrawNftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Withdraw external NFT to address
 */
export const nftControllerWithdrawExternalNft = (
  externalNftId: string,
  withdrawExternalNftDto: WithdrawExternalNftDto,
  signal?: AbortSignal,
) => {
  return customInstance<NftControllerWithdrawExternalNft201>({
    url: `/nft/withdraw-external/${externalNftId}`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: withdrawExternalNftDto,
    signal,
  });
};

export const getNftControllerWithdrawExternalNftMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>,
    TError,
    { externalNftId: string; data: WithdrawExternalNftDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>,
  TError,
  { externalNftId: string; data: WithdrawExternalNftDto },
  TContext
> => {
  const mutationKey = ['nftControllerWithdrawExternalNft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>,
    { externalNftId: string; data: WithdrawExternalNftDto }
  > = (props) => {
    const { externalNftId, data } = props ?? {};

    return nftControllerWithdrawExternalNft(externalNftId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NftControllerWithdrawExternalNftMutationResult = NonNullable<
  Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>
>;
export type NftControllerWithdrawExternalNftMutationBody = WithdrawExternalNftDto;
export type NftControllerWithdrawExternalNftMutationError = void;

/**
 * @summary Withdraw external NFT to address
 */
export const useNftControllerWithdrawExternalNft = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>,
    TError,
    { externalNftId: string; data: WithdrawExternalNftDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof nftControllerWithdrawExternalNft>>,
  TError,
  { externalNftId: string; data: WithdrawExternalNftDto },
  TContext
> => {
  const mutationOptions = getNftControllerWithdrawExternalNftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Sync deposited NFTs with blockchain and update pack ownership
 */
export const nftControllerSyncDepositedNfts = (signal?: AbortSignal) => {
  return customInstance<SyncUserNftsResponseDto>({ url: `/nft/sync-deposited-nfts`, method: 'POST', signal });
};

export const getNftControllerSyncDepositedNftsMutationOptions = <
  TError = RateLimitResponseDto | void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>, TError, void, TContext> => {
  const mutationKey = ['nftControllerSyncDepositedNfts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>, void> = () => {
    return nftControllerSyncDepositedNfts();
  };

  return { mutationFn, ...mutationOptions };
};

export type NftControllerSyncDepositedNftsMutationResult = NonNullable<
  Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>
>;

export type NftControllerSyncDepositedNftsMutationError = RateLimitResponseDto | void;

/**
 * @summary Sync deposited NFTs with blockchain and update pack ownership
 */
export const useNftControllerSyncDepositedNfts = <TError = RateLimitResponseDto | void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof nftControllerSyncDepositedNfts>>, TError, void, TContext> => {
  const mutationOptions = getNftControllerSyncDepositedNftsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Verify pack ownership for a user in a specific drop
 */
export const partnerControllerVerifyOwnership = (
  verifyOwnershipRequestDto: VerifyOwnershipRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<VerifyOwnershipResponseDto>({
    url: `/partner/verify-ownership`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: verifyOwnershipRequestDto,
    signal,
  });
};

export const getPartnerControllerVerifyOwnershipMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>,
    TError,
    { data: VerifyOwnershipRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>,
  TError,
  { data: VerifyOwnershipRequestDto },
  TContext
> => {
  const mutationKey = ['partnerControllerVerifyOwnership'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>,
    { data: VerifyOwnershipRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return partnerControllerVerifyOwnership(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PartnerControllerVerifyOwnershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>
>;
export type PartnerControllerVerifyOwnershipMutationBody = VerifyOwnershipRequestDto;
export type PartnerControllerVerifyOwnershipMutationError = void;

/**
 * @summary Verify pack ownership for a user in a specific drop
 */
export const usePartnerControllerVerifyOwnership = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>,
    TError,
    { data: VerifyOwnershipRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof partnerControllerVerifyOwnership>>,
  TError,
  { data: VerifyOwnershipRequestDto },
  TContext
> => {
  const mutationOptions = getPartnerControllerVerifyOwnershipMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all packs owned by a user
 */
export const partnerControllerGetUserOwnershipByPartner = (telegramUserId: string, signal?: AbortSignal) => {
  return customInstance<ExternalMarketplaceUserOwnershipResponseDto>({
    url: `/partner/telegram-user/${telegramUserId}/ownership`,
    method: 'GET',
    signal,
  });
};

export const getPartnerControllerGetUserOwnershipByPartnerQueryKey = (telegramUserId: string) => {
  return [`/partner/telegram-user/${telegramUserId}/ownership`] as const;
};

export const getPartnerControllerGetUserOwnershipByPartnerQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetUserOwnershipByPartnerQueryKey(telegramUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>> = ({ signal }) =>
    partnerControllerGetUserOwnershipByPartner(telegramUserId, signal);

  return { queryKey, queryFn, enabled: !!telegramUserId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetUserOwnershipByPartnerQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>
>;
export type PartnerControllerGetUserOwnershipByPartnerQueryError = void;

export function usePartnerControllerGetUserOwnershipByPartner<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
  TError = void,
>(
  telegramUserId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetUserOwnershipByPartner<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetUserOwnershipByPartner<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all packs owned by a user
 */

export function usePartnerControllerGetUserOwnershipByPartner<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnershipByPartner>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetUserOwnershipByPartnerQueryOptions(telegramUserId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all packs owned by a user
 */
export const partnerControllerGetUserOwnership = (telegramUserId: string, signal?: AbortSignal) => {
  return customInstance<ExternalMarketplaceUserOwnershipResponseDto>({
    url: `/partner/external-marketplace/telegram-user/${telegramUserId}/ownership`,
    method: 'GET',
    signal,
  });
};

export const getPartnerControllerGetUserOwnershipQueryKey = (telegramUserId: string) => {
  return [`/partner/external-marketplace/telegram-user/${telegramUserId}/ownership`] as const;
};

export const getPartnerControllerGetUserOwnershipQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetUserOwnershipQueryKey(telegramUserId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>> = ({ signal }) =>
    partnerControllerGetUserOwnership(telegramUserId, signal);

  return { queryKey, queryFn, enabled: !!telegramUserId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetUserOwnershipQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>
>;
export type PartnerControllerGetUserOwnershipQueryError = void;

export function usePartnerControllerGetUserOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
  TError = void,
>(
  telegramUserId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetUserOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetUserOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all packs owned by a user
 */

export function usePartnerControllerGetUserOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>,
  TError = void,
>(
  telegramUserId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetUserOwnership>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetUserOwnershipQueryOptions(telegramUserId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all packs owned by the marketplace
 */
export const partnerControllerGetMarketplaceOwnership = (signal?: AbortSignal) => {
  return customInstance<ExternalMarketplaceUserOwnershipResponseDto>({
    url: `/partner/external-marketplace/marketplace-ownership`,
    method: 'GET',
    signal,
  });
};

export const getPartnerControllerGetMarketplaceOwnershipQueryKey = () => {
  return [`/partner/external-marketplace/marketplace-ownership`] as const;
};

export const getPartnerControllerGetMarketplaceOwnershipQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetMarketplaceOwnershipQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>> = ({ signal }) =>
    partnerControllerGetMarketplaceOwnership(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetMarketplaceOwnershipQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>
>;
export type PartnerControllerGetMarketplaceOwnershipQueryError = void;

export function usePartnerControllerGetMarketplaceOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
  TError = void,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
        TError,
        Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetMarketplaceOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
        TError,
        Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetMarketplaceOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all packs owned by the marketplace
 */

export function usePartnerControllerGetMarketplaceOwnership<
  TData = Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetMarketplaceOwnership>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetMarketplaceOwnershipQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Transfer pack from marketplace back to user
 */
export const partnerControllerTransferFromMarket = (
  transferFromMarketRequestDto: TransferFromMarketRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/partner/transfer-from-market`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: transferFromMarketRequestDto,
    signal,
  });
};

export const getPartnerControllerTransferFromMarketMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>,
    TError,
    { data: TransferFromMarketRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>,
  TError,
  { data: TransferFromMarketRequestDto },
  TContext
> => {
  const mutationKey = ['partnerControllerTransferFromMarket'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>,
    { data: TransferFromMarketRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return partnerControllerTransferFromMarket(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PartnerControllerTransferFromMarketMutationResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>
>;
export type PartnerControllerTransferFromMarketMutationBody = TransferFromMarketRequestDto;
export type PartnerControllerTransferFromMarketMutationError = void;

/**
 * @summary Transfer pack from marketplace back to user
 */
export const usePartnerControllerTransferFromMarket = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>,
    TError,
    { data: TransferFromMarketRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof partnerControllerTransferFromMarket>>,
  TError,
  { data: TransferFromMarketRequestDto },
  TContext
> => {
  const mutationOptions = getPartnerControllerTransferFromMarketMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all collections data - collections with basic information
 */
export const partnerControllerGetCollections = (
  params?: PartnerControllerGetCollectionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<CollectionsListResponseDto>({ url: `/partner/collections`, method: 'GET', params, signal });
};

export const getPartnerControllerGetCollectionsQueryKey = (params?: PartnerControllerGetCollectionsParams) => {
  return [`/partner/collections`, ...(params ? [params] : [])] as const;
};

export const getPartnerControllerGetCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetCollections>>,
  TError = void,
>(
  params?: PartnerControllerGetCollectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetCollections>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetCollectionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetCollections>>> = ({ signal }) =>
    partnerControllerGetCollections(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetCollections>>
>;
export type PartnerControllerGetCollectionsQueryError = void;

export function usePartnerControllerGetCollections<
  TData = Awaited<ReturnType<typeof partnerControllerGetCollections>>,
  TError = void,
>(
  params: undefined | PartnerControllerGetCollectionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetCollections>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetCollections>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetCollections>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetCollections<
  TData = Awaited<ReturnType<typeof partnerControllerGetCollections>>,
  TError = void,
>(
  params?: PartnerControllerGetCollectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetCollections>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetCollections>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetCollections>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetCollections<
  TData = Awaited<ReturnType<typeof partnerControllerGetCollections>>,
  TError = void,
>(
  params?: PartnerControllerGetCollectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetCollections>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all collections data - collections with basic information
 */

export function usePartnerControllerGetCollections<
  TData = Awaited<ReturnType<typeof partnerControllerGetCollections>>,
  TError = void,
>(
  params?: PartnerControllerGetCollectionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetCollections>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetCollectionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get holders (telegram user IDs) for a collection by collection ID. Only unwrapped packs are included (blindboxes excluded).
 */
export const partnerControllerGetHolders = (params: PartnerControllerGetHoldersParams, signal?: AbortSignal) => {
  return customInstance<HoldersResponseDto>({ url: `/partner/holders`, method: 'GET', params, signal });
};

export const getPartnerControllerGetHoldersQueryKey = (params: PartnerControllerGetHoldersParams) => {
  return [`/partner/holders`, ...(params ? [params] : [])] as const;
};

export const getPartnerControllerGetHoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetHolders>>,
  TError = void,
>(
  params: PartnerControllerGetHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetHolders>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetHoldersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetHolders>>> = ({ signal }) =>
    partnerControllerGetHolders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetHolders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetHoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetHolders>>
>;
export type PartnerControllerGetHoldersQueryError = void;

export function usePartnerControllerGetHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetHolders>>,
  TError = void,
>(
  params: PartnerControllerGetHoldersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetHolders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetHolders>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetHolders>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetHolders>>,
  TError = void,
>(
  params: PartnerControllerGetHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetHolders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetHolders>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetHolders>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetHolders>>,
  TError = void,
>(
  params: PartnerControllerGetHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetHolders>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get holders (telegram user IDs) for a collection by collection ID. Only unwrapped packs are included (blindboxes excluded).
 */

export function usePartnerControllerGetHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetHolders>>,
  TError = void,
>(
  params: PartnerControllerGetHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetHolders>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetHoldersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get holders (telegram user IDs) for packs in a drop by drop ID. Returns all holders who have claimed packs from the specified drop.
 */
export const partnerControllerGetDropPacksHolders = (
  params: PartnerControllerGetDropPacksHoldersParams,
  signal?: AbortSignal,
) => {
  return customInstance<HoldersResponseDto>({ url: `/partner/drop-holders`, method: 'GET', params, signal });
};

export const getPartnerControllerGetDropPacksHoldersQueryKey = (params: PartnerControllerGetDropPacksHoldersParams) => {
  return [`/partner/drop-holders`, ...(params ? [params] : [])] as const;
};

export const getPartnerControllerGetDropPacksHoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
  TError = void,
>(
  params: PartnerControllerGetDropPacksHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPartnerControllerGetDropPacksHoldersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>> = ({ signal }) =>
    partnerControllerGetDropPacksHolders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PartnerControllerGetDropPacksHoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>
>;
export type PartnerControllerGetDropPacksHoldersQueryError = void;

export function usePartnerControllerGetDropPacksHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
  TError = void,
>(
  params: PartnerControllerGetDropPacksHoldersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetDropPacksHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
  TError = void,
>(
  params: PartnerControllerGetDropPacksHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
          TError,
          Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePartnerControllerGetDropPacksHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
  TError = void,
>(
  params: PartnerControllerGetDropPacksHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get holders (telegram user IDs) for packs in a drop by drop ID. Returns all holders who have claimed packs from the specified drop.
 */

export function usePartnerControllerGetDropPacksHolders<
  TData = Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>,
  TError = void,
>(
  params: PartnerControllerGetDropPacksHoldersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof partnerControllerGetDropPacksHolders>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPartnerControllerGetDropPacksHoldersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Synchronize all brands and collections with Palace NFT
 */
export const adminPartnerControllerSyncPalaceNft = (
  syncPalaceNftRequestDto?: SyncPalaceNftRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<AdminPartnerControllerSyncPalaceNft200>({
    url: `/partner/admin/sync-palace-nft`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: syncPalaceNftRequestDto,
    signal,
  });
};

export const getAdminPartnerControllerSyncPalaceNftMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>,
    TError,
    { data: SyncPalaceNftRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>,
  TError,
  { data: SyncPalaceNftRequestDto },
  TContext
> => {
  const mutationKey = ['adminPartnerControllerSyncPalaceNft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>,
    { data: SyncPalaceNftRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminPartnerControllerSyncPalaceNft(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPartnerControllerSyncPalaceNftMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>
>;
export type AdminPartnerControllerSyncPalaceNftMutationBody = SyncPalaceNftRequestDto;
export type AdminPartnerControllerSyncPalaceNftMutationError = void;

/**
 * @summary Synchronize all brands and collections with Palace NFT
 */
export const useAdminPartnerControllerSyncPalaceNft = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>,
    TError,
    { data: SyncPalaceNftRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminPartnerControllerSyncPalaceNft>>,
  TError,
  { data: SyncPalaceNftRequestDto },
  TContext
> => {
  const mutationOptions = getAdminPartnerControllerSyncPalaceNftMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user pack claims waiting to be claimed
 */
export const packClaimsControllerGetUserWaitingPackClaims = (signal?: AbortSignal) => {
  return customInstance<PackClaimResponseDto[]>({ url: `/pack-claims/waiting`, method: 'GET', signal });
};

export const getPackClaimsControllerGetUserWaitingPackClaimsQueryKey = () => {
  return [`/pack-claims/waiting`] as const;
};

export const getPackClaimsControllerGetUserWaitingPackClaimsQueryOptions = <
  TData = Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPackClaimsControllerGetUserWaitingPackClaimsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>> = ({
    signal,
  }) => packClaimsControllerGetUserWaitingPackClaims(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PackClaimsControllerGetUserWaitingPackClaimsQueryResult = NonNullable<
  Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>
>;
export type PackClaimsControllerGetUserWaitingPackClaimsQueryError = unknown;

export function usePackClaimsControllerGetUserWaitingPackClaims<
  TData = Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
        TError,
        Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePackClaimsControllerGetUserWaitingPackClaims<
  TData = Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
        TError,
        Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePackClaimsControllerGetUserWaitingPackClaims<
  TData = Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user pack claims waiting to be claimed
 */

export function usePackClaimsControllerGetUserWaitingPackClaims<
  TData = Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof packClaimsControllerGetUserWaitingPackClaims>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPackClaimsControllerGetUserWaitingPackClaimsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get rendered documentation by path
 */
export const docsControllerGetDocumentation = (path: string, signal?: AbortSignal) => {
  return customInstance<string>({ url: `/docs/${path}`, method: 'GET', signal });
};

export const getDocsControllerGetDocumentationQueryKey = (path: string) => {
  return [`/docs/${path}`] as const;
};

export const getDocsControllerGetDocumentationQueryOptions = <
  TData = Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
  TError = void,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof docsControllerGetDocumentation>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocsControllerGetDocumentationQueryKey(path);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof docsControllerGetDocumentation>>> = ({ signal }) =>
    docsControllerGetDocumentation(path, signal);

  return { queryKey, queryFn, enabled: !!path, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type DocsControllerGetDocumentationQueryResult = NonNullable<
  Awaited<ReturnType<typeof docsControllerGetDocumentation>>
>;
export type DocsControllerGetDocumentationQueryError = void;

export function useDocsControllerGetDocumentation<
  TData = Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
  TError = void,
>(
  path: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof docsControllerGetDocumentation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
          TError,
          Awaited<ReturnType<typeof docsControllerGetDocumentation>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDocsControllerGetDocumentation<
  TData = Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
  TError = void,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof docsControllerGetDocumentation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
          TError,
          Awaited<ReturnType<typeof docsControllerGetDocumentation>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDocsControllerGetDocumentation<
  TData = Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
  TError = void,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof docsControllerGetDocumentation>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get rendered documentation by path
 */

export function useDocsControllerGetDocumentation<
  TData = Awaited<ReturnType<typeof docsControllerGetDocumentation>>,
  TError = void,
>(
  path: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof docsControllerGetDocumentation>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getDocsControllerGetDocumentationQueryOptions(path, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Authenticate user with Telegram initData
 */
export const authControllerLogin = (loginDto: LoginDto, signal?: AbortSignal) => {
  return customInstance<AuthResponseDto>({
    url: `/auth/login`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: loginDto,
    signal,
  });
};

export const getAuthControllerLoginMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, { data: LoginDto }, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, { data: LoginDto }, TContext> => {
  const mutationKey = ['authControllerLogin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogin>>, { data: LoginDto }> = (props) => {
    const { data } = props ?? {};

    return authControllerLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerLoginMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogin>>>;
export type AuthControllerLoginMutationBody = LoginDto;
export type AuthControllerLoginMutationError = void;

/**
 * @summary Authenticate user with Telegram initData
 */
export const useAuthControllerLogin = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerLogin>>, TError, { data: LoginDto }, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerLogin>>, TError, { data: LoginDto }, TContext> => {
  const mutationOptions = getAuthControllerLoginMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Refresh JWT token
 */
export const authControllerRefresh = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/auth/refresh`, method: 'POST', signal });
};

export const getAuthControllerRefreshMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, void, TContext> => {
  const mutationKey = ['authControllerRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefresh>>, void> = () => {
    return authControllerRefresh();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthControllerRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefresh>>>;

export type AuthControllerRefreshMutationError = unknown;

/**
 * @summary Refresh JWT token
 */
export const useAuthControllerRefresh = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof authControllerRefresh>>, TError, void, TContext> => {
  const mutationOptions = getAuthControllerRefreshMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get current user profile with wallet information
 */
export const usersControllerGetProfile = (signal?: AbortSignal) => {
  return customInstance<UserResponseDto>({ url: `/users/me`, method: 'GET', signal });
};

export const getUsersControllerGetProfileQueryKey = () => {
  return [`/users/me`] as const;
};

export const getUsersControllerGetProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetProfile>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersControllerGetProfileQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetProfile>>> = ({ signal }) =>
    usersControllerGetProfile(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerGetProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UsersControllerGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof usersControllerGetProfile>>>;
export type UsersControllerGetProfileQueryError = unknown;

export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetProfile>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetProfile>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetProfile>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetProfile>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetProfile>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetProfile>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current user profile with wallet information
 */

export function useUsersControllerGetProfile<
  TData = Awaited<ReturnType<typeof usersControllerGetProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetProfile>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUsersControllerGetProfileQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update user profile
 */
export const usersControllerUpdateProfile = (updateUserDto: UpdateUserDto) => {
  return customInstance<void>({
    url: `/users/me`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateUserDto,
  });
};

export const getUsersControllerUpdateProfileMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
    TError,
    { data: UpdateUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
  TError,
  { data: UpdateUserDto },
  TContext
> => {
  const mutationKey = ['usersControllerUpdateProfile'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
    { data: UpdateUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return usersControllerUpdateProfile(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerUpdateProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>
>;
export type UsersControllerUpdateProfileMutationBody = UpdateUserDto;
export type UsersControllerUpdateProfileMutationError = void;

/**
 * @summary Update user profile
 */
export const useUsersControllerUpdateProfile = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
    TError,
    { data: UpdateUserDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof usersControllerUpdateProfile>>,
  TError,
  { data: UpdateUserDto },
  TContext
> => {
  const mutationOptions = getUsersControllerUpdateProfileMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user referral users
 */
export const usersControllerGetRefferedUsers = (signal?: AbortSignal) => {
  return customInstance<RefferedUserResponseDto[]>({ url: `/users/reffered-users`, method: 'GET', signal });
};

export const getUsersControllerGetRefferedUsersQueryKey = () => {
  return [`/users/reffered-users`] as const;
};

export const getUsersControllerGetRefferedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersControllerGetRefferedUsersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>> = ({ signal }) =>
    usersControllerGetRefferedUsers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UsersControllerGetRefferedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>
>;
export type UsersControllerGetRefferedUsersQueryError = unknown;

export function useUsersControllerGetRefferedUsers<
  TData = Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetRefferedUsers<
  TData = Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetRefferedUsers<
  TData = Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user referral users
 */

export function useUsersControllerGetRefferedUsers<
  TData = Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRefferedUsers>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUsersControllerGetRefferedUsersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Onboard user
 */
export const usersControllerOnboard = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/users/onboard`, method: 'POST', signal });
};

export const getUsersControllerOnboardMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersControllerOnboard>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof usersControllerOnboard>>, TError, void, TContext> => {
  const mutationKey = ['usersControllerOnboard'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof usersControllerOnboard>>, void> = () => {
    return usersControllerOnboard();
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersControllerOnboardMutationResult = NonNullable<Awaited<ReturnType<typeof usersControllerOnboard>>>;

export type UsersControllerOnboardMutationError = unknown;

/**
 * @summary Onboard user
 */
export const useUsersControllerOnboard = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof usersControllerOnboard>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof usersControllerOnboard>>, TError, void, TContext> => {
  const mutationOptions = getUsersControllerOnboardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get onboard info
 */
export const usersControllerGetOnboardInfo = (signal?: AbortSignal) => {
  return customInstance<OnboardDto>({ url: `/users/onboard-info`, method: 'GET', signal });
};

export const getUsersControllerGetOnboardInfoQueryKey = () => {
  return [`/users/onboard-info`] as const;
};

export const getUsersControllerGetOnboardInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersControllerGetOnboardInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>> = ({ signal }) =>
    usersControllerGetOnboardInfo(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UsersControllerGetOnboardInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>
>;
export type UsersControllerGetOnboardInfoQueryError = unknown;

export function useUsersControllerGetOnboardInfo<
  TData = Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetOnboardInfo<
  TData = Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetOnboardInfo<
  TData = Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get onboard info
 */

export function useUsersControllerGetOnboardInfo<
  TData = Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetOnboardInfo>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUsersControllerGetOnboardInfoQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get reward configuration values
 */
export const usersControllerGetRewardConfig = (signal?: AbortSignal) => {
  return customInstance<RewardConfigResponseDto>({ url: `/users/reward-config`, method: 'GET', signal });
};

export const getUsersControllerGetRewardConfigQueryKey = () => {
  return [`/users/reward-config`] as const;
};

export const getUsersControllerGetRewardConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersControllerGetRewardConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>> = ({ signal }) =>
    usersControllerGetRewardConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type UsersControllerGetRewardConfigQueryResult = NonNullable<
  Awaited<ReturnType<typeof usersControllerGetRewardConfig>>
>;
export type UsersControllerGetRewardConfigQueryError = void;

export function useUsersControllerGetRewardConfig<
  TData = Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
  TError = void,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetRewardConfig>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetRewardConfig<
  TData = Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
        TError,
        Awaited<ReturnType<typeof usersControllerGetRewardConfig>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useUsersControllerGetRewardConfig<
  TData = Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get reward configuration values
 */

export function useUsersControllerGetRewardConfig<
  TData = Awaited<ReturnType<typeof usersControllerGetRewardConfig>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof usersControllerGetRewardConfig>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getUsersControllerGetRewardConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get platform analytics and statistics
 */
export const adminControllerGetPlatformAnalytics = (signal?: AbortSignal) => {
  return customInstance<PlatformAnalyticsDto>({ url: `/admin/analytics`, method: 'GET', signal });
};

export const getAdminControllerGetPlatformAnalyticsQueryKey = () => {
  return [`/admin/analytics`] as const;
};

export const getAdminControllerGetPlatformAnalyticsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetPlatformAnalyticsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>> = ({ signal }) =>
    adminControllerGetPlatformAnalytics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetPlatformAnalyticsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>
>;
export type AdminControllerGetPlatformAnalyticsQueryError = unknown;

export function useAdminControllerGetPlatformAnalytics<
  TData = Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetPlatformAnalytics<
  TData = Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetPlatformAnalytics<
  TData = Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform analytics and statistics
 */

export function useAdminControllerGetPlatformAnalytics<
  TData = Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPlatformAnalytics>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetPlatformAnalyticsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get recent transactions
 */
export const adminControllerGetRecentTransactions = (
  params?: AdminControllerGetRecentTransactionsParams,
  signal?: AbortSignal,
) => {
  return customInstance<void>({ url: `/admin/transactions`, method: 'GET', params, signal });
};

export const getAdminControllerGetRecentTransactionsQueryKey = (
  params?: AdminControllerGetRecentTransactionsParams,
) => {
  return [`/admin/transactions`, ...(params ? [params] : [])] as const;
};

export const getAdminControllerGetRecentTransactionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
  TError = unknown,
>(
  params?: AdminControllerGetRecentTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetRecentTransactionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>> = ({ signal }) =>
    adminControllerGetRecentTransactions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetRecentTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>
>;
export type AdminControllerGetRecentTransactionsQueryError = unknown;

export function useAdminControllerGetRecentTransactions<
  TData = Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
  TError = unknown,
>(
  params: undefined | AdminControllerGetRecentTransactionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetRecentTransactions<
  TData = Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
  TError = unknown,
>(
  params?: AdminControllerGetRecentTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetRecentTransactions<
  TData = Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
  TError = unknown,
>(
  params?: AdminControllerGetRecentTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get recent transactions
 */

export function useAdminControllerGetRecentTransactions<
  TData = Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>,
  TError = unknown,
>(
  params?: AdminControllerGetRecentTransactionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetRecentTransactions>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetRecentTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user details with statistics
 */
export const adminControllerGetUserDetails = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/users/${id}`, method: 'GET', signal });
};

export const getAdminControllerGetUserDetailsQueryKey = (id: string) => {
  return [`/admin/users/${id}`] as const;
};

export const getAdminControllerGetUserDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetUserDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetUserDetails>>> = ({ signal }) =>
    adminControllerGetUserDetails(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetUserDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetUserDetails>>
>;
export type AdminControllerGetUserDetailsQueryError = void;

export function useAdminControllerGetUserDetails<
  TData = Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetUserDetails>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetUserDetails<
  TData = Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetUserDetails>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetUserDetails<
  TData = Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user details with statistics
 */

export function useAdminControllerGetUserDetails<
  TData = Awaited<ReturnType<typeof adminControllerGetUserDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetUserDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get user by wallet address
 */
export const adminControllerGetUserByWalletAddress = (address: string, signal?: AbortSignal) => {
  return customInstance<UserByWalletResponseDto>({ url: `/admin/users/by-wallet/${address}`, method: 'GET', signal });
};

export const getAdminControllerGetUserByWalletAddressQueryKey = (address: string) => {
  return [`/admin/users/by-wallet/${address}`] as const;
};

export const getAdminControllerGetUserByWalletAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetUserByWalletAddressQueryKey(address);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>> = ({ signal }) =>
    adminControllerGetUserByWalletAddress(address, signal);

  return { queryKey, queryFn, enabled: !!address, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetUserByWalletAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>
>;
export type AdminControllerGetUserByWalletAddressQueryError = void;

export function useAdminControllerGetUserByWalletAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
  TError = void,
>(
  address: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetUserByWalletAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetUserByWalletAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user by wallet address
 */

export function useAdminControllerGetUserByWalletAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetUserByWalletAddress>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetUserByWalletAddressQueryOptions(address, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Find user IDs by Telegram IDs
 */
export const adminControllerFindUserIdsByTelegramIds = (
  findUsersByTelegramIdsDto: FindUsersByTelegramIdsDto,
  signal?: AbortSignal,
) => {
  return customInstance<FindUsersByTelegramIdsResponseDto>({
    url: `/admin/users/by-telegram-ids`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: findUsersByTelegramIdsDto,
    signal,
  });
};

export const getAdminControllerFindUserIdsByTelegramIdsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>,
    TError,
    { data: FindUsersByTelegramIdsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>,
  TError,
  { data: FindUsersByTelegramIdsDto },
  TContext
> => {
  const mutationKey = ['adminControllerFindUserIdsByTelegramIds'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>,
    { data: FindUsersByTelegramIdsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminControllerFindUserIdsByTelegramIds(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerFindUserIdsByTelegramIdsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>
>;
export type AdminControllerFindUserIdsByTelegramIdsMutationBody = FindUsersByTelegramIdsDto;
export type AdminControllerFindUserIdsByTelegramIdsMutationError = unknown;

/**
 * @summary Find user IDs by Telegram IDs
 */
export const useAdminControllerFindUserIdsByTelegramIds = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>,
    TError,
    { data: FindUsersByTelegramIdsDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByTelegramIds>>,
  TError,
  { data: FindUsersByTelegramIdsDto },
  TContext
> => {
  const mutationOptions = getAdminControllerFindUserIdsByTelegramIdsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Find user IDs by usernames
 */
export const adminControllerFindUserIdsByUsernames = (
  findUsersByUsernamesDto: FindUsersByUsernamesDto,
  signal?: AbortSignal,
) => {
  return customInstance<FindUsersByUsernamesResponseDto>({
    url: `/admin/users/by-usernames`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: findUsersByUsernamesDto,
    signal,
  });
};

export const getAdminControllerFindUserIdsByUsernamesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>,
    TError,
    { data: FindUsersByUsernamesDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>,
  TError,
  { data: FindUsersByUsernamesDto },
  TContext
> => {
  const mutationKey = ['adminControllerFindUserIdsByUsernames'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>,
    { data: FindUsersByUsernamesDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminControllerFindUserIdsByUsernames(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerFindUserIdsByUsernamesMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>
>;
export type AdminControllerFindUserIdsByUsernamesMutationBody = FindUsersByUsernamesDto;
export type AdminControllerFindUserIdsByUsernamesMutationError = unknown;

/**
 * @summary Find user IDs by usernames
 */
export const useAdminControllerFindUserIdsByUsernames = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>,
    TError,
    { data: FindUsersByUsernamesDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerFindUserIdsByUsernames>>,
  TError,
  { data: FindUsersByUsernamesDto },
  TContext
> => {
  const mutationOptions = getAdminControllerFindUserIdsByUsernamesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get pack by NFT address
 */
export const adminControllerGetPackByNftAddress = (address: string, signal?: AbortSignal) => {
  return customInstance<PackByNftResponseDto>({ url: `/admin/packs/by-nft/${address}`, method: 'GET', signal });
};

export const getAdminControllerGetPackByNftAddressQueryKey = (address: string) => {
  return [`/admin/packs/by-nft/${address}`] as const;
};

export const getAdminControllerGetPackByNftAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetPackByNftAddressQueryKey(address);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>> = ({ signal }) =>
    adminControllerGetPackByNftAddress(address, signal);

  return { queryKey, queryFn, enabled: !!address, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetPackByNftAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>
>;
export type AdminControllerGetPackByNftAddressQueryError = void;

export function useAdminControllerGetPackByNftAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
  TError = void,
>(
  address: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetPackByNftAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
          TError,
          Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetPackByNftAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get pack by NFT address
 */

export function useAdminControllerGetPackByNftAddress<
  TData = Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>,
  TError = void,
>(
  address: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetPackByNftAddress>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetPackByNftAddressQueryOptions(address, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Reset user onboarded status to false
 */
export const adminControllerResetUserOnboardedStatus = (userId: string) => {
  return customInstance<ResetOnboardedResponseDto>({ url: `/admin/users/${userId}/reset-onboarded`, method: 'PUT' });
};

export const getAdminControllerResetUserOnboardedStatusMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminControllerResetUserOnboardedStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return adminControllerResetUserOnboardedStatus(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerResetUserOnboardedStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>
>;

export type AdminControllerResetUserOnboardedStatusMutationError = void;

/**
 * @summary Reset user onboarded status to false
 */
export const useAdminControllerResetUserOnboardedStatus = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerResetUserOnboardedStatus>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getAdminControllerResetUserOnboardedStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Set custom referral code for user
 */
export const adminControllerSetCustomReferralCode = (
  userId: string,
  setCustomReferralCodeDto: SetCustomReferralCodeDto,
) => {
  return customInstance<SetCustomReferralCodeResponseDto>({
    url: `/admin/users/${userId}/custom-referral-code`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setCustomReferralCodeDto,
  });
};

export const getAdminControllerSetCustomReferralCodeMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>,
    TError,
    { userId: string; data: SetCustomReferralCodeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>,
  TError,
  { userId: string; data: SetCustomReferralCodeDto },
  TContext
> => {
  const mutationKey = ['adminControllerSetCustomReferralCode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>,
    { userId: string; data: SetCustomReferralCodeDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminControllerSetCustomReferralCode(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerSetCustomReferralCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>
>;
export type AdminControllerSetCustomReferralCodeMutationBody = SetCustomReferralCodeDto;
export type AdminControllerSetCustomReferralCodeMutationError = void;

/**
 * @summary Set custom referral code for user
 */
export const useAdminControllerSetCustomReferralCode = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>,
    TError,
    { userId: string; data: SetCustomReferralCodeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerSetCustomReferralCode>>,
  TError,
  { userId: string; data: SetCustomReferralCodeDto },
  TContext
> => {
  const mutationOptions = getAdminControllerSetCustomReferralCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get transaction monitoring statistics
 */
export const adminControllerGetMonitoringStats = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/monitoring/stats`, method: 'GET', signal });
};

export const getAdminControllerGetMonitoringStatsQueryKey = () => {
  return [`/admin/monitoring/stats`] as const;
};

export const getAdminControllerGetMonitoringStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetMonitoringStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>> = ({ signal }) =>
    adminControllerGetMonitoringStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetMonitoringStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>
>;
export type AdminControllerGetMonitoringStatsQueryError = unknown;

export function useAdminControllerGetMonitoringStats<
  TData = Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetMonitoringStats<
  TData = Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetMonitoringStats<
  TData = Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get transaction monitoring statistics
 */

export function useAdminControllerGetMonitoringStats<
  TData = Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetMonitoringStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetMonitoringStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get system health status
 */
export const adminControllerGetSystemHealth = (signal?: AbortSignal) => {
  return customInstance<SystemHealthDto>({ url: `/admin/system/health`, method: 'GET', signal });
};

export const getAdminControllerGetSystemHealthQueryKey = () => {
  return [`/admin/system/health`] as const;
};

export const getAdminControllerGetSystemHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetSystemHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>> = ({ signal }) =>
    adminControllerGetSystemHealth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetSystemHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetSystemHealth>>
>;
export type AdminControllerGetSystemHealthQueryError = unknown;

export function useAdminControllerGetSystemHealth<
  TData = Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetSystemHealth>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetSystemHealth<
  TData = Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetSystemHealth>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetSystemHealth<
  TData = Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get system health status
 */

export function useAdminControllerGetSystemHealth<
  TData = Awaited<ReturnType<typeof adminControllerGetSystemHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetSystemHealth>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetSystemHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add XP to a specific user
 */
export const adminControllerAddXpToUser = (addXpDto: AddXpDto, signal?: AbortSignal) => {
  return customInstance<AddXpResponseDto>({
    url: `/admin/users/add-xp`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addXpDto,
    signal,
  });
};

export const getAdminControllerAddXpToUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerAddXpToUser>>,
    TError,
    { data: AddXpDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerAddXpToUser>>,
  TError,
  { data: AddXpDto },
  TContext
> => {
  const mutationKey = ['adminControllerAddXpToUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerAddXpToUser>>, { data: AddXpDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return adminControllerAddXpToUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerAddXpToUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerAddXpToUser>>
>;
export type AdminControllerAddXpToUserMutationBody = AddXpDto;
export type AdminControllerAddXpToUserMutationError = void;

/**
 * @summary Add XP to a specific user
 */
export const useAdminControllerAddXpToUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerAddXpToUser>>,
    TError,
    { data: AddXpDto },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof adminControllerAddXpToUser>>, TError, { data: AddXpDto }, TContext> => {
  const mutationOptions = getAdminControllerAddXpToUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Test Sentry error collection by generating a test error
 */
export const adminControllerTestSentry = (signal?: AbortSignal) => {
  return customInstance<SentryTestResponseDto>({ url: `/admin/sentry/test`, method: 'POST', signal });
};

export const getAdminControllerTestSentryMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminControllerTestSentry>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<typeof adminControllerTestSentry>>, TError, void, TContext> => {
  const mutationKey = ['adminControllerTestSentry'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerTestSentry>>, void> = () => {
    return adminControllerTestSentry();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerTestSentryMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerTestSentry>>
>;

export type AdminControllerTestSentryMutationError = void;

/**
 * @summary Test Sentry error collection by generating a test error
 */
export const useAdminControllerTestSentry = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof adminControllerTestSentry>>, TError, void, TContext>;
}): UseMutationResult<Awaited<ReturnType<typeof adminControllerTestSentry>>, TError, void, TContext> => {
  const mutationOptions = getAdminControllerTestSentryMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Reset user tasks by deleting task_user records
 */
export const adminControllerResetUserTasks = (userId: string, resetTasksDto: ResetTasksDto) => {
  return customInstance<ResetTasksResponseDto>({
    url: `/admin/users/${userId}/reset-tasks`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: resetTasksDto,
  });
};

export const getAdminControllerResetUserTasksMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerResetUserTasks>>,
    TError,
    { userId: string; data: ResetTasksDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerResetUserTasks>>,
  TError,
  { userId: string; data: ResetTasksDto },
  TContext
> => {
  const mutationKey = ['adminControllerResetUserTasks'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerResetUserTasks>>,
    { userId: string; data: ResetTasksDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminControllerResetUserTasks(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerResetUserTasksMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerResetUserTasks>>
>;
export type AdminControllerResetUserTasksMutationBody = ResetTasksDto;
export type AdminControllerResetUserTasksMutationError = void;

/**
 * @summary Reset user tasks by deleting task_user records
 */
export const useAdminControllerResetUserTasks = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerResetUserTasks>>,
    TError,
    { userId: string; data: ResetTasksDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerResetUserTasks>>,
  TError,
  { userId: string; data: ResetTasksDto },
  TContext
> => {
  const mutationOptions = getAdminControllerResetUserTasksMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create a new API key for basic authentication
 */
export const adminControllerCreateApiKey = (createApiKeyDto: CreateApiKeyDto, signal?: AbortSignal) => {
  return customInstance<CreateApiKeyResponseDto>({
    url: `/admin/api-keys`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createApiKeyDto,
    signal,
  });
};

export const getAdminControllerCreateApiKeyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateApiKey>>,
    TError,
    { data: CreateApiKeyDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerCreateApiKey>>,
  TError,
  { data: CreateApiKeyDto },
  TContext
> => {
  const mutationKey = ['adminControllerCreateApiKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerCreateApiKey>>,
    { data: CreateApiKeyDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminControllerCreateApiKey(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerCreateApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerCreateApiKey>>
>;
export type AdminControllerCreateApiKeyMutationBody = CreateApiKeyDto;
export type AdminControllerCreateApiKeyMutationError = void;

/**
 * @summary Create a new API key for basic authentication
 */
export const useAdminControllerCreateApiKey = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateApiKey>>,
    TError,
    { data: CreateApiKeyDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerCreateApiKey>>,
  TError,
  { data: CreateApiKeyDto },
  TContext
> => {
  const mutationOptions = getAdminControllerCreateApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all API keys (without password hashes)
 */
export const adminControllerListApiKeys = (signal?: AbortSignal) => {
  return customInstance<ApiKeyListItemDto[]>({ url: `/admin/api-keys`, method: 'GET', signal });
};

export const getAdminControllerListApiKeysQueryKey = () => {
  return [`/admin/api-keys`] as const;
};

export const getAdminControllerListApiKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerListApiKeys>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerListApiKeys>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerListApiKeysQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerListApiKeys>>> = ({ signal }) =>
    adminControllerListApiKeys(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerListApiKeys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerListApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof adminControllerListApiKeys>>>;
export type AdminControllerListApiKeysQueryError = unknown;

export function useAdminControllerListApiKeys<
  TData = Awaited<ReturnType<typeof adminControllerListApiKeys>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerListApiKeys>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerListApiKeys>>,
        TError,
        Awaited<ReturnType<typeof adminControllerListApiKeys>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerListApiKeys<
  TData = Awaited<ReturnType<typeof adminControllerListApiKeys>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerListApiKeys>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerListApiKeys>>,
        TError,
        Awaited<ReturnType<typeof adminControllerListApiKeys>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerListApiKeys<
  TData = Awaited<ReturnType<typeof adminControllerListApiKeys>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerListApiKeys>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all API keys (without password hashes)
 */

export function useAdminControllerListApiKeys<
  TData = Awaited<ReturnType<typeof adminControllerListApiKeys>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerListApiKeys>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerListApiKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete an API key by ID
 */
export const adminControllerDeleteApiKey = (id: string) => {
  return customInstance<DeleteApiKeyResponseDto>({ url: `/admin/api-keys/${id}`, method: 'DELETE' });
};

export const getAdminControllerDeleteApiKeyMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerDeleteApiKey>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<typeof adminControllerDeleteApiKey>>, TError, { id: string }, TContext> => {
  const mutationKey = ['adminControllerDeleteApiKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerDeleteApiKey>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminControllerDeleteApiKey(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerDeleteApiKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerDeleteApiKey>>
>;

export type AdminControllerDeleteApiKeyMutationError = void;

/**
 * @summary Delete an API key by ID
 */
export const useAdminControllerDeleteApiKey = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerDeleteApiKey>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<Awaited<ReturnType<typeof adminControllerDeleteApiKey>>, TError, { id: string }, TContext> => {
  const mutationOptions = getAdminControllerDeleteApiKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get authentication statistics from the last 10 minutes
 */
export const adminControllerGetAuthStats = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/auth-stats`, method: 'GET', signal });
};

export const getAdminControllerGetAuthStatsQueryKey = () => {
  return [`/admin/auth-stats`] as const;
};

export const getAdminControllerGetAuthStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetAuthStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetAuthStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetAuthStats>>> = ({ signal }) =>
    adminControllerGetAuthStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetAuthStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetAuthStats>>
>;
export type AdminControllerGetAuthStatsQueryError = unknown;

export function useAdminControllerGetAuthStats<
  TData = Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetAuthStats>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetAuthStats>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetAuthStats<
  TData = Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetAuthStats>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetAuthStats>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetAuthStats<
  TData = Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetAuthStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get authentication statistics from the last 10 minutes
 */

export function useAdminControllerGetAuthStats<
  TData = Awaited<ReturnType<typeof adminControllerGetAuthStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetAuthStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetAuthStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new marketplace for an API key
 */
export const adminControllerCreateMarketplace = (
  username: string,
  createMarketplaceDto: CreateMarketplaceDto,
  signal?: AbortSignal,
) => {
  return customInstance<MarketplaceResponseDto>({
    url: `/admin/api-keys/${username}/marketplace`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createMarketplaceDto,
    signal,
  });
};

export const getAdminControllerCreateMarketplaceMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateMarketplace>>,
    TError,
    { username: string; data: CreateMarketplaceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerCreateMarketplace>>,
  TError,
  { username: string; data: CreateMarketplaceDto },
  TContext
> => {
  const mutationKey = ['adminControllerCreateMarketplace'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerCreateMarketplace>>,
    { username: string; data: CreateMarketplaceDto }
  > = (props) => {
    const { username, data } = props ?? {};

    return adminControllerCreateMarketplace(username, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerCreateMarketplaceMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerCreateMarketplace>>
>;
export type AdminControllerCreateMarketplaceMutationBody = CreateMarketplaceDto;
export type AdminControllerCreateMarketplaceMutationError = void;

/**
 * @summary Create a new marketplace for an API key
 */
export const useAdminControllerCreateMarketplace = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateMarketplace>>,
    TError,
    { username: string; data: CreateMarketplaceDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerCreateMarketplace>>,
  TError,
  { username: string; data: CreateMarketplaceDto },
  TContext
> => {
  const mutationOptions = getAdminControllerCreateMarketplaceMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create a new user without Telegram account (non-Telegram user)
 */
export const adminControllerCreateNonTelegramUser = (
  createNonTelegramUserDto: CreateNonTelegramUserDto,
  signal?: AbortSignal,
) => {
  return customInstance<NonTelegramUserResponseDto>({
    url: `/admin/non-telegram-users`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createNonTelegramUserDto,
    signal,
  });
};

export const getAdminControllerCreateNonTelegramUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>,
    TError,
    { data: CreateNonTelegramUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>,
  TError,
  { data: CreateNonTelegramUserDto },
  TContext
> => {
  const mutationKey = ['adminControllerCreateNonTelegramUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>,
    { data: CreateNonTelegramUserDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminControllerCreateNonTelegramUser(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminControllerCreateNonTelegramUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>
>;
export type AdminControllerCreateNonTelegramUserMutationBody = CreateNonTelegramUserDto;
export type AdminControllerCreateNonTelegramUserMutationError = void;

/**
 * @summary Create a new user without Telegram account (non-Telegram user)
 */
export const useAdminControllerCreateNonTelegramUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>,
    TError,
    { data: CreateNonTelegramUserDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminControllerCreateNonTelegramUser>>,
  TError,
  { data: CreateNonTelegramUserDto },
  TContext
> => {
  const mutationOptions = getAdminControllerCreateNonTelegramUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Test RPC limiter by calling getBalance X times per second
 */
export const adminControllerTestRpcLimiter = (params: AdminControllerTestRpcLimiterParams, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/test/rpc-limiter`, method: 'GET', params, signal });
};

export const getAdminControllerTestRpcLimiterQueryKey = (params: AdminControllerTestRpcLimiterParams) => {
  return [`/admin/test/rpc-limiter`, ...(params ? [params] : [])] as const;
};

export const getAdminControllerTestRpcLimiterQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
  TError = unknown,
>(
  params: AdminControllerTestRpcLimiterParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerTestRpcLimiterQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>> = ({ signal }) =>
    adminControllerTestRpcLimiter(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerTestRpcLimiterQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>
>;
export type AdminControllerTestRpcLimiterQueryError = unknown;

export function useAdminControllerTestRpcLimiter<
  TData = Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
  TError = unknown,
>(
  params: AdminControllerTestRpcLimiterParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
          TError,
          Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerTestRpcLimiter<
  TData = Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
  TError = unknown,
>(
  params: AdminControllerTestRpcLimiterParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
          TError,
          Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerTestRpcLimiter<
  TData = Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
  TError = unknown,
>(
  params: AdminControllerTestRpcLimiterParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Test RPC limiter by calling getBalance X times per second
 */

export function useAdminControllerTestRpcLimiter<
  TData = Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>,
  TError = unknown,
>(
  params: AdminControllerTestRpcLimiterParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerTestRpcLimiter>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerTestRpcLimiterQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all collections with "Teddie" in the name
 */
export const adminControllerGetTeddieCollections = (signal?: AbortSignal) => {
  return customInstance<TeddieCollectionDto[]>({ url: `/admin/collections/teddie`, method: 'GET', signal });
};

export const getAdminControllerGetTeddieCollectionsQueryKey = () => {
  return [`/admin/collections/teddie`] as const;
};

export const getAdminControllerGetTeddieCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminControllerGetTeddieCollectionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>> = ({ signal }) =>
    adminControllerGetTeddieCollections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminControllerGetTeddieCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>
>;
export type AdminControllerGetTeddieCollectionsQueryError = unknown;

export function useAdminControllerGetTeddieCollections<
  TData = Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetTeddieCollections<
  TData = Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
        TError,
        Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminControllerGetTeddieCollections<
  TData = Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all collections with "Teddie" in the name
 */

export function useAdminControllerGetTeddieCollections<
  TData = Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerGetTeddieCollections>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminControllerGetTeddieCollectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get drops with participant statistics
 */
export const adminDropControllerGetDropsWithStats = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops`, method: 'GET', signal });
};

export const getAdminDropControllerGetDropsWithStatsQueryKey = () => {
  return [`/admin/drops`] as const;
};

export const getAdminDropControllerGetDropsWithStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetDropsWithStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>> = ({ signal }) =>
    adminDropControllerGetDropsWithStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetDropsWithStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>
>;
export type AdminDropControllerGetDropsWithStatsQueryError = unknown;

export function useAdminDropControllerGetDropsWithStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropsWithStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropsWithStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get drops with participant statistics
 */

export function useAdminDropControllerGetDropsWithStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsWithStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetDropsWithStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create new drop (admin only)
 */
export const adminDropControllerCreateDrop = (createDropWithImageDto: CreateDropWithImageDto, signal?: AbortSignal) => {
  const formData = new FormData();
  if (createDropWithImageDto.image !== undefined) {
    formData.append('image', createDropWithImageDto.image);
  }
  formData.append('request', JSON.stringify(createDropWithImageDto.request));

  return customInstance<CreatedEntityResponseDto>({
    url: `/admin/drops`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminDropControllerCreateDropMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerCreateDrop>>,
    TError,
    { data: CreateDropWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerCreateDrop>>,
  TError,
  { data: CreateDropWithImageDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerCreateDrop'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerCreateDrop>>,
    { data: CreateDropWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminDropControllerCreateDrop(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerCreateDropMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerCreateDrop>>
>;
export type AdminDropControllerCreateDropMutationBody = CreateDropWithImageDto;
export type AdminDropControllerCreateDropMutationError = unknown;

/**
 * @summary Create new drop (admin only)
 */
export const useAdminDropControllerCreateDrop = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerCreateDrop>>,
    TError,
    { data: CreateDropWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerCreateDrop>>,
  TError,
  { data: CreateDropWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerCreateDropMutationOptions(options);

  return useMutation(mutationOptions);
};

export const adminDropControllerGetAllDrops = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops/status`, method: 'GET', signal });
};

export const getAdminDropControllerGetAllDropsQueryKey = () => {
  return [`/admin/drops/status`] as const;
};

export const getAdminDropControllerGetAllDropsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetAllDropsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>> = ({ signal }) =>
    adminDropControllerGetAllDrops(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetAllDropsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>
>;
export type AdminDropControllerGetAllDropsQueryError = unknown;

export function useAdminDropControllerGetAllDrops<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetAllDrops<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetAllDrops<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAdminDropControllerGetAllDrops<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllDrops>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetAllDropsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const adminDropControllerGetDropsByStatus = (status: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops/status/${status}`, method: 'GET', signal });
};

export const getAdminDropControllerGetDropsByStatusQueryKey = (status: string) => {
  return [`/admin/drops/status/${status}`] as const;
};

export const getAdminDropControllerGetDropsByStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
  TError = unknown,
>(
  status: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetDropsByStatusQueryKey(status);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>> = ({ signal }) =>
    adminDropControllerGetDropsByStatus(status, signal);

  return { queryKey, queryFn, enabled: !!status, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetDropsByStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>
>;
export type AdminDropControllerGetDropsByStatusQueryError = unknown;

export function useAdminDropControllerGetDropsByStatus<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
  TError = unknown,
>(
  status: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropsByStatus<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
  TError = unknown,
>(
  status: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropsByStatus<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
  TError = unknown,
>(
  status: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAdminDropControllerGetDropsByStatus<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>,
  TError = unknown,
>(
  status: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropsByStatus>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetDropsByStatusQueryOptions(status, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update drop status
 */
export const adminDropControllerUpdateDropStatus = (id: string, updateDropStatusDto: UpdateDropStatusDto) => {
  return customInstance<void>({
    url: `/admin/drops/${id}/status`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateDropStatusDto,
  });
};

export const getAdminDropControllerUpdateDropStatusMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>,
    TError,
    { id: string; data: UpdateDropStatusDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>,
  TError,
  { id: string; data: UpdateDropStatusDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerUpdateDropStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>,
    { id: string; data: UpdateDropStatusDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDropControllerUpdateDropStatus(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerUpdateDropStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>
>;
export type AdminDropControllerUpdateDropStatusMutationBody = UpdateDropStatusDto;
export type AdminDropControllerUpdateDropStatusMutationError = void;

/**
 * @summary Update drop status
 */
export const useAdminDropControllerUpdateDropStatus = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>,
    TError,
    { id: string; data: UpdateDropStatusDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropStatus>>,
  TError,
  { id: string; data: UpdateDropStatusDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerUpdateDropStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update drop claim allowed
 */
export const adminDropControllerUpdateDropClaimAllowed = (
  id: string,
  updateDropClaimAllowedDto: UpdateDropClaimAllowedDto,
) => {
  return customInstance<void>({
    url: `/admin/drops/${id}/claim-allowed`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateDropClaimAllowedDto,
  });
};

export const getAdminDropControllerUpdateDropClaimAllowedMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>,
    TError,
    { id: string; data: UpdateDropClaimAllowedDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>,
  TError,
  { id: string; data: UpdateDropClaimAllowedDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerUpdateDropClaimAllowed'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>,
    { id: string; data: UpdateDropClaimAllowedDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDropControllerUpdateDropClaimAllowed(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerUpdateDropClaimAllowedMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>
>;
export type AdminDropControllerUpdateDropClaimAllowedMutationBody = UpdateDropClaimAllowedDto;
export type AdminDropControllerUpdateDropClaimAllowedMutationError = void;

/**
 * @summary Update drop claim allowed
 */
export const useAdminDropControllerUpdateDropClaimAllowed = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>,
    TError,
    { id: string; data: UpdateDropClaimAllowedDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerUpdateDropClaimAllowed>>,
  TError,
  { id: string; data: UpdateDropClaimAllowedDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerUpdateDropClaimAllowedMutationOptions(options);

  return useMutation(mutationOptions);
};

export const adminDropControllerGetDropAllocationStats = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops/${id}/allocation-stats`, method: 'GET', signal });
};

export const getAdminDropControllerGetDropAllocationStatsQueryKey = (id: string) => {
  return [`/admin/drops/${id}/allocation-stats`] as const;
};

export const getAdminDropControllerGetDropAllocationStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetDropAllocationStatsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>> = ({ signal }) =>
    adminDropControllerGetDropAllocationStats(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetDropAllocationStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>
>;
export type AdminDropControllerGetDropAllocationStatsQueryError = unknown;

export function useAdminDropControllerGetDropAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAdminDropControllerGetDropAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropAllocationStats>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetDropAllocationStatsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get locks for a drop
 */
export const adminDropControllerGetDropLocksResults = (id: string, signal?: AbortSignal) => {
  return customInstance<LockDto[]>({ url: `/admin/drops/${id}/locks`, method: 'GET', signal });
};

export const getAdminDropControllerGetDropLocksResultsQueryKey = (id: string) => {
  return [`/admin/drops/${id}/locks`] as const;
};

export const getAdminDropControllerGetDropLocksResultsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetDropLocksResultsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>> = ({ signal }) =>
    adminDropControllerGetDropLocksResults(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetDropLocksResultsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>
>;
export type AdminDropControllerGetDropLocksResultsQueryError = void;

export function useAdminDropControllerGetDropLocksResults<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropLocksResults<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropLocksResults<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get locks for a drop
 */

export function useAdminDropControllerGetDropLocksResults<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropLocksResults>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetDropLocksResultsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update drop (admin only)
 */
export const adminDropControllerUpdateDrop = (id: string, updateDropWithImageDto: UpdateDropWithImageDto) => {
  const formData = new FormData();
  if (updateDropWithImageDto.image !== undefined) {
    formData.append('image', updateDropWithImageDto.image);
  }
  formData.append('request', JSON.stringify(updateDropWithImageDto.request));

  return customInstance<unknown>({
    url: `/admin/drops/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getAdminDropControllerUpdateDropMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>,
    TError,
    { id: string; data: UpdateDropWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>,
  TError,
  { id: string; data: UpdateDropWithImageDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerUpdateDrop'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>,
    { id: string; data: UpdateDropWithImageDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDropControllerUpdateDrop(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerUpdateDropMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>
>;
export type AdminDropControllerUpdateDropMutationBody = UpdateDropWithImageDto;
export type AdminDropControllerUpdateDropMutationError = void;

/**
 * @summary Update drop (admin only)
 */
export const useAdminDropControllerUpdateDrop = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>,
    TError,
    { id: string; data: UpdateDropWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerUpdateDrop>>,
  TError,
  { id: string; data: UpdateDropWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerUpdateDropMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Trigger backup allocation check for all drops
 */
export const adminDropControllerTriggerAllocationCheck = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops/allocation/check`, method: 'POST', signal });
};

export const getAdminDropControllerTriggerAllocationCheckMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminDropControllerTriggerAllocationCheck'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>,
    void
  > = () => {
    return adminDropControllerTriggerAllocationCheck();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerTriggerAllocationCheckMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>
>;

export type AdminDropControllerTriggerAllocationCheckMutationError = unknown;

/**
 * @summary Trigger backup allocation check for all drops
 */
export const useAdminDropControllerTriggerAllocationCheck = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerTriggerAllocationCheck>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getAdminDropControllerTriggerAllocationCheckMutationOptions(options);

  return useMutation(mutationOptions);
};

export const adminDropControllerGetAllocationStats = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/drops/allocation/stats`, method: 'GET', signal });
};

export const getAdminDropControllerGetAllocationStatsQueryKey = () => {
  return [`/admin/drops/allocation/stats`] as const;
};

export const getAdminDropControllerGetAllocationStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetAllocationStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>> = ({ signal }) =>
    adminDropControllerGetAllocationStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetAllocationStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>
>;
export type AdminDropControllerGetAllocationStatsQueryError = unknown;

export function useAdminDropControllerGetAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

export function useAdminDropControllerGetAllocationStats<
  TData = Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetAllocationStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetAllocationStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add multiple users to drop whitelist
 */
export const adminDropControllerAddUsersToWhitelist = (
  dropId: string,
  bulkWhitelistDto: BulkWhitelistDto,
  signal?: AbortSignal,
) => {
  return customInstance<BulkWhitelistResponseDto>({
    url: `/admin/drops/${dropId}/whitelist/bulk-add`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkWhitelistDto,
    signal,
  });
};

export const getAdminDropControllerAddUsersToWhitelistMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>,
    TError,
    { dropId: string; data: BulkWhitelistDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>,
  TError,
  { dropId: string; data: BulkWhitelistDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerAddUsersToWhitelist'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>,
    { dropId: string; data: BulkWhitelistDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return adminDropControllerAddUsersToWhitelist(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerAddUsersToWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>
>;
export type AdminDropControllerAddUsersToWhitelistMutationBody = BulkWhitelistDto;
export type AdminDropControllerAddUsersToWhitelistMutationError = void;

/**
 * @summary Add multiple users to drop whitelist
 */
export const useAdminDropControllerAddUsersToWhitelist = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>,
    TError,
    { dropId: string; data: BulkWhitelistDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerAddUsersToWhitelist>>,
  TError,
  { dropId: string; data: BulkWhitelistDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerAddUsersToWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Remove multiple users from drop whitelist
 */
export const adminDropControllerRemoveUsersFromWhitelist = (
  dropId: string,
  bulkWhitelistDto: BulkWhitelistDto,
  signal?: AbortSignal,
) => {
  return customInstance<BulkWhitelistResponseDto>({
    url: `/admin/drops/${dropId}/whitelist/bulk-remove`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkWhitelistDto,
    signal,
  });
};

export const getAdminDropControllerRemoveUsersFromWhitelistMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>,
    TError,
    { dropId: string; data: BulkWhitelistDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>,
  TError,
  { dropId: string; data: BulkWhitelistDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerRemoveUsersFromWhitelist'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>,
    { dropId: string; data: BulkWhitelistDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return adminDropControllerRemoveUsersFromWhitelist(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerRemoveUsersFromWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>
>;
export type AdminDropControllerRemoveUsersFromWhitelistMutationBody = BulkWhitelistDto;
export type AdminDropControllerRemoveUsersFromWhitelistMutationError = void;

/**
 * @summary Remove multiple users from drop whitelist
 */
export const useAdminDropControllerRemoveUsersFromWhitelist = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>,
    TError,
    { dropId: string; data: BulkWhitelistDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerRemoveUsersFromWhitelist>>,
  TError,
  { dropId: string; data: BulkWhitelistDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerRemoveUsersFromWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all whitelisted users for a drop
 */
export const adminDropControllerGetWhitelistedUsers = (dropId: string, signal?: AbortSignal) => {
  return customInstance<WhitelistUserResponseDto[]>({ url: `/admin/drops/${dropId}/whitelist`, method: 'GET', signal });
};

export const getAdminDropControllerGetWhitelistedUsersQueryKey = (dropId: string) => {
  return [`/admin/drops/${dropId}/whitelist`] as const;
};

export const getAdminDropControllerGetWhitelistedUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetWhitelistedUsersQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>> = ({ signal }) =>
    adminDropControllerGetWhitelistedUsers(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetWhitelistedUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>
>;
export type AdminDropControllerGetWhitelistedUsersQueryError = void;

export function useAdminDropControllerGetWhitelistedUsers<
  TData = Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetWhitelistedUsers<
  TData = Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetWhitelistedUsers<
  TData = Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all whitelisted users for a drop
 */

export function useAdminDropControllerGetWhitelistedUsers<
  TData = Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetWhitelistedUsers>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetWhitelistedUsersQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set, update, or remove drop condition (minimum level requirement for automatic whitelist)
 */
export const adminDropControllerSetDropCondition = (dropId: string, setDropConditionDto: SetDropConditionDto) => {
  return customInstance<SuccessResultDto>({
    url: `/admin/drops/${dropId}/condition`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setDropConditionDto,
  });
};

export const getAdminDropControllerSetDropConditionMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>,
    TError,
    { dropId: string; data: SetDropConditionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>,
  TError,
  { dropId: string; data: SetDropConditionDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerSetDropCondition'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>,
    { dropId: string; data: SetDropConditionDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return adminDropControllerSetDropCondition(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerSetDropConditionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>
>;
export type AdminDropControllerSetDropConditionMutationBody = SetDropConditionDto;
export type AdminDropControllerSetDropConditionMutationError = void;

/**
 * @summary Set, update, or remove drop condition (minimum level requirement for automatic whitelist)
 */
export const useAdminDropControllerSetDropCondition = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>,
    TError,
    { dropId: string; data: SetDropConditionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerSetDropCondition>>,
  TError,
  { dropId: string; data: SetDropConditionDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerSetDropConditionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get drop condition (minimum level requirement for automatic whitelist)
 */
export const adminDropControllerGetDropCondition = (dropId: string, signal?: AbortSignal) => {
  return customInstance<DropConditionResponseDto>({ url: `/admin/drops/${dropId}/condition`, method: 'GET', signal });
};

export const getAdminDropControllerGetDropConditionQueryKey = (dropId: string) => {
  return [`/admin/drops/${dropId}/condition`] as const;
};

export const getAdminDropControllerGetDropConditionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetDropConditionQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>> = ({ signal }) =>
    adminDropControllerGetDropCondition(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetDropConditionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>
>;
export type AdminDropControllerGetDropConditionQueryError = void;

export function useAdminDropControllerGetDropCondition<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropCondition<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetDropCondition<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get drop condition (minimum level requirement for automatic whitelist)
 */

export function useAdminDropControllerGetDropCondition<
  TData = Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetDropCondition>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetDropConditionQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set collection whitelist for a drop (replaces all existing collections)
 */
export const adminDropControllerSetCollectionWhitelist = (
  dropId: string,
  setCollectionWhitelistDto: SetCollectionWhitelistDto,
) => {
  return customInstance<SuccessResultDto>({
    url: `/admin/drops/${dropId}/whitelist/collections`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setCollectionWhitelistDto,
  });
};

export const getAdminDropControllerSetCollectionWhitelistMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>,
    TError,
    { dropId: string; data: SetCollectionWhitelistDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>,
  TError,
  { dropId: string; data: SetCollectionWhitelistDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerSetCollectionWhitelist'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>,
    { dropId: string; data: SetCollectionWhitelistDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return adminDropControllerSetCollectionWhitelist(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerSetCollectionWhitelistMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>
>;
export type AdminDropControllerSetCollectionWhitelistMutationBody = SetCollectionWhitelistDto;
export type AdminDropControllerSetCollectionWhitelistMutationError = void;

/**
 * @summary Set collection whitelist for a drop (replaces all existing collections)
 */
export const useAdminDropControllerSetCollectionWhitelist = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>,
    TError,
    { dropId: string; data: SetCollectionWhitelistDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerSetCollectionWhitelist>>,
  TError,
  { dropId: string; data: SetCollectionWhitelistDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerSetCollectionWhitelistMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get collection whitelist for a drop
 */
export const adminDropControllerGetCollectionWhitelist = (dropId: string, signal?: AbortSignal) => {
  return customInstance<CollectionWhitelistResponseDto>({
    url: `/admin/drops/${dropId}/whitelist/collections`,
    method: 'GET',
    signal,
  });
};

export const getAdminDropControllerGetCollectionWhitelistQueryKey = (dropId: string) => {
  return [`/admin/drops/${dropId}/whitelist/collections`] as const;
};

export const getAdminDropControllerGetCollectionWhitelistQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerGetCollectionWhitelistQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>> = ({ signal }) =>
    adminDropControllerGetCollectionWhitelist(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerGetCollectionWhitelistQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>
>;
export type AdminDropControllerGetCollectionWhitelistQueryError = void;

export function useAdminDropControllerGetCollectionWhitelist<
  TData = Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetCollectionWhitelist<
  TData = Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
          TError,
          Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerGetCollectionWhitelist<
  TData = Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get collection whitelist for a drop
 */

export function useAdminDropControllerGetCollectionWhitelist<
  TData = Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerGetCollectionWhitelist>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerGetCollectionWhitelistQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set or remove maximum packs per user limit for a drop
 */
export const adminDropControllerSetMaxPacksPerUser = (dropId: string, setMaxPacksPerUserDto: SetMaxPacksPerUserDto) => {
  return customInstance<SuccessResultDto>({
    url: `/admin/drops/${dropId}/max-packs-per-user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: setMaxPacksPerUserDto,
  });
};

export const getAdminDropControllerSetMaxPacksPerUserMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>,
    TError,
    { dropId: string; data: SetMaxPacksPerUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>,
  TError,
  { dropId: string; data: SetMaxPacksPerUserDto },
  TContext
> => {
  const mutationKey = ['adminDropControllerSetMaxPacksPerUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>,
    { dropId: string; data: SetMaxPacksPerUserDto }
  > = (props) => {
    const { dropId, data } = props ?? {};

    return adminDropControllerSetMaxPacksPerUser(dropId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerSetMaxPacksPerUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>
>;
export type AdminDropControllerSetMaxPacksPerUserMutationBody = SetMaxPacksPerUserDto;
export type AdminDropControllerSetMaxPacksPerUserMutationError = void;

/**
 * @summary Set or remove maximum packs per user limit for a drop
 */
export const useAdminDropControllerSetMaxPacksPerUser = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>,
    TError,
    { dropId: string; data: SetMaxPacksPerUserDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerSetMaxPacksPerUser>>,
  TError,
  { dropId: string; data: SetMaxPacksPerUserDto },
  TContext
> => {
  const mutationOptions = getAdminDropControllerSetMaxPacksPerUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Analyze lock exploits (fast, database-only - without balance fetching)
 */
export const adminDropControllerAnalyzeLockExploits = (signal?: AbortSignal) => {
  return customInstance<LockExploitAnalysisPartialResponseDto>({
    url: `/admin/drops/lock-exploit-analysis`,
    method: 'GET',
    signal,
  });
};

export const getAdminDropControllerAnalyzeLockExploitsQueryKey = () => {
  return [`/admin/drops/lock-exploit-analysis`] as const;
};

export const getAdminDropControllerAnalyzeLockExploitsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDropControllerAnalyzeLockExploitsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>> = ({ signal }) =>
    adminDropControllerAnalyzeLockExploits(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminDropControllerAnalyzeLockExploitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>
>;
export type AdminDropControllerAnalyzeLockExploitsQueryError = void;

export function useAdminDropControllerAnalyzeLockExploits<
  TData = Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
  TError = void,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerAnalyzeLockExploits<
  TData = Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
        TError,
        Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminDropControllerAnalyzeLockExploits<
  TData = Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Analyze lock exploits (fast, database-only - without balance fetching)
 */

export function useAdminDropControllerAnalyzeLockExploits<
  TData = Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminDropControllerAnalyzeLockExploits>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminDropControllerAnalyzeLockExploitsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Run pure allocation algorithm on a drop (test mode - does not persist results)
 */
export const adminDropControllerRunPureAllocation = (dropId: string, signal?: AbortSignal) => {
  return customInstance<AllocationResultDto>({ url: `/admin/drops/${dropId}/pure-allocation`, method: 'POST', signal });
};

export const getAdminDropControllerRunPureAllocationMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>,
    TError,
    { dropId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>,
  TError,
  { dropId: string },
  TContext
> => {
  const mutationKey = ['adminDropControllerRunPureAllocation'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>,
    { dropId: string }
  > = (props) => {
    const { dropId } = props ?? {};

    return adminDropControllerRunPureAllocation(dropId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDropControllerRunPureAllocationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>
>;

export type AdminDropControllerRunPureAllocationMutationError = void;

/**
 * @summary Run pure allocation algorithm on a drop (test mode - does not persist results)
 */
export const useAdminDropControllerRunPureAllocation = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>,
    TError,
    { dropId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminDropControllerRunPureAllocation>>,
  TError,
  { dropId: string },
  TContext
> => {
  const mutationOptions = getAdminDropControllerRunPureAllocationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get NFT audit history for a specific pack
 */
export const adminNftAuditControllerGetPackAuditHistory = (packId: string, signal?: AbortSignal) => {
  return customInstance<NftAuditResponseDto[]>({ url: `/admin/nft-audit/pack/${packId}`, method: 'GET', signal });
};

export const getAdminNftAuditControllerGetPackAuditHistoryQueryKey = (packId: string) => {
  return [`/admin/nft-audit/pack/${packId}`] as const;
};

export const getAdminNftAuditControllerGetPackAuditHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
  TError = unknown,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetPackAuditHistoryQueryKey(packId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>> = ({ signal }) =>
    adminNftAuditControllerGetPackAuditHistory(packId, signal);

  return { queryKey, queryFn, enabled: !!packId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetPackAuditHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>
>;
export type AdminNftAuditControllerGetPackAuditHistoryQueryError = unknown;

export function useAdminNftAuditControllerGetPackAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
  TError = unknown,
>(
  packId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetPackAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
  TError = unknown,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetPackAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
  TError = unknown,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT audit history for a specific pack
 */

export function useAdminNftAuditControllerGetPackAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>,
  TError = unknown,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetPackAuditHistory>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetPackAuditHistoryQueryOptions(packId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT audit history for a specific user
 */
export const adminNftAuditControllerGetUserAuditHistory = (userId: string, signal?: AbortSignal) => {
  return customInstance<NftAuditResponseDto[]>({ url: `/admin/nft-audit/user/${userId}`, method: 'GET', signal });
};

export const getAdminNftAuditControllerGetUserAuditHistoryQueryKey = (userId: string) => {
  return [`/admin/nft-audit/user/${userId}`] as const;
};

export const getAdminNftAuditControllerGetUserAuditHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetUserAuditHistoryQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>> = ({ signal }) =>
    adminNftAuditControllerGetUserAuditHistory(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetUserAuditHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>
>;
export type AdminNftAuditControllerGetUserAuditHistoryQueryError = unknown;

export function useAdminNftAuditControllerGetUserAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetUserAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetUserAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT audit history for a specific user
 */

export function useAdminNftAuditControllerGetUserAuditHistory<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetUserAuditHistory>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetUserAuditHistoryQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT audit history by request ID
 */
export const adminNftAuditControllerGetAuditByRequestId = (requestId: string, signal?: AbortSignal) => {
  return customInstance<NftAuditResponseDto[]>({ url: `/admin/nft-audit/request/${requestId}`, method: 'GET', signal });
};

export const getAdminNftAuditControllerGetAuditByRequestIdQueryKey = (requestId: string) => {
  return [`/admin/nft-audit/request/${requestId}`] as const;
};

export const getAdminNftAuditControllerGetAuditByRequestIdQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
  TError = unknown,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetAuditByRequestIdQueryKey(requestId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>> = ({ signal }) =>
    adminNftAuditControllerGetAuditByRequestId(requestId, signal);

  return { queryKey, queryFn, enabled: !!requestId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetAuditByRequestIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>
>;
export type AdminNftAuditControllerGetAuditByRequestIdQueryError = unknown;

export function useAdminNftAuditControllerGetAuditByRequestId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
  TError = unknown,
>(
  requestId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetAuditByRequestId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
  TError = unknown,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetAuditByRequestId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
  TError = unknown,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT audit history by request ID
 */

export function useAdminNftAuditControllerGetAuditByRequestId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>,
  TError = unknown,
>(
  requestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByRequestId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetAuditByRequestIdQueryOptions(requestId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT audit history by queue job ID
 */
export const adminNftAuditControllerGetAuditByQueueJobId = (queueJobId: string, signal?: AbortSignal) => {
  return customInstance<NftAuditResponseDto[]>({
    url: `/admin/nft-audit/queue-job/${queueJobId}`,
    method: 'GET',
    signal,
  });
};

export const getAdminNftAuditControllerGetAuditByQueueJobIdQueryKey = (queueJobId: string) => {
  return [`/admin/nft-audit/queue-job/${queueJobId}`] as const;
};

export const getAdminNftAuditControllerGetAuditByQueueJobIdQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
  TError = unknown,
>(
  queueJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetAuditByQueueJobIdQueryKey(queueJobId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>> = ({
    signal,
  }) => adminNftAuditControllerGetAuditByQueueJobId(queueJobId, signal);

  return { queryKey, queryFn, enabled: !!queueJobId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetAuditByQueueJobIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>
>;
export type AdminNftAuditControllerGetAuditByQueueJobIdQueryError = unknown;

export function useAdminNftAuditControllerGetAuditByQueueJobId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
  TError = unknown,
>(
  queueJobId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetAuditByQueueJobId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
  TError = unknown,
>(
  queueJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetAuditByQueueJobId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
  TError = unknown,
>(
  queueJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT audit history by queue job ID
 */

export function useAdminNftAuditControllerGetAuditByQueueJobId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>,
  TError = unknown,
>(
  queueJobId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetAuditByQueueJobId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetAuditByQueueJobIdQueryOptions(queueJobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get recent NFT audit events
 */
export const adminNftAuditControllerGetRecentAuditEvents = (
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
  signal?: AbortSignal,
) => {
  return customInstance<NftAuditResponseDto[]>({ url: `/admin/nft-audit/recent`, method: 'GET', params, signal });
};

export const getAdminNftAuditControllerGetRecentAuditEventsQueryKey = (
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
) => {
  return [`/admin/nft-audit/recent`, ...(params ? [params] : [])] as const;
};

export const getAdminNftAuditControllerGetRecentAuditEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
  TError = unknown,
>(
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetRecentAuditEventsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>> = ({
    signal,
  }) => adminNftAuditControllerGetRecentAuditEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetRecentAuditEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>
>;
export type AdminNftAuditControllerGetRecentAuditEventsQueryError = unknown;

export function useAdminNftAuditControllerGetRecentAuditEvents<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
  TError = unknown,
>(
  params: undefined | AdminNftAuditControllerGetRecentAuditEventsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetRecentAuditEvents<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
  TError = unknown,
>(
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetRecentAuditEvents<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
  TError = unknown,
>(
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get recent NFT audit events
 */

export function useAdminNftAuditControllerGetRecentAuditEvents<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>,
  TError = unknown,
>(
  params?: AdminNftAuditControllerGetRecentAuditEventsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetRecentAuditEvents>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetRecentAuditEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT transactions for a specific pack
 */
export const adminNftAuditControllerGetNftTransactionsByPackId = (packId: string, signal?: AbortSignal) => {
  return customInstance<NftTransactionDto[]>({
    url: `/admin/nft-audit/pack/${packId}/transactions`,
    method: 'GET',
    signal,
  });
};

export const getAdminNftAuditControllerGetNftTransactionsByPackIdQueryKey = (packId: string) => {
  return [`/admin/nft-audit/pack/${packId}/transactions`] as const;
};

export const getAdminNftAuditControllerGetNftTransactionsByPackIdQueryOptions = <
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
  TError = void,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNftAuditControllerGetNftTransactionsByPackIdQueryKey(packId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>> = ({
    signal,
  }) => adminNftAuditControllerGetNftTransactionsByPackId(packId, signal);

  return { queryKey, queryFn, enabled: !!packId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminNftAuditControllerGetNftTransactionsByPackIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>
>;
export type AdminNftAuditControllerGetNftTransactionsByPackIdQueryError = void;

export function useAdminNftAuditControllerGetNftTransactionsByPackId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
  TError = void,
>(
  packId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetNftTransactionsByPackId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
  TError = void,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
          TError,
          Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminNftAuditControllerGetNftTransactionsByPackId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
  TError = void,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT transactions for a specific pack
 */

export function useAdminNftAuditControllerGetNftTransactionsByPackId<
  TData = Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>,
  TError = void,
>(
  packId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminNftAuditControllerGetNftTransactionsByPackId>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminNftAuditControllerGetNftTransactionsByPackIdQueryOptions(packId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get recent sale audit events with optional filters
 */
export const adminSaleAuditControllerGetSaleAuditEvents = (
  saleAuditFiltersDto: SaleAuditFiltersDto,
  signal?: AbortSignal,
) => {
  return customInstance<SaleAuditResponseDto[]>({
    url: `/admin/sale-audit/recent`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: saleAuditFiltersDto,
    signal,
  });
};

export const getAdminSaleAuditControllerGetSaleAuditEventsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>,
    TError,
    { data: SaleAuditFiltersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>,
  TError,
  { data: SaleAuditFiltersDto },
  TContext
> => {
  const mutationKey = ['adminSaleAuditControllerGetSaleAuditEvents'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>,
    { data: SaleAuditFiltersDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminSaleAuditControllerGetSaleAuditEvents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSaleAuditControllerGetSaleAuditEventsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>
>;
export type AdminSaleAuditControllerGetSaleAuditEventsMutationBody = SaleAuditFiltersDto;
export type AdminSaleAuditControllerGetSaleAuditEventsMutationError = void;

/**
 * @summary Get recent sale audit events with optional filters
 */
export const useAdminSaleAuditControllerGetSaleAuditEvents = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>,
    TError,
    { data: SaleAuditFiltersDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminSaleAuditControllerGetSaleAuditEvents>>,
  TError,
  { data: SaleAuditFiltersDto },
  TContext
> => {
  const mutationOptions = getAdminSaleAuditControllerGetSaleAuditEventsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Search payments with filters and pagination
 */
export const adminPaymentsControllerSearchPayments = (
  params?: AdminPaymentsControllerSearchPaymentsParams,
  signal?: AbortSignal,
) => {
  return customInstance<SearchPaymentsResponseDto>({ url: `/admin/payments`, method: 'GET', params, signal });
};

export const getAdminPaymentsControllerSearchPaymentsQueryKey = (
  params?: AdminPaymentsControllerSearchPaymentsParams,
) => {
  return [`/admin/payments`, ...(params ? [params] : [])] as const;
};

export const getAdminPaymentsControllerSearchPaymentsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
  TError = unknown,
>(
  params?: AdminPaymentsControllerSearchPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminPaymentsControllerSearchPaymentsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>> = ({ signal }) =>
    adminPaymentsControllerSearchPayments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminPaymentsControllerSearchPaymentsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>
>;
export type AdminPaymentsControllerSearchPaymentsQueryError = unknown;

export function useAdminPaymentsControllerSearchPayments<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
  TError = unknown,
>(
  params: undefined | AdminPaymentsControllerSearchPaymentsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminPaymentsControllerSearchPayments<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
  TError = unknown,
>(
  params?: AdminPaymentsControllerSearchPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminPaymentsControllerSearchPayments<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
  TError = unknown,
>(
  params?: AdminPaymentsControllerSearchPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search payments with filters and pagination
 */

export function useAdminPaymentsControllerSearchPayments<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>,
  TError = unknown,
>(
  params?: AdminPaymentsControllerSearchPaymentsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerSearchPayments>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminPaymentsControllerSearchPaymentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get detailed payment information including audit trail
 */
export const adminPaymentsControllerGetPaymentDetails = (id: string, signal?: AbortSignal) => {
  return customInstance<PaymentDetailResponseDto>({ url: `/admin/payments/${id}`, method: 'GET', signal });
};

export const getAdminPaymentsControllerGetPaymentDetailsQueryKey = (id: string) => {
  return [`/admin/payments/${id}`] as const;
};

export const getAdminPaymentsControllerGetPaymentDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminPaymentsControllerGetPaymentDetailsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>> = ({ signal }) =>
    adminPaymentsControllerGetPaymentDetails(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminPaymentsControllerGetPaymentDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>
>;
export type AdminPaymentsControllerGetPaymentDetailsQueryError = void;

export function useAdminPaymentsControllerGetPaymentDetails<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminPaymentsControllerGetPaymentDetails<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
          TError,
          Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminPaymentsControllerGetPaymentDetails<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get detailed payment information including audit trail
 */

export function useAdminPaymentsControllerGetPaymentDetails<
  TData = Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminPaymentsControllerGetPaymentDetails>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminPaymentsControllerGetPaymentDetailsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Manually refund a payment (admin only)
 */
export const adminPaymentsControllerRefundPayment = (
  id: string,
  manualRefundRequestDto: ManualRefundRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<RefundResponseDto>({
    url: `/admin/payments/${id}/refund`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: manualRefundRequestDto,
    signal,
  });
};

export const getAdminPaymentsControllerRefundPaymentMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>,
    TError,
    { id: string; data: ManualRefundRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>,
  TError,
  { id: string; data: ManualRefundRequestDto },
  TContext
> => {
  const mutationKey = ['adminPaymentsControllerRefundPayment'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>,
    { id: string; data: ManualRefundRequestDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminPaymentsControllerRefundPayment(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPaymentsControllerRefundPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>
>;
export type AdminPaymentsControllerRefundPaymentMutationBody = ManualRefundRequestDto;
export type AdminPaymentsControllerRefundPaymentMutationError = void;

/**
 * @summary Manually refund a payment (admin only)
 */
export const useAdminPaymentsControllerRefundPayment = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>,
    TError,
    { id: string; data: ManualRefundRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminPaymentsControllerRefundPayment>>,
  TError,
  { id: string; data: ManualRefundRequestDto },
  TContext
> => {
  const mutationOptions = getAdminPaymentsControllerRefundPaymentMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create a collection on GetGems using our collection data
 */
export const adminGetGemsControllerCreateGetGemsCollection = (
  createGetGemsCollectionDto: CreateGetGemsCollectionDto,
  signal?: AbortSignal,
) => {
  return customInstance<CreateGetGemsCollectionResponseDto>({
    url: `/admin/getgems/collections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createGetGemsCollectionDto,
    signal,
  });
};

export const getAdminGetGemsControllerCreateGetGemsCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>,
    TError,
    { data: CreateGetGemsCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>,
  TError,
  { data: CreateGetGemsCollectionDto },
  TContext
> => {
  const mutationKey = ['adminGetGemsControllerCreateGetGemsCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>,
    { data: CreateGetGemsCollectionDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminGetGemsControllerCreateGetGemsCollection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGetGemsControllerCreateGetGemsCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>
>;
export type AdminGetGemsControllerCreateGetGemsCollectionMutationBody = CreateGetGemsCollectionDto;
export type AdminGetGemsControllerCreateGetGemsCollectionMutationError = unknown;

/**
 * @summary Create a collection on GetGems using our collection data
 */
export const useAdminGetGemsControllerCreateGetGemsCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>,
    TError,
    { data: CreateGetGemsCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminGetGemsControllerCreateGetGemsCollection>>,
  TError,
  { data: CreateGetGemsCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminGetGemsControllerCreateGetGemsCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get GetGems collection minting status
 */
export const adminGetGemsControllerGetGetGemsCollectionStatus = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/getgems/collections/${id}/status`, method: 'GET', signal });
};

export const getAdminGetGemsControllerGetGetGemsCollectionStatusQueryKey = (id: string) => {
  return [`/admin/getgems/collections/${id}/status`] as const;
};

export const getAdminGetGemsControllerGetGetGemsCollectionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGetGemsControllerGetGetGemsCollectionStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>> = ({
    signal,
  }) => adminGetGemsControllerGetGetGemsCollectionStatus(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminGetGemsControllerGetGetGemsCollectionStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>
>;
export type AdminGetGemsControllerGetGetGemsCollectionStatusQueryError = unknown;

export function useAdminGetGemsControllerGetGetGemsCollectionStatus<
  TData = Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetGemsControllerGetGetGemsCollectionStatus<
  TData = Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
          TError,
          Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminGetGemsControllerGetGetGemsCollectionStatus<
  TData = Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get GetGems collection minting status
 */

export function useAdminGetGemsControllerGetGetGemsCollectionStatus<
  TData = Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminGetGemsControllerGetGetGemsCollectionStatus>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminGetGemsControllerGetGetGemsCollectionStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update GetGems collection
 */
export const adminGetGemsControllerUpdateGetGemsCollection = (
  id: string,
  updateGetGemsCollectionDto: UpdateGetGemsCollectionDto,
) => {
  return customInstance<void>({
    url: `/admin/getgems/collections/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateGetGemsCollectionDto,
  });
};

export const getAdminGetGemsControllerUpdateGetGemsCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>,
    TError,
    { id: string; data: UpdateGetGemsCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>,
  TError,
  { id: string; data: UpdateGetGemsCollectionDto },
  TContext
> => {
  const mutationKey = ['adminGetGemsControllerUpdateGetGemsCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>,
    { id: string; data: UpdateGetGemsCollectionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminGetGemsControllerUpdateGetGemsCollection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGetGemsControllerUpdateGetGemsCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>
>;
export type AdminGetGemsControllerUpdateGetGemsCollectionMutationBody = UpdateGetGemsCollectionDto;
export type AdminGetGemsControllerUpdateGetGemsCollectionMutationError = unknown;

/**
 * @summary Update GetGems collection
 */
export const useAdminGetGemsControllerUpdateGetGemsCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>,
    TError,
    { id: string; data: UpdateGetGemsCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminGetGemsControllerUpdateGetGemsCollection>>,
  TError,
  { id: string; data: UpdateGetGemsCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminGetGemsControllerUpdateGetGemsCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get queue statistics
 */
export const queueMonitoringControllerGetQueueStats = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/queues/stats`, method: 'GET', signal });
};

export const getQueueMonitoringControllerGetQueueStatsQueryKey = () => {
  return [`/admin/queues/stats`] as const;
};

export const getQueueMonitoringControllerGetQueueStatsQueryOptions = <
  TData = Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getQueueMonitoringControllerGetQueueStatsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>> = ({ signal }) =>
    queueMonitoringControllerGetQueueStats(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type QueueMonitoringControllerGetQueueStatsQueryResult = NonNullable<
  Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>
>;
export type QueueMonitoringControllerGetQueueStatsQueryError = unknown;

export function useQueueMonitoringControllerGetQueueStats<
  TData = Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
        TError,
        Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useQueueMonitoringControllerGetQueueStats<
  TData = Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
        TError,
        Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useQueueMonitoringControllerGetQueueStats<
  TData = Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get queue statistics
 */

export function useQueueMonitoringControllerGetQueueStats<
  TData = Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof queueMonitoringControllerGetQueueStats>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getQueueMonitoringControllerGetQueueStatsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get RPC analytics summary
 */
export const adminAnalyticsControllerGetSummary = (
  params?: AdminAnalyticsControllerGetSummaryParams,
  signal?: AbortSignal,
) => {
  return customInstance<AdminAnalyticsControllerGetSummary200>({
    url: `/admin/analytics/rpc/summary`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminAnalyticsControllerGetSummaryQueryKey = (params?: AdminAnalyticsControllerGetSummaryParams) => {
  return [`/admin/analytics/rpc/summary`, ...(params ? [params] : [])] as const;
};

export const getAdminAnalyticsControllerGetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAnalyticsControllerGetSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>> = ({ signal }) =>
    adminAnalyticsControllerGetSummary(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminAnalyticsControllerGetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>
>;
export type AdminAnalyticsControllerGetSummaryQueryError = unknown;

export function useAdminAnalyticsControllerGetSummary<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
  TError = unknown,
>(
  params: undefined | AdminAnalyticsControllerGetSummaryParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetSummary<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetSummary<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get RPC analytics summary
 */

export function useAdminAnalyticsControllerGetSummary<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetSummaryParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetSummary>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminAnalyticsControllerGetSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get RPC analytics per method
 */
export const adminAnalyticsControllerGetMethods = (
  params?: AdminAnalyticsControllerGetMethodsParams,
  signal?: AbortSignal,
) => {
  return customInstance<AdminAnalyticsControllerGetMethods200Item[]>({
    url: `/admin/analytics/rpc/methods`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminAnalyticsControllerGetMethodsQueryKey = (params?: AdminAnalyticsControllerGetMethodsParams) => {
  return [`/admin/analytics/rpc/methods`, ...(params ? [params] : [])] as const;
};

export const getAdminAnalyticsControllerGetMethodsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetMethodsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAnalyticsControllerGetMethodsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>> = ({ signal }) =>
    adminAnalyticsControllerGetMethods(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminAnalyticsControllerGetMethodsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>
>;
export type AdminAnalyticsControllerGetMethodsQueryError = unknown;

export function useAdminAnalyticsControllerGetMethods<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
  TError = unknown,
>(
  params: undefined | AdminAnalyticsControllerGetMethodsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetMethods<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetMethodsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetMethods<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetMethodsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get RPC analytics per method
 */

export function useAdminAnalyticsControllerGetMethods<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetMethodsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetMethods>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminAnalyticsControllerGetMethodsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get RPC analytics time series
 */
export const adminAnalyticsControllerGetTimeSeries = (
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
  signal?: AbortSignal,
) => {
  return customInstance<AdminAnalyticsControllerGetTimeSeries200Item[]>({
    url: `/admin/analytics/rpc/timeseries`,
    method: 'GET',
    params,
    signal,
  });
};

export const getAdminAnalyticsControllerGetTimeSeriesQueryKey = (
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
) => {
  return [`/admin/analytics/rpc/timeseries`, ...(params ? [params] : [])] as const;
};

export const getAdminAnalyticsControllerGetTimeSeriesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAnalyticsControllerGetTimeSeriesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>> = ({ signal }) =>
    adminAnalyticsControllerGetTimeSeries(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminAnalyticsControllerGetTimeSeriesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>
>;
export type AdminAnalyticsControllerGetTimeSeriesQueryError = unknown;

export function useAdminAnalyticsControllerGetTimeSeries<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
  TError = unknown,
>(
  params: undefined | AdminAnalyticsControllerGetTimeSeriesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetTimeSeries<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
          TError,
          Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetTimeSeries<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get RPC analytics time series
 */

export function useAdminAnalyticsControllerGetTimeSeries<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>,
  TError = unknown,
>(
  params?: AdminAnalyticsControllerGetTimeSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetTimeSeries>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminAnalyticsControllerGetTimeSeriesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get RPC congestion status
 */
export const adminAnalyticsControllerGetCongestion = (signal?: AbortSignal) => {
  return customInstance<AdminAnalyticsControllerGetCongestion200>({
    url: `/admin/analytics/rpc/congestion`,
    method: 'GET',
    signal,
  });
};

export const getAdminAnalyticsControllerGetCongestionQueryKey = () => {
  return [`/admin/analytics/rpc/congestion`] as const;
};

export const getAdminAnalyticsControllerGetCongestionQueryOptions = <
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAnalyticsControllerGetCongestionQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>> = ({ signal }) =>
    adminAnalyticsControllerGetCongestion(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminAnalyticsControllerGetCongestionQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>
>;
export type AdminAnalyticsControllerGetCongestionQueryError = unknown;

export function useAdminAnalyticsControllerGetCongestion<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
        TError,
        Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetCongestion<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
        TError,
        Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminAnalyticsControllerGetCongestion<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get RPC congestion status
 */

export function useAdminAnalyticsControllerGetCongestion<
  TData = Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminAnalyticsControllerGetCongestion>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminAnalyticsControllerGetCongestionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Search top holders of specified collections
 */
export const adminCollectionsControllerSearchTopHolders = (
  searchTopHoldersRequest: SearchTopHoldersRequest,
  signal?: AbortSignal,
) => {
  return customInstance<SearchTopHoldersResponse>({
    url: `/admin/collections/search-top-holders`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: searchTopHoldersRequest,
    signal,
  });
};

export const getAdminCollectionsControllerSearchTopHoldersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>,
    TError,
    { data: SearchTopHoldersRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>,
  TError,
  { data: SearchTopHoldersRequest },
  TContext
> => {
  const mutationKey = ['adminCollectionsControllerSearchTopHolders'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>,
    { data: SearchTopHoldersRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminCollectionsControllerSearchTopHolders(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCollectionsControllerSearchTopHoldersMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>
>;
export type AdminCollectionsControllerSearchTopHoldersMutationBody = SearchTopHoldersRequest;
export type AdminCollectionsControllerSearchTopHoldersMutationError = unknown;

/**
 * @summary Search top holders of specified collections
 */
export const useAdminCollectionsControllerSearchTopHolders = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>,
    TError,
    { data: SearchTopHoldersRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminCollectionsControllerSearchTopHolders>>,
  TError,
  { data: SearchTopHoldersRequest },
  TContext
> => {
  const mutationOptions = getAdminCollectionsControllerSearchTopHoldersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get overview of users with undelivered packs that have been paid via Telegram Stars
 */
export const adminReconciliationControllerGetCollectionStarsReconciliationOverview = (
  getReconciliationOverviewRequestDto: GetReconciliationOverviewRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<GetReconciliationOverviewResponseDto>({
    url: `/admin/reconciliation/collection-stars/overview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getReconciliationOverviewRequestDto,
    signal,
  });
};

export const getAdminReconciliationControllerGetCollectionStarsReconciliationOverviewMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>,
    TError,
    { data: GetReconciliationOverviewRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>,
  TError,
  { data: GetReconciliationOverviewRequestDto },
  TContext
> => {
  const mutationKey = ['adminReconciliationControllerGetCollectionStarsReconciliationOverview'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>,
    { data: GetReconciliationOverviewRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminReconciliationControllerGetCollectionStarsReconciliationOverview(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReconciliationControllerGetCollectionStarsReconciliationOverviewMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>
>;
export type AdminReconciliationControllerGetCollectionStarsReconciliationOverviewMutationBody =
  GetReconciliationOverviewRequestDto;
export type AdminReconciliationControllerGetCollectionStarsReconciliationOverviewMutationError = void;

/**
 * @summary Get overview of users with undelivered packs that have been paid via Telegram Stars
 */
export const useAdminReconciliationControllerGetCollectionStarsReconciliationOverview = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>,
    TError,
    { data: GetReconciliationOverviewRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReconciliationControllerGetCollectionStarsReconciliationOverview>>,
  TError,
  { data: GetReconciliationOverviewRequestDto },
  TContext
> => {
  const mutationOptions =
    getAdminReconciliationControllerGetCollectionStarsReconciliationOverviewMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Allows admins to manually assign packs to users for support/compensation purposes. Auto-generates packs if needed.
 * @summary Manually deliver packs to users (admin recovery tool)
 */
export const adminReconciliationControllerManuallyDeliverPacks = (
  manualDeliverPacksRequestDto: ManualDeliverPacksRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<UserDeliveryResultDto>({
    url: `/admin/reconciliation/deliver-packs-manual`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: manualDeliverPacksRequestDto,
    signal,
  });
};

export const getAdminReconciliationControllerManuallyDeliverPacksMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>,
    TError,
    { data: ManualDeliverPacksRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>,
  TError,
  { data: ManualDeliverPacksRequestDto },
  TContext
> => {
  const mutationKey = ['adminReconciliationControllerManuallyDeliverPacks'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>,
    { data: ManualDeliverPacksRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminReconciliationControllerManuallyDeliverPacks(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReconciliationControllerManuallyDeliverPacksMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>
>;
export type AdminReconciliationControllerManuallyDeliverPacksMutationBody = ManualDeliverPacksRequestDto;
export type AdminReconciliationControllerManuallyDeliverPacksMutationError = void;

/**
 * @summary Manually deliver packs to users (admin recovery tool)
 */
export const useAdminReconciliationControllerManuallyDeliverPacks = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>,
    TError,
    { data: ManualDeliverPacksRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReconciliationControllerManuallyDeliverPacks>>,
  TError,
  { data: ManualDeliverPacksRequestDto },
  TContext
> => {
  const mutationOptions = getAdminReconciliationControllerManuallyDeliverPacksMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get raw paginated Telegram Star transactions from Telegram API
 */
export const adminReconciliationControllerGetTelegramStarTransactions = (
  getTelegramStarTransactionsRequestDto: GetTelegramStarTransactionsRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<GetTelegramStarTransactionsResponseDto>({
    url: `/admin/reconciliation/telegram-star-transactions`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: getTelegramStarTransactionsRequestDto,
    signal,
  });
};

export const getAdminReconciliationControllerGetTelegramStarTransactionsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>,
    TError,
    { data: GetTelegramStarTransactionsRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>,
  TError,
  { data: GetTelegramStarTransactionsRequestDto },
  TContext
> => {
  const mutationKey = ['adminReconciliationControllerGetTelegramStarTransactions'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>,
    { data: GetTelegramStarTransactionsRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminReconciliationControllerGetTelegramStarTransactions(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminReconciliationControllerGetTelegramStarTransactionsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>
>;
export type AdminReconciliationControllerGetTelegramStarTransactionsMutationBody =
  GetTelegramStarTransactionsRequestDto;
export type AdminReconciliationControllerGetTelegramStarTransactionsMutationError = unknown;

/**
 * @summary Get raw paginated Telegram Star transactions from Telegram API
 */
export const useAdminReconciliationControllerGetTelegramStarTransactions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>,
    TError,
    { data: GetTelegramStarTransactionsRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminReconciliationControllerGetTelegramStarTransactions>>,
  TError,
  { data: GetTelegramStarTransactionsRequestDto },
  TContext
> => {
  const mutationOptions = getAdminReconciliationControllerGetTelegramStarTransactionsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Send a formatted broadcast message (optionally with an image) to all bot users. Supports multipart/form-data upload — in Swagger UI, attach file via image field and JSON payload via request field.
 */
export const adminBroadcastControllerBroadcastMessage = (
  broadcastMessageWithImageDto: BroadcastMessageWithImageDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (broadcastMessageWithImageDto.image !== undefined) {
    formData.append('image', broadcastMessageWithImageDto.image);
  }
  formData.append('request', JSON.stringify(broadcastMessageWithImageDto.request));

  return customInstance<BroadcastMessageResponseDto>({
    url: `/admin/broadcast`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminBroadcastControllerBroadcastMessageMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>,
    TError,
    { data: BroadcastMessageWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>,
  TError,
  { data: BroadcastMessageWithImageDto },
  TContext
> => {
  const mutationKey = ['adminBroadcastControllerBroadcastMessage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>,
    { data: BroadcastMessageWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminBroadcastControllerBroadcastMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBroadcastControllerBroadcastMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>
>;
export type AdminBroadcastControllerBroadcastMessageMutationBody = BroadcastMessageWithImageDto;
export type AdminBroadcastControllerBroadcastMessageMutationError = void;

/**
 * @summary Send a formatted broadcast message (optionally with an image) to all bot users. Supports multipart/form-data upload — in Swagger UI, attach file via image field and JSON payload via request field.
 */
export const useAdminBroadcastControllerBroadcastMessage = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>,
    TError,
    { data: BroadcastMessageWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminBroadcastControllerBroadcastMessage>>,
  TError,
  { data: BroadcastMessageWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminBroadcastControllerBroadcastMessageMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create stickers pack for authenticated user
 */
export const stickersControllerCreateStickersPack = (
  createStickersPackDto: CreateStickersPackDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/stickers/create-pack`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createStickersPackDto,
    signal,
  });
};

export const getStickersControllerCreateStickersPackMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>,
    TError,
    { data: CreateStickersPackDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>,
  TError,
  { data: CreateStickersPackDto },
  TContext
> => {
  const mutationKey = ['stickersControllerCreateStickersPack'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>,
    { data: CreateStickersPackDto }
  > = (props) => {
    const { data } = props ?? {};

    return stickersControllerCreateStickersPack(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type StickersControllerCreateStickersPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>
>;
export type StickersControllerCreateStickersPackMutationBody = CreateStickersPackDto;
export type StickersControllerCreateStickersPackMutationError = unknown;

/**
 * @summary Create stickers pack for authenticated user
 */
export const useStickersControllerCreateStickersPack = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>,
    TError,
    { data: CreateStickersPackDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof stickersControllerCreateStickersPack>>,
  TError,
  { data: CreateStickersPackDto },
  TContext
> => {
  const mutationOptions = getStickersControllerCreateStickersPackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Re-create stickers pack for authenticated user
 */
export const stickersControllerRecreateStickersPack = (
  createStickersPackDto: CreateStickersPackDto,
  signal?: AbortSignal,
) => {
  return customInstance<RecreateStickersPackResponseDto>({
    url: `/stickers/recreate-pack`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createStickersPackDto,
    signal,
  });
};

export const getStickersControllerRecreateStickersPackMutationOptions = <
  TError = void | RateLimitStickersResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>,
    TError,
    { data: CreateStickersPackDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>,
  TError,
  { data: CreateStickersPackDto },
  TContext
> => {
  const mutationKey = ['stickersControllerRecreateStickersPack'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>,
    { data: CreateStickersPackDto }
  > = (props) => {
    const { data } = props ?? {};

    return stickersControllerRecreateStickersPack(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type StickersControllerRecreateStickersPackMutationResult = NonNullable<
  Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>
>;
export type StickersControllerRecreateStickersPackMutationBody = CreateStickersPackDto;
export type StickersControllerRecreateStickersPackMutationError = void | RateLimitStickersResponseDto;

/**
 * @summary Re-create stickers pack for authenticated user
 */
export const useStickersControllerRecreateStickersPack = <
  TError = void | RateLimitStickersResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>,
    TError,
    { data: CreateStickersPackDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof stickersControllerRecreateStickersPack>>,
  TError,
  { data: CreateStickersPackDto },
  TContext
> => {
  const mutationOptions = getStickersControllerRecreateStickersPackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Upload single sticker to CDN (admin only)
 */
export const adminStickersControllerUploadSticker = (
  uploadStickerMultipartDto: UploadStickerMultipartDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append('name', uploadStickerMultipartDto.name);
  if (uploadStickerMultipartDto.emojis !== undefined) {
    uploadStickerMultipartDto.emojis.forEach((value) => formData.append('emojis', value));
  }
  formData.append('collectionId', uploadStickerMultipartDto.collectionId);
  formData.append('file', uploadStickerMultipartDto.file);

  return customInstance<UploadStickerResponseDto>({
    url: `/admin/stickers/upload`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminStickersControllerUploadStickerMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>,
    TError,
    { data: UploadStickerMultipartDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>,
  TError,
  { data: UploadStickerMultipartDto },
  TContext
> => {
  const mutationKey = ['adminStickersControllerUploadSticker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>,
    { data: UploadStickerMultipartDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminStickersControllerUploadSticker(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStickersControllerUploadStickerMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>
>;
export type AdminStickersControllerUploadStickerMutationBody = UploadStickerMultipartDto;
export type AdminStickersControllerUploadStickerMutationError = void;

/**
 * @summary Upload single sticker to CDN (admin only)
 */
export const useAdminStickersControllerUploadSticker = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>,
    TError,
    { data: UploadStickerMultipartDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminStickersControllerUploadSticker>>,
  TError,
  { data: UploadStickerMultipartDto },
  TContext
> => {
  const mutationOptions = getAdminStickersControllerUploadStickerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all stickers (admin only)
 */
export const adminStickersControllerGetAllStickers = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/stickers`, method: 'GET', signal });
};

export const getAdminStickersControllerGetAllStickersQueryKey = () => {
  return [`/admin/stickers`] as const;
};

export const getAdminStickersControllerGetAllStickersQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStickersControllerGetAllStickersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>> = ({ signal }) =>
    adminStickersControllerGetAllStickers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminStickersControllerGetAllStickersQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>
>;
export type AdminStickersControllerGetAllStickersQueryError = unknown;

export function useAdminStickersControllerGetAllStickers<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
        TError,
        Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminStickersControllerGetAllStickers<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
        TError,
        Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminStickersControllerGetAllStickers<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all stickers (admin only)
 */

export function useAdminStickersControllerGetAllStickers<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetAllStickers>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminStickersControllerGetAllStickersQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get sticker by ID (admin only)
 */
export const adminStickersControllerGetStickerById = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/stickers/${id}`, method: 'GET', signal });
};

export const getAdminStickersControllerGetStickerByIdQueryKey = (id: string) => {
  return [`/admin/stickers/${id}`] as const;
};

export const getAdminStickersControllerGetStickerByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStickersControllerGetStickerByIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>> = ({ signal }) =>
    adminStickersControllerGetStickerById(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminStickersControllerGetStickerByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>
>;
export type AdminStickersControllerGetStickerByIdQueryError = void;

export function useAdminStickersControllerGetStickerById<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
          TError,
          Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminStickersControllerGetStickerById<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
          TError,
          Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminStickersControllerGetStickerById<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get sticker by ID (admin only)
 */

export function useAdminStickersControllerGetStickerById<
  TData = Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminStickersControllerGetStickerById>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminStickersControllerGetStickerByIdQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete sticker by ID (admin only)
 */
export const adminStickersControllerDeleteSticker = (id: string) => {
  return customInstance<void>({ url: `/admin/stickers/${id}`, method: 'DELETE' });
};

export const getAdminStickersControllerDeleteStickerMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminStickersControllerDeleteSticker'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminStickersControllerDeleteSticker(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStickersControllerDeleteStickerMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>
>;

export type AdminStickersControllerDeleteStickerMutationError = void;

/**
 * @summary Delete sticker by ID (admin only)
 */
export const useAdminStickersControllerDeleteSticker = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminStickersControllerDeleteSticker>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminStickersControllerDeleteStickerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Stream real-time drop status updates via Server-Sent Events
 */
export const streamControllerStreamDropStatus = (dropId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/stream/drops/${dropId}/status`, method: 'GET', signal });
};

export const getStreamControllerStreamDropStatusQueryKey = (dropId: string) => {
  return [`/stream/drops/${dropId}/status`] as const;
};

export const getStreamControllerStreamDropStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamControllerStreamDropStatusQueryKey(dropId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>> = ({ signal }) =>
    streamControllerStreamDropStatus(dropId, signal);

  return { queryKey, queryFn, enabled: !!dropId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamControllerStreamDropStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamControllerStreamDropStatus>>
>;
export type StreamControllerStreamDropStatusQueryError = void;

export function useStreamControllerStreamDropStatus<
  TData = Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
  TError = void,
>(
  dropId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
          TError,
          Awaited<ReturnType<typeof streamControllerStreamDropStatus>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamControllerStreamDropStatus<
  TData = Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
          TError,
          Awaited<ReturnType<typeof streamControllerStreamDropStatus>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamControllerStreamDropStatus<
  TData = Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Stream real-time drop status updates via Server-Sent Events
 */

export function useStreamControllerStreamDropStatus<
  TData = Awaited<ReturnType<typeof streamControllerStreamDropStatus>>,
  TError = void,
>(
  dropId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamDropStatus>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamControllerStreamDropStatusQueryOptions(dropId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Stream real-time user events via Server-Sent Events
 */
export const streamControllerStreamUserEvents = (userId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/stream/users/${userId}/events`, method: 'GET', signal });
};

export const getStreamControllerStreamUserEventsQueryKey = (userId: string) => {
  return [`/stream/users/${userId}/events`] as const;
};

export const getStreamControllerStreamUserEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
  TError = void,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamControllerStreamUserEventsQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>> = ({ signal }) =>
    streamControllerStreamUserEvents(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type StreamControllerStreamUserEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof streamControllerStreamUserEvents>>
>;
export type StreamControllerStreamUserEventsQueryError = void;

export function useStreamControllerStreamUserEvents<
  TData = Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
  TError = void,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
          TError,
          Awaited<ReturnType<typeof streamControllerStreamUserEvents>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamControllerStreamUserEvents<
  TData = Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
  TError = void,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
          TError,
          Awaited<ReturnType<typeof streamControllerStreamUserEvents>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useStreamControllerStreamUserEvents<
  TData = Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
  TError = void,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Stream real-time user events via Server-Sent Events
 */

export function useStreamControllerStreamUserEvents<
  TData = Awaited<ReturnType<typeof streamControllerStreamUserEvents>>,
  TError = void,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamControllerStreamUserEvents>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getStreamControllerStreamUserEventsQueryOptions(userId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all brands
 */
export const brandControllerGetAllBrands = (params?: BrandControllerGetAllBrandsParams) => {
  return customInstance<BrandListResponseDto>({ url: `/brand/all`, method: 'GET', params });
};

export const getBrandControllerGetAllBrandsQueryKey = (params?: BrandControllerGetAllBrandsParams) => {
  return [`/brand/all`, ...(params ? [params] : [])] as const;
};

export const getBrandControllerGetAllBrandsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    BrandControllerGetAllBrandsParams['page']
  >,
  TError = unknown,
>(
  params?: BrandControllerGetAllBrandsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        TError,
        TData,
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        QueryKey,
        BrandControllerGetAllBrandsParams['page']
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBrandControllerGetAllBrandsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    QueryKey,
    BrandControllerGetAllBrandsParams['page']
  > = ({ pageParam }) => brandControllerGetAllBrands({ ...params, page: pageParam || params?.['page'] });

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    TError,
    TData,
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    QueryKey,
    BrandControllerGetAllBrandsParams['page']
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type BrandControllerGetAllBrandsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof brandControllerGetAllBrands>>
>;
export type BrandControllerGetAllBrandsInfiniteQueryError = unknown;

export function useBrandControllerGetAllBrandsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    BrandControllerGetAllBrandsParams['page']
  >,
  TError = unknown,
>(
  params: undefined | BrandControllerGetAllBrandsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        TError,
        TData,
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        QueryKey,
        BrandControllerGetAllBrandsParams['page']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
          TError,
          Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
          QueryKey
        >,
        'initialData'
      >;
  },
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBrandControllerGetAllBrandsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    BrandControllerGetAllBrandsParams['page']
  >,
  TError = unknown,
>(
  params?: BrandControllerGetAllBrandsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        TError,
        TData,
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        QueryKey,
        BrandControllerGetAllBrandsParams['page']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
          TError,
          Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
          QueryKey
        >,
        'initialData'
      >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useBrandControllerGetAllBrandsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    BrandControllerGetAllBrandsParams['page']
  >,
  TError = unknown,
>(
  params?: BrandControllerGetAllBrandsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        TError,
        TData,
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        QueryKey,
        BrandControllerGetAllBrandsParams['page']
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all brands
 */

export function useBrandControllerGetAllBrandsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
    BrandControllerGetAllBrandsParams['page']
  >,
  TError = unknown,
>(
  params?: BrandControllerGetAllBrandsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        TError,
        TData,
        Awaited<ReturnType<typeof brandControllerGetAllBrands>>,
        QueryKey,
        BrandControllerGetAllBrandsParams['page']
      >
    >;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getBrandControllerGetAllBrandsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new brand
 */
export const brandControllerCreateBrand = (createBrandWithImageDto: CreateBrandWithImageDto, signal?: AbortSignal) => {
  const formData = new FormData();
  formData.append('image', createBrandWithImageDto.image);
  if (createBrandWithImageDto.coverImage !== undefined) {
    formData.append('coverImage', createBrandWithImageDto.coverImage);
  }
  formData.append('request', JSON.stringify(createBrandWithImageDto.request));

  return customInstance<BrandDto>({
    url: `/brand/create`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getBrandControllerCreateBrandMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandControllerCreateBrand>>,
    TError,
    { data: CreateBrandWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandControllerCreateBrand>>,
  TError,
  { data: CreateBrandWithImageDto },
  TContext
> => {
  const mutationKey = ['brandControllerCreateBrand'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandControllerCreateBrand>>,
    { data: CreateBrandWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return brandControllerCreateBrand(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandControllerCreateBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandControllerCreateBrand>>
>;
export type BrandControllerCreateBrandMutationBody = CreateBrandWithImageDto;
export type BrandControllerCreateBrandMutationError = unknown;

/**
 * @summary Create a new brand
 */
export const useBrandControllerCreateBrand = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandControllerCreateBrand>>,
    TError,
    { data: CreateBrandWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof brandControllerCreateBrand>>,
  TError,
  { data: CreateBrandWithImageDto },
  TContext
> => {
  const mutationOptions = getBrandControllerCreateBrandMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update a brand
 */
export const brandControllerUpdateBrand = (id: string, updateBrandWithImageDto: UpdateBrandWithImageDto) => {
  const formData = new FormData();
  if (updateBrandWithImageDto.image !== undefined) {
    formData.append('image', updateBrandWithImageDto.image);
  }
  if (updateBrandWithImageDto.coverImage !== undefined) {
    formData.append('coverImage', updateBrandWithImageDto.coverImage);
  }
  formData.append('request', JSON.stringify(updateBrandWithImageDto.request));

  return customInstance<BrandDto>({
    url: `/brand/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getBrandControllerUpdateBrandMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandControllerUpdateBrand>>,
    TError,
    { id: string; data: UpdateBrandWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof brandControllerUpdateBrand>>,
  TError,
  { id: string; data: UpdateBrandWithImageDto },
  TContext
> => {
  const mutationKey = ['brandControllerUpdateBrand'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof brandControllerUpdateBrand>>,
    { id: string; data: UpdateBrandWithImageDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return brandControllerUpdateBrand(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BrandControllerUpdateBrandMutationResult = NonNullable<
  Awaited<ReturnType<typeof brandControllerUpdateBrand>>
>;
export type BrandControllerUpdateBrandMutationBody = UpdateBrandWithImageDto;
export type BrandControllerUpdateBrandMutationError = unknown;

/**
 * @summary Update a brand
 */
export const useBrandControllerUpdateBrand = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof brandControllerUpdateBrand>>,
    TError,
    { id: string; data: UpdateBrandWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof brandControllerUpdateBrand>>,
  TError,
  { id: string; data: UpdateBrandWithImageDto },
  TContext
> => {
  const mutationOptions = getBrandControllerUpdateBrandMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get Prometheus metrics
 */
export const metricsControllerIndex = (params?: MetricsControllerIndexParams, signal?: AbortSignal) => {
  return customInstance<string>({ url: `/metrics`, method: 'GET', params, signal });
};

export const getMetricsControllerIndexQueryKey = (params?: MetricsControllerIndexParams) => {
  return [`/metrics`, ...(params ? [params] : [])] as const;
};

export const getMetricsControllerIndexQueryOptions = <
  TData = Awaited<ReturnType<typeof metricsControllerIndex>>,
  TError = void,
>(
  params?: MetricsControllerIndexParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerIndex>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetricsControllerIndexQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsControllerIndex>>> = ({ signal }) =>
    metricsControllerIndex(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metricsControllerIndex>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MetricsControllerIndexQueryResult = NonNullable<Awaited<ReturnType<typeof metricsControllerIndex>>>;
export type MetricsControllerIndexQueryError = void;

export function useMetricsControllerIndex<TData = Awaited<ReturnType<typeof metricsControllerIndex>>, TError = void>(
  params: undefined | MetricsControllerIndexParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerIndex>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricsControllerIndex>>,
          TError,
          Awaited<ReturnType<typeof metricsControllerIndex>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMetricsControllerIndex<TData = Awaited<ReturnType<typeof metricsControllerIndex>>, TError = void>(
  params?: MetricsControllerIndexParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerIndex>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricsControllerIndex>>,
          TError,
          Awaited<ReturnType<typeof metricsControllerIndex>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMetricsControllerIndex<TData = Awaited<ReturnType<typeof metricsControllerIndex>>, TError = void>(
  params?: MetricsControllerIndexParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerIndex>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Prometheus metrics
 */

export function useMetricsControllerIndex<TData = Awaited<ReturnType<typeof metricsControllerIndex>>, TError = void>(
  params?: MetricsControllerIndexParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerIndex>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMetricsControllerIndexQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Database health check
 */
export const metricsControllerGetHealth = (params?: MetricsControllerGetHealthParams, signal?: AbortSignal) => {
  return customInstance<MetricsHealthDto>({ url: `/metrics/health`, method: 'GET', params, signal });
};

export const getMetricsControllerGetHealthQueryKey = (params?: MetricsControllerGetHealthParams) => {
  return [`/metrics/health`, ...(params ? [params] : [])] as const;
};

export const getMetricsControllerGetHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof metricsControllerGetHealth>>,
  TError = void | MetricsHealthDto,
>(
  params?: MetricsControllerGetHealthParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerGetHealth>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetricsControllerGetHealthQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof metricsControllerGetHealth>>> = ({ signal }) =>
    metricsControllerGetHealth(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof metricsControllerGetHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type MetricsControllerGetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof metricsControllerGetHealth>>>;
export type MetricsControllerGetHealthQueryError = void | MetricsHealthDto;

export function useMetricsControllerGetHealth<
  TData = Awaited<ReturnType<typeof metricsControllerGetHealth>>,
  TError = void | MetricsHealthDto,
>(
  params: undefined | MetricsControllerGetHealthParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerGetHealth>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricsControllerGetHealth>>,
          TError,
          Awaited<ReturnType<typeof metricsControllerGetHealth>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMetricsControllerGetHealth<
  TData = Awaited<ReturnType<typeof metricsControllerGetHealth>>,
  TError = void | MetricsHealthDto,
>(
  params?: MetricsControllerGetHealthParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerGetHealth>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricsControllerGetHealth>>,
          TError,
          Awaited<ReturnType<typeof metricsControllerGetHealth>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useMetricsControllerGetHealth<
  TData = Awaited<ReturnType<typeof metricsControllerGetHealth>>,
  TError = void | MetricsHealthDto,
>(
  params?: MetricsControllerGetHealthParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerGetHealth>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Database health check
 */

export function useMetricsControllerGetHealth<
  TData = Awaited<ReturnType<typeof metricsControllerGetHealth>>,
  TError = void | MetricsHealthDto,
>(
  params?: MetricsControllerGetHealthParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof metricsControllerGetHealth>>, TError, TData>> },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getMetricsControllerGetHealthQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT metadata
 */
export const nftMetadataControllerGetNftMetadata = (collectionId: string, nftId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/nft-metadata/${collectionId}/${nftId}`, method: 'GET', signal });
};

export const getNftMetadataControllerGetNftMetadataQueryKey = (collectionId: string, nftId: string) => {
  return [`/nft-metadata/${collectionId}/${nftId}`] as const;
};

export const getNftMetadataControllerGetNftMetadataQueryOptions = <
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNftMetadataControllerGetNftMetadataQueryKey(collectionId, nftId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>> = ({ signal }) =>
    nftMetadataControllerGetNftMetadata(collectionId, nftId, signal);

  return { queryKey, queryFn, enabled: !!(collectionId && nftId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type NftMetadataControllerGetNftMetadataQueryResult = NonNullable<
  Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>
>;
export type NftMetadataControllerGetNftMetadataQueryError = void;

export function useNftMetadataControllerGetNftMetadata<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
          TError,
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useNftMetadataControllerGetNftMetadata<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
          TError,
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useNftMetadataControllerGetNftMetadata<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT metadata
 */

export function useNftMetadataControllerGetNftMetadata<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadata>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getNftMetadataControllerGetNftMetadataQueryOptions(collectionId, nftId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get NFT metadata as JSON file
 */
export const nftMetadataControllerGetNftMetadataJson = (collectionId: string, nftId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/nft-metadata/${collectionId}/${nftId}.json`, method: 'GET', signal });
};

export const getNftMetadataControllerGetNftMetadataJsonQueryKey = (collectionId: string, nftId: string) => {
  return [`/nft-metadata/${collectionId}/${nftId}.json`] as const;
};

export const getNftMetadataControllerGetNftMetadataJsonQueryOptions = <
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNftMetadataControllerGetNftMetadataJsonQueryKey(collectionId, nftId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>> = ({ signal }) =>
    nftMetadataControllerGetNftMetadataJson(collectionId, nftId, signal);

  return { queryKey, queryFn, enabled: !!(collectionId && nftId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type NftMetadataControllerGetNftMetadataJsonQueryResult = NonNullable<
  Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>
>;
export type NftMetadataControllerGetNftMetadataJsonQueryError = void;

export function useNftMetadataControllerGetNftMetadataJson<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
          TError,
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useNftMetadataControllerGetNftMetadataJson<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
          TError,
          Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useNftMetadataControllerGetNftMetadataJson<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get NFT metadata as JSON file
 */

export function useNftMetadataControllerGetNftMetadataJson<
  TData = Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>,
  TError = void,
>(
  collectionId: string,
  nftId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof nftMetadataControllerGetNftMetadataJson>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getNftMetadataControllerGetNftMetadataJsonQueryOptions(collectionId, nftId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get OAuth client info for consent screen
 */
export const oauthControllerGetAuthorizeInfo = (
  params: OauthControllerGetAuthorizeInfoParams,
  signal?: AbortSignal,
) => {
  return customInstance<AuthorizeClientInfoResponseDto>({ url: `/oauth/authorize`, method: 'GET', params, signal });
};

export const getOauthControllerGetAuthorizeInfoQueryKey = (params: OauthControllerGetAuthorizeInfoParams) => {
  return [`/oauth/authorize`, ...(params ? [params] : [])] as const;
};

export const getOauthControllerGetAuthorizeInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
  TError = void,
>(
  params: OauthControllerGetAuthorizeInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOauthControllerGetAuthorizeInfoQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>> = ({ signal }) =>
    oauthControllerGetAuthorizeInfo(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type OauthControllerGetAuthorizeInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>
>;
export type OauthControllerGetAuthorizeInfoQueryError = void;

export function useOauthControllerGetAuthorizeInfo<
  TData = Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
  TError = void,
>(
  params: OauthControllerGetAuthorizeInfoParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
          TError,
          Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOauthControllerGetAuthorizeInfo<
  TData = Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
  TError = void,
>(
  params: OauthControllerGetAuthorizeInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
          TError,
          Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOauthControllerGetAuthorizeInfo<
  TData = Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
  TError = void,
>(
  params: OauthControllerGetAuthorizeInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get OAuth client info for consent screen
 */

export function useOauthControllerGetAuthorizeInfo<
  TData = Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>,
  TError = void,
>(
  params: OauthControllerGetAuthorizeInfoParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthControllerGetAuthorizeInfo>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getOauthControllerGetAuthorizeInfoQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Approve OAuth authorization and get authorization code
 */
export const oauthControllerAuthorize = (authorizeRequestDto: AuthorizeRequestDto, signal?: AbortSignal) => {
  return customInstance<AuthorizeCodeResponseDto>({
    url: `/oauth/authorize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: authorizeRequestDto,
    signal,
  });
};

export const getOauthControllerAuthorizeMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthControllerAuthorize>>,
    TError,
    { data: AuthorizeRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthControllerAuthorize>>,
  TError,
  { data: AuthorizeRequestDto },
  TContext
> => {
  const mutationKey = ['oauthControllerAuthorize'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oauthControllerAuthorize>>,
    { data: AuthorizeRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return oauthControllerAuthorize(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthControllerAuthorizeMutationResult = NonNullable<Awaited<ReturnType<typeof oauthControllerAuthorize>>>;
export type OauthControllerAuthorizeMutationBody = AuthorizeRequestDto;
export type OauthControllerAuthorizeMutationError = void;

/**
 * @summary Approve OAuth authorization and get authorization code
 */
export const useOauthControllerAuthorize = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthControllerAuthorize>>,
    TError,
    { data: AuthorizeRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthControllerAuthorize>>,
  TError,
  { data: AuthorizeRequestDto },
  TContext
> => {
  const mutationOptions = getOauthControllerAuthorizeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Exchange authorization code or refresh token for access token
 */
export const oauthControllerToken = (tokenRequestDto: TokenRequestDto, signal?: AbortSignal) => {
  return customInstance<TokenResponseDto>({
    url: `/oauth/token`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tokenRequestDto,
    signal,
  });
};

export const getOauthControllerTokenMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthControllerToken>>,
    TError,
    { data: TokenRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthControllerToken>>,
  TError,
  { data: TokenRequestDto },
  TContext
> => {
  const mutationKey = ['oauthControllerToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof oauthControllerToken>>, { data: TokenRequestDto }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return oauthControllerToken(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthControllerTokenMutationResult = NonNullable<Awaited<ReturnType<typeof oauthControllerToken>>>;
export type OauthControllerTokenMutationBody = TokenRequestDto;
export type OauthControllerTokenMutationError = void;

/**
 * @summary Exchange authorization code or refresh token for access token
 */
export const useOauthControllerToken = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthControllerToken>>,
    TError,
    { data: TokenRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthControllerToken>>,
  TError,
  { data: TokenRequestDto },
  TContext
> => {
  const mutationOptions = getOauthControllerTokenMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Create a new OAuth client
 */
export const oauthAdminControllerCreateClient = (createOauthClientDto: CreateOauthClientDto, signal?: AbortSignal) => {
  return customInstance<CreateOauthClientResponseDto>({
    url: `/oauth/admin/clients`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createOauthClientDto,
    signal,
  });
};

export const getOauthAdminControllerCreateClientMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>,
    TError,
    { data: CreateOauthClientDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>,
  TError,
  { data: CreateOauthClientDto },
  TContext
> => {
  const mutationKey = ['oauthAdminControllerCreateClient'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>,
    { data: CreateOauthClientDto }
  > = (props) => {
    const { data } = props ?? {};

    return oauthAdminControllerCreateClient(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthAdminControllerCreateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>
>;
export type OauthAdminControllerCreateClientMutationBody = CreateOauthClientDto;
export type OauthAdminControllerCreateClientMutationError = void;

/**
 * @summary Create a new OAuth client
 */
export const useOauthAdminControllerCreateClient = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>,
    TError,
    { data: CreateOauthClientDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthAdminControllerCreateClient>>,
  TError,
  { data: CreateOauthClientDto },
  TContext
> => {
  const mutationOptions = getOauthAdminControllerCreateClientMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all active OAuth clients
 */
export const oauthAdminControllerListClients = (signal?: AbortSignal) => {
  return customInstance<OauthClientListItemDto[]>({ url: `/oauth/admin/clients`, method: 'GET', signal });
};

export const getOauthAdminControllerListClientsQueryKey = () => {
  return [`/oauth/admin/clients`] as const;
};

export const getOauthAdminControllerListClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthAdminControllerListClients>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getOauthAdminControllerListClientsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof oauthAdminControllerListClients>>> = ({ signal }) =>
    oauthAdminControllerListClients(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type OauthAdminControllerListClientsQueryResult = NonNullable<
  Awaited<ReturnType<typeof oauthAdminControllerListClients>>
>;
export type OauthAdminControllerListClientsQueryError = unknown;

export function useOauthAdminControllerListClients<
  TData = Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthAdminControllerListClients>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
        TError,
        Awaited<ReturnType<typeof oauthAdminControllerListClients>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOauthAdminControllerListClients<
  TData = Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthAdminControllerListClients>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
        TError,
        Awaited<ReturnType<typeof oauthAdminControllerListClients>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useOauthAdminControllerListClients<
  TData = Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthAdminControllerListClients>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all active OAuth clients
 */

export function useOauthAdminControllerListClients<
  TData = Awaited<ReturnType<typeof oauthAdminControllerListClients>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof oauthAdminControllerListClients>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getOauthAdminControllerListClientsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Deactivate an OAuth client and revoke all its tokens
 */
export const oauthAdminControllerDeactivateClient = (id: string) => {
  return customInstance<void>({ url: `/oauth/admin/clients/${id}`, method: 'DELETE' });
};

export const getOauthAdminControllerDeactivateClientMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['oauthAdminControllerDeactivateClient'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return oauthAdminControllerDeactivateClient(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthAdminControllerDeactivateClientMutationResult = NonNullable<
  Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>
>;

export type OauthAdminControllerDeactivateClientMutationError = void;

/**
 * @summary Deactivate an OAuth client and revoke all its tokens
 */
export const useOauthAdminControllerDeactivateClient = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthAdminControllerDeactivateClient>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getOauthAdminControllerDeactivateClientMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Revoke all refresh tokens for an OAuth client
 */
export const oauthAdminControllerRevokeClientTokens = (id: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/oauth/admin/clients/${id}/revoke-tokens`, method: 'POST', signal });
};

export const getOauthAdminControllerRevokeClientTokensMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['oauthAdminControllerRevokeClientTokens'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return oauthAdminControllerRevokeClientTokens(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthAdminControllerRevokeClientTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>
>;

export type OauthAdminControllerRevokeClientTokensMutationError = unknown;

/**
 * @summary Revoke all refresh tokens for an OAuth client
 */
export const useOauthAdminControllerRevokeClientTokens = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeClientTokens>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getOauthAdminControllerRevokeClientTokensMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Revoke all OAuth refresh tokens for a user
 */
export const oauthAdminControllerRevokeUserTokens = (userId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/oauth/admin/users/${userId}/revoke-tokens`, method: 'POST', signal });
};

export const getOauthAdminControllerRevokeUserTokensMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['oauthAdminControllerRevokeUserTokens'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return oauthAdminControllerRevokeUserTokens(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type OauthAdminControllerRevokeUserTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>
>;

export type OauthAdminControllerRevokeUserTokensMutationError = unknown;

/**
 * @summary Revoke all OAuth refresh tokens for a user
 */
export const useOauthAdminControllerRevokeUserTokens = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof oauthAdminControllerRevokeUserTokens>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getOauthAdminControllerRevokeUserTokensMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List promo campaigns with filters, search, and pagination
 */
export const promoAdminCampaignControllerListCampaigns = (
  params?: PromoAdminCampaignControllerListCampaignsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PromoCampaignListItemDto[]>({ url: `/admin/promo-campaigns`, method: 'GET', params, signal });
};

export const getPromoAdminCampaignControllerListCampaignsQueryKey = (
  params?: PromoAdminCampaignControllerListCampaignsParams,
) => {
  return [`/admin/promo-campaigns`, ...(params ? [params] : [])] as const;
};

export const getPromoAdminCampaignControllerListCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
  TError = unknown,
>(
  params?: PromoAdminCampaignControllerListCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCampaignControllerListCampaignsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>> = ({ signal }) =>
    promoAdminCampaignControllerListCampaigns(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCampaignControllerListCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>
>;
export type PromoAdminCampaignControllerListCampaignsQueryError = unknown;

export function usePromoAdminCampaignControllerListCampaigns<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
  TError = unknown,
>(
  params: undefined | PromoAdminCampaignControllerListCampaignsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCampaignControllerListCampaigns<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
  TError = unknown,
>(
  params?: PromoAdminCampaignControllerListCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCampaignControllerListCampaigns<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
  TError = unknown,
>(
  params?: PromoAdminCampaignControllerListCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List promo campaigns with filters, search, and pagination
 */

export function usePromoAdminCampaignControllerListCampaigns<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>,
  TError = unknown,
>(
  params?: PromoAdminCampaignControllerListCampaignsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerListCampaigns>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCampaignControllerListCampaignsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new promo campaign
 */
export const promoAdminCampaignControllerCreateCampaign = (
  createPromoCampaignDto: CreatePromoCampaignDto,
  signal?: AbortSignal,
) => {
  return customInstance<PromoCampaignResponseDto>({
    url: `/admin/promo-campaigns`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createPromoCampaignDto,
    signal,
  });
};

export const getPromoAdminCampaignControllerCreateCampaignMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>,
    TError,
    { data: CreatePromoCampaignDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>,
  TError,
  { data: CreatePromoCampaignDto },
  TContext
> => {
  const mutationKey = ['promoAdminCampaignControllerCreateCampaign'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>,
    { data: CreatePromoCampaignDto }
  > = (props) => {
    const { data } = props ?? {};

    return promoAdminCampaignControllerCreateCampaign(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCampaignControllerCreateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>
>;
export type PromoAdminCampaignControllerCreateCampaignMutationBody = CreatePromoCampaignDto;
export type PromoAdminCampaignControllerCreateCampaignMutationError = void;

/**
 * @summary Create a new promo campaign
 */
export const usePromoAdminCampaignControllerCreateCampaign = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>,
    TError,
    { data: CreatePromoCampaignDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCampaignControllerCreateCampaign>>,
  TError,
  { data: CreatePromoCampaignDto },
  TContext
> => {
  const mutationOptions = getPromoAdminCampaignControllerCreateCampaignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get promo campaign detail with stats
 */
export const promoAdminCampaignControllerGetCampaignDetail = (id: string, signal?: AbortSignal) => {
  return customInstance<PromoCampaignDetailResponseDto>({ url: `/admin/promo-campaigns/${id}`, method: 'GET', signal });
};

export const getPromoAdminCampaignControllerGetCampaignDetailQueryKey = (id: string) => {
  return [`/admin/promo-campaigns/${id}`] as const;
};

export const getPromoAdminCampaignControllerGetCampaignDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCampaignControllerGetCampaignDetailQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>> = ({
    signal,
  }) => promoAdminCampaignControllerGetCampaignDetail(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCampaignControllerGetCampaignDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>
>;
export type PromoAdminCampaignControllerGetCampaignDetailQueryError = void;

export function usePromoAdminCampaignControllerGetCampaignDetail<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCampaignControllerGetCampaignDetail<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCampaignControllerGetCampaignDetail<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get promo campaign detail with stats
 */

export function usePromoAdminCampaignControllerGetCampaignDetail<
  TData = Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCampaignControllerGetCampaignDetail>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCampaignControllerGetCampaignDetailQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update promo campaign (immutable fields cannot be changed)
 */
export const promoAdminCampaignControllerUpdateCampaign = (
  id: string,
  updatePromoCampaignDto: UpdatePromoCampaignDto,
) => {
  return customInstance<PromoCampaignResponseDto>({
    url: `/admin/promo-campaigns/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updatePromoCampaignDto,
  });
};

export const getPromoAdminCampaignControllerUpdateCampaignMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>,
    TError,
    { id: string; data: UpdatePromoCampaignDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>,
  TError,
  { id: string; data: UpdatePromoCampaignDto },
  TContext
> => {
  const mutationKey = ['promoAdminCampaignControllerUpdateCampaign'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>,
    { id: string; data: UpdatePromoCampaignDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return promoAdminCampaignControllerUpdateCampaign(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCampaignControllerUpdateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>
>;
export type PromoAdminCampaignControllerUpdateCampaignMutationBody = UpdatePromoCampaignDto;
export type PromoAdminCampaignControllerUpdateCampaignMutationError = void;

/**
 * @summary Update promo campaign (immutable fields cannot be changed)
 */
export const usePromoAdminCampaignControllerUpdateCampaign = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>,
    TError,
    { id: string; data: UpdatePromoCampaignDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCampaignControllerUpdateCampaign>>,
  TError,
  { id: string; data: UpdatePromoCampaignDto },
  TContext
> => {
  const mutationOptions = getPromoAdminCampaignControllerUpdateCampaignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Soft delete promo campaign (sets status to ended)
 */
export const promoAdminCampaignControllerDeleteCampaign = (id: string) => {
  return customInstance<PromoCampaignResponseDto>({ url: `/admin/promo-campaigns/${id}`, method: 'DELETE' });
};

export const getPromoAdminCampaignControllerDeleteCampaignMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['promoAdminCampaignControllerDeleteCampaign'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return promoAdminCampaignControllerDeleteCampaign(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCampaignControllerDeleteCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>
>;

export type PromoAdminCampaignControllerDeleteCampaignMutationError = void;

/**
 * @summary Soft delete promo campaign (sets status to ended)
 */
export const usePromoAdminCampaignControllerDeleteCampaign = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCampaignControllerDeleteCampaign>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPromoAdminCampaignControllerDeleteCampaignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List promo codes for a campaign with filters and pagination
 */
export const promoAdminCodeControllerListCodes = (
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PromoCodeResponseDto[]>({
    url: `/admin/promo-campaigns/${id}/codes`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPromoAdminCodeControllerListCodesQueryKey = (
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
) => {
  return [`/admin/promo-campaigns/${id}/codes`, ...(params ? [params] : [])] as const;
};

export const getPromoAdminCodeControllerListCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCodeControllerListCodesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>> = ({ signal }) =>
    promoAdminCodeControllerListCodes(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCodeControllerListCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>
>;
export type PromoAdminCodeControllerListCodesQueryError = void;

export function usePromoAdminCodeControllerListCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
  TError = void,
>(
  id: string,
  params: undefined | PromoAdminCodeControllerListCodesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List promo codes for a campaign with filters and pagination
 */

export function usePromoAdminCodeControllerListCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCodeControllerListCodesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List only valid promo codes for a campaign (for partner distribution)
 */
export const promoAdminCodeControllerListValidCodes = (
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PromoCodeResponseDto[]>({
    url: `/admin/promo-campaigns/${id}/codes/valid`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPromoAdminCodeControllerListValidCodesQueryKey = (
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
) => {
  return [`/admin/promo-campaigns/${id}/codes/valid`, ...(params ? [params] : [])] as const;
};

export const getPromoAdminCodeControllerListValidCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCodeControllerListValidCodesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>> = ({ signal }) =>
    promoAdminCodeControllerListValidCodes(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCodeControllerListValidCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>
>;
export type PromoAdminCodeControllerListValidCodesQueryError = void;

export function usePromoAdminCodeControllerListValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
  TError = void,
>(
  id: string,
  params: undefined | PromoAdminCodeControllerListValidCodesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List only valid promo codes for a campaign (for partner distribution)
 */

export function usePromoAdminCodeControllerListValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListValidCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListValidCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCodeControllerListValidCodesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List used promo codes with user info, sorted by usedAt DESC
 */
export const promoAdminCodeControllerListUsedCodes = (
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
  signal?: AbortSignal,
) => {
  return customInstance<PromoCodeUsedResponseDto[]>({
    url: `/admin/promo-campaigns/${id}/codes/used`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPromoAdminCodeControllerListUsedCodesQueryKey = (
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
) => {
  return [`/admin/promo-campaigns/${id}/codes/used`, ...(params ? [params] : [])] as const;
};

export const getPromoAdminCodeControllerListUsedCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCodeControllerListUsedCodesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>> = ({ signal }) =>
    promoAdminCodeControllerListUsedCodes(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCodeControllerListUsedCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>
>;
export type PromoAdminCodeControllerListUsedCodesQueryError = void;

export function usePromoAdminCodeControllerListUsedCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
  TError = void,
>(
  id: string,
  params: undefined | PromoAdminCodeControllerListUsedCodesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListUsedCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerListUsedCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List used promo codes with user info, sorted by usedAt DESC
 */

export function usePromoAdminCodeControllerListUsedCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminCodeControllerListUsedCodesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerListUsedCodes>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCodeControllerListUsedCodesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Export all valid codes as plain JSON array (rate limited: 1 req/10s)
 */
export const promoAdminCodeControllerExportValidCodes = (id: string, signal?: AbortSignal) => {
  return customInstance<PromoCodeExportItemDto[]>({
    url: `/admin/promo-campaigns/${id}/codes/export`,
    method: 'GET',
    signal,
  });
};

export const getPromoAdminCodeControllerExportValidCodesQueryKey = (id: string) => {
  return [`/admin/promo-campaigns/${id}/codes/export`] as const;
};

export const getPromoAdminCodeControllerExportValidCodesQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminCodeControllerExportValidCodesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>> = ({ signal }) =>
    promoAdminCodeControllerExportValidCodes(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminCodeControllerExportValidCodesQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>
>;
export type PromoAdminCodeControllerExportValidCodesQueryError = void;

export function usePromoAdminCodeControllerExportValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerExportValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
          TError,
          Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminCodeControllerExportValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Export all valid codes as plain JSON array (rate limited: 1 req/10s)
 */

export function usePromoAdminCodeControllerExportValidCodes<
  TData = Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminCodeControllerExportValidCodes>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminCodeControllerExportValidCodesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Invalidate a single promo code (only if currently valid)
 */
export const promoAdminCodeControllerInvalidateCode = (id: string, codeId: string) => {
  return customInstance<InvalidateCodeResponseDto>({
    url: `/admin/promo-campaigns/${id}/codes/${codeId}/invalidate`,
    method: 'PATCH',
  });
};

export const getPromoAdminCodeControllerInvalidateCodeMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>,
    TError,
    { id: string; codeId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>,
  TError,
  { id: string; codeId: string },
  TContext
> => {
  const mutationKey = ['promoAdminCodeControllerInvalidateCode'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>,
    { id: string; codeId: string }
  > = (props) => {
    const { id, codeId } = props ?? {};

    return promoAdminCodeControllerInvalidateCode(id, codeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCodeControllerInvalidateCodeMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>
>;

export type PromoAdminCodeControllerInvalidateCodeMutationError = void;

/**
 * @summary Invalidate a single promo code (only if currently valid)
 */
export const usePromoAdminCodeControllerInvalidateCode = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>,
    TError,
    { id: string; codeId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateCode>>,
  TError,
  { id: string; codeId: string },
  TContext
> => {
  const mutationOptions = getPromoAdminCodeControllerInvalidateCodeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Bulk invalidate all valid codes in a campaign (emergency use)
 */
export const promoAdminCodeControllerInvalidateAllCodes = (
  id: string,
  bulkInvalidateBodyDto: BulkInvalidateBodyDto,
  signal?: AbortSignal,
) => {
  return customInstance<BulkInvalidateResponseDto>({
    url: `/admin/promo-campaigns/${id}/codes/invalidate-all`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkInvalidateBodyDto,
    signal,
  });
};

export const getPromoAdminCodeControllerInvalidateAllCodesMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>,
    TError,
    { id: string; data: BulkInvalidateBodyDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>,
  TError,
  { id: string; data: BulkInvalidateBodyDto },
  TContext
> => {
  const mutationKey = ['promoAdminCodeControllerInvalidateAllCodes'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>,
    { id: string; data: BulkInvalidateBodyDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return promoAdminCodeControllerInvalidateAllCodes(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCodeControllerInvalidateAllCodesMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>
>;
export type PromoAdminCodeControllerInvalidateAllCodesMutationBody = BulkInvalidateBodyDto;
export type PromoAdminCodeControllerInvalidateAllCodesMutationError = void;

/**
 * @summary Bulk invalidate all valid codes in a campaign (emergency use)
 */
export const usePromoAdminCodeControllerInvalidateAllCodes = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>,
    TError,
    { id: string; data: BulkInvalidateBodyDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCodeControllerInvalidateAllCodes>>,
  TError,
  { id: string; data: BulkInvalidateBodyDto },
  TContext
> => {
  const mutationOptions = getPromoAdminCodeControllerInvalidateAllCodesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Generate a batch of unique promo codes for a campaign
 */
export const promoAdminCodeControllerGenerateCodes = (
  id: string,
  generatePromoCodesDto: GeneratePromoCodesDto,
  signal?: AbortSignal,
) => {
  return customInstance<GeneratePromoCodesResponseDto>({
    url: `/admin/promo-campaigns/${id}/generate-codes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: generatePromoCodesDto,
    signal,
  });
};

export const getPromoAdminCodeControllerGenerateCodesMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>,
    TError,
    { id: string; data: GeneratePromoCodesDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>,
  TError,
  { id: string; data: GeneratePromoCodesDto },
  TContext
> => {
  const mutationKey = ['promoAdminCodeControllerGenerateCodes'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>,
    { id: string; data: GeneratePromoCodesDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return promoAdminCodeControllerGenerateCodes(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoAdminCodeControllerGenerateCodesMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>
>;
export type PromoAdminCodeControllerGenerateCodesMutationBody = GeneratePromoCodesDto;
export type PromoAdminCodeControllerGenerateCodesMutationError = void;

/**
 * @summary Generate a batch of unique promo codes for a campaign
 */
export const usePromoAdminCodeControllerGenerateCodes = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>,
    TError,
    { id: string; data: GeneratePromoCodesDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoAdminCodeControllerGenerateCodes>>,
  TError,
  { id: string; data: GeneratePromoCodesDto },
  TContext
> => {
  const mutationOptions = getPromoAdminCodeControllerGenerateCodesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List all users who claimed from a campaign with full context
 */
export const promoAdminParticipantControllerListParticipants = (
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
  signal?: AbortSignal,
) => {
  return customInstance<PromoParticipantResponseDto[]>({
    url: `/admin/promo-campaigns/${id}/participants`,
    method: 'GET',
    params,
    signal,
  });
};

export const getPromoAdminParticipantControllerListParticipantsQueryKey = (
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
) => {
  return [`/admin/promo-campaigns/${id}/participants`, ...(params ? [params] : [])] as const;
};

export const getPromoAdminParticipantControllerListParticipantsQueryOptions = <
  TData = Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPromoAdminParticipantControllerListParticipantsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>> = ({
    signal,
  }) => promoAdminParticipantControllerListParticipants(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type PromoAdminParticipantControllerListParticipantsQueryResult = NonNullable<
  Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>
>;
export type PromoAdminParticipantControllerListParticipantsQueryError = void;

export function usePromoAdminParticipantControllerListParticipants<
  TData = Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
  TError = void,
>(
  id: string,
  params: undefined | PromoAdminParticipantControllerListParticipantsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
          TError,
          Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminParticipantControllerListParticipants<
  TData = Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
          TError,
          Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePromoAdminParticipantControllerListParticipants<
  TData = Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List all users who claimed from a campaign with full context
 */

export function usePromoAdminParticipantControllerListParticipants<
  TData = Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>,
  TError = void,
>(
  id: string,
  params?: PromoAdminParticipantControllerListParticipantsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof promoAdminParticipantControllerListParticipants>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getPromoAdminParticipantControllerListParticipantsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Claim packs using a promo code
 */
export const promoUserControllerClaim = (claimPromoCodeDto: ClaimPromoCodeDto, signal?: AbortSignal) => {
  return customInstance<ClaimPromoCodeSuccessResponseDto>({
    url: `/promo/claim`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: claimPromoCodeDto,
    signal,
  });
};

export const getPromoUserControllerClaimMutationOptions = <
  TError = void | ClaimPromoCodeErrorResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoUserControllerClaim>>,
    TError,
    { data: ClaimPromoCodeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoUserControllerClaim>>,
  TError,
  { data: ClaimPromoCodeDto },
  TContext
> => {
  const mutationKey = ['promoUserControllerClaim'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoUserControllerClaim>>,
    { data: ClaimPromoCodeDto }
  > = (props) => {
    const { data } = props ?? {};

    return promoUserControllerClaim(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoUserControllerClaimMutationResult = NonNullable<Awaited<ReturnType<typeof promoUserControllerClaim>>>;
export type PromoUserControllerClaimMutationBody = ClaimPromoCodeDto;
export type PromoUserControllerClaimMutationError = void | ClaimPromoCodeErrorResponseDto;

/**
 * @summary Claim packs using a promo code
 */
export const usePromoUserControllerClaim = <
  TError = void | ClaimPromoCodeErrorResponseDto,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoUserControllerClaim>>,
    TError,
    { data: ClaimPromoCodeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoUserControllerClaim>>,
  TError,
  { data: ClaimPromoCodeDto },
  TContext
> => {
  const mutationOptions = getPromoUserControllerClaimMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all external collections
 */
export const adminWorkshopControllerGetExternalCollections = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/external-collections`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetExternalCollectionsQueryKey = () => {
  return [`/admin/workshop/external-collections`] as const;
};

export const getAdminWorkshopControllerGetExternalCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetExternalCollectionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>> = ({
    signal,
  }) => adminWorkshopControllerGetExternalCollections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetExternalCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>
>;
export type AdminWorkshopControllerGetExternalCollectionsQueryError = unknown;

export function useAdminWorkshopControllerGetExternalCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetExternalCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetExternalCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all external collections
 */

export function useAdminWorkshopControllerGetExternalCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetExternalCollections>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetExternalCollectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create external collection
 */
export const adminWorkshopControllerCreateExternalCollection = (
  createExternalCollectionDto: CreateExternalCollectionDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/external-collections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createExternalCollectionDto,
    signal,
  });
};

export const getAdminWorkshopControllerCreateExternalCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>,
    TError,
    { data: CreateExternalCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>,
  TError,
  { data: CreateExternalCollectionDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateExternalCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>,
    { data: CreateExternalCollectionDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateExternalCollection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateExternalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>
>;
export type AdminWorkshopControllerCreateExternalCollectionMutationBody = CreateExternalCollectionDto;
export type AdminWorkshopControllerCreateExternalCollectionMutationError = unknown;

/**
 * @summary Create external collection
 */
export const useAdminWorkshopControllerCreateExternalCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>,
    TError,
    { data: CreateExternalCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateExternalCollection>>,
  TError,
  { data: CreateExternalCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateExternalCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update external collection
 */
export const adminWorkshopControllerUpdateExternalCollection = (
  id: string,
  updateExternalCollectionDto: UpdateExternalCollectionDto,
) => {
  return customInstance<void>({
    url: `/admin/workshop/external-collections/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateExternalCollectionDto,
  });
};

export const getAdminWorkshopControllerUpdateExternalCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>,
    TError,
    { id: string; data: UpdateExternalCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>,
  TError,
  { id: string; data: UpdateExternalCollectionDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateExternalCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>,
    { id: string; data: UpdateExternalCollectionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateExternalCollection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateExternalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>
>;
export type AdminWorkshopControllerUpdateExternalCollectionMutationBody = UpdateExternalCollectionDto;
export type AdminWorkshopControllerUpdateExternalCollectionMutationError = unknown;

/**
 * @summary Update external collection
 */
export const useAdminWorkshopControllerUpdateExternalCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>,
    TError,
    { id: string; data: UpdateExternalCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateExternalCollection>>,
  TError,
  { id: string; data: UpdateExternalCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateExternalCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete external collection
 */
export const adminWorkshopControllerDeleteExternalCollection = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/external-collections/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteExternalCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteExternalCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteExternalCollection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteExternalCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>
>;

export type AdminWorkshopControllerDeleteExternalCollectionMutationError = unknown;

/**
 * @summary Delete external collection
 */
export const useAdminWorkshopControllerDeleteExternalCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteExternalCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteExternalCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all workshop events
 */
export const adminWorkshopControllerGetWorkshopEvents = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/events`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetWorkshopEventsQueryKey = () => {
  return [`/admin/workshop/events`] as const;
};

export const getAdminWorkshopControllerGetWorkshopEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetWorkshopEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>> = ({ signal }) =>
    adminWorkshopControllerGetWorkshopEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetWorkshopEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>
>;
export type AdminWorkshopControllerGetWorkshopEventsQueryError = unknown;

export function useAdminWorkshopControllerGetWorkshopEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetWorkshopEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetWorkshopEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all workshop events
 */

export function useAdminWorkshopControllerGetWorkshopEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetWorkshopEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create workshop event
 */
export const adminWorkshopControllerCreateWorkshopEvent = (
  createWorkshopEventWithImageDto: CreateWorkshopEventWithImageDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  if (createWorkshopEventWithImageDto.image !== undefined) {
    formData.append('image', createWorkshopEventWithImageDto.image);
  }
  formData.append('request', JSON.stringify(createWorkshopEventWithImageDto.request));

  return customInstance<void>({
    url: `/admin/workshop/events`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminWorkshopControllerCreateWorkshopEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>,
    TError,
    { data: CreateWorkshopEventWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>,
  TError,
  { data: CreateWorkshopEventWithImageDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateWorkshopEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>,
    { data: CreateWorkshopEventWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateWorkshopEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateWorkshopEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>
>;
export type AdminWorkshopControllerCreateWorkshopEventMutationBody = CreateWorkshopEventWithImageDto;
export type AdminWorkshopControllerCreateWorkshopEventMutationError = unknown;

/**
 * @summary Create workshop event
 */
export const useAdminWorkshopControllerCreateWorkshopEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>,
    TError,
    { data: CreateWorkshopEventWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEvent>>,
  TError,
  { data: CreateWorkshopEventWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateWorkshopEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update workshop event
 */
export const adminWorkshopControllerUpdateWorkshopEvent = (
  id: string,
  updateWorkshopEventWithImageDto: UpdateWorkshopEventWithImageDto,
) => {
  const formData = new FormData();
  if (updateWorkshopEventWithImageDto.image !== undefined) {
    formData.append('image', updateWorkshopEventWithImageDto.image);
  }
  formData.append('request', JSON.stringify(updateWorkshopEventWithImageDto.request));

  return customInstance<void>({
    url: `/admin/workshop/events/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getAdminWorkshopControllerUpdateWorkshopEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>,
    TError,
    { id: string; data: UpdateWorkshopEventWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>,
  TError,
  { id: string; data: UpdateWorkshopEventWithImageDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateWorkshopEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>,
    { id: string; data: UpdateWorkshopEventWithImageDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateWorkshopEvent(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateWorkshopEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>
>;
export type AdminWorkshopControllerUpdateWorkshopEventMutationBody = UpdateWorkshopEventWithImageDto;
export type AdminWorkshopControllerUpdateWorkshopEventMutationError = unknown;

/**
 * @summary Update workshop event
 */
export const useAdminWorkshopControllerUpdateWorkshopEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>,
    TError,
    { id: string; data: UpdateWorkshopEventWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEvent>>,
  TError,
  { id: string; data: UpdateWorkshopEventWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateWorkshopEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete workshop event
 */
export const adminWorkshopControllerDeleteWorkshopEvent = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/events/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteWorkshopEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteWorkshopEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteWorkshopEvent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteWorkshopEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>
>;

export type AdminWorkshopControllerDeleteWorkshopEventMutationError = unknown;

/**
 * @summary Delete workshop event
 */
export const useAdminWorkshopControllerDeleteWorkshopEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEvent>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteWorkshopEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get activities for event
 */
export const adminWorkshopControllerGetEventActivities = (eventId: string, signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/events/${eventId}/activities`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetEventActivitiesQueryKey = (eventId: string) => {
  return [`/admin/workshop/events/${eventId}/activities`] as const;
};

export const getAdminWorkshopControllerGetEventActivitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetEventActivitiesQueryKey(eventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>> = ({ signal }) =>
    adminWorkshopControllerGetEventActivities(eventId, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetEventActivitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>
>;
export type AdminWorkshopControllerGetEventActivitiesQueryError = unknown;

export function useAdminWorkshopControllerGetEventActivities<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
  TError = unknown,
>(
  eventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
          TError,
          Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetEventActivities<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
          TError,
          Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetEventActivities<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get activities for event
 */

export function useAdminWorkshopControllerGetEventActivities<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetEventActivities>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetEventActivitiesQueryOptions(eventId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create workshop event activity
 */
export const adminWorkshopControllerCreateWorkshopEventActivity = (
  createWorkshopEventActivityDto: CreateWorkshopEventActivityDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/activities`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createWorkshopEventActivityDto,
    signal,
  });
};

export const getAdminWorkshopControllerCreateWorkshopEventActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>,
    TError,
    { data: CreateWorkshopEventActivityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>,
  TError,
  { data: CreateWorkshopEventActivityDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateWorkshopEventActivity'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>,
    { data: CreateWorkshopEventActivityDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateWorkshopEventActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateWorkshopEventActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>
>;
export type AdminWorkshopControllerCreateWorkshopEventActivityMutationBody = CreateWorkshopEventActivityDto;
export type AdminWorkshopControllerCreateWorkshopEventActivityMutationError = unknown;

/**
 * @summary Create workshop event activity
 */
export const useAdminWorkshopControllerCreateWorkshopEventActivity = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>,
    TError,
    { data: CreateWorkshopEventActivityDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopEventActivity>>,
  TError,
  { data: CreateWorkshopEventActivityDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateWorkshopEventActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update workshop event activity
 */
export const adminWorkshopControllerUpdateWorkshopEventActivity = (
  id: string,
  updateWorkshopEventActivityDto: UpdateWorkshopEventActivityDto,
) => {
  return customInstance<void>({
    url: `/admin/workshop/activities/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateWorkshopEventActivityDto,
  });
};

export const getAdminWorkshopControllerUpdateWorkshopEventActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>,
    TError,
    { id: string; data: UpdateWorkshopEventActivityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>,
  TError,
  { id: string; data: UpdateWorkshopEventActivityDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateWorkshopEventActivity'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>,
    { id: string; data: UpdateWorkshopEventActivityDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateWorkshopEventActivity(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateWorkshopEventActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>
>;
export type AdminWorkshopControllerUpdateWorkshopEventActivityMutationBody = UpdateWorkshopEventActivityDto;
export type AdminWorkshopControllerUpdateWorkshopEventActivityMutationError = unknown;

/**
 * @summary Update workshop event activity
 */
export const useAdminWorkshopControllerUpdateWorkshopEventActivity = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>,
    TError,
    { id: string; data: UpdateWorkshopEventActivityDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopEventActivity>>,
  TError,
  { id: string; data: UpdateWorkshopEventActivityDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateWorkshopEventActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete workshop event activity
 */
export const adminWorkshopControllerDeleteWorkshopEventActivity = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/activities/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteWorkshopEventActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteWorkshopEventActivity'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteWorkshopEventActivity(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteWorkshopEventActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>
>;

export type AdminWorkshopControllerDeleteWorkshopEventActivityMutationError = unknown;

/**
 * @summary Delete workshop event activity
 */
export const useAdminWorkshopControllerDeleteWorkshopEventActivity = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopEventActivity>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteWorkshopEventActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add asset to activity
 */
export const adminWorkshopControllerAddActivityAsset = (
  activityId: string,
  addActivityAssetDto: AddActivityAssetDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/activities/${activityId}/assets`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addActivityAssetDto,
    signal,
  });
};

export const getAdminWorkshopControllerAddActivityAssetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>,
    TError,
    { activityId: string; data: AddActivityAssetDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>,
  TError,
  { activityId: string; data: AddActivityAssetDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerAddActivityAsset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>,
    { activityId: string; data: AddActivityAssetDto }
  > = (props) => {
    const { activityId, data } = props ?? {};

    return adminWorkshopControllerAddActivityAsset(activityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerAddActivityAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>
>;
export type AdminWorkshopControllerAddActivityAssetMutationBody = AddActivityAssetDto;
export type AdminWorkshopControllerAddActivityAssetMutationError = unknown;

/**
 * @summary Add asset to activity
 */
export const useAdminWorkshopControllerAddActivityAsset = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>,
    TError,
    { activityId: string; data: AddActivityAssetDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityAsset>>,
  TError,
  { activityId: string; data: AddActivityAssetDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerAddActivityAssetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Remove asset from activity
 */
export const adminWorkshopControllerRemoveActivityAsset = (activityId: string, assetId: string) => {
  return customInstance<void>({ url: `/admin/workshop/activities/${activityId}/assets/${assetId}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerRemoveActivityAssetMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>,
    TError,
    { activityId: string; assetId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>,
  TError,
  { activityId: string; assetId: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerRemoveActivityAsset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>,
    { activityId: string; assetId: string }
  > = (props) => {
    const { activityId, assetId } = props ?? {};

    return adminWorkshopControllerRemoveActivityAsset(activityId, assetId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerRemoveActivityAssetMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>
>;

export type AdminWorkshopControllerRemoveActivityAssetMutationError = unknown;

/**
 * @summary Remove asset from activity
 */
export const useAdminWorkshopControllerRemoveActivityAsset = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>,
    TError,
    { activityId: string; assetId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityAsset>>,
  TError,
  { activityId: string; assetId: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerRemoveActivityAssetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Add bonus collection to activity
 */
export const adminWorkshopControllerAddActivityBonusCollection = (
  activityId: string,
  addActivityBonusCollectionDto: AddActivityBonusCollectionDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/activities/${activityId}/bonus-collections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addActivityBonusCollectionDto,
    signal,
  });
};

export const getAdminWorkshopControllerAddActivityBonusCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>,
    TError,
    { activityId: string; data: AddActivityBonusCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>,
  TError,
  { activityId: string; data: AddActivityBonusCollectionDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerAddActivityBonusCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>,
    { activityId: string; data: AddActivityBonusCollectionDto }
  > = (props) => {
    const { activityId, data } = props ?? {};

    return adminWorkshopControllerAddActivityBonusCollection(activityId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerAddActivityBonusCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>
>;
export type AdminWorkshopControllerAddActivityBonusCollectionMutationBody = AddActivityBonusCollectionDto;
export type AdminWorkshopControllerAddActivityBonusCollectionMutationError = unknown;

/**
 * @summary Add bonus collection to activity
 */
export const useAdminWorkshopControllerAddActivityBonusCollection = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>,
    TError,
    { activityId: string; data: AddActivityBonusCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerAddActivityBonusCollection>>,
  TError,
  { activityId: string; data: AddActivityBonusCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerAddActivityBonusCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Remove bonus collection from activity
 */
export const adminWorkshopControllerRemoveActivityBonusCollection = (
  activityId: string,
  bonusCollectionLinkId: string,
) => {
  return customInstance<void>({
    url: `/admin/workshop/activities/${activityId}/bonus-collections/${bonusCollectionLinkId}`,
    method: 'DELETE',
  });
};

export const getAdminWorkshopControllerRemoveActivityBonusCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>,
    TError,
    { activityId: string; bonusCollectionLinkId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>,
  TError,
  { activityId: string; bonusCollectionLinkId: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerRemoveActivityBonusCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>,
    { activityId: string; bonusCollectionLinkId: string }
  > = (props) => {
    const { activityId, bonusCollectionLinkId } = props ?? {};

    return adminWorkshopControllerRemoveActivityBonusCollection(activityId, bonusCollectionLinkId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerRemoveActivityBonusCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>
>;

export type AdminWorkshopControllerRemoveActivityBonusCollectionMutationError = unknown;

/**
 * @summary Remove bonus collection from activity
 */
export const useAdminWorkshopControllerRemoveActivityBonusCollection = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>,
    TError,
    { activityId: string; bonusCollectionLinkId: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerRemoveActivityBonusCollection>>,
  TError,
  { activityId: string; bonusCollectionLinkId: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerRemoveActivityBonusCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all asset points configurations
 */
export const adminWorkshopControllerGetAssetPointsConfigs = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/asset-points`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetAssetPointsConfigsQueryKey = () => {
  return [`/admin/workshop/asset-points`] as const;
};

export const getAdminWorkshopControllerGetAssetPointsConfigsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetAssetPointsConfigsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>> = ({
    signal,
  }) => adminWorkshopControllerGetAssetPointsConfigs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetAssetPointsConfigsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>
>;
export type AdminWorkshopControllerGetAssetPointsConfigsQueryError = unknown;

export function useAdminWorkshopControllerGetAssetPointsConfigs<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetAssetPointsConfigs<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetAssetPointsConfigs<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all asset points configurations
 */

export function useAdminWorkshopControllerGetAssetPointsConfigs<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetAssetPointsConfigs>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetAssetPointsConfigsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create asset points configuration
 */
export const adminWorkshopControllerCreateAssetPointsConfig = (
  createAssetPointsConfigDto: CreateAssetPointsConfigDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/asset-points`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createAssetPointsConfigDto,
    signal,
  });
};

export const getAdminWorkshopControllerCreateAssetPointsConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>,
    TError,
    { data: CreateAssetPointsConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>,
  TError,
  { data: CreateAssetPointsConfigDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateAssetPointsConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>,
    { data: CreateAssetPointsConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateAssetPointsConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateAssetPointsConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>
>;
export type AdminWorkshopControllerCreateAssetPointsConfigMutationBody = CreateAssetPointsConfigDto;
export type AdminWorkshopControllerCreateAssetPointsConfigMutationError = unknown;

/**
 * @summary Create asset points configuration
 */
export const useAdminWorkshopControllerCreateAssetPointsConfig = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>,
    TError,
    { data: CreateAssetPointsConfigDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateAssetPointsConfig>>,
  TError,
  { data: CreateAssetPointsConfigDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateAssetPointsConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update asset points configuration
 */
export const adminWorkshopControllerUpdateAssetPointsConfig = (
  id: string,
  updateAssetPointsConfigDto: UpdateAssetPointsConfigDto,
) => {
  return customInstance<void>({
    url: `/admin/workshop/asset-points/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateAssetPointsConfigDto,
  });
};

export const getAdminWorkshopControllerUpdateAssetPointsConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>,
    TError,
    { id: string; data: UpdateAssetPointsConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>,
  TError,
  { id: string; data: UpdateAssetPointsConfigDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateAssetPointsConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>,
    { id: string; data: UpdateAssetPointsConfigDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateAssetPointsConfig(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateAssetPointsConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>
>;
export type AdminWorkshopControllerUpdateAssetPointsConfigMutationBody = UpdateAssetPointsConfigDto;
export type AdminWorkshopControllerUpdateAssetPointsConfigMutationError = unknown;

/**
 * @summary Update asset points configuration
 */
export const useAdminWorkshopControllerUpdateAssetPointsConfig = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>,
    TError,
    { id: string; data: UpdateAssetPointsConfigDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateAssetPointsConfig>>,
  TError,
  { id: string; data: UpdateAssetPointsConfigDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateAssetPointsConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete asset points configuration
 */
export const adminWorkshopControllerDeleteAssetPointsConfig = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/asset-points/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteAssetPointsConfigMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteAssetPointsConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteAssetPointsConfig(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteAssetPointsConfigMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>
>;

export type AdminWorkshopControllerDeleteAssetPointsConfigMutationError = unknown;

/**
 * @summary Delete asset points configuration
 */
export const useAdminWorkshopControllerDeleteAssetPointsConfig = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteAssetPointsConfig>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteAssetPointsConfigMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get all forge events
 */
export const adminWorkshopControllerGetForgeEvents = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/forge-events`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetForgeEventsQueryKey = () => {
  return [`/admin/workshop/forge-events`] as const;
};

export const getAdminWorkshopControllerGetForgeEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetForgeEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>> = ({ signal }) =>
    adminWorkshopControllerGetForgeEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetForgeEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>
>;
export type AdminWorkshopControllerGetForgeEventsQueryError = unknown;

export function useAdminWorkshopControllerGetForgeEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetForgeEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetForgeEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all forge events
 */

export function useAdminWorkshopControllerGetForgeEvents<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetForgeEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetForgeEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create forge event
 */
export const adminWorkshopControllerCreateForgeEvent = (
  createForgeEventWithImageDto: CreateForgeEventWithImageDto,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append('name', createForgeEventWithImageDto.name);
  if (createForgeEventWithImageDto.description !== undefined) {
    formData.append('description', createForgeEventWithImageDto.description);
  }
  formData.append('successProbability', createForgeEventWithImageDto.successProbability.toString());
  formData.append('outputCollectionId', createForgeEventWithImageDto.outputCollectionId);
  formData.append('pointsMin', createForgeEventWithImageDto.pointsMin.toString());
  formData.append('pointsMax', createForgeEventWithImageDto.pointsMax.toString());
  createForgeEventWithImageDto.cheatSheet.forEach((value) => formData.append('cheatSheet', JSON.stringify(value)));
  if (createForgeEventWithImageDto.image !== undefined) {
    formData.append('image', createForgeEventWithImageDto.image);
  }

  return customInstance<void>({
    url: `/admin/workshop/forge-events`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal,
  });
};

export const getAdminWorkshopControllerCreateForgeEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>,
    TError,
    { data: CreateForgeEventWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>,
  TError,
  { data: CreateForgeEventWithImageDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateForgeEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>,
    { data: CreateForgeEventWithImageDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateForgeEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateForgeEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>
>;
export type AdminWorkshopControllerCreateForgeEventMutationBody = CreateForgeEventWithImageDto;
export type AdminWorkshopControllerCreateForgeEventMutationError = unknown;

/**
 * @summary Create forge event
 */
export const useAdminWorkshopControllerCreateForgeEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>,
    TError,
    { data: CreateForgeEventWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateForgeEvent>>,
  TError,
  { data: CreateForgeEventWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateForgeEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update forge event
 */
export const adminWorkshopControllerUpdateForgeEvent = (
  id: string,
  updateForgeEventWithImageDto: UpdateForgeEventWithImageDto,
) => {
  const formData = new FormData();
  if (updateForgeEventWithImageDto.name !== undefined) {
    formData.append('name', updateForgeEventWithImageDto.name);
  }
  if (updateForgeEventWithImageDto.description !== undefined) {
    formData.append('description', updateForgeEventWithImageDto.description);
  }
  if (updateForgeEventWithImageDto.successProbability !== undefined) {
    formData.append('successProbability', updateForgeEventWithImageDto.successProbability.toString());
  }
  if (updateForgeEventWithImageDto.isActive !== undefined) {
    formData.append('isActive', updateForgeEventWithImageDto.isActive.toString());
  }
  if (updateForgeEventWithImageDto.outputCollectionId !== undefined) {
    formData.append('outputCollectionId', updateForgeEventWithImageDto.outputCollectionId);
  }
  if (updateForgeEventWithImageDto.pointsMin !== undefined) {
    formData.append('pointsMin', updateForgeEventWithImageDto.pointsMin.toString());
  }
  if (updateForgeEventWithImageDto.pointsMax !== undefined) {
    formData.append('pointsMax', updateForgeEventWithImageDto.pointsMax.toString());
  }
  if (updateForgeEventWithImageDto.cheatSheet !== undefined) {
    updateForgeEventWithImageDto.cheatSheet.forEach((value) => formData.append('cheatSheet', JSON.stringify(value)));
  }
  if (updateForgeEventWithImageDto.image !== undefined) {
    formData.append('image', updateForgeEventWithImageDto.image);
  }

  return customInstance<void>({
    url: `/admin/workshop/forge-events/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};

export const getAdminWorkshopControllerUpdateForgeEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>,
    TError,
    { id: string; data: UpdateForgeEventWithImageDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>,
  TError,
  { id: string; data: UpdateForgeEventWithImageDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateForgeEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>,
    { id: string; data: UpdateForgeEventWithImageDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateForgeEvent(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateForgeEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>
>;
export type AdminWorkshopControllerUpdateForgeEventMutationBody = UpdateForgeEventWithImageDto;
export type AdminWorkshopControllerUpdateForgeEventMutationError = unknown;

/**
 * @summary Update forge event
 */
export const useAdminWorkshopControllerUpdateForgeEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>,
    TError,
    { id: string; data: UpdateForgeEventWithImageDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateForgeEvent>>,
  TError,
  { id: string; data: UpdateForgeEventWithImageDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateForgeEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete forge event
 */
export const adminWorkshopControllerDeleteForgeEvent = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/forge-events/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteForgeEventMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteForgeEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteForgeEvent(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteForgeEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>
>;

export type AdminWorkshopControllerDeleteForgeEventMutationError = unknown;

/**
 * @summary Delete forge event
 */
export const useAdminWorkshopControllerDeleteForgeEvent = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteForgeEvent>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteForgeEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary List forge attempts that were rolled as success but received no output pack (incident triage / backfill)
 */
export const adminWorkshopControllerGetOrphanedForgeSuccessAttempts = (forgeEventId: string, signal?: AbortSignal) => {
  return customInstance<ForgeOrphanedSuccessAttemptListDto>({
    url: `/admin/workshop/forge-events/${forgeEventId}/orphaned-success-attempts`,
    method: 'GET',
    signal,
  });
};

export const getAdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryKey = (forgeEventId: string) => {
  return [`/admin/workshop/forge-events/${forgeEventId}/orphaned-success-attempts`] as const;
};

export const getAdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
  TError = void,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryKey(forgeEventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>> = ({
    signal,
  }) => adminWorkshopControllerGetOrphanedForgeSuccessAttempts(forgeEventId, signal);

  return { queryKey, queryFn, enabled: !!forgeEventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>
>;
export type AdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryError = void;

export function useAdminWorkshopControllerGetOrphanedForgeSuccessAttempts<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
  TError = void,
>(
  forgeEventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
          TError,
          Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetOrphanedForgeSuccessAttempts<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
  TError = void,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
          TError,
          Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetOrphanedForgeSuccessAttempts<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
  TError = void,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List forge attempts that were rolled as success but received no output pack (incident triage / backfill)
 */

export function useAdminWorkshopControllerGetOrphanedForgeSuccessAttempts<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>,
  TError = void,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetOrphanedForgeSuccessAttempts>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetOrphanedForgeSuccessAttemptsQueryOptions(forgeEventId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all workshop bonus collections
 */
export const adminWorkshopControllerGetWorkshopBonusCollections = (signal?: AbortSignal) => {
  return customInstance<void>({ url: `/admin/workshop/bonus-collections`, method: 'GET', signal });
};

export const getAdminWorkshopControllerGetWorkshopBonusCollectionsQueryKey = () => {
  return [`/admin/workshop/bonus-collections`] as const;
};

export const getAdminWorkshopControllerGetWorkshopBonusCollectionsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWorkshopControllerGetWorkshopBonusCollectionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>> = ({
    signal,
  }) => adminWorkshopControllerGetWorkshopBonusCollections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type AdminWorkshopControllerGetWorkshopBonusCollectionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>
>;
export type AdminWorkshopControllerGetWorkshopBonusCollectionsQueryError = unknown;

export function useAdminWorkshopControllerGetWorkshopBonusCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
  TError = unknown,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetWorkshopBonusCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
        TError,
        Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useAdminWorkshopControllerGetWorkshopBonusCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all workshop bonus collections
 */

export function useAdminWorkshopControllerGetWorkshopBonusCollections<
  TData = Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminWorkshopControllerGetWorkshopBonusCollections>>, TError, TData>
  >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getAdminWorkshopControllerGetWorkshopBonusCollectionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create workshop bonus collection
 */
export const adminWorkshopControllerCreateWorkshopBonusCollection = (
  createWorkshopBonusCollectionDto: CreateWorkshopBonusCollectionDto,
  signal?: AbortSignal,
) => {
  return customInstance<void>({
    url: `/admin/workshop/bonus-collections`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createWorkshopBonusCollectionDto,
    signal,
  });
};

export const getAdminWorkshopControllerCreateWorkshopBonusCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>,
    TError,
    { data: CreateWorkshopBonusCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>,
  TError,
  { data: CreateWorkshopBonusCollectionDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerCreateWorkshopBonusCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>,
    { data: CreateWorkshopBonusCollectionDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWorkshopControllerCreateWorkshopBonusCollection(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerCreateWorkshopBonusCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>
>;
export type AdminWorkshopControllerCreateWorkshopBonusCollectionMutationBody = CreateWorkshopBonusCollectionDto;
export type AdminWorkshopControllerCreateWorkshopBonusCollectionMutationError = unknown;

/**
 * @summary Create workshop bonus collection
 */
export const useAdminWorkshopControllerCreateWorkshopBonusCollection = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>,
    TError,
    { data: CreateWorkshopBonusCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerCreateWorkshopBonusCollection>>,
  TError,
  { data: CreateWorkshopBonusCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerCreateWorkshopBonusCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Update workshop bonus collection
 */
export const adminWorkshopControllerUpdateWorkshopBonusCollection = (
  id: string,
  updateWorkshopBonusCollectionDto: UpdateWorkshopBonusCollectionDto,
) => {
  return customInstance<void>({
    url: `/admin/workshop/bonus-collections/${id}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateWorkshopBonusCollectionDto,
  });
};

export const getAdminWorkshopControllerUpdateWorkshopBonusCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>,
    TError,
    { id: string; data: UpdateWorkshopBonusCollectionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>,
  TError,
  { id: string; data: UpdateWorkshopBonusCollectionDto },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerUpdateWorkshopBonusCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>,
    { id: string; data: UpdateWorkshopBonusCollectionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWorkshopControllerUpdateWorkshopBonusCollection(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerUpdateWorkshopBonusCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>
>;
export type AdminWorkshopControllerUpdateWorkshopBonusCollectionMutationBody = UpdateWorkshopBonusCollectionDto;
export type AdminWorkshopControllerUpdateWorkshopBonusCollectionMutationError = unknown;

/**
 * @summary Update workshop bonus collection
 */
export const useAdminWorkshopControllerUpdateWorkshopBonusCollection = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>,
    TError,
    { id: string; data: UpdateWorkshopBonusCollectionDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerUpdateWorkshopBonusCollection>>,
  TError,
  { id: string; data: UpdateWorkshopBonusCollectionDto },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerUpdateWorkshopBonusCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Delete workshop bonus collection
 */
export const adminWorkshopControllerDeleteWorkshopBonusCollection = (id: string) => {
  return customInstance<void>({ url: `/admin/workshop/bonus-collections/${id}`, method: 'DELETE' });
};

export const getAdminWorkshopControllerDeleteWorkshopBonusCollectionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWorkshopControllerDeleteWorkshopBonusCollection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWorkshopControllerDeleteWorkshopBonusCollection(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWorkshopControllerDeleteWorkshopBonusCollectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>
>;

export type AdminWorkshopControllerDeleteWorkshopBonusCollectionMutationError = unknown;

/**
 * @summary Delete workshop bonus collection
 */
export const useAdminWorkshopControllerDeleteWorkshopBonusCollection = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof adminWorkshopControllerDeleteWorkshopBonusCollection>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminWorkshopControllerDeleteWorkshopBonusCollectionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get user's external NFTs
 */
export const workshopControllerGetUserExternalNfts = (signal?: AbortSignal) => {
  return customInstance<ExternalPackNftDto[]>({ url: `/workshop/external-nfts`, method: 'GET', signal });
};

export const getWorkshopControllerGetUserExternalNftsQueryKey = () => {
  return [`/workshop/external-nfts`] as const;
};

export const getWorkshopControllerGetUserExternalNftsQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetUserExternalNftsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>> = ({ signal }) =>
    workshopControllerGetUserExternalNfts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetUserExternalNftsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>
>;
export type WorkshopControllerGetUserExternalNftsQueryError = unknown;

export function useWorkshopControllerGetUserExternalNfts<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetUserExternalNfts<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetUserExternalNfts<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get user's external NFTs
 */

export function useWorkshopControllerGetUserExternalNfts<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserExternalNfts>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetUserExternalNftsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get all events, divided into ongoing and passed
 */
export const workshopControllerGetAllEvents = (signal?: AbortSignal) => {
  return customInstance<WorkshopEventsByActivityTypeResponseDto>({ url: `/workshop/events`, method: 'GET', signal });
};

export const getWorkshopControllerGetAllEventsQueryKey = () => {
  return [`/workshop/events`] as const;
};

export const getWorkshopControllerGetAllEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetAllEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>> = ({ signal }) =>
    workshopControllerGetAllEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetAllEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetAllEvents>>
>;
export type WorkshopControllerGetAllEventsQueryError = unknown;

export function useWorkshopControllerGetAllEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetAllEvents>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetAllEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetAllEvents>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetAllEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get all events, divided into ongoing and passed
 */

export function useWorkshopControllerGetAllEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetAllEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetAllEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetAllEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get events by activity type, divided into ongoing and passed
 */
export const workshopControllerGetEventsByActivityType = (
  params: WorkshopControllerGetEventsByActivityTypeParams,
  signal?: AbortSignal,
) => {
  return customInstance<WorkshopEventsByActivityTypeResponseDto>({
    url: `/workshop/activities`,
    method: 'GET',
    params,
    signal,
  });
};

export const getWorkshopControllerGetEventsByActivityTypeQueryKey = (
  params: WorkshopControllerGetEventsByActivityTypeParams,
) => {
  return [`/workshop/activities`, ...(params ? [params] : [])] as const;
};

export const getWorkshopControllerGetEventsByActivityTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
  TError = unknown,
>(
  params: WorkshopControllerGetEventsByActivityTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetEventsByActivityTypeQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>> = ({ signal }) =>
    workshopControllerGetEventsByActivityType(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetEventsByActivityTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>
>;
export type WorkshopControllerGetEventsByActivityTypeQueryError = unknown;

export function useWorkshopControllerGetEventsByActivityType<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
  TError = unknown,
>(
  params: WorkshopControllerGetEventsByActivityTypeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetEventsByActivityType<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
  TError = unknown,
>(
  params: WorkshopControllerGetEventsByActivityTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetEventsByActivityType<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
  TError = unknown,
>(
  params: WorkshopControllerGetEventsByActivityTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get events by activity type, divided into ongoing and passed
 */

export function useWorkshopControllerGetEventsByActivityType<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>,
  TError = unknown,
>(
  params: WorkshopControllerGetEventsByActivityTypeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventsByActivityType>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetEventsByActivityTypeQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get activity detail by ID
 */
export const workshopControllerGetActivityDetail = (activityId: string, signal?: AbortSignal) => {
  return customInstance<WorkshopActivityDetailResponseDto>({
    url: `/workshop/activities/${activityId}`,
    method: 'GET',
    signal,
  });
};

export const getWorkshopControllerGetActivityDetailQueryKey = (activityId: string) => {
  return [`/workshop/activities/${activityId}`] as const;
};

export const getWorkshopControllerGetActivityDetailQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetActivityDetailQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>> = ({ signal }) =>
    workshopControllerGetActivityDetail(activityId, signal);

  return { queryKey, queryFn, enabled: !!activityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetActivityDetailQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>
>;
export type WorkshopControllerGetActivityDetailQueryError = unknown;

export function useWorkshopControllerGetActivityDetail<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
  TError = unknown,
>(
  activityId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityDetail<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityDetail<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get activity detail by ID
 */

export function useWorkshopControllerGetActivityDetail<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityDetail>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetActivityDetailQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get allowed assets for activity
 */
export const workshopControllerGetActivityAssets = (activityId: string, signal?: AbortSignal) => {
  return customInstance<ActivityAssetResponseDto[]>({
    url: `/workshop/activities/${activityId}/assets`,
    method: 'GET',
    signal,
  });
};

export const getWorkshopControllerGetActivityAssetsQueryKey = (activityId: string) => {
  return [`/workshop/activities/${activityId}/assets`] as const;
};

export const getWorkshopControllerGetActivityAssetsQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetActivityAssetsQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>> = ({ signal }) =>
    workshopControllerGetActivityAssets(activityId, signal);

  return { queryKey, queryFn, enabled: !!activityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetActivityAssetsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>
>;
export type WorkshopControllerGetActivityAssetsQueryError = unknown;

export function useWorkshopControllerGetActivityAssets<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
  TError = unknown,
>(
  activityId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityAssets<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityAssets<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get allowed assets for activity
 */

export function useWorkshopControllerGetActivityAssets<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssets>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetActivityAssetsQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get allowed assets for activity that user owns
 */
export const workshopControllerGetActivityAssetsAvailable = (activityId: string, signal?: AbortSignal) => {
  return customInstance<ActivityAssetAvailableResponseDto[]>({
    url: `/workshop/activities/${activityId}/assets/available`,
    method: 'GET',
    signal,
  });
};

export const getWorkshopControllerGetActivityAssetsAvailableQueryKey = (activityId: string) => {
  return [`/workshop/activities/${activityId}/assets/available`] as const;
};

export const getWorkshopControllerGetActivityAssetsAvailableQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetActivityAssetsAvailableQueryKey(activityId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>> = ({
    signal,
  }) => workshopControllerGetActivityAssetsAvailable(activityId, signal);

  return { queryKey, queryFn, enabled: !!activityId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetActivityAssetsAvailableQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>
>;
export type WorkshopControllerGetActivityAssetsAvailableQueryError = unknown;

export function useWorkshopControllerGetActivityAssetsAvailable<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
  TError = unknown,
>(
  activityId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityAssetsAvailable<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActivityAssetsAvailable<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get allowed assets for activity that user owns
 */

export function useWorkshopControllerGetActivityAssetsAvailable<
  TData = Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>,
  TError = unknown,
>(
  activityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActivityAssetsAvailable>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetActivityAssetsAvailableQueryOptions(activityId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get forge event cheatsheet for current user
 */
export const workshopControllerGetForgeEventCheatSheet = (forgeEventId: string, signal?: AbortSignal) => {
  return customInstance<ForgeCheatSheetResponseDto>({
    url: `/workshop/forge-events/${forgeEventId}/cheatsheet`,
    method: 'GET',
    signal,
  });
};

export const getWorkshopControllerGetForgeEventCheatSheetQueryKey = (forgeEventId: string) => {
  return [`/workshop/forge-events/${forgeEventId}/cheatsheet`] as const;
};

export const getWorkshopControllerGetForgeEventCheatSheetQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
  TError = unknown,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetForgeEventCheatSheetQueryKey(forgeEventId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>> = ({ signal }) =>
    workshopControllerGetForgeEventCheatSheet(forgeEventId, signal);

  return { queryKey, queryFn, enabled: !!forgeEventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetForgeEventCheatSheetQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>
>;
export type WorkshopControllerGetForgeEventCheatSheetQueryError = unknown;

export function useWorkshopControllerGetForgeEventCheatSheet<
  TData = Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
  TError = unknown,
>(
  forgeEventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetForgeEventCheatSheet<
  TData = Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
  TError = unknown,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetForgeEventCheatSheet<
  TData = Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
  TError = unknown,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get forge event cheatsheet for current user
 */

export function useWorkshopControllerGetForgeEventCheatSheet<
  TData = Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>,
  TError = unknown,
>(
  forgeEventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetForgeEventCheatSheet>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetForgeEventCheatSheetQueryOptions(forgeEventId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List active forge events with availability for user
 */
export const workshopControllerGetActiveForgeEvents = (signal?: AbortSignal) => {
  return customInstance<ForgeActiveEventResponseDto[]>({ url: `/workshop/forge-events/active`, method: 'GET', signal });
};

export const getWorkshopControllerGetActiveForgeEventsQueryKey = () => {
  return [`/workshop/forge-events/active`] as const;
};

export const getWorkshopControllerGetActiveForgeEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetActiveForgeEventsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>> = ({ signal }) =>
    workshopControllerGetActiveForgeEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetActiveForgeEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>
>;
export type WorkshopControllerGetActiveForgeEventsQueryError = unknown;

export function useWorkshopControllerGetActiveForgeEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActiveForgeEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetActiveForgeEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List active forge events with availability for user
 */

export function useWorkshopControllerGetActiveForgeEvents<
  TData = Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetActiveForgeEvents>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetActiveForgeEventsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Preview forge attempt results
 */
export const workshopControllerPreviewForge = (
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<ForgePreviewResponseDto>({
    url: `/workshop/forge-events/${forgeEventId}/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: forgePreviewRequestDto,
    signal,
  });
};

export const getWorkshopControllerPreviewForgeQueryKey = (
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
) => {
  return [`/workshop/forge-events/${forgeEventId}/preview`, forgePreviewRequestDto] as const;
};

export const getWorkshopControllerPreviewForgeQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
  TError = unknown,
>(
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerPreviewForge>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getWorkshopControllerPreviewForgeQueryKey(forgeEventId, forgePreviewRequestDto);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerPreviewForge>>> = ({ signal }) =>
    workshopControllerPreviewForge(forgeEventId, forgePreviewRequestDto, signal);

  return { queryKey, queryFn, enabled: !!forgeEventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerPreviewForgeQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerPreviewForge>>
>;
export type WorkshopControllerPreviewForgeQueryError = unknown;

export function useWorkshopControllerPreviewForge<
  TData = Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
  TError = unknown,
>(
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerPreviewForge>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerPreviewForge>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerPreviewForge<
  TData = Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
  TError = unknown,
>(
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerPreviewForge>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerPreviewForge>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerPreviewForge<
  TData = Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
  TError = unknown,
>(
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerPreviewForge>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview forge attempt results
 */

export function useWorkshopControllerPreviewForge<
  TData = Awaited<ReturnType<typeof workshopControllerPreviewForge>>,
  TError = unknown,
>(
  forgeEventId: string,
  forgePreviewRequestDto: ForgePreviewRequestDto,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerPreviewForge>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerPreviewForgeQueryOptions(forgeEventId, forgePreviewRequestDto, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start forge attempt (irreversible)
 */
export const workshopControllerStartForge = (
  forgeEventId: string,
  forgeStartRequestDto: ForgeStartRequestDto,
  signal?: AbortSignal,
) => {
  return customInstance<ForgeStartResponseDto>({
    url: `/workshop/forge-events/${forgeEventId}/start`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: forgeStartRequestDto,
    signal,
  });
};

export const getWorkshopControllerStartForgeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerStartForge>>,
    TError,
    { forgeEventId: string; data: ForgeStartRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workshopControllerStartForge>>,
  TError,
  { forgeEventId: string; data: ForgeStartRequestDto },
  TContext
> => {
  const mutationKey = ['workshopControllerStartForge'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workshopControllerStartForge>>,
    { forgeEventId: string; data: ForgeStartRequestDto }
  > = (props) => {
    const { forgeEventId, data } = props ?? {};

    return workshopControllerStartForge(forgeEventId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkshopControllerStartForgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerStartForge>>
>;
export type WorkshopControllerStartForgeMutationBody = ForgeStartRequestDto;
export type WorkshopControllerStartForgeMutationError = unknown;

/**
 * @summary Start forge attempt (irreversible)
 */
export const useWorkshopControllerStartForge = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerStartForge>>,
    TError,
    { forgeEventId: string; data: ForgeStartRequestDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof workshopControllerStartForge>>,
  TError,
  { forgeEventId: string; data: ForgeStartRequestDto },
  TContext
> => {
  const mutationOptions = getWorkshopControllerStartForgeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get global leaderboard
 */
export const workshopControllerGetGlobalLeaderboard = (
  params?: WorkshopControllerGetGlobalLeaderboardParams,
  signal?: AbortSignal,
) => {
  return customInstance<LeaderboardResponseDto>({ url: `/workshop/leaderboard`, method: 'GET', params, signal });
};

export const getWorkshopControllerGetGlobalLeaderboardQueryKey = (
  params?: WorkshopControllerGetGlobalLeaderboardParams,
) => {
  return [`/workshop/leaderboard`, ...(params ? [params] : [])] as const;
};

export const getWorkshopControllerGetGlobalLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetGlobalLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetGlobalLeaderboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>> = ({ signal }) =>
    workshopControllerGetGlobalLeaderboard(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetGlobalLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>
>;
export type WorkshopControllerGetGlobalLeaderboardQueryError = unknown;

export function useWorkshopControllerGetGlobalLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
  TError = unknown,
>(
  params: undefined | WorkshopControllerGetGlobalLeaderboardParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetGlobalLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetGlobalLeaderboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetGlobalLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetGlobalLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get global leaderboard
 */

export function useWorkshopControllerGetGlobalLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetGlobalLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetGlobalLeaderboard>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetGlobalLeaderboardQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get leaderboard for specific event
 */
export const workshopControllerGetEventLeaderboard = (
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
  signal?: AbortSignal,
) => {
  return customInstance<EventLeaderboardResponseDto>({
    url: `/workshop/leaderboard/${eventId}`,
    method: 'GET',
    params,
    signal,
  });
};

export const getWorkshopControllerGetEventLeaderboardQueryKey = (
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
) => {
  return [`/workshop/leaderboard/${eventId}`, ...(params ? [params] : [])] as const;
};

export const getWorkshopControllerGetEventLeaderboardQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
  TError = unknown,
>(
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetEventLeaderboardQueryKey(eventId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>> = ({ signal }) =>
    workshopControllerGetEventLeaderboard(eventId, params, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetEventLeaderboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>
>;
export type WorkshopControllerGetEventLeaderboardQueryError = unknown;

export function useWorkshopControllerGetEventLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
  TError = unknown,
>(
  eventId: string,
  params: undefined | WorkshopControllerGetEventLeaderboardParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetEventLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
  TError = unknown,
>(
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetEventLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
  TError = unknown,
>(
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get leaderboard for specific event
 */

export function useWorkshopControllerGetEventLeaderboard<
  TData = Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>,
  TError = unknown,
>(
  eventId: string,
  params?: WorkshopControllerGetEventLeaderboardParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetEventLeaderboard>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetEventLeaderboardQueryOptions(eventId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get current user rank in leaderboard
 */
export const workshopControllerGetUserRank = (params?: WorkshopControllerGetUserRankParams, signal?: AbortSignal) => {
  return customInstance<UserRankResponseDto>({ url: `/workshop/leaderboard/user/rank`, method: 'GET', params, signal });
};

export const getWorkshopControllerGetUserRankQueryKey = (params?: WorkshopControllerGetUserRankParams) => {
  return [`/workshop/leaderboard/user/rank`, ...(params ? [params] : [])] as const;
};

export const getWorkshopControllerGetUserRankQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetUserRankParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserRank>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetUserRankQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetUserRank>>> = ({ signal }) =>
    workshopControllerGetUserRank(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetUserRankQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetUserRank>>
>;
export type WorkshopControllerGetUserRankQueryError = unknown;

export function useWorkshopControllerGetUserRank<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
  TError = unknown,
>(
  params: undefined | WorkshopControllerGetUserRankParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserRank>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetUserRank>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetUserRank<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetUserRankParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserRank>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
          TError,
          Awaited<ReturnType<typeof workshopControllerGetUserRank>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetUserRank<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetUserRankParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserRank>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get current user rank in leaderboard
 */

export function useWorkshopControllerGetUserRank<
  TData = Awaited<ReturnType<typeof workshopControllerGetUserRank>>,
  TError = unknown,
>(
  params?: WorkshopControllerGetUserRankParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetUserRank>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetUserRankQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Calculate points range for burning multiple assets
 */
export const workshopControllerCalculateBurningPointsRange = (
  calculateBurningPointsRangeDto: CalculateBurningPointsRangeDto,
  signal?: AbortSignal,
) => {
  return customInstance<CalculateBurningPointsRangeResponseDto>({
    url: `/workshop/activities/burn/points-range`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: calculateBurningPointsRangeDto,
    signal,
  });
};

export const getWorkshopControllerCalculateBurningPointsRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>,
    TError,
    { data: CalculateBurningPointsRangeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>,
  TError,
  { data: CalculateBurningPointsRangeDto },
  TContext
> => {
  const mutationKey = ['workshopControllerCalculateBurningPointsRange'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>,
    { data: CalculateBurningPointsRangeDto }
  > = (props) => {
    const { data } = props ?? {};

    return workshopControllerCalculateBurningPointsRange(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkshopControllerCalculateBurningPointsRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>
>;
export type WorkshopControllerCalculateBurningPointsRangeMutationBody = CalculateBurningPointsRangeDto;
export type WorkshopControllerCalculateBurningPointsRangeMutationError = unknown;

/**
 * @summary Calculate points range for burning multiple assets
 */
export const useWorkshopControllerCalculateBurningPointsRange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>,
    TError,
    { data: CalculateBurningPointsRangeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof workshopControllerCalculateBurningPointsRange>>,
  TError,
  { data: CalculateBurningPointsRangeDto },
  TContext
> => {
  const mutationOptions = getWorkshopControllerCalculateBurningPointsRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Burn NFTs in workshop burning activity (single or multiple)
 */
export const workshopControllerBurnAssetsInActivity = (
  burnAssetsInActivityDto: BurnAssetsInActivityDto,
  signal?: AbortSignal,
) => {
  return customInstance<BurnAssetsInActivityResponseDto>({
    url: `/workshop/activities/burn`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: burnAssetsInActivityDto,
    signal,
  });
};

export const getWorkshopControllerBurnAssetsInActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>,
    TError,
    { data: BurnAssetsInActivityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>,
  TError,
  { data: BurnAssetsInActivityDto },
  TContext
> => {
  const mutationKey = ['workshopControllerBurnAssetsInActivity'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>,
    { data: BurnAssetsInActivityDto }
  > = (props) => {
    const { data } = props ?? {};

    return workshopControllerBurnAssetsInActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkshopControllerBurnAssetsInActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>
>;
export type WorkshopControllerBurnAssetsInActivityMutationBody = BurnAssetsInActivityDto;
export type WorkshopControllerBurnAssetsInActivityMutationError = unknown;

/**
 * @summary Burn NFTs in workshop burning activity (single or multiple)
 */
export const useWorkshopControllerBurnAssetsInActivity = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>,
    TError,
    { data: BurnAssetsInActivityDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof workshopControllerBurnAssetsInActivity>>,
  TError,
  { data: BurnAssetsInActivityDto },
  TContext
> => {
  const mutationOptions = getWorkshopControllerBurnAssetsInActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Calculate points range for staking multiple assets
 */
export const workshopControllerCalculateStakingPointsRange = (
  calculateStakingPointsRangeDto: CalculateStakingPointsRangeDto,
  signal?: AbortSignal,
) => {
  return customInstance<CalculateStakingPointsRangeResponseDto>({
    url: `/workshop/activities/stake/points-range`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: calculateStakingPointsRangeDto,
    signal,
  });
};

export const getWorkshopControllerCalculateStakingPointsRangeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>,
    TError,
    { data: CalculateStakingPointsRangeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>,
  TError,
  { data: CalculateStakingPointsRangeDto },
  TContext
> => {
  const mutationKey = ['workshopControllerCalculateStakingPointsRange'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>,
    { data: CalculateStakingPointsRangeDto }
  > = (props) => {
    const { data } = props ?? {};

    return workshopControllerCalculateStakingPointsRange(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkshopControllerCalculateStakingPointsRangeMutationResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>
>;
export type WorkshopControllerCalculateStakingPointsRangeMutationBody = CalculateStakingPointsRangeDto;
export type WorkshopControllerCalculateStakingPointsRangeMutationError = unknown;

/**
 * @summary Calculate points range for staking multiple assets
 */
export const useWorkshopControllerCalculateStakingPointsRange = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>,
    TError,
    { data: CalculateStakingPointsRangeDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof workshopControllerCalculateStakingPointsRange>>,
  TError,
  { data: CalculateStakingPointsRangeDto },
  TContext
> => {
  const mutationOptions = getWorkshopControllerCalculateStakingPointsRangeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Stake assets in workshop staking activity (single alebo viac)
 */
export const workshopControllerStakeAssetsInActivity = (
  stakeAssetsInActivityDto: StakeAssetsInActivityDto,
  signal?: AbortSignal,
) => {
  return customInstance<StakeAssetsInActivityResponseDto>({
    url: `/workshop/activities/stake`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: stakeAssetsInActivityDto,
    signal,
  });
};

export const getWorkshopControllerStakeAssetsInActivityMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>,
    TError,
    { data: StakeAssetsInActivityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>,
  TError,
  { data: StakeAssetsInActivityDto },
  TContext
> => {
  const mutationKey = ['workshopControllerStakeAssetsInActivity'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>,
    { data: StakeAssetsInActivityDto }
  > = (props) => {
    const { data } = props ?? {};

    return workshopControllerStakeAssetsInActivity(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WorkshopControllerStakeAssetsInActivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>
>;
export type WorkshopControllerStakeAssetsInActivityMutationBody = StakeAssetsInActivityDto;
export type WorkshopControllerStakeAssetsInActivityMutationError = unknown;

/**
 * @summary Stake assets in workshop staking activity (single alebo viac)
 */
export const useWorkshopControllerStakeAssetsInActivity = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>,
    TError,
    { data: StakeAssetsInActivityDto },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof workshopControllerStakeAssetsInActivity>>,
  TError,
  { data: StakeAssetsInActivityDto },
  TContext
> => {
  const mutationOptions = getWorkshopControllerStakeAssetsInActivityMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Get active Teddie badges for current user
 */
export const workshopControllerGetTeddieBadges = (signal?: AbortSignal) => {
  return customInstance<TeddieBadgesResponseDto>({ url: `/workshop/teddie-badges`, method: 'GET', signal });
};

export const getWorkshopControllerGetTeddieBadgesQueryKey = () => {
  return [`/workshop/teddie-badges`] as const;
};

export const getWorkshopControllerGetTeddieBadgesQueryOptions = <
  TData = Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWorkshopControllerGetTeddieBadgesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>> = ({ signal }) =>
    workshopControllerGetTeddieBadges(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type WorkshopControllerGetTeddieBadgesQueryResult = NonNullable<
  Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>
>;
export type WorkshopControllerGetTeddieBadgesQueryError = unknown;

export function useWorkshopControllerGetTeddieBadges<
  TData = Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
  TError = unknown,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>, TError, TData>> &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>
      >,
      'initialData'
    >;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetTeddieBadges<
  TData = Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>, TError, TData>> &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
        TError,
        Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>
      >,
      'initialData'
    >;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useWorkshopControllerGetTeddieBadges<
  TData = Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get active Teddie badges for current user
 */

export function useWorkshopControllerGetTeddieBadges<
  TData = Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof workshopControllerGetTeddieBadges>>, TError, TData>>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getWorkshopControllerGetTeddieBadgesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
